/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 140);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* harmony export (immutable) */ __webpack_exports__["f"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["h"] = __generator;
/* unused harmony export __exportStar */
/* harmony export (immutable) */ __webpack_exports__["k"] = __values;
/* harmony export (immutable) */ __webpack_exports__["i"] = __read;
/* harmony export (immutable) */ __webpack_exports__["j"] = __spread;
/* harmony export (immutable) */ __webpack_exports__["e"] = __await;
/* harmony export (immutable) */ __webpack_exports__["c"] = __asyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["b"] = __asyncDelegator;
/* harmony export (immutable) */ __webpack_exports__["d"] = __asyncValues;
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(6);
var core = __webpack_require__(24);
var hide = __webpack_require__(16);
var redefine = __webpack_require__(20);
var ctx = __webpack_require__(27);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ArrowType", function() { return ArrowType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DateUnit", function() { return DateUnit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TimeUnit", function() { return TimeUnit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Precision", function() { return Precision; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnionMode", function() { return UnionMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VectorType", function() { return VectorType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntervalUnit", function() { return IntervalUnit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MessageHeader", function() { return MessageHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MetadataVersion", function() { return MetadataVersion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Type", function() { return Type; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fb_Schema__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fb_Message__ = __webpack_require__(114);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.


var ArrowType = __WEBPACK_IMPORTED_MODULE_0__fb_Schema__["a" /* org */].apache.arrow.flatbuf.Type;
var DateUnit = __WEBPACK_IMPORTED_MODULE_0__fb_Schema__["a" /* org */].apache.arrow.flatbuf.DateUnit;
var TimeUnit = __WEBPACK_IMPORTED_MODULE_0__fb_Schema__["a" /* org */].apache.arrow.flatbuf.TimeUnit;
var Precision = __WEBPACK_IMPORTED_MODULE_0__fb_Schema__["a" /* org */].apache.arrow.flatbuf.Precision;
var UnionMode = __WEBPACK_IMPORTED_MODULE_0__fb_Schema__["a" /* org */].apache.arrow.flatbuf.UnionMode;
var VectorType = __WEBPACK_IMPORTED_MODULE_0__fb_Schema__["a" /* org */].apache.arrow.flatbuf.VectorType;
var IntervalUnit = __WEBPACK_IMPORTED_MODULE_0__fb_Schema__["a" /* org */].apache.arrow.flatbuf.IntervalUnit;
var MessageHeader = __WEBPACK_IMPORTED_MODULE_1__fb_Message__["a" /* org */].apache.arrow.flatbuf.MessageHeader;
var MetadataVersion = __WEBPACK_IMPORTED_MODULE_0__fb_Schema__["a" /* org */].apache.arrow.flatbuf.MetadataVersion;
/**
 * *
 * Main data type enumeration:
 * *
 * Data types in this library are all *logical*. They can be expressed as
 * either a primitive physical type (bytes or bits of some fixed size), a
 * nested type consisting of other data types, or another data type (e.g. a
 * timestamp encoded as an int64)
 */
var Type;
(function (Type) {
    Type[Type["NONE"] = 0] = "NONE";
    Type[Type["Null"] = 1] = "Null";
    Type[Type["Int"] = 2] = "Int";
    Type[Type["Float"] = 3] = "Float";
    Type[Type["Binary"] = 4] = "Binary";
    Type[Type["Utf8"] = 5] = "Utf8";
    Type[Type["Bool"] = 6] = "Bool";
    Type[Type["Decimal"] = 7] = "Decimal";
    Type[Type["Date"] = 8] = "Date";
    Type[Type["Time"] = 9] = "Time";
    Type[Type["Timestamp"] = 10] = "Timestamp";
    Type[Type["Interval"] = 11] = "Interval";
    Type[Type["List"] = 12] = "List";
    Type[Type["Struct"] = 13] = "Struct";
    Type[Type["Union"] = 14] = "Union";
    Type[Type["FixedSizeBinary"] = 15] = "FixedSizeBinary";
    Type[Type["FixedSizeList"] = 16] = "FixedSizeList";
    Type[Type["Map"] = 17] = "Map";
    // These enum values are here so that TypeScript can narrow the type signatures further
    // beyond the base Arrow types. The base Arrow types include metadata like bitWidths that
    // impact the type signatures of the values we return. For example, the Int8Vector reads
    // 1-byte numbers from an Int8Array, an Int32Vector reads a 4-byte number from an Int32Array,
    // and an Int64Vector reads a pair of 4-byte lo, hi int32s, and returns them as a zero-copy
    // slice from an underlying Int32Array. Library consumers benefit by doing this type narrowing,
    // since we can ensure the types across all public methods are propagated and never bail to `any`.
    // These values are _never_ actually used at runtime, and they will _never_ be written into the
    // flatbuffers metadata of serialized Arrow IPC payloads.
    Type[Type["Dictionary"] = -1] = "Dictionary";
    Type[Type["Int8"] = -2] = "Int8";
    Type[Type["Int16"] = -3] = "Int16";
    Type[Type["Int32"] = -4] = "Int32";
    Type[Type["Int64"] = -5] = "Int64";
    Type[Type["Uint8"] = -6] = "Uint8";
    Type[Type["Uint16"] = -7] = "Uint16";
    Type[Type["Uint32"] = -8] = "Uint32";
    Type[Type["Uint64"] = -9] = "Uint64";
    Type[Type["Float16"] = -10] = "Float16";
    Type[Type["Float32"] = -11] = "Float32";
    Type[Type["Float64"] = -12] = "Float64";
    Type[Type["DateDay"] = -13] = "DateDay";
    Type[Type["DateMillisecond"] = -14] = "DateMillisecond";
    Type[Type["TimestampSecond"] = -15] = "TimestampSecond";
    Type[Type["TimestampMillisecond"] = -16] = "TimestampMillisecond";
    Type[Type["TimestampMicrosecond"] = -17] = "TimestampMicrosecond";
    Type[Type["TimestampNanosecond"] = -18] = "TimestampNanosecond";
    Type[Type["TimeSecond"] = -19] = "TimeSecond";
    Type[Type["TimeMillisecond"] = -20] = "TimeMillisecond";
    Type[Type["TimeMicrosecond"] = -21] = "TimeMicrosecond";
    Type[Type["TimeNanosecond"] = -22] = "TimeNanosecond";
    Type[Type["DenseUnion"] = -23] = "DenseUnion";
    Type[Type["SparseUnion"] = -24] = "SparseUnion";
    Type[Type["IntervalDayTime"] = -25] = "IntervalDayTime";
    Type[Type["IntervalYearMonth"] = -26] = "IntervalYearMonth";
})(Type || (Type = {}));



/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DataType", function() { return DataType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Null", function() { return Null; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Int", function() { return Int_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Int8", function() { return Int8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Int16", function() { return Int16; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Int32", function() { return Int32; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Int64", function() { return Int64; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Uint8", function() { return Uint8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Uint16", function() { return Uint16; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Uint32", function() { return Uint32; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Uint64", function() { return Uint64; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Float", function() { return Float; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Float16", function() { return Float16; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Float32", function() { return Float32; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Float64", function() { return Float64; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Binary", function() { return Binary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Utf8", function() { return Utf8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Bool", function() { return Bool; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Decimal", function() { return Decimal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Date_", function() { return Date_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DateDay", function() { return DateDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DateMillisecond", function() { return DateMillisecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Time", function() { return Time_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TimeSecond", function() { return TimeSecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TimeMillisecond", function() { return TimeMillisecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TimeMicrosecond", function() { return TimeMicrosecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TimeNanosecond", function() { return TimeNanosecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Timestamp", function() { return Timestamp_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TimestampSecond", function() { return TimestampSecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TimestampMillisecond", function() { return TimestampMillisecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TimestampMicrosecond", function() { return TimestampMicrosecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TimestampNanosecond", function() { return TimestampNanosecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Interval", function() { return Interval_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntervalDayTime", function() { return IntervalDayTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntervalYearMonth", function() { return IntervalYearMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "List", function() { return List; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Struct", function() { return Struct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Union", function() { return Union_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DenseUnion", function() { return DenseUnion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SparseUnion", function() { return SparseUnion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FixedSizeBinary", function() { return FixedSizeBinary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FixedSizeList", function() { return FixedSizeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Map_", function() { return Map_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Dictionary", function() { return Dictionary; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enum__ = __webpack_require__(2);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.


var DataType = /** @class */ (function () {
    function DataType(_children) {
        this._children = _children;
    }
    /** @nocollapse */ DataType.isNull = function (x) { return x && x.typeId === __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].Null; };
    /** @nocollapse */ DataType.isInt = function (x) { return x && x.typeId === __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].Int; };
    /** @nocollapse */ DataType.isFloat = function (x) { return x && x.typeId === __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].Float; };
    /** @nocollapse */ DataType.isBinary = function (x) { return x && x.typeId === __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].Binary; };
    /** @nocollapse */ DataType.isUtf8 = function (x) { return x && x.typeId === __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].Utf8; };
    /** @nocollapse */ DataType.isBool = function (x) { return x && x.typeId === __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].Bool; };
    /** @nocollapse */ DataType.isDecimal = function (x) { return x && x.typeId === __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].Decimal; };
    /** @nocollapse */ DataType.isDate = function (x) { return x && x.typeId === __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].Date; };
    /** @nocollapse */ DataType.isTime = function (x) { return x && x.typeId === __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].Time; };
    /** @nocollapse */ DataType.isTimestamp = function (x) { return x && x.typeId === __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].Timestamp; };
    /** @nocollapse */ DataType.isInterval = function (x) { return x && x.typeId === __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].Interval; };
    /** @nocollapse */ DataType.isList = function (x) { return x && x.typeId === __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].List; };
    /** @nocollapse */ DataType.isStruct = function (x) { return x && x.typeId === __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].Struct; };
    /** @nocollapse */ DataType.isUnion = function (x) { return x && x.typeId === __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].Union; };
    /** @nocollapse */ DataType.isFixedSizeBinary = function (x) { return x && x.typeId === __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].FixedSizeBinary; };
    /** @nocollapse */ DataType.isFixedSizeList = function (x) { return x && x.typeId === __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].FixedSizeList; };
    /** @nocollapse */ DataType.isMap = function (x) { return x && x.typeId === __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].Map; };
    /** @nocollapse */ DataType.isDictionary = function (x) { return x && x.typeId === __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].Dictionary; };
    Object.defineProperty(DataType.prototype, "children", {
        get: function () { return this._children; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataType.prototype, "typeId", {
        get: function () { return __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].NONE; },
        enumerable: true,
        configurable: true
    });
    DataType[Symbol.toStringTag] = (function (proto) {
        proto.ArrayType = Array;
        return proto[Symbol.toStringTag] = 'DataType';
    })(DataType.prototype);
    return DataType;
}());

var Null = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Null, _super);
    function Null() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Null.prototype.toString = function () { return "Null"; };
    Object.defineProperty(Null.prototype, "typeId", {
        get: function () { return __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].Null; },
        enumerable: true,
        configurable: true
    });
    Null[Symbol.toStringTag] = (function (proto) {
        return proto[Symbol.toStringTag] = 'Null';
    })(Null.prototype);
    return Null;
}(DataType));

var Int_ = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Int_, _super);
    function Int_(_isSigned, _bitWidth) {
        var _this = _super.call(this) || this;
        _this._isSigned = _isSigned;
        _this._bitWidth = _bitWidth;
        return _this;
    }
    Object.defineProperty(Int_.prototype, "typeId", {
        get: function () { return __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].Int; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Int_.prototype, "isSigned", {
        get: function () { return this._isSigned; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Int_.prototype, "bitWidth", {
        get: function () { return this._bitWidth; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Int_.prototype, "ArrayType", {
        get: function () {
            switch (this._bitWidth) {
                case 8: return (this._isSigned ? Int8Array : Uint8Array);
                case 16: return (this._isSigned ? Int16Array : Uint16Array);
                case 32: return (this._isSigned ? Int32Array : Uint32Array);
                case 64: return (this._isSigned ? Int32Array : Uint32Array);
            }
            throw new Error("Unrecognized " + this[Symbol.toStringTag] + " type");
        },
        enumerable: true,
        configurable: true
    });
    Int_.prototype.toString = function () { return (this._isSigned ? "I" : "Ui") + "nt" + this._bitWidth; };
    Int_[Symbol.toStringTag] = (function (proto) {
        return proto[Symbol.toStringTag] = 'Int';
    })(Int_.prototype);
    return Int_;
}(DataType));

var Int8 = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Int8, _super);
    function Int8() {
        return _super.call(this, true, 8) || this;
    }
    return Int8;
}(Int_));

var Int16 = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Int16, _super);
    function Int16() {
        return _super.call(this, true, 16) || this;
    }
    return Int16;
}(Int_));

var Int32 = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Int32, _super);
    function Int32() {
        return _super.call(this, true, 32) || this;
    }
    return Int32;
}(Int_));

var Int64 = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Int64, _super);
    function Int64() {
        return _super.call(this, true, 64) || this;
    }
    return Int64;
}(Int_));

var Uint8 = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Uint8, _super);
    function Uint8() {
        return _super.call(this, false, 8) || this;
    }
    return Uint8;
}(Int_));

var Uint16 = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Uint16, _super);
    function Uint16() {
        return _super.call(this, false, 16) || this;
    }
    return Uint16;
}(Int_));

var Uint32 = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Uint32, _super);
    function Uint32() {
        return _super.call(this, false, 32) || this;
    }
    return Uint32;
}(Int_));

var Uint64 = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Uint64, _super);
    function Uint64() {
        return _super.call(this, false, 64) || this;
    }
    return Uint64;
}(Int_));

var Float = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Float, _super);
    function Float(_precision) {
        var _this = _super.call(this) || this;
        _this._precision = _precision;
        return _this;
    }
    Object.defineProperty(Float.prototype, "typeId", {
        get: function () { return __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].Float; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Float.prototype, "precision", {
        get: function () { return this._precision; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Float.prototype, "ArrayType", {
        get: function () {
            switch (this.precision) {
                case __WEBPACK_IMPORTED_MODULE_1__enum__["Precision"].HALF: return Uint16Array;
                case __WEBPACK_IMPORTED_MODULE_1__enum__["Precision"].SINGLE: return Float32Array;
                case __WEBPACK_IMPORTED_MODULE_1__enum__["Precision"].DOUBLE: return Float64Array;
            }
            throw new Error("Unrecognized " + this[Symbol.toStringTag] + " type");
        },
        enumerable: true,
        configurable: true
    });
    Float.prototype.toString = function () { return "Float" + ((this.precision << 5) || 16); };
    Float[Symbol.toStringTag] = (function (proto) {
        return proto[Symbol.toStringTag] = 'Float';
    })(Float.prototype);
    return Float;
}(DataType));

var Float16 = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Float16, _super);
    function Float16() {
        return _super.call(this, __WEBPACK_IMPORTED_MODULE_1__enum__["Precision"].HALF) || this;
    }
    return Float16;
}(Float));

var Float32 = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Float32, _super);
    function Float32() {
        return _super.call(this, __WEBPACK_IMPORTED_MODULE_1__enum__["Precision"].SINGLE) || this;
    }
    return Float32;
}(Float));

var Float64 = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Float64, _super);
    function Float64() {
        return _super.call(this, __WEBPACK_IMPORTED_MODULE_1__enum__["Precision"].DOUBLE) || this;
    }
    return Float64;
}(Float));

var Binary = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Binary, _super);
    function Binary() {
        return _super.call(this) || this;
    }
    Object.defineProperty(Binary.prototype, "typeId", {
        get: function () { return __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].Binary; },
        enumerable: true,
        configurable: true
    });
    Binary.prototype.toString = function () { return "Binary"; };
    Binary[Symbol.toStringTag] = (function (proto) {
        proto.ArrayType = Uint8Array;
        return proto[Symbol.toStringTag] = 'Binary';
    })(Binary.prototype);
    return Binary;
}(DataType));

var Utf8 = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Utf8, _super);
    function Utf8() {
        return _super.call(this) || this;
    }
    Object.defineProperty(Utf8.prototype, "typeId", {
        get: function () { return __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].Utf8; },
        enumerable: true,
        configurable: true
    });
    Utf8.prototype.toString = function () { return "Utf8"; };
    Utf8[Symbol.toStringTag] = (function (proto) {
        proto.ArrayType = Uint8Array;
        return proto[Symbol.toStringTag] = 'Utf8';
    })(Utf8.prototype);
    return Utf8;
}(DataType));

var Bool = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Bool, _super);
    function Bool() {
        return _super.call(this) || this;
    }
    Object.defineProperty(Bool.prototype, "typeId", {
        get: function () { return __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].Bool; },
        enumerable: true,
        configurable: true
    });
    Bool.prototype.toString = function () { return "Bool"; };
    Bool[Symbol.toStringTag] = (function (proto) {
        proto.ArrayType = Uint8Array;
        return proto[Symbol.toStringTag] = 'Bool';
    })(Bool.prototype);
    return Bool;
}(DataType));

var Decimal = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Decimal, _super);
    function Decimal(_scale, _precision) {
        var _this = _super.call(this) || this;
        _this._scale = _scale;
        _this._precision = _precision;
        return _this;
    }
    Object.defineProperty(Decimal.prototype, "typeId", {
        get: function () { return __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].Decimal; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Decimal.prototype, "scale", {
        get: function () { return this._scale; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Decimal.prototype, "precision", {
        get: function () { return this._precision; },
        enumerable: true,
        configurable: true
    });
    Decimal.prototype.toString = function () { return "Decimal[" + this._precision + "e" + (this._scale > 0 ? "+" : "") + this._scale + "]"; };
    Decimal[Symbol.toStringTag] = (function (proto) {
        proto.ArrayType = Uint32Array;
        return proto[Symbol.toStringTag] = 'Decimal';
    })(Decimal.prototype);
    return Decimal;
}(DataType));

var Date_ = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Date_, _super);
    function Date_(_unit) {
        var _this = _super.call(this) || this;
        _this._unit = _unit;
        return _this;
    }
    Object.defineProperty(Date_.prototype, "typeId", {
        get: function () { return __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].Date; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Date_.prototype, "unit", {
        get: function () { return this._unit; },
        enumerable: true,
        configurable: true
    });
    Date_.prototype.toString = function () { return "Date" + (this._unit + 1) * 32 + "<" + __WEBPACK_IMPORTED_MODULE_1__enum__["DateUnit"][this._unit] + ">"; };
    Date_[Symbol.toStringTag] = (function (proto) {
        proto.ArrayType = Int32Array;
        return proto[Symbol.toStringTag] = 'Date';
    })(Date_.prototype);
    return Date_;
}(DataType));

var DateDay = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](DateDay, _super);
    function DateDay() {
        return _super.call(this, __WEBPACK_IMPORTED_MODULE_1__enum__["DateUnit"].DAY) || this;
    }
    return DateDay;
}(Date_));

var DateMillisecond = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](DateMillisecond, _super);
    function DateMillisecond() {
        return _super.call(this, __WEBPACK_IMPORTED_MODULE_1__enum__["DateUnit"].MILLISECOND) || this;
    }
    return DateMillisecond;
}(Date_));

var Time_ = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Time_, _super);
    function Time_(_unit, _bitWidth) {
        var _this = _super.call(this) || this;
        _this._unit = _unit;
        _this._bitWidth = _bitWidth;
        return _this;
    }
    Object.defineProperty(Time_.prototype, "typeId", {
        get: function () { return __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].Time; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Time_.prototype, "unit", {
        get: function () { return this._unit; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Time_.prototype, "bitWidth", {
        get: function () { return this._bitWidth; },
        enumerable: true,
        configurable: true
    });
    Time_.prototype.toString = function () { return "Time" + this._bitWidth + "<" + __WEBPACK_IMPORTED_MODULE_1__enum__["TimeUnit"][this._unit] + ">"; };
    Time_[Symbol.toStringTag] = (function (proto) {
        proto.ArrayType = Int32Array;
        return proto[Symbol.toStringTag] = 'Time';
    })(Time_.prototype);
    return Time_;
}(DataType));

var TimeSecond = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](TimeSecond, _super);
    function TimeSecond() {
        return _super.call(this, __WEBPACK_IMPORTED_MODULE_1__enum__["TimeUnit"].SECOND, 32) || this;
    }
    return TimeSecond;
}(Time_));

var TimeMillisecond = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](TimeMillisecond, _super);
    function TimeMillisecond() {
        return _super.call(this, __WEBPACK_IMPORTED_MODULE_1__enum__["TimeUnit"].MILLISECOND, 32) || this;
    }
    return TimeMillisecond;
}(Time_));

var TimeMicrosecond = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](TimeMicrosecond, _super);
    function TimeMicrosecond() {
        return _super.call(this, __WEBPACK_IMPORTED_MODULE_1__enum__["TimeUnit"].MICROSECOND, 64) || this;
    }
    return TimeMicrosecond;
}(Time_));

var TimeNanosecond = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](TimeNanosecond, _super);
    function TimeNanosecond() {
        return _super.call(this, __WEBPACK_IMPORTED_MODULE_1__enum__["TimeUnit"].NANOSECOND, 64) || this;
    }
    return TimeNanosecond;
}(Time_));

var Timestamp_ = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Timestamp_, _super);
    function Timestamp_(_unit, _timezone) {
        var _this = _super.call(this) || this;
        _this._unit = _unit;
        _this._timezone = _timezone;
        return _this;
    }
    Object.defineProperty(Timestamp_.prototype, "typeId", {
        get: function () { return __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].Timestamp; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Timestamp_.prototype, "unit", {
        get: function () { return this._unit; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Timestamp_.prototype, "timezone", {
        get: function () { return this._timezone; },
        enumerable: true,
        configurable: true
    });
    Timestamp_.prototype.toString = function () { return "Timestamp<" + __WEBPACK_IMPORTED_MODULE_1__enum__["TimeUnit"][this._unit] + (this._timezone ? ", " + this._timezone : "") + ">"; };
    Timestamp_[Symbol.toStringTag] = (function (proto) {
        proto.ArrayType = Int32Array;
        return proto[Symbol.toStringTag] = 'Timestamp';
    })(Timestamp_.prototype);
    return Timestamp_;
}(DataType));

var TimestampSecond = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](TimestampSecond, _super);
    function TimestampSecond(timezone) {
        return _super.call(this, __WEBPACK_IMPORTED_MODULE_1__enum__["TimeUnit"].SECOND, timezone) || this;
    }
    return TimestampSecond;
}(Timestamp_));

var TimestampMillisecond = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](TimestampMillisecond, _super);
    function TimestampMillisecond(timezone) {
        return _super.call(this, __WEBPACK_IMPORTED_MODULE_1__enum__["TimeUnit"].MILLISECOND, timezone) || this;
    }
    return TimestampMillisecond;
}(Timestamp_));

var TimestampMicrosecond = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](TimestampMicrosecond, _super);
    function TimestampMicrosecond(timezone) {
        return _super.call(this, __WEBPACK_IMPORTED_MODULE_1__enum__["TimeUnit"].MICROSECOND, timezone) || this;
    }
    return TimestampMicrosecond;
}(Timestamp_));

var TimestampNanosecond = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](TimestampNanosecond, _super);
    function TimestampNanosecond(timezone) {
        return _super.call(this, __WEBPACK_IMPORTED_MODULE_1__enum__["TimeUnit"].NANOSECOND, timezone) || this;
    }
    return TimestampNanosecond;
}(Timestamp_));

var Interval_ = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Interval_, _super);
    function Interval_(_unit) {
        var _this = _super.call(this) || this;
        _this._unit = _unit;
        return _this;
    }
    Object.defineProperty(Interval_.prototype, "typeId", {
        get: function () { return __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].Interval; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Interval_.prototype, "unit", {
        get: function () { return this._unit; },
        enumerable: true,
        configurable: true
    });
    Interval_.prototype.toString = function () { return "Interval<" + __WEBPACK_IMPORTED_MODULE_1__enum__["IntervalUnit"][this._unit] + ">"; };
    Interval_[Symbol.toStringTag] = (function (proto) {
        proto.ArrayType = Int32Array;
        return proto[Symbol.toStringTag] = 'Interval';
    })(Interval_.prototype);
    return Interval_;
}(DataType));

var IntervalDayTime = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](IntervalDayTime, _super);
    function IntervalDayTime() {
        return _super.call(this, __WEBPACK_IMPORTED_MODULE_1__enum__["IntervalUnit"].DAY_TIME) || this;
    }
    return IntervalDayTime;
}(Interval_));

var IntervalYearMonth = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](IntervalYearMonth, _super);
    function IntervalYearMonth() {
        return _super.call(this, __WEBPACK_IMPORTED_MODULE_1__enum__["IntervalUnit"].YEAR_MONTH) || this;
    }
    return IntervalYearMonth;
}(Interval_));

var List = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](List, _super);
    function List(child) {
        return _super.call(this, [child]) || this;
    }
    Object.defineProperty(List.prototype, "typeId", {
        get: function () { return __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].List; },
        enumerable: true,
        configurable: true
    });
    List.prototype.toString = function () { return "List<" + this.valueType + ">"; };
    Object.defineProperty(List.prototype, "children", {
        get: function () { return this._children; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(List.prototype, "valueType", {
        get: function () { return this._children[0].type; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(List.prototype, "valueField", {
        get: function () { return this._children[0]; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(List.prototype, "ArrayType", {
        get: function () { return this.valueType.ArrayType; },
        enumerable: true,
        configurable: true
    });
    List[Symbol.toStringTag] = (function (proto) {
        return proto[Symbol.toStringTag] = 'List';
    })(List.prototype);
    return List;
}(DataType));

var Struct = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Struct, _super);
    function Struct(_children) {
        var _this = _super.call(this, _children) || this;
        _this._children = _children;
        return _this;
    }
    Object.defineProperty(Struct.prototype, "typeId", {
        get: function () { return __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].Struct; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Struct.prototype, "children", {
        get: function () { return this._children; },
        enumerable: true,
        configurable: true
    });
    Struct.prototype.toString = function () { return "Struct<[" + this._children.map(function (f) { return f.type; }).join(", ") + "]>"; };
    Struct[Symbol.toStringTag] = (function (proto) {
        return proto[Symbol.toStringTag] = 'Struct';
    })(Struct.prototype);
    return Struct;
}(DataType));

var Union_ = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Union_, _super);
    function Union_(_mode, _typeIds, _children) {
        var _this = _super.call(this, _children) || this;
        _this._mode = _mode;
        _this._children = _children;
        _this._typeIds = _typeIds = Int32Array.from(_typeIds);
        _this._typeIdToChildIndex = _typeIds.reduce(function (typeIdToChildIndex, typeId, idx) {
            return (typeIdToChildIndex[typeId] = idx) && typeIdToChildIndex || typeIdToChildIndex;
        }, Object.create(null));
        return _this;
    }
    Object.defineProperty(Union_.prototype, "typeId", {
        get: function () { return __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].Union; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Union_.prototype, "mode", {
        get: function () { return this._mode; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Union_.prototype, "typeIds", {
        get: function () { return this._typeIds; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Union_.prototype, "children", {
        get: function () { return this._children; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Union_.prototype, "typeIdToChildIndex", {
        get: function () { return this._typeIdToChildIndex; },
        enumerable: true,
        configurable: true
    });
    Union_.prototype.toString = function () {
        return this[Symbol.toStringTag] + "<" + this._children.map(function (x) { return "" + x.type; }).join(" | ") + ">";
    };
    Union_[Symbol.toStringTag] = (function (proto) {
        proto.ArrayType = Int32Array;
        return proto[Symbol.toStringTag] = 'Union';
    })(Union_.prototype);
    return Union_;
}(DataType));

var DenseUnion = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](DenseUnion, _super);
    function DenseUnion(typeIds, children) {
        return _super.call(this, __WEBPACK_IMPORTED_MODULE_1__enum__["UnionMode"].Dense, typeIds, children) || this;
    }
    return DenseUnion;
}(Union_));

var SparseUnion = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](SparseUnion, _super);
    function SparseUnion(typeIds, children) {
        return _super.call(this, __WEBPACK_IMPORTED_MODULE_1__enum__["UnionMode"].Sparse, typeIds, children) || this;
    }
    return SparseUnion;
}(Union_));

var FixedSizeBinary = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](FixedSizeBinary, _super);
    function FixedSizeBinary(_byteWidth) {
        var _this = _super.call(this) || this;
        _this._byteWidth = _byteWidth;
        return _this;
    }
    Object.defineProperty(FixedSizeBinary.prototype, "typeId", {
        get: function () { return __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].FixedSizeBinary; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FixedSizeBinary.prototype, "byteWidth", {
        get: function () { return this._byteWidth; },
        enumerable: true,
        configurable: true
    });
    FixedSizeBinary.prototype.toString = function () { return "FixedSizeBinary[" + this.byteWidth + "]"; };
    FixedSizeBinary[Symbol.toStringTag] = (function (proto) {
        proto.ArrayType = Uint8Array;
        return proto[Symbol.toStringTag] = 'FixedSizeBinary';
    })(FixedSizeBinary.prototype);
    return FixedSizeBinary;
}(DataType));

var FixedSizeList = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](FixedSizeList, _super);
    function FixedSizeList(_listSize, child) {
        var _this = _super.call(this, [child]) || this;
        _this._listSize = _listSize;
        return _this;
    }
    Object.defineProperty(FixedSizeList.prototype, "typeId", {
        get: function () { return __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].FixedSizeList; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FixedSizeList.prototype, "listSize", {
        get: function () { return this._listSize; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FixedSizeList.prototype, "children", {
        get: function () { return this._children; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FixedSizeList.prototype, "valueType", {
        get: function () { return this.children[0].type; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FixedSizeList.prototype, "valueField", {
        get: function () { return this.children[0]; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FixedSizeList.prototype, "ArrayType", {
        get: function () { return this.valueType.ArrayType; },
        enumerable: true,
        configurable: true
    });
    FixedSizeList.prototype.toString = function () { return "FixedSizeList[" + this._listSize + "]<" + this.valueType + ">"; };
    FixedSizeList[Symbol.toStringTag] = (function (proto) {
        return proto[Symbol.toStringTag] = 'FixedSizeList';
    })(FixedSizeList.prototype);
    return FixedSizeList;
}(DataType));

var Map_ = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Map_, _super);
    function Map_(_children, _keysSorted) {
        if (_keysSorted === void 0) { _keysSorted = false; }
        var _this = _super.call(this, _children) || this;
        _this._children = _children;
        _this._keysSorted = _keysSorted;
        return _this;
    }
    Object.defineProperty(Map_.prototype, "typeId", {
        get: function () { return __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].Map; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Map_.prototype, "children", {
        get: function () { return this._children; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Map_.prototype, "keysSorted", {
        get: function () { return this._keysSorted; },
        enumerable: true,
        configurable: true
    });
    Map_.prototype.toString = function () { return "Map<{" + this._children.map(function (f) { return f.name + ":" + f.type; }).join(", ") + "}>"; };
    Map_[Symbol.toStringTag] = (function (proto) {
        return proto[Symbol.toStringTag] = 'Map_';
    })(Map_.prototype);
    return Map_;
}(DataType));

/** @ignore */
var getId = (function (atomicDictionaryId) { return function () { return ++atomicDictionaryId; }; })(-1);
var Dictionary = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Dictionary, _super);
    function Dictionary(dictionary, indices, id, isOrdered, dictionaryVector) {
        var _this = _super.call(this) || this;
        _this._indices = indices;
        _this._dictionary = dictionary;
        _this._isOrdered = isOrdered || false;
        _this._dictionaryVector = dictionaryVector;
        _this._id = id == null ? getId() : typeof id === 'number' ? id : id.low;
        return _this;
    }
    Object.defineProperty(Dictionary.prototype, "dictionaryVector", {
        get: function () { return this._dictionaryVector; },
        set: function (v) { this._dictionaryVector = v; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dictionary.prototype, "typeId", {
        get: function () { return __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].Dictionary; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dictionary.prototype, "id", {
        get: function () { return this._id; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dictionary.prototype, "indices", {
        get: function () { return this._indices; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dictionary.prototype, "dictionary", {
        get: function () { return this._dictionary; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dictionary.prototype, "isOrdered", {
        get: function () { return this._isOrdered; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dictionary.prototype, "children", {
        get: function () { return this.dictionary.children; },
        set: function (_) { },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dictionary.prototype, "valueType", {
        get: function () { return this.dictionary; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dictionary.prototype, "ArrayType", {
        get: function () { return this.dictionary.ArrayType; },
        enumerable: true,
        configurable: true
    });
    Dictionary.prototype.toString = function () { return "Dictionary<" + this.indices + ", " + this.dictionary + ">"; };
    Dictionary[Symbol.toStringTag] = (function (proto) {
        return proto[Symbol.toStringTag] = 'Dictionary';
    })(Dictionary.prototype);
    return Dictionary;
}(DataType));




/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(51)('wks');
var uid = __webpack_require__(25);
var Symbol = __webpack_require__(6).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseVector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vector__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chunked__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_vector__ = __webpack_require__(84);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.




var BaseVector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](BaseVector, _super);
    function BaseVector(data, children) {
        var _this = _super.call(this) || this;
        _this._children = children;
        _this.numChildren = data.childData.length;
        _this._bindDataAccessors(_this.data = data);
        return _this;
    }
    Object.defineProperty(BaseVector.prototype, "type", {
        get: function () { return this.data.type; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseVector.prototype, "typeId", {
        get: function () { return this.data.typeId; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseVector.prototype, "length", {
        get: function () { return this.data.length; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseVector.prototype, "offset", {
        get: function () { return this.data.offset; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseVector.prototype, "stride", {
        get: function () { return this.data.stride; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseVector.prototype, "nullCount", {
        get: function () { return this.data.nullCount; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseVector.prototype, "VectorName", {
        get: function () { return this.constructor.name; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseVector.prototype, "ArrayType", {
        get: function () { return this.data.ArrayType; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseVector.prototype, "values", {
        get: function () { return this.data.values; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseVector.prototype, "typeIds", {
        get: function () { return this.data.typeIds; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseVector.prototype, "nullBitmap", {
        get: function () { return this.data.nullBitmap; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseVector.prototype, "valueOffsets", {
        get: function () { return this.data.valueOffsets; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseVector.prototype, Symbol.toStringTag, {
        get: function () { return this.VectorName + "<" + this.type[Symbol.toStringTag] + ">"; },
        enumerable: true,
        configurable: true
    });
    BaseVector.prototype.clone = function (data, children) {
        if (children === void 0) { children = this._children; }
        return __WEBPACK_IMPORTED_MODULE_1__vector__["Vector"].new(data, children);
    };
    BaseVector.prototype.concat = function () {
        var others = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            others[_i] = arguments[_i];
        }
        return __WEBPACK_IMPORTED_MODULE_2__chunked__["a" /* Chunked */].concat.apply(__WEBPACK_IMPORTED_MODULE_2__chunked__["a" /* Chunked */], __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */]([this], others));
    };
    BaseVector.prototype.slice = function (begin, end) {
        // Adjust args similar to Array.prototype.slice. Normalize begin/end to
        // clamp between 0 and length, and wrap around on negative indices, e.g.
        // slice(-1, 5) or slice(5, -1)
        return Object(__WEBPACK_IMPORTED_MODULE_3__util_vector__["a" /* clampRange */])(this, begin, end, this._sliceInternal);
    };
    BaseVector.prototype.isValid = function (index) {
        if (this.nullCount > 0) {
            var idx = this.offset + index;
            var val = this.nullBitmap[idx >> 3];
            var mask = (val & (1 << (idx % 8)));
            return mask !== 0;
        }
        return true;
    };
    BaseVector.prototype.getChildAt = function (index) {
        return index < 0 || index >= this.numChildren ? null : ((this._children || (this._children = []))[index] ||
            (this._children[index] = __WEBPACK_IMPORTED_MODULE_1__vector__["Vector"].new(this.data.childData[index])));
    };
    // @ts-ignore
    BaseVector.prototype.toJSON = function () { return __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](this); };
    BaseVector.prototype._sliceInternal = function (self, begin, end) {
        return self.clone(self.data.slice(begin, end - begin));
    };
    // @ts-ignore
    BaseVector.prototype._bindDataAccessors = function (data) {
        // Implementation in src/vectors/index.ts due to circular dependency/packaging shenanigans
    };
    return BaseVector;
}(__WEBPACK_IMPORTED_MODULE_1__vector__["Vector"]));





/***/ }),
/* 6 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Vector", function() { return Vector; });
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.
var Vector = /** @class */ (function () {
    function Vector() {
    }
    return Vector;
}());




/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(10);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export memcpy */
/* harmony export (immutable) */ __webpack_exports__["b"] = joinUint8Arrays;
/* harmony export (immutable) */ __webpack_exports__["d"] = toArrayBufferView;
/* unused harmony export toInt8Array */
/* unused harmony export toInt16Array */
/* unused harmony export toInt32Array */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return toUint8Array; });
/* unused harmony export toUint16Array */
/* unused harmony export toUint32Array */
/* unused harmony export toFloat32Array */
/* unused harmony export toFloat64Array */
/* unused harmony export toUint8ClampedArray */
/* unused harmony export toArrayBufferViewIterator */
/* unused harmony export toInt8ArrayIterator */
/* unused harmony export toInt16ArrayIterator */
/* unused harmony export toInt32ArrayIterator */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return toUint8ArrayIterator; });
/* unused harmony export toUint16ArrayIterator */
/* unused harmony export toUint32ArrayIterator */
/* unused harmony export toFloat32ArrayIterator */
/* unused harmony export toFloat64ArrayIterator */
/* unused harmony export toUint8ClampedArrayIterator */
/* unused harmony export toArrayBufferViewAsyncIterator */
/* unused harmony export toInt8ArrayAsyncIterator */
/* unused harmony export toInt16ArrayAsyncIterator */
/* unused harmony export toInt32ArrayAsyncIterator */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return toUint8ArrayAsyncIterator; });
/* unused harmony export toUint16ArrayAsyncIterator */
/* unused harmony export toUint32ArrayAsyncIterator */
/* unused harmony export toFloat32ArrayAsyncIterator */
/* unused harmony export toFloat64ArrayAsyncIterator */
/* unused harmony export toUint8ClampedArrayAsyncIterator */
/* harmony export (immutable) */ __webpack_exports__["c"] = rebaseValueOffsets;
/* harmony export (immutable) */ __webpack_exports__["a"] = compareArrayLike;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_flatbuffers__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_utf8__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__compat__ = __webpack_require__(37);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.



var ByteBuffer = __WEBPACK_IMPORTED_MODULE_1_flatbuffers__["a" /* flatbuffers */].ByteBuffer;

/** @ignore */
var SharedArrayBuf = (typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : ArrayBuffer);
/** @ignore */
function collapseContiguousByteRanges(chunks) {
    var result = chunks[0] ? [chunks[0]] : [];
    var xOffset, yOffset, xLen, yLen;
    for (var x = void 0, y = void 0, i = 0, j = 0, n = chunks.length; ++i < n;) {
        x = result[j];
        y = chunks[i];
        // continue x and y don't share the same underlying ArrayBuffer
        if (!x || !y || x.buffer !== y.buffer) {
            y && (result[++j] = y);
            continue;
        }
        // swap if y starts before x
        if (y.byteOffset < x.byteOffset) {
            x = chunks[i];
            y = result[j];
        }
        (xOffset = x.byteOffset, xLen = x.byteLength);
        (yOffset = y.byteOffset, yLen = y.byteLength);
        // continue if the byte ranges of x and y aren't contiguous
        if ((xOffset + xLen) < yOffset || (yOffset + yLen) < xOffset) {
            y && (result[++j] = y);
            continue;
        }
        result[j] = new Uint8Array(x.buffer, xOffset, yOffset - xOffset + yLen);
    }
    return result;
}
/** @ignore */
function memcpy(target, source, targetByteOffset, sourceByteLength) {
    if (targetByteOffset === void 0) { targetByteOffset = 0; }
    if (sourceByteLength === void 0) { sourceByteLength = source.byteLength; }
    var targetByteLength = target.byteLength;
    var dst = new Uint8Array(target.buffer, target.byteOffset, targetByteLength);
    var src = new Uint8Array(source.buffer, source.byteOffset, Math.min(sourceByteLength, targetByteLength));
    dst.set(src, targetByteOffset);
    return target;
}
/** @ignore */
function joinUint8Arrays(chunks, size) {
    // collapse chunks that share the same underlying ArrayBuffer and whose byte ranges overlap,
    // to avoid unnecessarily copying the bytes to do this buffer join. This is a common case during
    // streaming, where we may be reading partial byte ranges out of the same underlying ArrayBuffer
    var result = collapseContiguousByteRanges(chunks);
    var byteLength = result.reduce(function (x, b) { return x + b.byteLength; }, 0);
    var source, sliced, buffer;
    var offset = 0, index = -1, length = Math.min(size || Infinity, byteLength);
    for (var n = result.length; ++index < n;) {
        source = result[index];
        sliced = source.subarray(0, Math.min(source.length, length - offset));
        if (length <= (offset + sliced.length)) {
            if (sliced.length < source.length) {
                result[index] = source.subarray(sliced.length);
            }
            else if (sliced.length === source.length) {
                index++;
            }
            buffer ? memcpy(buffer, sliced, offset) : (buffer = sliced);
            break;
        }
        memcpy(buffer || (buffer = new Uint8Array(length)), sliced, offset);
        offset += sliced.length;
    }
    return [buffer || new Uint8Array(0), result.slice(index), byteLength - (buffer ? buffer.byteLength : 0)];
}
/** @ignore */
function toArrayBufferView(ArrayBufferViewCtor, input) {
    var value = Object(__WEBPACK_IMPORTED_MODULE_3__compat__["f" /* isIteratorResult */])(input) ? input.value : input;
    if (!value) {
        return new ArrayBufferViewCtor(0);
    }
    if (typeof value === 'string') {
        value = Object(__WEBPACK_IMPORTED_MODULE_2__util_utf8__["b" /* encodeUtf8 */])(value);
    }
    if (value instanceof ArrayBufferViewCtor) {
        return value.constructor === ArrayBufferViewCtor ? value :
            // Node's `Buffer` class passes the `instanceof Uint8Array` check, but we need
            // a real Uint8Array, since Buffer#slice isn't the same as Uint8Array#slice :/
            new ArrayBufferViewCtor(value.buffer, value.byteOffset, value.byteLength / ArrayBufferViewCtor.BYTES_PER_ELEMENT);
    }
    if (value instanceof ArrayBuffer) {
        return new ArrayBufferViewCtor(value);
    }
    if (value instanceof SharedArrayBuf) {
        return new ArrayBufferViewCtor(value);
    }
    if (value instanceof ByteBuffer) {
        return toArrayBufferView(ArrayBufferViewCtor, value.bytes());
    }
    return !ArrayBuffer.isView(value) ? ArrayBufferViewCtor.from(value) : value.byteLength <= 0 ? new ArrayBufferViewCtor(0)
        : new ArrayBufferViewCtor(value.buffer, value.byteOffset, value.byteLength / ArrayBufferViewCtor.BYTES_PER_ELEMENT);
}
/** @ignore */ var toInt8Array = function (input) { return toArrayBufferView(Int8Array, input); };
/** @ignore */ var toInt16Array = function (input) { return toArrayBufferView(Int16Array, input); };
/** @ignore */ var toInt32Array = function (input) { return toArrayBufferView(Int32Array, input); };
/** @ignore */ var toUint8Array = function (input) { return toArrayBufferView(Uint8Array, input); };
/** @ignore */ var toUint16Array = function (input) { return toArrayBufferView(Uint16Array, input); };
/** @ignore */ var toUint32Array = function (input) { return toArrayBufferView(Uint32Array, input); };
/** @ignore */ var toFloat32Array = function (input) { return toArrayBufferView(Float32Array, input); };
/** @ignore */ var toFloat64Array = function (input) { return toArrayBufferView(Float64Array, input); };
/** @ignore */ var toUint8ClampedArray = function (input) { return toArrayBufferView(Uint8ClampedArray, input); };
/** @ignore */
var pump = function (iterator) { iterator.next(); return iterator; };
/** @ignore */
function toArrayBufferViewIterator(ArrayCtor, source) {
    var wrap, buffers;
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
        switch (_a.label) {
            case 0:
                wrap = function (x) { return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, x];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                }); };
                buffers = (typeof source === 'string') ? wrap(source)
                    : (ArrayBuffer.isView(source)) ? wrap(source)
                        : (source instanceof ArrayBuffer) ? wrap(source)
                            : (source instanceof SharedArrayBuf) ? wrap(source)
                                : !Object(__WEBPACK_IMPORTED_MODULE_3__compat__["e" /* isIterable */])(source) ? wrap(source) : source;
                return [5 /*yield**/, __WEBPACK_IMPORTED_MODULE_0_tslib__["k" /* __values */](pump((function (it) {
                        var r, _a, _b;
                        return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    r = null;
                                    _c.label = 1;
                                case 1:
                                    _b = (_a = it).next;
                                    return [4 /*yield*/, toArrayBufferView(ArrayCtor, r)];
                                case 2:
                                    r = _b.apply(_a, [_c.sent()]);
                                    _c.label = 3;
                                case 3:
                                    if (!r.done) return [3 /*break*/, 1];
                                    _c.label = 4;
                                case 4: return [2 /*return*/];
                            }
                        });
                    })(buffers[Symbol.iterator]())))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
/** @ignore */ var toInt8ArrayIterator = function (input) { return toArrayBufferViewIterator(Int8Array, input); };
/** @ignore */ var toInt16ArrayIterator = function (input) { return toArrayBufferViewIterator(Int16Array, input); };
/** @ignore */ var toInt32ArrayIterator = function (input) { return toArrayBufferViewIterator(Int32Array, input); };
/** @ignore */ var toUint8ArrayIterator = function (input) { return toArrayBufferViewIterator(Uint8Array, input); };
/** @ignore */ var toUint16ArrayIterator = function (input) { return toArrayBufferViewIterator(Uint16Array, input); };
/** @ignore */ var toUint32ArrayIterator = function (input) { return toArrayBufferViewIterator(Uint32Array, input); };
/** @ignore */ var toFloat32ArrayIterator = function (input) { return toArrayBufferViewIterator(Float32Array, input); };
/** @ignore */ var toFloat64ArrayIterator = function (input) { return toArrayBufferViewIterator(Float64Array, input); };
/** @ignore */ var toUint8ClampedArrayIterator = function (input) { return toArrayBufferViewIterator(Uint8ClampedArray, input); };
/** @ignore */
function toArrayBufferViewAsyncIterator(ArrayCtor, source) {
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __asyncGenerator */](this, arguments, function toArrayBufferViewAsyncIterator_1() {
        var _a, _b, wrap, emit, buffers;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!Object(__WEBPACK_IMPORTED_MODULE_3__compat__["g" /* isPromise */])(source)) return [3 /*break*/, 5];
                    _a = toArrayBufferViewAsyncIterator;
                    _b = [ArrayCtor];
                    return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __await */](source)];
                case 1: return [5 /*yield**/, __WEBPACK_IMPORTED_MODULE_0_tslib__["k" /* __values */](__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __asyncDelegator */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __asyncValues */].apply(void 0, [_a.apply(void 0, _b.concat([_c.sent()]))])]))];
                case 2: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __await */].apply(void 0, [_c.sent()])];
                case 3: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __await */].apply(void 0, [_c.sent()])];
                case 4: return [2 /*return*/, _c.sent()];
                case 5:
                    wrap = function (x) { return __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __asyncGenerator */](this, arguments, function () { return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __await */](x)];
                            case 1: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __await */].apply(void 0, [_a.sent()])];
                            case 2: return [4 /*yield*/, _a.sent()];
                            case 3:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    }); }); };
                    emit = function (source) {
                        return __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __asyncGenerator */](this, arguments, function () {
                            return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [5 /*yield**/, __WEBPACK_IMPORTED_MODULE_0_tslib__["k" /* __values */](__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __asyncDelegator */](__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __asyncValues */](pump((function (it) {
                                            var r, _a, _b;
                                            return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_c) {
                                                switch (_c.label) {
                                                    case 0:
                                                        r = null;
                                                        _c.label = 1;
                                                    case 1:
                                                        _b = (_a = it).next;
                                                        return [4 /*yield*/, r && r.value];
                                                    case 2:
                                                        r = _b.apply(_a, [_c.sent()]);
                                                        _c.label = 3;
                                                    case 3:
                                                        if (!r.done) return [3 /*break*/, 1];
                                                        _c.label = 4;
                                                    case 4: return [2 /*return*/];
                                                }
                                            });
                                        })(source[Symbol.iterator]())))))];
                                    case 1: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __await */].apply(void 0, [_a.sent()])];
                                    case 2:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        });
                    };
                    buffers = (typeof source === 'string') ? wrap(source) // if string, wrap in an AsyncIterableIterator
                        : (ArrayBuffer.isView(source)) ? wrap(source) // if TypedArray, wrap in an AsyncIterableIterator
                            : (source instanceof ArrayBuffer) ? wrap(source) // if ArrayBuffer, wrap in an AsyncIterableIterator
                                : (source instanceof SharedArrayBuf) ? wrap(source) // if SharedArrayBuffer, wrap in an AsyncIterableIterator
                                    : Object(__WEBPACK_IMPORTED_MODULE_3__compat__["e" /* isIterable */])(source) ? emit(source) // If Iterable, wrap in an AsyncIterableIterator and compose the `next` values
                                        : !Object(__WEBPACK_IMPORTED_MODULE_3__compat__["b" /* isAsyncIterable */])(source) ? wrap(source) // If not an AsyncIterable, treat as a sentinel and wrap in an AsyncIterableIterator
                                            : source;
                    return [5 /*yield**/, // otherwise if AsyncIterable, use it
                        __WEBPACK_IMPORTED_MODULE_0_tslib__["k" /* __values */](__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __asyncDelegator */](__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __asyncValues */](pump((function (it) {
                            return __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __asyncGenerator */](this, arguments, function () {
                                var r, _a, _b;
                                return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            r = null;
                                            _c.label = 1;
                                        case 1:
                                            _b = (_a = it).next;
                                            return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __await */](toArrayBufferView(ArrayCtor, r))];
                                        case 2: return [4 /*yield*/, _c.sent()];
                                        case 3: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __await */].apply(void 0, [_b.apply(_a, [_c.sent()])])];
                                        case 4:
                                            r = _c.sent();
                                            _c.label = 5;
                                        case 5:
                                            if (!r.done) return [3 /*break*/, 1];
                                            _c.label = 6;
                                        case 6: return [2 /*return*/];
                                    }
                                });
                            });
                        })(buffers[Symbol.asyncIterator]())))))];
                case 6: // otherwise if AsyncIterable, use it
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __await */].apply(void 0, [// otherwise if AsyncIterable, use it
                        _c.sent()])];
                case 7:
                    _c.sent();
                    return [2 /*return*/];
            }
        });
    });
}
/** @ignore */ var toInt8ArrayAsyncIterator = function (input) { return toArrayBufferViewAsyncIterator(Int8Array, input); };
/** @ignore */ var toInt16ArrayAsyncIterator = function (input) { return toArrayBufferViewAsyncIterator(Int16Array, input); };
/** @ignore */ var toInt32ArrayAsyncIterator = function (input) { return toArrayBufferViewAsyncIterator(Int32Array, input); };
/** @ignore */ var toUint8ArrayAsyncIterator = function (input) { return toArrayBufferViewAsyncIterator(Uint8Array, input); };
/** @ignore */ var toUint16ArrayAsyncIterator = function (input) { return toArrayBufferViewAsyncIterator(Uint16Array, input); };
/** @ignore */ var toUint32ArrayAsyncIterator = function (input) { return toArrayBufferViewAsyncIterator(Uint32Array, input); };
/** @ignore */ var toFloat32ArrayAsyncIterator = function (input) { return toArrayBufferViewAsyncIterator(Float32Array, input); };
/** @ignore */ var toFloat64ArrayAsyncIterator = function (input) { return toArrayBufferViewAsyncIterator(Float64Array, input); };
/** @ignore */ var toUint8ClampedArrayAsyncIterator = function (input) { return toArrayBufferViewAsyncIterator(Uint8ClampedArray, input); };
/** @ignore */
function rebaseValueOffsets(offset, length, valueOffsets) {
    // If we have a non-zero offset, create a new offsets array with the values
    // shifted by the start offset, such that the new start offset is 0
    if (offset !== 0) {
        valueOffsets = valueOffsets.slice(0, length + 1);
        for (var i = -1; ++i <= length;) {
            valueOffsets[i] += offset;
        }
    }
    return valueOffsets;
}
/** @ignore */
function compareArrayLike(a, b) {
    var i = 0, n = a.length;
    if (n !== b.length) {
        return false;
    }
    if (n > 0) {
        do {
            if (a[i] !== b[i]) {
                return false;
            }
        } while (++i < n);
    }
    return true;
}



/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Visitor", function() { return Visitor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vector__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__enum__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__type__ = __webpack_require__(3);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.





var Visitor = /** @class */ (function () {
    function Visitor() {
    }
    Visitor.prototype.visitMany = function (nodes) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return nodes.map(function (node, i) { return _this.visit.apply(_this, __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */]([node], args.map(function (x) { return x[i]; }))); });
    };
    Visitor.prototype.visit = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return this.getVisitFn(args[0], false).apply(this, args);
    };
    Visitor.prototype.getVisitFn = function (node, throwIfNotFound) {
        if (throwIfNotFound === void 0) { throwIfNotFound = true; }
        return getVisitFn(this, node, throwIfNotFound);
    };
    Visitor.prototype.visitNull = function (_node) {
        var _args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            _args[_i - 1] = arguments[_i];
        }
        return null;
    };
    Visitor.prototype.visitBool = function (_node) {
        var _args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            _args[_i - 1] = arguments[_i];
        }
        return null;
    };
    Visitor.prototype.visitInt = function (_node) {
        var _args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            _args[_i - 1] = arguments[_i];
        }
        return null;
    };
    Visitor.prototype.visitFloat = function (_node) {
        var _args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            _args[_i - 1] = arguments[_i];
        }
        return null;
    };
    Visitor.prototype.visitUtf8 = function (_node) {
        var _args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            _args[_i - 1] = arguments[_i];
        }
        return null;
    };
    Visitor.prototype.visitBinary = function (_node) {
        var _args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            _args[_i - 1] = arguments[_i];
        }
        return null;
    };
    Visitor.prototype.visitFixedSizeBinary = function (_node) {
        var _args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            _args[_i - 1] = arguments[_i];
        }
        return null;
    };
    Visitor.prototype.visitDate = function (_node) {
        var _args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            _args[_i - 1] = arguments[_i];
        }
        return null;
    };
    Visitor.prototype.visitTimestamp = function (_node) {
        var _args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            _args[_i - 1] = arguments[_i];
        }
        return null;
    };
    Visitor.prototype.visitTime = function (_node) {
        var _args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            _args[_i - 1] = arguments[_i];
        }
        return null;
    };
    Visitor.prototype.visitDecimal = function (_node) {
        var _args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            _args[_i - 1] = arguments[_i];
        }
        return null;
    };
    Visitor.prototype.visitList = function (_node) {
        var _args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            _args[_i - 1] = arguments[_i];
        }
        return null;
    };
    Visitor.prototype.visitStruct = function (_node) {
        var _args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            _args[_i - 1] = arguments[_i];
        }
        return null;
    };
    Visitor.prototype.visitUnion = function (_node) {
        var _args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            _args[_i - 1] = arguments[_i];
        }
        return null;
    };
    Visitor.prototype.visitDictionary = function (_node) {
        var _args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            _args[_i - 1] = arguments[_i];
        }
        return null;
    };
    Visitor.prototype.visitInterval = function (_node) {
        var _args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            _args[_i - 1] = arguments[_i];
        }
        return null;
    };
    Visitor.prototype.visitFixedSizeList = function (_node) {
        var _args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            _args[_i - 1] = arguments[_i];
        }
        return null;
    };
    Visitor.prototype.visitMap = function (_node) {
        var _args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            _args[_i - 1] = arguments[_i];
        }
        return null;
    };
    return Visitor;
}());

/** @ignore */
function getVisitFn(visitor, node, throwIfNotFound) {
    if (throwIfNotFound === void 0) { throwIfNotFound = true; }
    var fn = null;
    var dtype = __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].NONE;
    // tslint:disable
    if (node instanceof __WEBPACK_IMPORTED_MODULE_1__data__["Data"]) {
        dtype = inferDType(node.type);
    }
    else if (node instanceof __WEBPACK_IMPORTED_MODULE_2__vector__["Vector"]) {
        dtype = inferDType(node.type);
    }
    else if (node instanceof __WEBPACK_IMPORTED_MODULE_4__type__["DataType"]) {
        dtype = inferDType(node);
    }
    else if (typeof (dtype = node) !== 'number') {
        dtype = __WEBPACK_IMPORTED_MODULE_3__enum__["Type"][node];
    }
    switch (dtype) {
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Null:
            fn = visitor.visitNull;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Bool:
            fn = visitor.visitBool;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Int:
            fn = visitor.visitInt;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Int8:
            fn = visitor.visitInt8 || visitor.visitInt;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Int16:
            fn = visitor.visitInt16 || visitor.visitInt;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Int32:
            fn = visitor.visitInt32 || visitor.visitInt;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Int64:
            fn = visitor.visitInt64 || visitor.visitInt;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Uint8:
            fn = visitor.visitUint8 || visitor.visitInt;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Uint16:
            fn = visitor.visitUint16 || visitor.visitInt;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Uint32:
            fn = visitor.visitUint32 || visitor.visitInt;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Uint64:
            fn = visitor.visitUint64 || visitor.visitInt;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Float:
            fn = visitor.visitFloat;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Float16:
            fn = visitor.visitFloat16 || visitor.visitFloat;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Float32:
            fn = visitor.visitFloat32 || visitor.visitFloat;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Float64:
            fn = visitor.visitFloat64 || visitor.visitFloat;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Utf8:
            fn = visitor.visitUtf8;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Binary:
            fn = visitor.visitBinary;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].FixedSizeBinary:
            fn = visitor.visitFixedSizeBinary;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Date:
            fn = visitor.visitDate;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].DateDay:
            fn = visitor.visitDateDay || visitor.visitDate;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].DateMillisecond:
            fn = visitor.visitDateMillisecond || visitor.visitDate;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Timestamp:
            fn = visitor.visitTimestamp;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].TimestampSecond:
            fn = visitor.visitTimestampSecond || visitor.visitTimestamp;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].TimestampMillisecond:
            fn = visitor.visitTimestampMillisecond || visitor.visitTimestamp;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].TimestampMicrosecond:
            fn = visitor.visitTimestampMicrosecond || visitor.visitTimestamp;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].TimestampNanosecond:
            fn = visitor.visitTimestampNanosecond || visitor.visitTimestamp;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Time:
            fn = visitor.visitTime;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].TimeSecond:
            fn = visitor.visitTimeSecond || visitor.visitTime;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].TimeMillisecond:
            fn = visitor.visitTimeMillisecond || visitor.visitTime;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].TimeMicrosecond:
            fn = visitor.visitTimeMicrosecond || visitor.visitTime;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].TimeNanosecond:
            fn = visitor.visitTimeNanosecond || visitor.visitTime;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Decimal:
            fn = visitor.visitDecimal;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].List:
            fn = visitor.visitList;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Struct:
            fn = visitor.visitStruct;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Union:
            fn = visitor.visitUnion;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].DenseUnion:
            fn = visitor.visitDenseUnion || visitor.visitUnion;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].SparseUnion:
            fn = visitor.visitSparseUnion || visitor.visitUnion;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Dictionary:
            fn = visitor.visitDictionary;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Interval:
            fn = visitor.visitInterval;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].IntervalDayTime:
            fn = visitor.visitIntervalDayTime || visitor.visitInterval;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].IntervalYearMonth:
            fn = visitor.visitIntervalYearMonth || visitor.visitInterval;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].FixedSizeList:
            fn = visitor.visitFixedSizeList;
            break;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Map:
            fn = visitor.visitMap;
            break;
    }
    if (typeof fn === 'function')
        return fn;
    if (!throwIfNotFound)
        return function () { return null; };
    throw new Error("Unrecognized type '" + __WEBPACK_IMPORTED_MODULE_3__enum__["Type"][dtype] + "'");
}
/** @ignore */
function inferDType(type) {
    switch (type.typeId) {
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Null: return __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Null;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Int:
            var _a = type, bitWidth = _a.bitWidth, isSigned = _a.isSigned;
            switch (bitWidth) {
                case 8: return isSigned ? __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Int8 : __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Uint8;
                case 16: return isSigned ? __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Int16 : __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Uint16;
                case 32: return isSigned ? __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Int32 : __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Uint32;
                case 64: return isSigned ? __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Int64 : __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Uint64;
            }
            return __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Int;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Float:
            switch (type.precision) {
                case __WEBPACK_IMPORTED_MODULE_3__enum__["Precision"].HALF: return __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Float16;
                case __WEBPACK_IMPORTED_MODULE_3__enum__["Precision"].SINGLE: return __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Float32;
                case __WEBPACK_IMPORTED_MODULE_3__enum__["Precision"].DOUBLE: return __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Float64;
            }
            return __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Float;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Binary: return __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Binary;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Utf8: return __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Utf8;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Bool: return __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Bool;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Decimal: return __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Decimal;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Time:
            switch (type.unit) {
                case __WEBPACK_IMPORTED_MODULE_3__enum__["TimeUnit"].SECOND: return __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].TimeSecond;
                case __WEBPACK_IMPORTED_MODULE_3__enum__["TimeUnit"].MILLISECOND: return __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].TimeMillisecond;
                case __WEBPACK_IMPORTED_MODULE_3__enum__["TimeUnit"].MICROSECOND: return __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].TimeMicrosecond;
                case __WEBPACK_IMPORTED_MODULE_3__enum__["TimeUnit"].NANOSECOND: return __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].TimeNanosecond;
            }
            return __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Time;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Timestamp:
            switch (type.unit) {
                case __WEBPACK_IMPORTED_MODULE_3__enum__["TimeUnit"].SECOND: return __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].TimestampSecond;
                case __WEBPACK_IMPORTED_MODULE_3__enum__["TimeUnit"].MILLISECOND: return __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].TimestampMillisecond;
                case __WEBPACK_IMPORTED_MODULE_3__enum__["TimeUnit"].MICROSECOND: return __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].TimestampMicrosecond;
                case __WEBPACK_IMPORTED_MODULE_3__enum__["TimeUnit"].NANOSECOND: return __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].TimestampNanosecond;
            }
            return __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Timestamp;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Date:
            switch (type.unit) {
                case __WEBPACK_IMPORTED_MODULE_3__enum__["DateUnit"].DAY: return __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].DateDay;
                case __WEBPACK_IMPORTED_MODULE_3__enum__["DateUnit"].MILLISECOND: return __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].DateMillisecond;
            }
            return __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Date;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Interval:
            switch (type.unit) {
                case __WEBPACK_IMPORTED_MODULE_3__enum__["IntervalUnit"].DAY_TIME: return __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].IntervalDayTime;
                case __WEBPACK_IMPORTED_MODULE_3__enum__["IntervalUnit"].YEAR_MONTH: return __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].IntervalYearMonth;
            }
            return __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Interval;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Map: return __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Map;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].List: return __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].List;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Struct: return __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Struct;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Union:
            switch (type.mode) {
                case __WEBPACK_IMPORTED_MODULE_3__enum__["UnionMode"].Dense: return __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].DenseUnion;
                case __WEBPACK_IMPORTED_MODULE_3__enum__["UnionMode"].Sparse: return __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].SparseUnion;
            }
            return __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Union;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].FixedSizeBinary: return __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].FixedSizeBinary;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].FixedSizeList: return __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].FixedSizeList;
        case __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Dictionary: return __WEBPACK_IMPORTED_MODULE_3__enum__["Type"].Dictionary;
    }
    throw new Error("Unrecognized type '" + __WEBPACK_IMPORTED_MODULE_3__enum__["Type"][type.typeId] + "'");
}
// Add these here so they're picked up by the externs creator
// in the build, and closure-compiler doesn't minify them away
Visitor.prototype.visitInt8 = null;
Visitor.prototype.visitInt16 = null;
Visitor.prototype.visitInt32 = null;
Visitor.prototype.visitInt64 = null;
Visitor.prototype.visitUint8 = null;
Visitor.prototype.visitUint16 = null;
Visitor.prototype.visitUint32 = null;
Visitor.prototype.visitUint64 = null;
Visitor.prototype.visitFloat16 = null;
Visitor.prototype.visitFloat32 = null;
Visitor.prototype.visitFloat64 = null;
Visitor.prototype.visitDateDay = null;
Visitor.prototype.visitDateMillisecond = null;
Visitor.prototype.visitTimestampSecond = null;
Visitor.prototype.visitTimestampMillisecond = null;
Visitor.prototype.visitTimestampMicrosecond = null;
Visitor.prototype.visitTimestampNanosecond = null;
Visitor.prototype.visitTimeSecond = null;
Visitor.prototype.visitTimeMillisecond = null;
Visitor.prototype.visitTimeMicrosecond = null;
Visitor.prototype.visitTimeNanosecond = null;
Visitor.prototype.visitDenseUnion = null;
Visitor.prototype.visitSparseUnion = null;
Visitor.prototype.visitIntervalDayTime = null;
Visitor.prototype.visitIntervalYearMonth = null;



/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(9);
var IE8_DOM_DEFINE = __webpack_require__(88);
var toPrimitive = __webpack_require__(38);
var dP = Object.defineProperty;

exports.f = __webpack_require__(14) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(8)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(30);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(13);
var createDesc = __webpack_require__(39);
module.exports = __webpack_require__(14) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(33);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "kUnknownNullCount", function() { return kUnknownNullCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Data", function() { return Data; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_bit__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_buffer__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enum__ = __webpack_require__(2);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.



/** @ignore */ var kUnknownNullCount = -1;
/** @ignore */
var Data = /** @class */ (function () {
    function Data(type, offset, length, nullCount, buffers, childData) {
        this.type = type;
        this.offset = Math.floor(Math.max(offset || 0, 0));
        this.length = Math.floor(Math.max(length || 0, 0));
        this._nullCount = Math.floor(Math.max(nullCount || 0, -1));
        this.childData = (childData || []).map(function (x) { return x instanceof Data ? x : x.data; });
        var buffer;
        if (buffers instanceof Data) {
            this.stride = buffers.stride;
            this.values = buffers.values;
            this.typeIds = buffers.typeIds;
            this.nullBitmap = buffers.nullBitmap;
            this.valueOffsets = buffers.valueOffsets;
        }
        else {
            if (buffers) {
                (buffer = buffers[0]) && (this.valueOffsets = buffer);
                (buffer = buffers[1]) && (this.values = buffer);
                (buffer = buffers[2]) && (this.nullBitmap = buffer);
                (buffer = buffers[3]) && (this.typeIds = buffer);
            }
            var t = type;
            switch (type.typeId) {
                case __WEBPACK_IMPORTED_MODULE_2__enum__["Type"].Decimal:
                    this.stride = 4;
                    break;
                case __WEBPACK_IMPORTED_MODULE_2__enum__["Type"].Timestamp:
                    this.stride = 2;
                    break;
                case __WEBPACK_IMPORTED_MODULE_2__enum__["Type"].Date:
                    this.stride = 1 + t.unit;
                    break;
                case __WEBPACK_IMPORTED_MODULE_2__enum__["Type"].Interval:
                    this.stride = 1 + t.unit;
                    break;
                case __WEBPACK_IMPORTED_MODULE_2__enum__["Type"].Int:
                    this.stride = 1 + +(t.bitWidth > 32);
                    break;
                case __WEBPACK_IMPORTED_MODULE_2__enum__["Type"].Time:
                    this.stride = 1 + +(t.bitWidth > 32);
                    break;
                case __WEBPACK_IMPORTED_MODULE_2__enum__["Type"].FixedSizeList:
                    this.stride = t.listSize;
                    break;
                case __WEBPACK_IMPORTED_MODULE_2__enum__["Type"].FixedSizeBinary:
                    this.stride = t.byteWidth;
                    break;
                default: this.stride = 1;
            }
        }
    }
    Object.defineProperty(Data.prototype, "ArrayType", {
        get: function () { return this.type.ArrayType; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Data.prototype, "typeId", {
        get: function () { return this.type.typeId; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Data.prototype, "buffers", {
        get: function () {
            return [this.valueOffsets, this.values, this.nullBitmap, this.typeIds];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Data.prototype, "nullCount", {
        get: function () {
            var nullCount = this._nullCount;
            var nullBitmap;
            if (nullCount <= kUnknownNullCount && (nullBitmap = this.nullBitmap)) {
                this._nullCount = nullCount = this.length - Object(__WEBPACK_IMPORTED_MODULE_0__util_bit__["e" /* popcnt_bit_range */])(nullBitmap, this.offset, this.offset + this.length);
            }
            return nullCount;
        },
        enumerable: true,
        configurable: true
    });
    Data.prototype.clone = function (type, offset, length, nullCount, buffers, childData) {
        if (offset === void 0) { offset = this.offset; }
        if (length === void 0) { length = this.length; }
        if (nullCount === void 0) { nullCount = this._nullCount; }
        if (buffers === void 0) { buffers = this; }
        if (childData === void 0) { childData = this.childData; }
        return new Data(type, offset, length, nullCount, buffers, childData);
    };
    Data.prototype.slice = function (offset, length) {
        // +true === 1, +false === 0, so this means
        // we keep nullCount at 0 if it's already 0,
        // otherwise set to the invalidated flag -1
        var _a = this, stride = _a.stride, typeId = _a.typeId, childData = _a.childData;
        var nullCount = +(this._nullCount === 0) - 1;
        var childStride = typeId === 16 /* FixedSizeList */ ? stride : 1;
        var buffers = this._sliceBuffers(offset, length, stride, typeId);
        return this.clone(this.type, this.offset + offset, length, nullCount, buffers, 
        // Don't slice children if we have value offsets (the variable-width types)
        (!childData.length || this.valueOffsets) ? childData : this._sliceChildren(childData, childStride * offset, childStride * length));
    };
    Data.prototype._sliceBuffers = function (offset, length, stride, typeId) {
        var arr, buffers = this.buffers;
        // If typeIds exist, slice the typeIds buffer
        (arr = buffers[__WEBPACK_IMPORTED_MODULE_2__enum__["VectorType"].TYPE]) && (buffers[__WEBPACK_IMPORTED_MODULE_2__enum__["VectorType"].TYPE] = arr.subarray(offset, offset + length));
        // If offsets exist, only slice the offsets buffer
        (arr = buffers[__WEBPACK_IMPORTED_MODULE_2__enum__["VectorType"].OFFSET]) && (buffers[__WEBPACK_IMPORTED_MODULE_2__enum__["VectorType"].OFFSET] = arr.subarray(offset, offset + length + 1)) ||
            // Otherwise if no offsets, slice the data buffer. Don't slice the data vector for Booleans, since the offset goes by bits not bytes
            (arr = buffers[__WEBPACK_IMPORTED_MODULE_2__enum__["VectorType"].DATA]) && (buffers[__WEBPACK_IMPORTED_MODULE_2__enum__["VectorType"].DATA] = typeId === 6 ? arr : arr.subarray(stride * offset, stride * (offset + length)));
        return buffers;
    };
    Data.prototype._sliceChildren = function (childData, offset, length) {
        return childData.map(function (child) { return child.slice(offset, length); });
    };
    //
    // Convenience methods for creating Data instances for each of the Arrow Vector types
    //
    /** @nocollapse */
    Data.Null = function (type, offset, length, nullCount, nullBitmap) {
        return new Data(type, offset, length, nullCount, [undefined, undefined, Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["d" /* toArrayBufferView */])(Uint8Array, nullBitmap)]);
    };
    /** @nocollapse */
    Data.Int = function (type, offset, length, nullCount, nullBitmap, data) {
        return new Data(type, offset, length, nullCount, [undefined, Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["d" /* toArrayBufferView */])(type.ArrayType, data), Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["d" /* toArrayBufferView */])(Uint8Array, nullBitmap)]);
    };
    /** @nocollapse */
    Data.Dictionary = function (type, offset, length, nullCount, nullBitmap, data) {
        return new Data(type, offset, length, nullCount, [undefined, Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["d" /* toArrayBufferView */])(type.indices.ArrayType, data), Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["d" /* toArrayBufferView */])(Uint8Array, nullBitmap)]);
    };
    /** @nocollapse */
    Data.Float = function (type, offset, length, nullCount, nullBitmap, data) {
        return new Data(type, offset, length, nullCount, [undefined, Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["d" /* toArrayBufferView */])(type.ArrayType, data), Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["d" /* toArrayBufferView */])(Uint8Array, nullBitmap)]);
    };
    /** @nocollapse */
    Data.Bool = function (type, offset, length, nullCount, nullBitmap, data) {
        return new Data(type, offset, length, nullCount, [undefined, Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["d" /* toArrayBufferView */])(type.ArrayType, data), Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["d" /* toArrayBufferView */])(Uint8Array, nullBitmap)]);
    };
    /** @nocollapse */
    Data.Decimal = function (type, offset, length, nullCount, nullBitmap, data) {
        return new Data(type, offset, length, nullCount, [undefined, Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["d" /* toArrayBufferView */])(type.ArrayType, data), Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["d" /* toArrayBufferView */])(Uint8Array, nullBitmap)]);
    };
    /** @nocollapse */
    Data.Date = function (type, offset, length, nullCount, nullBitmap, data) {
        return new Data(type, offset, length, nullCount, [undefined, Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["d" /* toArrayBufferView */])(type.ArrayType, data), Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["d" /* toArrayBufferView */])(Uint8Array, nullBitmap)]);
    };
    /** @nocollapse */
    Data.Time = function (type, offset, length, nullCount, nullBitmap, data) {
        return new Data(type, offset, length, nullCount, [undefined, Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["d" /* toArrayBufferView */])(type.ArrayType, data), Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["d" /* toArrayBufferView */])(Uint8Array, nullBitmap)]);
    };
    /** @nocollapse */
    Data.Timestamp = function (type, offset, length, nullCount, nullBitmap, data) {
        return new Data(type, offset, length, nullCount, [undefined, Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["d" /* toArrayBufferView */])(type.ArrayType, data), Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["d" /* toArrayBufferView */])(Uint8Array, nullBitmap)]);
    };
    /** @nocollapse */
    Data.Interval = function (type, offset, length, nullCount, nullBitmap, data) {
        return new Data(type, offset, length, nullCount, [undefined, Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["d" /* toArrayBufferView */])(type.ArrayType, data), Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["d" /* toArrayBufferView */])(Uint8Array, nullBitmap)]);
    };
    /** @nocollapse */
    Data.FixedSizeBinary = function (type, offset, length, nullCount, nullBitmap, data) {
        return new Data(type, offset, length, nullCount, [undefined, Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["d" /* toArrayBufferView */])(type.ArrayType, data), Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["d" /* toArrayBufferView */])(Uint8Array, nullBitmap)]);
    };
    /** @nocollapse */
    Data.Binary = function (type, offset, length, nullCount, nullBitmap, valueOffsets, data) {
        return new Data(type, offset, length, nullCount, [Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["d" /* toArrayBufferView */])(Int32Array, valueOffsets), Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["d" /* toArrayBufferView */])(Uint8Array, data), Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["d" /* toArrayBufferView */])(Uint8Array, nullBitmap)]);
    };
    /** @nocollapse */
    Data.Utf8 = function (type, offset, length, nullCount, nullBitmap, valueOffsets, data) {
        return new Data(type, offset, length, nullCount, [Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["d" /* toArrayBufferView */])(Int32Array, valueOffsets), Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["d" /* toArrayBufferView */])(Uint8Array, data), Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["d" /* toArrayBufferView */])(Uint8Array, nullBitmap)]);
    };
    /** @nocollapse */
    Data.List = function (type, offset, length, nullCount, nullBitmap, valueOffsets, child) {
        return new Data(type, offset, length, nullCount, [Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["d" /* toArrayBufferView */])(Int32Array, valueOffsets), undefined, Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["d" /* toArrayBufferView */])(Uint8Array, nullBitmap)], [child]);
    };
    /** @nocollapse */
    Data.FixedSizeList = function (type, offset, length, nullCount, nullBitmap, child) {
        return new Data(type, offset, length, nullCount, [undefined, undefined, Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["d" /* toArrayBufferView */])(Uint8Array, nullBitmap)], [child]);
    };
    /** @nocollapse */
    Data.Struct = function (type, offset, length, nullCount, nullBitmap, children) {
        return new Data(type, offset, length, nullCount, [undefined, undefined, Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["d" /* toArrayBufferView */])(Uint8Array, nullBitmap)], children);
    };
    /** @nocollapse */
    Data.Map = function (type, offset, length, nullCount, nullBitmap, children) {
        return new Data(type, offset, length, nullCount, [undefined, undefined, Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["d" /* toArrayBufferView */])(Uint8Array, nullBitmap)], children);
    };
    /** @nocollapse */
    Data.Union = function (type, offset, length, nullCount, nullBitmap, typeIds, valueOffsetsOrChildren, children) {
        var buffers = [
            undefined, undefined,
            Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["d" /* toArrayBufferView */])(Uint8Array, nullBitmap),
            Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["d" /* toArrayBufferView */])(type.ArrayType, typeIds)
        ];
        if (type.mode === __WEBPACK_IMPORTED_MODULE_2__enum__["UnionMode"].Sparse) {
            return new Data(type, offset, length, nullCount, buffers, valueOffsetsOrChildren);
        }
        buffers[__WEBPACK_IMPORTED_MODULE_2__enum__["VectorType"].OFFSET] = Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["d" /* toArrayBufferView */])(Int32Array, valueOffsetsOrChildren);
        return new Data(type, offset, length, nullCount, buffers, children);
    };
    return Data;
}());

(Data.prototype.childData = Object.freeze([]));



/***/ }),
/* 19 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(6);
var hide = __webpack_require__(16);
var has = __webpack_require__(19);
var SRC = __webpack_require__(25)('src');
var $toString = __webpack_require__(146);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(24).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Schema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Field; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(3);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.

var Schema = /** @class */ (function () {
    function Schema(fields, metadata, dictionaries, dictionaryFields) {
        var _a;
        this._fields = fields || [];
        this._metadata = metadata || new Map();
        if (!dictionaries || !dictionaryFields) {
            (_a = generateDictionaryMap(fields, dictionaries || new Map(), dictionaryFields || new Map()), dictionaries = _a.dictionaries, dictionaryFields = _a.dictionaryFields);
        }
        this._dictionaries = dictionaries;
        this._dictionaryFields = dictionaryFields;
    }
    /** @nocollapse */
    Schema.from = function (vectors, names) {
        if (names === void 0) { names = []; }
        return new Schema(vectors.map(function (v, i) { return new Field('' + (names[i] || i), v.type); }));
    };
    Object.defineProperty(Schema.prototype, "fields", {
        get: function () { return this._fields; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Schema.prototype, "metadata", {
        get: function () { return this._metadata; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Schema.prototype, "dictionaries", {
        get: function () { return this._dictionaries; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Schema.prototype, "dictionaryFields", {
        get: function () { return this._dictionaryFields; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Schema.prototype, Symbol.toStringTag, {
        get: function () { return 'Schema'; },
        enumerable: true,
        configurable: true
    });
    Schema.prototype.toString = function () {
        return "Schema<{ " + this._fields.map(function (f, i) { return i + ": " + f; }).join(', ') + " }>";
    };
    Schema.prototype.select = function () {
        var columnNames = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            columnNames[_i] = arguments[_i];
        }
        var names = columnNames.reduce(function (xs, x) { return (xs[x] = true) && xs; }, Object.create(null));
        return new Schema(this.fields.filter(function (f) { return names[f.name]; }), this.metadata);
    };
    return Schema;
}());

var Field = /** @class */ (function () {
    function Field(name, type, nullable, metadata) {
        if (nullable === void 0) { nullable = false; }
        this._name = name;
        this._type = type;
        this._nullable = nullable;
        this._metadata = metadata || new Map();
    }
    Object.defineProperty(Field.prototype, "type", {
        get: function () { return this._type; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Field.prototype, "name", {
        get: function () { return this._name; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Field.prototype, "nullable", {
        get: function () { return this._nullable; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Field.prototype, "metadata", {
        get: function () { return this._metadata; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Field.prototype, "typeId", {
        get: function () { return this._type.typeId; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Field.prototype, Symbol.toStringTag, {
        get: function () { return 'Field'; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Field.prototype, "indices", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_0__type__["DataType"].isDictionary(this._type) ? this._type.indices : this._type;
        },
        enumerable: true,
        configurable: true
    });
    Field.prototype.toString = function () { return this.name + ": " + this.type; };
    return Field;
}());

/** @ignore */
function generateDictionaryMap(fields, dictionaries, dictionaryFields) {
    for (var i = -1, n = fields.length; ++i < n;) {
        var field = fields[i];
        var type = field.type;
        if (__WEBPACK_IMPORTED_MODULE_0__type__["DataType"].isDictionary(type)) {
            if (!dictionaryFields.get(type.id)) {
                dictionaryFields.set(type.id, []);
            }
            if (!dictionaries.has(type.id)) {
                dictionaries.set(type.id, type.dictionary);
                dictionaryFields.get(type.id).push(field);
            }
            else if (dictionaries.get(type.id) !== type.dictionary) {
                throw new Error("Cannot create Schema containing two different dictionaries with the same Id");
            }
        }
        if (type.children) {
            generateDictionaryMap(type.children, dictionaries, dictionaryFields);
        }
    }
    return { dictionaries: dictionaries, dictionaryFields: dictionaryFields };
}



/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getBool;
/* harmony export (immutable) */ __webpack_exports__["a"] = getBit;
/* harmony export (immutable) */ __webpack_exports__["f"] = setBool;
/* harmony export (immutable) */ __webpack_exports__["g"] = truncateBitmap;
/* harmony export (immutable) */ __webpack_exports__["d"] = packBools;
/* harmony export (immutable) */ __webpack_exports__["c"] = iterateBits;
/* harmony export (immutable) */ __webpack_exports__["e"] = popcnt_bit_range;
/* unused harmony export popcnt_array */
/* unused harmony export popcnt_uint32 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.

/** @ignore */
function getBool(_data, _index, byte, bit) {
    return (byte & 1 << bit) !== 0;
}
/** @ignore */
function getBit(_data, _index, byte, bit) {
    return (byte & 1 << bit) >> bit;
}
/** @ignore */
function setBool(bytes, index, value) {
    return value ?
        !!(bytes[index >> 3] |= (1 << (index % 8))) || true :
        !(bytes[index >> 3] &= ~(1 << (index % 8))) && false;
}
/** @ignore */
function truncateBitmap(offset, length, bitmap) {
    var alignedSize = (bitmap.byteLength + 7) & ~7;
    if (offset > 0 || bitmap.byteLength < alignedSize) {
        var bytes = new Uint8Array(alignedSize);
        bytes.set((offset % 8 === 0)
            // If the offset is a multiple of 8 bits, it's safe to slice the bitmap
            ? bitmap.subarray(offset >> 3)
            // Otherwise iterate each bit from the offset and return a new one
            : packBools(iterateBits(bitmap, offset, length, null, getBool)));
        return bytes;
    }
    return bitmap;
}
/** @ignore */
function packBools(values) {
    var e_1, _a;
    var n = 0, i = 0;
    var xs = [];
    var bit = 0, byte = 0;
    try {
        for (var values_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["k" /* __values */](values), values_1_1 = values_1.next(); !values_1_1.done; values_1_1 = values_1.next()) {
            var value = values_1_1.value;
            value && (byte |= 1 << bit);
            if (++bit === 8) {
                xs[i++] = byte;
                byte = bit = 0;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (values_1_1 && !values_1_1.done && (_a = values_1.return)) _a.call(values_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    if (i === 0 || bit > 0) {
        xs[i++] = byte;
    }
    if (i % 8 && (n = i + 8 - i % 8)) {
        do {
            xs[i] = 0;
        } while (++i < n);
    }
    return new Uint8Array(xs);
}
/** @ignore */
function iterateBits(bytes, begin, length, context, get) {
    var bit, byteIndex, index, remaining, byte;
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
        switch (_a.label) {
            case 0:
                bit = begin % 8;
                byteIndex = begin >> 3;
                index = 0, remaining = length;
                _a.label = 1;
            case 1:
                if (!(remaining > 0)) return [3 /*break*/, 6];
                byte = bytes[byteIndex++];
                _a.label = 2;
            case 2: return [4 /*yield*/, get(context, index++, byte, bit)];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4:
                if (--remaining > 0 && ++bit < 8) return [3 /*break*/, 2];
                _a.label = 5;
            case 5:
                bit = 0;
                return [3 /*break*/, 1];
            case 6: return [2 /*return*/];
        }
    });
}
/**
 * Compute the population count (the number of bits set to 1) for a range of bits in a Uint8Array.
 * @param vector The Uint8Array of bits for which to compute the population count.
 * @param lhs The range's left-hand side (or start) bit
 * @param rhs The range's right-hand side (or end) bit
 */
/** @ignore */
function popcnt_bit_range(data, lhs, rhs) {
    var e_2, _a;
    if (rhs - lhs <= 0) {
        return 0;
    }
    // If the bit range is less than one byte, sum the 1 bits in the bit range
    if (rhs - lhs < 8) {
        var sum = 0;
        try {
            for (var _b = __WEBPACK_IMPORTED_MODULE_0_tslib__["k" /* __values */](iterateBits(data, lhs, rhs - lhs, data, getBit)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var bit = _c.value;
                sum += bit;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return sum;
    }
    // Get the next lowest multiple of 8 from the right hand side
    var rhsInside = rhs >> 3 << 3;
    // Get the next highest multiple of 8 from the left hand side
    var lhsInside = lhs + (lhs % 8 === 0 ? 0 : 8 - lhs % 8);
    return (
    // Get the popcnt of bits between the left hand side, and the next highest multiple of 8
    popcnt_bit_range(data, lhs, lhsInside) +
        // Get the popcnt of bits between the right hand side, and the next lowest multiple of 8
        popcnt_bit_range(data, rhsInside, rhs) +
        // Get the popcnt of all bits between the left and right hand sides' multiples of 8
        popcnt_array(data, lhsInside >> 3, (rhsInside - lhsInside) >> 3));
}
/** @ignore */
function popcnt_array(arr, byteOffset, byteLength) {
    var cnt = 0, pos = byteOffset | 0;
    var view = new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
    var len = byteLength === void 0 ? arr.byteLength : pos + byteLength;
    while (len - pos >= 4) {
        cnt += popcnt_uint32(view.getUint32(pos));
        pos += 4;
    }
    while (len - pos >= 2) {
        cnt += popcnt_uint32(view.getUint16(pos));
        pos += 2;
    }
    while (len - pos >= 1) {
        cnt += popcnt_uint32(view.getUint8(pos));
        pos += 1;
    }
    return cnt;
}
/** @ignore */
function popcnt_uint32(uint32) {
    var i = uint32 | 0;
    i = i - ((i >>> 1) & 0x55555555);
    i = (i & 0x33333333) + ((i >>> 2) & 0x33333333);
    return (((i + (i >>> 4)) & 0x0F0F0F0F) * 0x01010101) >>> 24;
}



/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(14), 'Object', { defineProperty: __webpack_require__(13).f });


/***/ }),
/* 24 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 25 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(28);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 30 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(89);
var enumBugKeys = __webpack_require__(65);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(52);
var defined = __webpack_require__(33);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 33 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(8);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return decodeUtf8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return encodeUtf8; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__buffer__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_text_encoding_utf_8__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_text_encoding_utf_8___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_text_encoding_utf_8__);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.


/** @ignore @suppress {missingRequire} */
var _Buffer = typeof Buffer === 'function' ? Buffer : null;
/** @ignore */
var useNativeEncoders = typeof TextDecoder === 'function' && typeof TextEncoder === 'function';
/** @ignore */
var decodeUtf8 = (function (TextDecoder) {
    if (useNativeEncoders || !_Buffer) {
        var decoder = new TextDecoder();
        return decoder.decode.bind(decoder);
    }
    return function (input) {
        var _a = Object(__WEBPACK_IMPORTED_MODULE_0__buffer__["e" /* toUint8Array */])(input), buffer = _a.buffer, byteOffset = _a.byteOffset, length = _a.length;
        return _Buffer.from(buffer, byteOffset, length).toString();
    };
})(typeof TextDecoder !== 'undefined' ? TextDecoder : __WEBPACK_IMPORTED_MODULE_1_text_encoding_utf_8__["TextDecoder"]);
/** @ignore */
var encodeUtf8 = (function (TextEncoder) {
    if (useNativeEncoders || !_Buffer) {
        var encoder = new TextEncoder();
        return encoder.encode.bind(encoder);
    }
    return function (input) {
        if (input === void 0) { input = ''; }
        return Object(__WEBPACK_IMPORTED_MODULE_0__buffer__["e" /* toUint8Array */])(_Buffer.from(input, 'utf8'));
    };
})(typeof TextEncoder !== 'undefined' ? TextEncoder : __WEBPACK_IMPORTED_MODULE_1_text_encoding_utf_8__["TextEncoder"]);


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(87).Buffer))

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isObject */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isPromise; });
/* unused harmony export isObservable */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isIterable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isAsyncIterable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isArrowJSON; });
/* unused harmony export isArrayLike */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isIteratorResult; });
/* unused harmony export isUnderlyingSink */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isFileHandle; });
/* unused harmony export isFSReadStream */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isFetchResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isWritableDOMStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isReadableDOMStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isWritableNodeStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isReadableNodeStream; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__io_interfaces__ = __webpack_require__(49);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.

/** @ignore */ var isNumber = function (x) { return typeof x === 'number'; };
/** @ignore */ var isBoolean = function (x) { return typeof x === 'boolean'; };
/** @ignore */ var isFunction = function (x) { return typeof x === 'function'; };
/** @ignore */
var isObject = function (x) { return x != null && Object(x) === x; };
/** @ignore */
var isPromise = function (x) {
    return isObject(x) && isFunction(x.then);
};
/** @ignore */
var isObservable = function (x) {
    return isObject(x) && isFunction(x.subscribe);
};
/** @ignore */
var isIterable = function (x) {
    return isObject(x) && isFunction(x[Symbol.iterator]);
};
/** @ignore */
var isAsyncIterable = function (x) {
    return isObject(x) && isFunction(x[Symbol.asyncIterator]);
};
/** @ignore */
var isArrowJSON = function (x) {
    return isObject(x) && isObject(x['schema']);
};
/** @ignore */
var isArrayLike = function (x) {
    return isObject(x) && isNumber(x['length']);
};
/** @ignore */
var isIteratorResult = function (x) {
    return isObject(x) && ('done' in x) && ('value' in x);
};
/** @ignore */
var isUnderlyingSink = function (x) {
    return isObject(x) &&
        isFunction(x['abort']) &&
        isFunction(x['close']) &&
        isFunction(x['start']) &&
        isFunction(x['write']);
};
/** @ignore */
var isFileHandle = function (x) {
    return isObject(x) && isFunction(x['stat']) && isNumber(x['fd']);
};
/** @ignore */
var isFSReadStream = function (x) {
    return isReadableNodeStream(x) && isNumber(x['bytesRead']);
};
/** @ignore */
var isFetchResponse = function (x) {
    return isObject(x) && isReadableDOMStream(x['body']);
};
/** @ignore */
var isWritableDOMStream = function (x) {
    return isObject(x) &&
        isFunction(x['abort']) &&
        isFunction(x['getWriter']) &&
        !(x instanceof __WEBPACK_IMPORTED_MODULE_0__io_interfaces__["d" /* ReadableInterop */]);
};
/** @ignore */
var isReadableDOMStream = function (x) {
    return isObject(x) &&
        isFunction(x['tee']) &&
        isFunction(x['cancel']) &&
        isFunction(x['pipeTo']) &&
        isFunction(x['getReader']) &&
        !(x instanceof __WEBPACK_IMPORTED_MODULE_0__io_interfaces__["d" /* ReadableInterop */]);
};
/** @ignore */
var isWritableNodeStream = function (x) {
    return isObject(x) &&
        isFunction(x['end']) &&
        isFunction(x['write']) &&
        isBoolean(x['writable']) &&
        !(x instanceof __WEBPACK_IMPORTED_MODULE_0__io_interfaces__["d" /* ReadableInterop */]);
};
/** @ignore */
var isReadableNodeStream = function (x) {
    return isObject(x) &&
        isFunction(x['read']) &&
        isFunction(x['pipe']) &&
        isBoolean(x['readable']) &&
        !(x instanceof __WEBPACK_IMPORTED_MODULE_0__io_interfaces__["d" /* ReadableInterop */]);
};



/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(10);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(9);
var dPs = __webpack_require__(148);
var enumBugKeys = __webpack_require__(65);
var IE_PROTO = __webpack_require__(64)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(63)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(90).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(29);
var TAG = __webpack_require__(4)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(89);
var hiddenKeys = __webpack_require__(65).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(13).f;
var has = __webpack_require__(19);
var TAG = __webpack_require__(4)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(103);
var step = __webpack_require__(170);
var Iterators = __webpack_require__(35);
var toIObject = __webpack_require__(32);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(101)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(44);
var getKeys = __webpack_require__(31);
var redefine = __webpack_require__(20);
var global = __webpack_require__(6);
var hide = __webpack_require__(16);
var Iterators = __webpack_require__(35);
var wks = __webpack_require__(4);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return org; });
/* tslint:disable:class-name */
// automatically generated by the FlatBuffers compiler, do not modify
/**
 * @enum
 */
var org;
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var MetadataVersion;
                (function (MetadataVersion) {
                    /**
                     * 0.1.0
                     */
                    MetadataVersion[MetadataVersion["V1"] = 0] = "V1";
                    /**
                     * 0.2.0
                     */
                    MetadataVersion[MetadataVersion["V2"] = 1] = "V2";
                    /**
                     * 0.3.0 -> 0.7.1
                     */
                    MetadataVersion[MetadataVersion["V3"] = 2] = "V3";
                    /**
                     * >= 0.8.0
                     */
                    MetadataVersion[MetadataVersion["V4"] = 3] = "V4";
                })(MetadataVersion = flatbuf.MetadataVersion || (flatbuf.MetadataVersion = {}));
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * @enum
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var UnionMode;
                (function (UnionMode) {
                    UnionMode[UnionMode["Sparse"] = 0] = "Sparse";
                    UnionMode[UnionMode["Dense"] = 1] = "Dense";
                })(UnionMode = flatbuf.UnionMode || (flatbuf.UnionMode = {}));
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * @enum
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var Precision;
                (function (Precision) {
                    Precision[Precision["HALF"] = 0] = "HALF";
                    Precision[Precision["SINGLE"] = 1] = "SINGLE";
                    Precision[Precision["DOUBLE"] = 2] = "DOUBLE";
                })(Precision = flatbuf.Precision || (flatbuf.Precision = {}));
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * @enum
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var DateUnit;
                (function (DateUnit) {
                    DateUnit[DateUnit["DAY"] = 0] = "DAY";
                    DateUnit[DateUnit["MILLISECOND"] = 1] = "MILLISECOND";
                })(DateUnit = flatbuf.DateUnit || (flatbuf.DateUnit = {}));
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * @enum
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var TimeUnit;
                (function (TimeUnit) {
                    TimeUnit[TimeUnit["SECOND"] = 0] = "SECOND";
                    TimeUnit[TimeUnit["MILLISECOND"] = 1] = "MILLISECOND";
                    TimeUnit[TimeUnit["MICROSECOND"] = 2] = "MICROSECOND";
                    TimeUnit[TimeUnit["NANOSECOND"] = 3] = "NANOSECOND";
                })(TimeUnit = flatbuf.TimeUnit || (flatbuf.TimeUnit = {}));
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * @enum
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var IntervalUnit;
                (function (IntervalUnit) {
                    IntervalUnit[IntervalUnit["YEAR_MONTH"] = 0] = "YEAR_MONTH";
                    IntervalUnit[IntervalUnit["DAY_TIME"] = 1] = "DAY_TIME";
                })(IntervalUnit = flatbuf.IntervalUnit || (flatbuf.IntervalUnit = {}));
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * ----------------------------------------------------------------------
 * Top-level Type value, enabling extensible type-specific metadata. We can
 * add new logical types to Type without breaking backwards compatibility
 *
 * @enum
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var Type;
                (function (Type) {
                    Type[Type["NONE"] = 0] = "NONE";
                    Type[Type["Null"] = 1] = "Null";
                    Type[Type["Int"] = 2] = "Int";
                    Type[Type["FloatingPoint"] = 3] = "FloatingPoint";
                    Type[Type["Binary"] = 4] = "Binary";
                    Type[Type["Utf8"] = 5] = "Utf8";
                    Type[Type["Bool"] = 6] = "Bool";
                    Type[Type["Decimal"] = 7] = "Decimal";
                    Type[Type["Date"] = 8] = "Date";
                    Type[Type["Time"] = 9] = "Time";
                    Type[Type["Timestamp"] = 10] = "Timestamp";
                    Type[Type["Interval"] = 11] = "Interval";
                    Type[Type["List"] = 12] = "List";
                    Type[Type["Struct_"] = 13] = "Struct_";
                    Type[Type["Union"] = 14] = "Union";
                    Type[Type["FixedSizeBinary"] = 15] = "FixedSizeBinary";
                    Type[Type["FixedSizeList"] = 16] = "FixedSizeList";
                    Type[Type["Map"] = 17] = "Map";
                })(Type = flatbuf.Type || (flatbuf.Type = {}));
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * ----------------------------------------------------------------------
 * The possible types of a vector
 *
 * @enum
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var VectorType;
                (function (VectorType) {
                    /**
                     * used in List type, Dense Union and variable length primitive types (String, Binary)
                     */
                    VectorType[VectorType["OFFSET"] = 0] = "OFFSET";
                    /**
                     * actual data, either wixed width primitive types in slots or variable width delimited by an OFFSET vector
                     */
                    VectorType[VectorType["DATA"] = 1] = "DATA";
                    /**
                     * Bit vector indicating if each value is null
                     */
                    VectorType[VectorType["VALIDITY"] = 2] = "VALIDITY";
                    /**
                     * Type vector used in Union type
                     */
                    VectorType[VectorType["TYPE"] = 3] = "TYPE";
                })(VectorType = flatbuf.VectorType || (flatbuf.VectorType = {}));
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * ----------------------------------------------------------------------
 * Endianness of the platform producing the data
 *
 * @enum
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var Endianness;
                (function (Endianness) {
                    Endianness[Endianness["Little"] = 0] = "Little";
                    Endianness[Endianness["Big"] = 1] = "Big";
                })(Endianness = flatbuf.Endianness || (flatbuf.Endianness = {}));
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * These are stored in the flatbuffer in the Type union below
 *
 * @constructor
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var Null = /** @class */ (function () {
                    function Null() {
                        /**
                         * @type {number}
                         */
                        this.bb_pos = 0;
                    }
                    /**
                     * @param {number} i
                     * @param {flatbuffers.ByteBuffer} bb
                     * @returns {Null}
                     */
                    Null.prototype.__init = function (i, bb) {
                        this.bb_pos = i;
                        this.bb = bb;
                        return this;
                    };
                    /**
                     * @param {flatbuffers.ByteBuffer} bb
                     * @param {Null=} obj
                     * @returns {Null}
                     */
                    Null.getRootAsNull = function (bb, obj) {
                        return (obj || new Null).__init(bb.readInt32(bb.position()) + bb.position(), bb);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     */
                    Null.startNull = function (builder) {
                        builder.startObject(0);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @returns {flatbuffers.Offset}
                     */
                    Null.endNull = function (builder) {
                        var offset = builder.endObject();
                        return offset;
                    };
                    return Null;
                }());
                flatbuf.Null = Null;
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * A Struct_ in the flatbuffer metadata is the same as an Arrow Struct
 * (according to the physical memory layout). We used Struct_ here as
 * Struct is a reserved word in Flatbuffers
 *
 * @constructor
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var Struct_ = /** @class */ (function () {
                    function Struct_() {
                        /**
                         * @type {number}
                         */
                        this.bb_pos = 0;
                    }
                    /**
                     * @param {number} i
                     * @param {flatbuffers.ByteBuffer} bb
                     * @returns {Struct_}
                     */
                    Struct_.prototype.__init = function (i, bb) {
                        this.bb_pos = i;
                        this.bb = bb;
                        return this;
                    };
                    /**
                     * @param {flatbuffers.ByteBuffer} bb
                     * @param {Struct_=} obj
                     * @returns {Struct_}
                     */
                    Struct_.getRootAsStruct_ = function (bb, obj) {
                        return (obj || new Struct_).__init(bb.readInt32(bb.position()) + bb.position(), bb);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     */
                    Struct_.startStruct_ = function (builder) {
                        builder.startObject(0);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @returns {flatbuffers.Offset}
                     */
                    Struct_.endStruct_ = function (builder) {
                        var offset = builder.endObject();
                        return offset;
                    };
                    return Struct_;
                }());
                flatbuf.Struct_ = Struct_;
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * @constructor
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var List = /** @class */ (function () {
                    function List() {
                        /**
                         * @type {number}
                         */
                        this.bb_pos = 0;
                    }
                    /**
                     * @param {number} i
                     * @param {flatbuffers.ByteBuffer} bb
                     * @returns {List}
                     */
                    List.prototype.__init = function (i, bb) {
                        this.bb_pos = i;
                        this.bb = bb;
                        return this;
                    };
                    /**
                     * @param {flatbuffers.ByteBuffer} bb
                     * @param {List=} obj
                     * @returns {List}
                     */
                    List.getRootAsList = function (bb, obj) {
                        return (obj || new List).__init(bb.readInt32(bb.position()) + bb.position(), bb);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     */
                    List.startList = function (builder) {
                        builder.startObject(0);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @returns {flatbuffers.Offset}
                     */
                    List.endList = function (builder) {
                        var offset = builder.endObject();
                        return offset;
                    };
                    return List;
                }());
                flatbuf.List = List;
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * @constructor
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var FixedSizeList = /** @class */ (function () {
                    function FixedSizeList() {
                        /**
                         * @type {number}
                         */
                        this.bb_pos = 0;
                    }
                    /**
                     * @param {number} i
                     * @param {flatbuffers.ByteBuffer} bb
                     * @returns {FixedSizeList}
                     */
                    FixedSizeList.prototype.__init = function (i, bb) {
                        this.bb_pos = i;
                        this.bb = bb;
                        return this;
                    };
                    /**
                     * @param {flatbuffers.ByteBuffer} bb
                     * @param {FixedSizeList=} obj
                     * @returns {FixedSizeList}
                     */
                    FixedSizeList.getRootAsFixedSizeList = function (bb, obj) {
                        return (obj || new FixedSizeList).__init(bb.readInt32(bb.position()) + bb.position(), bb);
                    };
                    /**
                     * Number of list items per value
                     *
                     * @returns {number}
                     */
                    FixedSizeList.prototype.listSize = function () {
                        var offset = this.bb.__offset(this.bb_pos, 4);
                        return offset ? this.bb.readInt32(this.bb_pos + offset) : 0;
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     */
                    FixedSizeList.startFixedSizeList = function (builder) {
                        builder.startObject(1);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {number} listSize
                     */
                    FixedSizeList.addListSize = function (builder, listSize) {
                        builder.addFieldInt32(0, listSize, 0);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @returns {flatbuffers.Offset}
                     */
                    FixedSizeList.endFixedSizeList = function (builder) {
                        var offset = builder.endObject();
                        return offset;
                    };
                    return FixedSizeList;
                }());
                flatbuf.FixedSizeList = FixedSizeList;
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * A Map is a logical nested type that is represented as
 *
 * List<entry: Struct<key: K, value: V>>
 *
 * In this layout, the keys and values are each respectively contiguous. We do
 * not constrain the key and value types, so the application is responsible
 * for ensuring that the keys are hashable and unique. Whether the keys are sorted
 * may be set in the metadata for this field
 *
 * In a Field with Map type, the Field has a child Struct field, which then
 * has two children: key type and the second the value type. The names of the
 * child fields may be respectively "entry", "key", and "value", but this is
 * not enforced
 *
 * Map
 *   - child[0] entry: Struct
 *     - child[0] key: K
 *     - child[1] value: V
 *
 * Neither the "entry" field nor the "key" field may be nullable.
 *
 * The metadata is structured so that Arrow systems without special handling
 * for Map can make Map an alias for List. The "layout" attribute for the Map
 * field must have the same contents as a List.
 *
 * @constructor
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var Map = /** @class */ (function () {
                    function Map() {
                        /**
                         * @type {number}
                         */
                        this.bb_pos = 0;
                    }
                    /**
                     * @param {number} i
                     * @param {flatbuffers.ByteBuffer} bb
                     * @returns {Map}
                     */
                    Map.prototype.__init = function (i, bb) {
                        this.bb_pos = i;
                        this.bb = bb;
                        return this;
                    };
                    /**
                     * @param {flatbuffers.ByteBuffer} bb
                     * @param {Map=} obj
                     * @returns {Map}
                     */
                    Map.getRootAsMap = function (bb, obj) {
                        return (obj || new Map).__init(bb.readInt32(bb.position()) + bb.position(), bb);
                    };
                    /**
                     * Set to true if the keys within each value are sorted
                     *
                     * @returns {boolean}
                     */
                    Map.prototype.keysSorted = function () {
                        var offset = this.bb.__offset(this.bb_pos, 4);
                        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     */
                    Map.startMap = function (builder) {
                        builder.startObject(1);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {boolean} keysSorted
                     */
                    Map.addKeysSorted = function (builder, keysSorted) {
                        builder.addFieldInt8(0, +keysSorted, +false);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @returns {flatbuffers.Offset}
                     */
                    Map.endMap = function (builder) {
                        var offset = builder.endObject();
                        return offset;
                    };
                    return Map;
                }());
                flatbuf.Map = Map;
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * A union is a complex type with children in Field
 * By default ids in the type vector refer to the offsets in the children
 * optionally typeIds provides an indirection between the child offset and the type id
 * for each child typeIds[offset] is the id used in the type vector
 *
 * @constructor
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var Union = /** @class */ (function () {
                    function Union() {
                        /**
                         * @type {number}
                         */
                        this.bb_pos = 0;
                    }
                    /**
                     * @param {number} i
                     * @param {flatbuffers.ByteBuffer} bb
                     * @returns {Union}
                     */
                    Union.prototype.__init = function (i, bb) {
                        this.bb_pos = i;
                        this.bb = bb;
                        return this;
                    };
                    /**
                     * @param {flatbuffers.ByteBuffer} bb
                     * @param {Union=} obj
                     * @returns {Union}
                     */
                    Union.getRootAsUnion = function (bb, obj) {
                        return (obj || new Union).__init(bb.readInt32(bb.position()) + bb.position(), bb);
                    };
                    /**
                     * @returns {org.apache.arrow.flatbuf.UnionMode}
                     */
                    Union.prototype.mode = function () {
                        var offset = this.bb.__offset(this.bb_pos, 4);
                        return offset ? /** @type {org.apache.arrow.flatbuf.UnionMode} */ (this.bb.readInt16(this.bb_pos + offset)) : org.apache.arrow.flatbuf.UnionMode.Sparse;
                    };
                    /**
                     * @param {number} index
                     * @returns {number}
                     */
                    Union.prototype.typeIds = function (index) {
                        var offset = this.bb.__offset(this.bb_pos, 6);
                        return offset ? this.bb.readInt32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
                    };
                    /**
                     * @returns {number}
                     */
                    Union.prototype.typeIdsLength = function () {
                        var offset = this.bb.__offset(this.bb_pos, 6);
                        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
                    };
                    /**
                     * @returns {Int32Array}
                     */
                    Union.prototype.typeIdsArray = function () {
                        var offset = this.bb.__offset(this.bb_pos, 6);
                        return offset ? new Int32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     */
                    Union.startUnion = function (builder) {
                        builder.startObject(2);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {org.apache.arrow.flatbuf.UnionMode} mode
                     */
                    Union.addMode = function (builder, mode) {
                        builder.addFieldInt16(0, mode, org.apache.arrow.flatbuf.UnionMode.Sparse);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {flatbuffers.Offset} typeIdsOffset
                     */
                    Union.addTypeIds = function (builder, typeIdsOffset) {
                        builder.addFieldOffset(1, typeIdsOffset, 0);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {Array.<number>} data
                     * @returns {flatbuffers.Offset}
                     */
                    Union.createTypeIdsVector = function (builder, data) {
                        builder.startVector(4, data.length, 4);
                        for (var i = data.length - 1; i >= 0; i--) {
                            builder.addInt32(data[i]);
                        }
                        return builder.endVector();
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {number} numElems
                     */
                    Union.startTypeIdsVector = function (builder, numElems) {
                        builder.startVector(4, numElems, 4);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @returns {flatbuffers.Offset}
                     */
                    Union.endUnion = function (builder) {
                        var offset = builder.endObject();
                        return offset;
                    };
                    return Union;
                }());
                flatbuf.Union = Union;
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * @constructor
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var Int = /** @class */ (function () {
                    function Int() {
                        /**
                         * @type {number}
                         */
                        this.bb_pos = 0;
                    }
                    /**
                     * @param {number} i
                     * @param {flatbuffers.ByteBuffer} bb
                     * @returns {Int}
                     */
                    Int.prototype.__init = function (i, bb) {
                        this.bb_pos = i;
                        this.bb = bb;
                        return this;
                    };
                    /**
                     * @param {flatbuffers.ByteBuffer} bb
                     * @param {Int=} obj
                     * @returns {Int}
                     */
                    Int.getRootAsInt = function (bb, obj) {
                        return (obj || new Int).__init(bb.readInt32(bb.position()) + bb.position(), bb);
                    };
                    /**
                     * @returns {number}
                     */
                    Int.prototype.bitWidth = function () {
                        var offset = this.bb.__offset(this.bb_pos, 4);
                        return offset ? this.bb.readInt32(this.bb_pos + offset) : 0;
                    };
                    /**
                     * @returns {boolean}
                     */
                    Int.prototype.isSigned = function () {
                        var offset = this.bb.__offset(this.bb_pos, 6);
                        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     */
                    Int.startInt = function (builder) {
                        builder.startObject(2);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {number} bitWidth
                     */
                    Int.addBitWidth = function (builder, bitWidth) {
                        builder.addFieldInt32(0, bitWidth, 0);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {boolean} isSigned
                     */
                    Int.addIsSigned = function (builder, isSigned) {
                        builder.addFieldInt8(1, +isSigned, +false);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @returns {flatbuffers.Offset}
                     */
                    Int.endInt = function (builder) {
                        var offset = builder.endObject();
                        return offset;
                    };
                    return Int;
                }());
                flatbuf.Int = Int;
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * @constructor
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var FloatingPoint = /** @class */ (function () {
                    function FloatingPoint() {
                        /**
                         * @type {number}
                         */
                        this.bb_pos = 0;
                    }
                    /**
                     * @param {number} i
                     * @param {flatbuffers.ByteBuffer} bb
                     * @returns {FloatingPoint}
                     */
                    FloatingPoint.prototype.__init = function (i, bb) {
                        this.bb_pos = i;
                        this.bb = bb;
                        return this;
                    };
                    /**
                     * @param {flatbuffers.ByteBuffer} bb
                     * @param {FloatingPoint=} obj
                     * @returns {FloatingPoint}
                     */
                    FloatingPoint.getRootAsFloatingPoint = function (bb, obj) {
                        return (obj || new FloatingPoint).__init(bb.readInt32(bb.position()) + bb.position(), bb);
                    };
                    /**
                     * @returns {org.apache.arrow.flatbuf.Precision}
                     */
                    FloatingPoint.prototype.precision = function () {
                        var offset = this.bb.__offset(this.bb_pos, 4);
                        return offset ? /** @type {org.apache.arrow.flatbuf.Precision} */ (this.bb.readInt16(this.bb_pos + offset)) : org.apache.arrow.flatbuf.Precision.HALF;
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     */
                    FloatingPoint.startFloatingPoint = function (builder) {
                        builder.startObject(1);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {org.apache.arrow.flatbuf.Precision} precision
                     */
                    FloatingPoint.addPrecision = function (builder, precision) {
                        builder.addFieldInt16(0, precision, org.apache.arrow.flatbuf.Precision.HALF);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @returns {flatbuffers.Offset}
                     */
                    FloatingPoint.endFloatingPoint = function (builder) {
                        var offset = builder.endObject();
                        return offset;
                    };
                    return FloatingPoint;
                }());
                flatbuf.FloatingPoint = FloatingPoint;
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * Unicode with UTF-8 encoding
 *
 * @constructor
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var Utf8 = /** @class */ (function () {
                    function Utf8() {
                        /**
                         * @type {number}
                         */
                        this.bb_pos = 0;
                    }
                    /**
                     * @param {number} i
                     * @param {flatbuffers.ByteBuffer} bb
                     * @returns {Utf8}
                     */
                    Utf8.prototype.__init = function (i, bb) {
                        this.bb_pos = i;
                        this.bb = bb;
                        return this;
                    };
                    /**
                     * @param {flatbuffers.ByteBuffer} bb
                     * @param {Utf8=} obj
                     * @returns {Utf8}
                     */
                    Utf8.getRootAsUtf8 = function (bb, obj) {
                        return (obj || new Utf8).__init(bb.readInt32(bb.position()) + bb.position(), bb);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     */
                    Utf8.startUtf8 = function (builder) {
                        builder.startObject(0);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @returns {flatbuffers.Offset}
                     */
                    Utf8.endUtf8 = function (builder) {
                        var offset = builder.endObject();
                        return offset;
                    };
                    return Utf8;
                }());
                flatbuf.Utf8 = Utf8;
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * @constructor
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var Binary = /** @class */ (function () {
                    function Binary() {
                        /**
                         * @type {number}
                         */
                        this.bb_pos = 0;
                    }
                    /**
                     * @param {number} i
                     * @param {flatbuffers.ByteBuffer} bb
                     * @returns {Binary}
                     */
                    Binary.prototype.__init = function (i, bb) {
                        this.bb_pos = i;
                        this.bb = bb;
                        return this;
                    };
                    /**
                     * @param {flatbuffers.ByteBuffer} bb
                     * @param {Binary=} obj
                     * @returns {Binary}
                     */
                    Binary.getRootAsBinary = function (bb, obj) {
                        return (obj || new Binary).__init(bb.readInt32(bb.position()) + bb.position(), bb);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     */
                    Binary.startBinary = function (builder) {
                        builder.startObject(0);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @returns {flatbuffers.Offset}
                     */
                    Binary.endBinary = function (builder) {
                        var offset = builder.endObject();
                        return offset;
                    };
                    return Binary;
                }());
                flatbuf.Binary = Binary;
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * @constructor
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var FixedSizeBinary = /** @class */ (function () {
                    function FixedSizeBinary() {
                        /**
                         * @type {number}
                         */
                        this.bb_pos = 0;
                    }
                    /**
                     * @param {number} i
                     * @param {flatbuffers.ByteBuffer} bb
                     * @returns {FixedSizeBinary}
                     */
                    FixedSizeBinary.prototype.__init = function (i, bb) {
                        this.bb_pos = i;
                        this.bb = bb;
                        return this;
                    };
                    /**
                     * @param {flatbuffers.ByteBuffer} bb
                     * @param {FixedSizeBinary=} obj
                     * @returns {FixedSizeBinary}
                     */
                    FixedSizeBinary.getRootAsFixedSizeBinary = function (bb, obj) {
                        return (obj || new FixedSizeBinary).__init(bb.readInt32(bb.position()) + bb.position(), bb);
                    };
                    /**
                     * Number of bytes per value
                     *
                     * @returns {number}
                     */
                    FixedSizeBinary.prototype.byteWidth = function () {
                        var offset = this.bb.__offset(this.bb_pos, 4);
                        return offset ? this.bb.readInt32(this.bb_pos + offset) : 0;
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     */
                    FixedSizeBinary.startFixedSizeBinary = function (builder) {
                        builder.startObject(1);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {number} byteWidth
                     */
                    FixedSizeBinary.addByteWidth = function (builder, byteWidth) {
                        builder.addFieldInt32(0, byteWidth, 0);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @returns {flatbuffers.Offset}
                     */
                    FixedSizeBinary.endFixedSizeBinary = function (builder) {
                        var offset = builder.endObject();
                        return offset;
                    };
                    return FixedSizeBinary;
                }());
                flatbuf.FixedSizeBinary = FixedSizeBinary;
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * @constructor
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var Bool = /** @class */ (function () {
                    function Bool() {
                        /**
                         * @type {number}
                         */
                        this.bb_pos = 0;
                    }
                    /**
                     * @param {number} i
                     * @param {flatbuffers.ByteBuffer} bb
                     * @returns {Bool}
                     */
                    Bool.prototype.__init = function (i, bb) {
                        this.bb_pos = i;
                        this.bb = bb;
                        return this;
                    };
                    /**
                     * @param {flatbuffers.ByteBuffer} bb
                     * @param {Bool=} obj
                     * @returns {Bool}
                     */
                    Bool.getRootAsBool = function (bb, obj) {
                        return (obj || new Bool).__init(bb.readInt32(bb.position()) + bb.position(), bb);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     */
                    Bool.startBool = function (builder) {
                        builder.startObject(0);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @returns {flatbuffers.Offset}
                     */
                    Bool.endBool = function (builder) {
                        var offset = builder.endObject();
                        return offset;
                    };
                    return Bool;
                }());
                flatbuf.Bool = Bool;
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * @constructor
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var Decimal = /** @class */ (function () {
                    function Decimal() {
                        /**
                         * @type {number}
                         */
                        this.bb_pos = 0;
                    }
                    /**
                     * @param {number} i
                     * @param {flatbuffers.ByteBuffer} bb
                     * @returns {Decimal}
                     */
                    Decimal.prototype.__init = function (i, bb) {
                        this.bb_pos = i;
                        this.bb = bb;
                        return this;
                    };
                    /**
                     * @param {flatbuffers.ByteBuffer} bb
                     * @param {Decimal=} obj
                     * @returns {Decimal}
                     */
                    Decimal.getRootAsDecimal = function (bb, obj) {
                        return (obj || new Decimal).__init(bb.readInt32(bb.position()) + bb.position(), bb);
                    };
                    /**
                     * Total number of decimal digits
                     *
                     * @returns {number}
                     */
                    Decimal.prototype.precision = function () {
                        var offset = this.bb.__offset(this.bb_pos, 4);
                        return offset ? this.bb.readInt32(this.bb_pos + offset) : 0;
                    };
                    /**
                     * Number of digits after the decimal point "."
                     *
                     * @returns {number}
                     */
                    Decimal.prototype.scale = function () {
                        var offset = this.bb.__offset(this.bb_pos, 6);
                        return offset ? this.bb.readInt32(this.bb_pos + offset) : 0;
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     */
                    Decimal.startDecimal = function (builder) {
                        builder.startObject(2);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {number} precision
                     */
                    Decimal.addPrecision = function (builder, precision) {
                        builder.addFieldInt32(0, precision, 0);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {number} scale
                     */
                    Decimal.addScale = function (builder, scale) {
                        builder.addFieldInt32(1, scale, 0);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @returns {flatbuffers.Offset}
                     */
                    Decimal.endDecimal = function (builder) {
                        var offset = builder.endObject();
                        return offset;
                    };
                    return Decimal;
                }());
                flatbuf.Decimal = Decimal;
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * Date is either a 32-bit or 64-bit type representing elapsed time since UNIX
 * epoch (1970-01-01), stored in either of two units:
 *
 * * Milliseconds (64 bits) indicating UNIX time elapsed since the epoch (no
 *   leap seconds), where the values are evenly divisible by 86400000
 * * Days (32 bits) since the UNIX epoch
 *
 * @constructor
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var Date = /** @class */ (function () {
                    function Date() {
                        /**
                         * @type {number}
                         */
                        this.bb_pos = 0;
                    }
                    /**
                     * @param {number} i
                     * @param {flatbuffers.ByteBuffer} bb
                     * @returns {Date}
                     */
                    Date.prototype.__init = function (i, bb) {
                        this.bb_pos = i;
                        this.bb = bb;
                        return this;
                    };
                    /**
                     * @param {flatbuffers.ByteBuffer} bb
                     * @param {Date=} obj
                     * @returns {Date}
                     */
                    Date.getRootAsDate = function (bb, obj) {
                        return (obj || new Date).__init(bb.readInt32(bb.position()) + bb.position(), bb);
                    };
                    /**
                     * @returns {org.apache.arrow.flatbuf.DateUnit}
                     */
                    Date.prototype.unit = function () {
                        var offset = this.bb.__offset(this.bb_pos, 4);
                        return offset ? /** @type {org.apache.arrow.flatbuf.DateUnit} */ (this.bb.readInt16(this.bb_pos + offset)) : org.apache.arrow.flatbuf.DateUnit.MILLISECOND;
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     */
                    Date.startDate = function (builder) {
                        builder.startObject(1);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {org.apache.arrow.flatbuf.DateUnit} unit
                     */
                    Date.addUnit = function (builder, unit) {
                        builder.addFieldInt16(0, unit, org.apache.arrow.flatbuf.DateUnit.MILLISECOND);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @returns {flatbuffers.Offset}
                     */
                    Date.endDate = function (builder) {
                        var offset = builder.endObject();
                        return offset;
                    };
                    return Date;
                }());
                flatbuf.Date = Date;
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * Time type. The physical storage type depends on the unit
 * - SECOND and MILLISECOND: 32 bits
 * - MICROSECOND and NANOSECOND: 64 bits
 *
 * @constructor
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var Time = /** @class */ (function () {
                    function Time() {
                        /**
                         * @type {number}
                         */
                        this.bb_pos = 0;
                    }
                    /**
                     * @param {number} i
                     * @param {flatbuffers.ByteBuffer} bb
                     * @returns {Time}
                     */
                    Time.prototype.__init = function (i, bb) {
                        this.bb_pos = i;
                        this.bb = bb;
                        return this;
                    };
                    /**
                     * @param {flatbuffers.ByteBuffer} bb
                     * @param {Time=} obj
                     * @returns {Time}
                     */
                    Time.getRootAsTime = function (bb, obj) {
                        return (obj || new Time).__init(bb.readInt32(bb.position()) + bb.position(), bb);
                    };
                    /**
                     * @returns {org.apache.arrow.flatbuf.TimeUnit}
                     */
                    Time.prototype.unit = function () {
                        var offset = this.bb.__offset(this.bb_pos, 4);
                        return offset ? /** @type {org.apache.arrow.flatbuf.TimeUnit} */ (this.bb.readInt16(this.bb_pos + offset)) : org.apache.arrow.flatbuf.TimeUnit.MILLISECOND;
                    };
                    /**
                     * @returns {number}
                     */
                    Time.prototype.bitWidth = function () {
                        var offset = this.bb.__offset(this.bb_pos, 6);
                        return offset ? this.bb.readInt32(this.bb_pos + offset) : 32;
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     */
                    Time.startTime = function (builder) {
                        builder.startObject(2);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {org.apache.arrow.flatbuf.TimeUnit} unit
                     */
                    Time.addUnit = function (builder, unit) {
                        builder.addFieldInt16(0, unit, org.apache.arrow.flatbuf.TimeUnit.MILLISECOND);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {number} bitWidth
                     */
                    Time.addBitWidth = function (builder, bitWidth) {
                        builder.addFieldInt32(1, bitWidth, 32);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @returns {flatbuffers.Offset}
                     */
                    Time.endTime = function (builder) {
                        var offset = builder.endObject();
                        return offset;
                    };
                    return Time;
                }());
                flatbuf.Time = Time;
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * Time elapsed from the Unix epoch, 00:00:00.000 on 1 January 1970, excluding
 * leap seconds, as a 64-bit integer. Note that UNIX time does not include
 * leap seconds.
 *
 * The Timestamp metadata supports both "time zone naive" and "time zone
 * aware" timestamps. Read about the timezone attribute for more detail
 *
 * @constructor
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var Timestamp = /** @class */ (function () {
                    function Timestamp() {
                        /**
                         * @type {number}
                         */
                        this.bb_pos = 0;
                    }
                    /**
                     * @param {number} i
                     * @param {flatbuffers.ByteBuffer} bb
                     * @returns {Timestamp}
                     */
                    Timestamp.prototype.__init = function (i, bb) {
                        this.bb_pos = i;
                        this.bb = bb;
                        return this;
                    };
                    /**
                     * @param {flatbuffers.ByteBuffer} bb
                     * @param {Timestamp=} obj
                     * @returns {Timestamp}
                     */
                    Timestamp.getRootAsTimestamp = function (bb, obj) {
                        return (obj || new Timestamp).__init(bb.readInt32(bb.position()) + bb.position(), bb);
                    };
                    /**
                     * @returns {org.apache.arrow.flatbuf.TimeUnit}
                     */
                    Timestamp.prototype.unit = function () {
                        var offset = this.bb.__offset(this.bb_pos, 4);
                        return offset ? /** @type {org.apache.arrow.flatbuf.TimeUnit} */ (this.bb.readInt16(this.bb_pos + offset)) : org.apache.arrow.flatbuf.TimeUnit.SECOND;
                    };
                    Timestamp.prototype.timezone = function (optionalEncoding) {
                        var offset = this.bb.__offset(this.bb_pos, 6);
                        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     */
                    Timestamp.startTimestamp = function (builder) {
                        builder.startObject(2);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {org.apache.arrow.flatbuf.TimeUnit} unit
                     */
                    Timestamp.addUnit = function (builder, unit) {
                        builder.addFieldInt16(0, unit, org.apache.arrow.flatbuf.TimeUnit.SECOND);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {flatbuffers.Offset} timezoneOffset
                     */
                    Timestamp.addTimezone = function (builder, timezoneOffset) {
                        builder.addFieldOffset(1, timezoneOffset, 0);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @returns {flatbuffers.Offset}
                     */
                    Timestamp.endTimestamp = function (builder) {
                        var offset = builder.endObject();
                        return offset;
                    };
                    return Timestamp;
                }());
                flatbuf.Timestamp = Timestamp;
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * @constructor
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var Interval = /** @class */ (function () {
                    function Interval() {
                        /**
                         * @type {number}
                         */
                        this.bb_pos = 0;
                    }
                    /**
                     * @param {number} i
                     * @param {flatbuffers.ByteBuffer} bb
                     * @returns {Interval}
                     */
                    Interval.prototype.__init = function (i, bb) {
                        this.bb_pos = i;
                        this.bb = bb;
                        return this;
                    };
                    /**
                     * @param {flatbuffers.ByteBuffer} bb
                     * @param {Interval=} obj
                     * @returns {Interval}
                     */
                    Interval.getRootAsInterval = function (bb, obj) {
                        return (obj || new Interval).__init(bb.readInt32(bb.position()) + bb.position(), bb);
                    };
                    /**
                     * @returns {org.apache.arrow.flatbuf.IntervalUnit}
                     */
                    Interval.prototype.unit = function () {
                        var offset = this.bb.__offset(this.bb_pos, 4);
                        return offset ? /** @type {org.apache.arrow.flatbuf.IntervalUnit} */ (this.bb.readInt16(this.bb_pos + offset)) : org.apache.arrow.flatbuf.IntervalUnit.YEAR_MONTH;
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     */
                    Interval.startInterval = function (builder) {
                        builder.startObject(1);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {org.apache.arrow.flatbuf.IntervalUnit} unit
                     */
                    Interval.addUnit = function (builder, unit) {
                        builder.addFieldInt16(0, unit, org.apache.arrow.flatbuf.IntervalUnit.YEAR_MONTH);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @returns {flatbuffers.Offset}
                     */
                    Interval.endInterval = function (builder) {
                        var offset = builder.endObject();
                        return offset;
                    };
                    return Interval;
                }());
                flatbuf.Interval = Interval;
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * ----------------------------------------------------------------------
 * represents the physical layout of a buffer
 * buffers have fixed width slots of a given type
 *
 * @constructor
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var VectorLayout = /** @class */ (function () {
                    function VectorLayout() {
                        /**
                         * @type {number}
                         */
                        this.bb_pos = 0;
                    }
                    /**
                     * @param {number} i
                     * @param {flatbuffers.ByteBuffer} bb
                     * @returns {VectorLayout}
                     */
                    VectorLayout.prototype.__init = function (i, bb) {
                        this.bb_pos = i;
                        this.bb = bb;
                        return this;
                    };
                    /**
                     * @param {flatbuffers.ByteBuffer} bb
                     * @param {VectorLayout=} obj
                     * @returns {VectorLayout}
                     */
                    VectorLayout.getRootAsVectorLayout = function (bb, obj) {
                        return (obj || new VectorLayout).__init(bb.readInt32(bb.position()) + bb.position(), bb);
                    };
                    /**
                     * the width of a slot in the buffer (typically 1, 8, 16, 32 or 64)
                     *
                     * @returns {number}
                     */
                    VectorLayout.prototype.bitWidth = function () {
                        var offset = this.bb.__offset(this.bb_pos, 4);
                        return offset ? this.bb.readInt16(this.bb_pos + offset) : 0;
                    };
                    /**
                     * the purpose of the vector
                     *
                     * @returns {org.apache.arrow.flatbuf.VectorType}
                     */
                    VectorLayout.prototype.type = function () {
                        var offset = this.bb.__offset(this.bb_pos, 6);
                        return offset ? /** @type {org.apache.arrow.flatbuf.VectorType} */ (this.bb.readInt16(this.bb_pos + offset)) : org.apache.arrow.flatbuf.VectorType.OFFSET;
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     */
                    VectorLayout.startVectorLayout = function (builder) {
                        builder.startObject(2);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {number} bitWidth
                     */
                    VectorLayout.addBitWidth = function (builder, bitWidth) {
                        builder.addFieldInt16(0, bitWidth, 0);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {org.apache.arrow.flatbuf.VectorType} type
                     */
                    VectorLayout.addType = function (builder, type) {
                        builder.addFieldInt16(1, type, org.apache.arrow.flatbuf.VectorType.OFFSET);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @returns {flatbuffers.Offset}
                     */
                    VectorLayout.endVectorLayout = function (builder) {
                        var offset = builder.endObject();
                        return offset;
                    };
                    return VectorLayout;
                }());
                flatbuf.VectorLayout = VectorLayout;
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * ----------------------------------------------------------------------
 * user defined key value pairs to add custom metadata to arrow
 * key namespacing is the responsibility of the user
 *
 * @constructor
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var KeyValue = /** @class */ (function () {
                    function KeyValue() {
                        /**
                         * @type {number}
                         */
                        this.bb_pos = 0;
                    }
                    /**
                     * @param {number} i
                     * @param {flatbuffers.ByteBuffer} bb
                     * @returns {KeyValue}
                     */
                    KeyValue.prototype.__init = function (i, bb) {
                        this.bb_pos = i;
                        this.bb = bb;
                        return this;
                    };
                    /**
                     * @param {flatbuffers.ByteBuffer} bb
                     * @param {KeyValue=} obj
                     * @returns {KeyValue}
                     */
                    KeyValue.getRootAsKeyValue = function (bb, obj) {
                        return (obj || new KeyValue).__init(bb.readInt32(bb.position()) + bb.position(), bb);
                    };
                    KeyValue.prototype.key = function (optionalEncoding) {
                        var offset = this.bb.__offset(this.bb_pos, 4);
                        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
                    };
                    KeyValue.prototype.value = function (optionalEncoding) {
                        var offset = this.bb.__offset(this.bb_pos, 6);
                        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     */
                    KeyValue.startKeyValue = function (builder) {
                        builder.startObject(2);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {flatbuffers.Offset} keyOffset
                     */
                    KeyValue.addKey = function (builder, keyOffset) {
                        builder.addFieldOffset(0, keyOffset, 0);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {flatbuffers.Offset} valueOffset
                     */
                    KeyValue.addValue = function (builder, valueOffset) {
                        builder.addFieldOffset(1, valueOffset, 0);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @returns {flatbuffers.Offset}
                     */
                    KeyValue.endKeyValue = function (builder) {
                        var offset = builder.endObject();
                        return offset;
                    };
                    return KeyValue;
                }());
                flatbuf.KeyValue = KeyValue;
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * ----------------------------------------------------------------------
 * Dictionary encoding metadata
 *
 * @constructor
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var DictionaryEncoding = /** @class */ (function () {
                    function DictionaryEncoding() {
                        /**
                         * @type {number}
                         */
                        this.bb_pos = 0;
                    }
                    /**
                     * @param {number} i
                     * @param {flatbuffers.ByteBuffer} bb
                     * @returns {DictionaryEncoding}
                     */
                    DictionaryEncoding.prototype.__init = function (i, bb) {
                        this.bb_pos = i;
                        this.bb = bb;
                        return this;
                    };
                    /**
                     * @param {flatbuffers.ByteBuffer} bb
                     * @param {DictionaryEncoding=} obj
                     * @returns {DictionaryEncoding}
                     */
                    DictionaryEncoding.getRootAsDictionaryEncoding = function (bb, obj) {
                        return (obj || new DictionaryEncoding).__init(bb.readInt32(bb.position()) + bb.position(), bb);
                    };
                    /**
                     * The known dictionary id in the application where this data is used. In
                     * the file or streaming formats, the dictionary ids are found in the
                     * DictionaryBatch messages
                     *
                     * @returns {flatbuffers.Long}
                     */
                    DictionaryEncoding.prototype.id = function () {
                        var offset = this.bb.__offset(this.bb_pos, 4);
                        return offset ? this.bb.readInt64(this.bb_pos + offset) : this.bb.createLong(0, 0);
                    };
                    /**
                     * The dictionary indices are constrained to be positive integers. If this
                     * field is null, the indices must be signed int32
                     *
                     * @param {org.apache.arrow.flatbuf.Int=} obj
                     * @returns {org.apache.arrow.flatbuf.Int|null}
                     */
                    DictionaryEncoding.prototype.indexType = function (obj) {
                        var offset = this.bb.__offset(this.bb_pos, 6);
                        return offset ? (obj || new org.apache.arrow.flatbuf.Int).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
                    };
                    /**
                     * By default, dictionaries are not ordered, or the order does not have
                     * semantic meaning. In some statistical, applications, dictionary-encoding
                     * is used to represent ordered categorical data, and we provide a way to
                     * preserve that metadata here
                     *
                     * @returns {boolean}
                     */
                    DictionaryEncoding.prototype.isOrdered = function () {
                        var offset = this.bb.__offset(this.bb_pos, 8);
                        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     */
                    DictionaryEncoding.startDictionaryEncoding = function (builder) {
                        builder.startObject(3);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {flatbuffers.Long} id
                     */
                    DictionaryEncoding.addId = function (builder, id) {
                        builder.addFieldInt64(0, id, builder.createLong(0, 0));
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {flatbuffers.Offset} indexTypeOffset
                     */
                    DictionaryEncoding.addIndexType = function (builder, indexTypeOffset) {
                        builder.addFieldOffset(1, indexTypeOffset, 0);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {boolean} isOrdered
                     */
                    DictionaryEncoding.addIsOrdered = function (builder, isOrdered) {
                        builder.addFieldInt8(2, +isOrdered, +false);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @returns {flatbuffers.Offset}
                     */
                    DictionaryEncoding.endDictionaryEncoding = function (builder) {
                        var offset = builder.endObject();
                        return offset;
                    };
                    return DictionaryEncoding;
                }());
                flatbuf.DictionaryEncoding = DictionaryEncoding;
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * ----------------------------------------------------------------------
 * A field represents a named column in a record / row batch or child of a
 * nested type.
 *
 * - children is only for nested Arrow arrays
 * - For primitive types, children will have length 0
 * - nullable should default to true in general
 *
 * @constructor
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var Field = /** @class */ (function () {
                    function Field() {
                        /**
                         * @type {number}
                         */
                        this.bb_pos = 0;
                    }
                    /**
                     * @param {number} i
                     * @param {flatbuffers.ByteBuffer} bb
                     * @returns {Field}
                     */
                    Field.prototype.__init = function (i, bb) {
                        this.bb_pos = i;
                        this.bb = bb;
                        return this;
                    };
                    /**
                     * @param {flatbuffers.ByteBuffer} bb
                     * @param {Field=} obj
                     * @returns {Field}
                     */
                    Field.getRootAsField = function (bb, obj) {
                        return (obj || new Field).__init(bb.readInt32(bb.position()) + bb.position(), bb);
                    };
                    Field.prototype.name = function (optionalEncoding) {
                        var offset = this.bb.__offset(this.bb_pos, 4);
                        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
                    };
                    /**
                     * @returns {boolean}
                     */
                    Field.prototype.nullable = function () {
                        var offset = this.bb.__offset(this.bb_pos, 6);
                        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
                    };
                    /**
                     * @returns {org.apache.arrow.flatbuf.Type}
                     */
                    Field.prototype.typeType = function () {
                        var offset = this.bb.__offset(this.bb_pos, 8);
                        return offset ? /** @type {org.apache.arrow.flatbuf.Type} */ (this.bb.readUint8(this.bb_pos + offset)) : org.apache.arrow.flatbuf.Type.NONE;
                    };
                    /**
                     * @param {flatbuffers.Table} obj
                     * @returns {?flatbuffers.Table}
                     */
                    Field.prototype.type = function (obj) {
                        var offset = this.bb.__offset(this.bb_pos, 10);
                        return offset ? this.bb.__union(obj, this.bb_pos + offset) : null;
                    };
                    /**
                     * @param {org.apache.arrow.flatbuf.DictionaryEncoding=} obj
                     * @returns {org.apache.arrow.flatbuf.DictionaryEncoding|null}
                     */
                    Field.prototype.dictionary = function (obj) {
                        var offset = this.bb.__offset(this.bb_pos, 12);
                        return offset ? (obj || new org.apache.arrow.flatbuf.DictionaryEncoding).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
                    };
                    /**
                     * @param {number} index
                     * @param {org.apache.arrow.flatbuf.Field=} obj
                     * @returns {org.apache.arrow.flatbuf.Field}
                     */
                    Field.prototype.children = function (index, obj) {
                        var offset = this.bb.__offset(this.bb_pos, 14);
                        return offset ? (obj || new org.apache.arrow.flatbuf.Field).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
                    };
                    /**
                     * @returns {number}
                     */
                    Field.prototype.childrenLength = function () {
                        var offset = this.bb.__offset(this.bb_pos, 14);
                        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
                    };
                    /**
                     * layout of buffers produced for this type (as derived from the Type)
                     * does not include children
                     * each recordbatch will return instances of those Buffers.
                     *
                     * @param {number} index
                     * @param {org.apache.arrow.flatbuf.VectorLayout=} obj
                     * @returns {org.apache.arrow.flatbuf.VectorLayout}
                     */
                    Field.prototype.layout = function (index, obj) {
                        var offset = this.bb.__offset(this.bb_pos, 16);
                        return offset ? (obj || new org.apache.arrow.flatbuf.VectorLayout).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
                    };
                    /**
                     * @returns {number}
                     */
                    Field.prototype.layoutLength = function () {
                        var offset = this.bb.__offset(this.bb_pos, 16);
                        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
                    };
                    /**
                     * @param {number} index
                     * @param {org.apache.arrow.flatbuf.KeyValue=} obj
                     * @returns {org.apache.arrow.flatbuf.KeyValue}
                     */
                    Field.prototype.customMetadata = function (index, obj) {
                        var offset = this.bb.__offset(this.bb_pos, 18);
                        return offset ? (obj || new org.apache.arrow.flatbuf.KeyValue).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
                    };
                    /**
                     * @returns {number}
                     */
                    Field.prototype.customMetadataLength = function () {
                        var offset = this.bb.__offset(this.bb_pos, 18);
                        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     */
                    Field.startField = function (builder) {
                        builder.startObject(8);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {flatbuffers.Offset} nameOffset
                     */
                    Field.addName = function (builder, nameOffset) {
                        builder.addFieldOffset(0, nameOffset, 0);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {boolean} nullable
                     */
                    Field.addNullable = function (builder, nullable) {
                        builder.addFieldInt8(1, +nullable, +false);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {org.apache.arrow.flatbuf.Type} typeType
                     */
                    Field.addTypeType = function (builder, typeType) {
                        builder.addFieldInt8(2, typeType, org.apache.arrow.flatbuf.Type.NONE);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {flatbuffers.Offset} typeOffset
                     */
                    Field.addType = function (builder, typeOffset) {
                        builder.addFieldOffset(3, typeOffset, 0);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {flatbuffers.Offset} dictionaryOffset
                     */
                    Field.addDictionary = function (builder, dictionaryOffset) {
                        builder.addFieldOffset(4, dictionaryOffset, 0);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {flatbuffers.Offset} childrenOffset
                     */
                    Field.addChildren = function (builder, childrenOffset) {
                        builder.addFieldOffset(5, childrenOffset, 0);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {Array.<flatbuffers.Offset>} data
                     * @returns {flatbuffers.Offset}
                     */
                    Field.createChildrenVector = function (builder, data) {
                        builder.startVector(4, data.length, 4);
                        for (var i = data.length - 1; i >= 0; i--) {
                            builder.addOffset(data[i]);
                        }
                        return builder.endVector();
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {number} numElems
                     */
                    Field.startChildrenVector = function (builder, numElems) {
                        builder.startVector(4, numElems, 4);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {flatbuffers.Offset} layoutOffset
                     */
                    Field.addLayout = function (builder, layoutOffset) {
                        builder.addFieldOffset(6, layoutOffset, 0);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {Array.<flatbuffers.Offset>} data
                     * @returns {flatbuffers.Offset}
                     */
                    Field.createLayoutVector = function (builder, data) {
                        builder.startVector(4, data.length, 4);
                        for (var i = data.length - 1; i >= 0; i--) {
                            builder.addOffset(data[i]);
                        }
                        return builder.endVector();
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {number} numElems
                     */
                    Field.startLayoutVector = function (builder, numElems) {
                        builder.startVector(4, numElems, 4);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {flatbuffers.Offset} customMetadataOffset
                     */
                    Field.addCustomMetadata = function (builder, customMetadataOffset) {
                        builder.addFieldOffset(7, customMetadataOffset, 0);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {Array.<flatbuffers.Offset>} data
                     * @returns {flatbuffers.Offset}
                     */
                    Field.createCustomMetadataVector = function (builder, data) {
                        builder.startVector(4, data.length, 4);
                        for (var i = data.length - 1; i >= 0; i--) {
                            builder.addOffset(data[i]);
                        }
                        return builder.endVector();
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {number} numElems
                     */
                    Field.startCustomMetadataVector = function (builder, numElems) {
                        builder.startVector(4, numElems, 4);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @returns {flatbuffers.Offset}
                     */
                    Field.endField = function (builder) {
                        var offset = builder.endObject();
                        return offset;
                    };
                    return Field;
                }());
                flatbuf.Field = Field;
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * ----------------------------------------------------------------------
 * A Buffer represents a single contiguous memory segment
 *
 * @constructor
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var Buffer = /** @class */ (function () {
                    function Buffer() {
                        /**
                         * @type {number}
                         */
                        this.bb_pos = 0;
                    }
                    /**
                     * @param {number} i
                     * @param {flatbuffers.ByteBuffer} bb
                     * @returns {Buffer}
                     */
                    Buffer.prototype.__init = function (i, bb) {
                        this.bb_pos = i;
                        this.bb = bb;
                        return this;
                    };
                    /**
                     * The relative offset into the shared memory page where the bytes for this
                     * buffer starts
                     *
                     * @returns {flatbuffers.Long}
                     */
                    Buffer.prototype.offset = function () {
                        return this.bb.readInt64(this.bb_pos);
                    };
                    /**
                     * The absolute length (in bytes) of the memory buffer. The memory is found
                     * from offset (inclusive) to offset + length (non-inclusive).
                     *
                     * @returns {flatbuffers.Long}
                     */
                    Buffer.prototype.length = function () {
                        return this.bb.readInt64(this.bb_pos + 8);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {flatbuffers.Long} offset
                     * @param {flatbuffers.Long} length
                     * @returns {flatbuffers.Offset}
                     */
                    Buffer.createBuffer = function (builder, offset, length) {
                        builder.prep(8, 16);
                        builder.writeInt64(length);
                        builder.writeInt64(offset);
                        return builder.offset();
                    };
                    return Buffer;
                }());
                flatbuf.Buffer = Buffer;
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * ----------------------------------------------------------------------
 * A Schema describes the columns in a row batch
 *
 * @constructor
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var Schema = /** @class */ (function () {
                    function Schema() {
                        /**
                         * @type {number}
                         */
                        this.bb_pos = 0;
                    }
                    /**
                     * @param {number} i
                     * @param {flatbuffers.ByteBuffer} bb
                     * @returns {Schema}
                     */
                    Schema.prototype.__init = function (i, bb) {
                        this.bb_pos = i;
                        this.bb = bb;
                        return this;
                    };
                    /**
                     * @param {flatbuffers.ByteBuffer} bb
                     * @param {Schema=} obj
                     * @returns {Schema}
                     */
                    Schema.getRootAsSchema = function (bb, obj) {
                        return (obj || new Schema).__init(bb.readInt32(bb.position()) + bb.position(), bb);
                    };
                    /**
                     * endianness of the buffer
                     * it is Little Endian by default
                     * if endianness doesn't match the underlying system then the vectors need to be converted
                     *
                     * @returns {org.apache.arrow.flatbuf.Endianness}
                     */
                    Schema.prototype.endianness = function () {
                        var offset = this.bb.__offset(this.bb_pos, 4);
                        return offset ? /** @type {org.apache.arrow.flatbuf.Endianness} */ (this.bb.readInt16(this.bb_pos + offset)) : org.apache.arrow.flatbuf.Endianness.Little;
                    };
                    /**
                     * @param {number} index
                     * @param {org.apache.arrow.flatbuf.Field=} obj
                     * @returns {org.apache.arrow.flatbuf.Field}
                     */
                    Schema.prototype.fields = function (index, obj) {
                        var offset = this.bb.__offset(this.bb_pos, 6);
                        return offset ? (obj || new org.apache.arrow.flatbuf.Field).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
                    };
                    /**
                     * @returns {number}
                     */
                    Schema.prototype.fieldsLength = function () {
                        var offset = this.bb.__offset(this.bb_pos, 6);
                        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
                    };
                    /**
                     * @param {number} index
                     * @param {org.apache.arrow.flatbuf.KeyValue=} obj
                     * @returns {org.apache.arrow.flatbuf.KeyValue}
                     */
                    Schema.prototype.customMetadata = function (index, obj) {
                        var offset = this.bb.__offset(this.bb_pos, 8);
                        return offset ? (obj || new org.apache.arrow.flatbuf.KeyValue).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
                    };
                    /**
                     * @returns {number}
                     */
                    Schema.prototype.customMetadataLength = function () {
                        var offset = this.bb.__offset(this.bb_pos, 8);
                        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     */
                    Schema.startSchema = function (builder) {
                        builder.startObject(3);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {org.apache.arrow.flatbuf.Endianness} endianness
                     */
                    Schema.addEndianness = function (builder, endianness) {
                        builder.addFieldInt16(0, endianness, org.apache.arrow.flatbuf.Endianness.Little);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {flatbuffers.Offset} fieldsOffset
                     */
                    Schema.addFields = function (builder, fieldsOffset) {
                        builder.addFieldOffset(1, fieldsOffset, 0);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {Array.<flatbuffers.Offset>} data
                     * @returns {flatbuffers.Offset}
                     */
                    Schema.createFieldsVector = function (builder, data) {
                        builder.startVector(4, data.length, 4);
                        for (var i = data.length - 1; i >= 0; i--) {
                            builder.addOffset(data[i]);
                        }
                        return builder.endVector();
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {number} numElems
                     */
                    Schema.startFieldsVector = function (builder, numElems) {
                        builder.startVector(4, numElems, 4);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {flatbuffers.Offset} customMetadataOffset
                     */
                    Schema.addCustomMetadata = function (builder, customMetadataOffset) {
                        builder.addFieldOffset(2, customMetadataOffset, 0);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {Array.<flatbuffers.Offset>} data
                     * @returns {flatbuffers.Offset}
                     */
                    Schema.createCustomMetadataVector = function (builder, data) {
                        builder.startVector(4, data.length, 4);
                        for (var i = data.length - 1; i >= 0; i--) {
                            builder.addOffset(data[i]);
                        }
                        return builder.endVector();
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {number} numElems
                     */
                    Schema.startCustomMetadataVector = function (builder, numElems) {
                        builder.startVector(4, numElems, 4);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @returns {flatbuffers.Offset}
                     */
                    Schema.endSchema = function (builder) {
                        var offset = builder.endObject();
                        return offset;
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {flatbuffers.Offset} offset
                     */
                    Schema.finishSchemaBuffer = function (builder, offset) {
                        builder.finish(offset);
                    };
                    return Schema;
                }());
                flatbuf.Schema = Schema;
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));



/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Chunked; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vector__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_vector__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__type__ = __webpack_require__(3);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.




/** @ignore */
var Chunked = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Chunked, _super);
    function Chunked(type, chunks, offsets) {
        if (chunks === void 0) { chunks = []; }
        if (offsets === void 0) { offsets = calculateOffsets(chunks); }
        var _this = _super.call(this) || this;
        _this._nullCount = -1;
        _this._type = type;
        _this._chunks = chunks;
        _this._chunkOffsets = offsets;
        _this._length = offsets[offsets.length - 1];
        _this._numChildren = (_this._type.children || []).length;
        return _this;
    }
    /** @nocollapse */
    Chunked.flatten = function () {
        var vectors = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            vectors[_i] = arguments[_i];
        }
        return vectors.reduce(function flatten(xs, x) {
            return x instanceof Chunked ? x.chunks.reduce(flatten, xs) : __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](xs, [x]);
        }, []).filter(function (x) { return x instanceof __WEBPACK_IMPORTED_MODULE_1__vector__["Vector"]; });
    };
    /** @nocollapse */
    Chunked.concat = function () {
        var chunks = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            chunks[_i] = arguments[_i];
        }
        return new Chunked(chunks[0].type, Chunked.flatten.apply(Chunked, __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](chunks)));
    };
    Object.defineProperty(Chunked.prototype, "type", {
        get: function () { return this._type; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Chunked.prototype, "length", {
        get: function () { return this._length; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Chunked.prototype, "chunks", {
        get: function () { return this._chunks; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Chunked.prototype, "typeId", {
        get: function () { return this._type.typeId; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Chunked.prototype, "data", {
        get: function () {
            return this._chunks[0] ? this._chunks[0].data : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Chunked.prototype, "ArrayType", {
        get: function () { return this._type.ArrayType; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Chunked.prototype, "numChildren", {
        get: function () { return this._numChildren; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Chunked.prototype, "stride", {
        get: function () { return this._chunks[0] ? this._chunks[0].stride : 1; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Chunked.prototype, "nullCount", {
        get: function () {
            var nullCount = this._nullCount;
            if (nullCount < 0) {
                this._nullCount = nullCount = this._chunks.reduce(function (x, _a) {
                    var nullCount = _a.nullCount;
                    return x + nullCount;
                }, 0);
            }
            return nullCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Chunked.prototype, "indices", {
        get: function () {
            if (__WEBPACK_IMPORTED_MODULE_3__type__["DataType"].isDictionary(this._type)) {
                if (!this._indices) {
                    var chunks = this._chunks;
                    this._indices = (chunks.length === 1
                        ? chunks[0].indices
                        : Chunked.concat.apply(Chunked, __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](chunks.map(function (x) { return x.indices; }))));
                }
                return this._indices;
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Chunked.prototype, "dictionary", {
        get: function () {
            if (__WEBPACK_IMPORTED_MODULE_3__type__["DataType"].isDictionary(this._type)) {
                return this._type.dictionaryVector;
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Chunked.prototype[Symbol.iterator] = function () {
        var e_1, _a, _b, _c, chunk, e_1_1;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 5, 6, 7]);
                    _b = __WEBPACK_IMPORTED_MODULE_0_tslib__["k" /* __values */](this._chunks), _c = _b.next();
                    _d.label = 1;
                case 1:
                    if (!!_c.done) return [3 /*break*/, 4];
                    chunk = _c.value;
                    return [5 /*yield**/, __WEBPACK_IMPORTED_MODULE_0_tslib__["k" /* __values */](chunk)];
                case 2:
                    _d.sent();
                    _d.label = 3;
                case 3:
                    _c = _b.next();
                    return [3 /*break*/, 1];
                case 4: return [3 /*break*/, 7];
                case 5:
                    e_1_1 = _d.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 7];
                case 6:
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    };
    Chunked.prototype.clone = function (chunks) {
        if (chunks === void 0) { chunks = this._chunks; }
        return new Chunked(this._type, chunks);
    };
    Chunked.prototype.concat = function () {
        var others = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            others[_i] = arguments[_i];
        }
        return this.clone(Chunked.flatten.apply(Chunked, __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */]([this], others)));
    };
    Chunked.prototype.slice = function (begin, end) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__util_vector__["a" /* clampRange */])(this, begin, end, this._sliceInternal);
    };
    Chunked.prototype.getChildAt = function (index) {
        if (index < 0 || index >= this._numChildren) {
            return null;
        }
        var columns = this._children || (this._children = []);
        var child, field, chunks;
        if (child = columns[index]) {
            return child;
        }
        if (field = (this._type.children || [])[index]) {
            chunks = this._chunks
                .map(function (vector) { return vector.getChildAt(index); })
                .filter(function (vec) { return vec != null; });
            if (chunks.length > 0) {
                return (columns[index] = new Chunked(field.type, chunks));
            }
        }
        return null;
    };
    Chunked.prototype.search = function (index, then) {
        var idx = index;
        // binary search to find the child vector and value indices
        var offsets = this._chunkOffsets, rhs = offsets.length - 1;
        // return early if out of bounds, or if there's just one child
        if (idx < 0) {
            return null;
        }
        if (idx >= offsets[rhs]) {
            return null;
        }
        if (rhs <= 1) {
            return then ? then(this, 0, idx) : [0, idx];
        }
        var lhs = 0, pos = 0, mid = 0;
        do {
            if (lhs + 1 === rhs) {
                return then ? then(this, lhs, idx - pos) : [lhs, idx - pos];
            }
            mid = lhs + ((rhs - lhs) / 2) | 0;
            idx >= offsets[mid] ? (lhs = mid) : (rhs = mid);
        } while (idx < offsets[rhs] && idx >= (pos = offsets[lhs]));
        return null;
    };
    Chunked.prototype.isValid = function (index) {
        return !!this.search(index, this.isValidInternal);
    };
    Chunked.prototype.get = function (index) {
        return this.search(index, this.getInternal);
    };
    Chunked.prototype.set = function (index, value) {
        this.search(index, function (_a, i, j) {
            var chunks = _a.chunks;
            return chunks[i].set(j, value);
        });
    };
    Chunked.prototype.indexOf = function (element, offset) {
        var _this = this;
        if (offset && typeof offset === 'number') {
            return this.search(offset, function (self, i, j) { return _this.indexOfInternal(self, i, j, element); });
        }
        return this.indexOfInternal(this, 0, Math.max(0, offset || 0), element);
    };
    Chunked.prototype.toArray = function () {
        var chunks = this.chunks;
        var n = chunks.length;
        var ArrayType = this._type.ArrayType;
        if (n <= 0) {
            return new ArrayType(0);
        }
        if (n <= 1) {
            return chunks[0].toArray();
        }
        var len = 0, src = new Array(n);
        for (var i = -1; ++i < n;) {
            len += (src[i] = chunks[i].toArray()).length;
        }
        if (ArrayType !== src[0].constructor) {
            ArrayType = src[0].constructor;
        }
        var dst = new ArrayType(len);
        var set = ArrayType === Array ? arraySet : typedSet;
        for (var i = -1, idx = 0; ++i < n;) {
            idx = set(src[i], dst, idx);
        }
        return dst;
    };
    Chunked.prototype.getInternal = function (_a, i, j) {
        var _chunks = _a._chunks;
        return _chunks[i].get(j);
    };
    Chunked.prototype.isValidInternal = function (_a, i, j) {
        var _chunks = _a._chunks;
        return _chunks[i].isValid(j);
    };
    Chunked.prototype.indexOfInternal = function (_a, chunkIndex, fromIndex, element) {
        var _chunks = _a._chunks;
        var i = chunkIndex - 1, n = _chunks.length;
        var start = fromIndex, offset = 0, found = -1;
        while (++i < n) {
            if (~(found = _chunks[i].indexOf(element, start))) {
                return offset + found;
            }
            start = 0;
            offset += _chunks[i].length;
        }
        return -1;
    };
    Chunked.prototype._sliceInternal = function (self, begin, end) {
        var slices = [];
        var chunks = self.chunks, chunkOffsets = self._chunkOffsets;
        for (var i = -1, n = chunks.length; ++i < n;) {
            var chunk = chunks[i];
            var chunkLength = chunk.length;
            var chunkOffset = chunkOffsets[i];
            // If the child is to the right of the slice boundary, we can stop
            if (chunkOffset >= end) {
                break;
            }
            // If the child is to the left of of the slice boundary, exclude
            if (begin >= chunkOffset + chunkLength) {
                continue;
            }
            // If the child is between both left and right boundaries, include w/o slicing
            if (chunkOffset >= begin && (chunkOffset + chunkLength) <= end) {
                slices.push(chunk);
                continue;
            }
            // If the child overlaps one of the slice boundaries, include that slice
            var from = Math.max(0, begin - chunkOffset);
            var to = from + Math.min(chunkLength - from, end - chunkOffset);
            slices.push(chunk.slice(from, to));
        }
        return self.clone(slices);
    };
    return Chunked;
}(__WEBPACK_IMPORTED_MODULE_1__vector__["Vector"]));

/** @ignore */
function calculateOffsets(vectors) {
    var offsets = new Uint32Array((vectors || []).length + 1);
    var offset = offsets[0] = 0, length = offsets.length;
    for (var index = 0; ++index < length;) {
        offsets[index] = (offset += vectors[index - 1].length);
    }
    return offsets;
}
/** @ignore */
var typedSet = function (src, dst, offset) {
    dst.set(src, offset);
    return (offset + src.length);
};
/** @ignore */
var arraySet = function (src, dst, offset) {
    var idx = offset - 1;
    for (var i = -1, n = src.length; ++i < n;) {
        dst[++idx] = src[i];
    }
    return idx;
};



/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return flatbuffers; });
/// @file
/// @addtogroup flatbuffers_javascript_api
/// @{
/// @cond FLATBUFFERS_INTERNAL

/**
 * @fileoverview
 *
 * Need to suppress 'global this' error so the Node.js export line doesn't cause
 * closure compile to error out.
 * @suppress {globalThis}
 */

/**
 * @const
 * @namespace
 */
var flatbuffers = {};

/**
 * @typedef {number}
 */
flatbuffers.Offset;

/**
 * @typedef {{
 *   bb: flatbuffers.ByteBuffer,
 *   bb_pos: number
 * }}
 */
flatbuffers.Table;

/**
 * @type {number}
 * @const
 */
flatbuffers.SIZEOF_SHORT = 2;

/**
 * @type {number}
 * @const
 */
flatbuffers.SIZEOF_INT = 4;

/**
 * @type {number}
 * @const
 */
flatbuffers.FILE_IDENTIFIER_LENGTH = 4;

/**
 * @enum {number}
 */
flatbuffers.Encoding = {
  UTF8_BYTES: 1,
  UTF16_STRING: 2
};

/**
 * @type {Int32Array}
 * @const
 */
flatbuffers.int32 = new Int32Array(2);

/**
 * @type {Float32Array}
 * @const
 */
flatbuffers.float32 = new Float32Array(flatbuffers.int32.buffer);

/**
 * @type {Float64Array}
 * @const
 */
flatbuffers.float64 = new Float64Array(flatbuffers.int32.buffer);

/**
 * @type {boolean}
 * @const
 */
flatbuffers.isLittleEndian = new Uint16Array(new Uint8Array([1, 0]).buffer)[0] === 1;

////////////////////////////////////////////////////////////////////////////////

/**
 * @constructor
 * @param {number} low
 * @param {number} high
 */
flatbuffers.Long = function(low, high) {
  /**
   * @type {number}
   * @const
   */
  this.low = low | 0;

  /**
   * @type {number}
   * @const
   */
  this.high = high | 0;
};

/**
 * @param {number} low
 * @param {number} high
 * @returns {flatbuffers.Long}
 */
flatbuffers.Long.create = function(low, high) {
  // Special-case zero to avoid GC overhead for default values
  return low == 0 && high == 0 ? flatbuffers.Long.ZERO : new flatbuffers.Long(low, high);
};

/**
 * @returns {number}
 */
flatbuffers.Long.prototype.toFloat64 = function() {
  return (this.low >>> 0) + this.high * 0x100000000;
};

/**
 * @param {flatbuffers.Long} other
 * @returns {boolean}
 */
flatbuffers.Long.prototype.equals = function(other) {
  return this.low == other.low && this.high == other.high;
};

/**
 * @type {flatbuffers.Long}
 * @const
 */
flatbuffers.Long.ZERO = new flatbuffers.Long(0, 0);

/// @endcond
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a FlatBufferBuilder.
 *
 * @constructor
 * @param {number=} opt_initial_size
 */
flatbuffers.Builder = function(opt_initial_size) {
  if (!opt_initial_size) {
    var initial_size = 1024;
  } else {
    var initial_size = opt_initial_size;
  }

  /**
   * @type {flatbuffers.ByteBuffer}
   * @private
   */
  this.bb = flatbuffers.ByteBuffer.allocate(initial_size);

  /**
   * Remaining space in the ByteBuffer.
   *
   * @type {number}
   * @private
   */
  this.space = initial_size;

  /**
   * Minimum alignment encountered so far.
   *
   * @type {number}
   * @private
   */
  this.minalign = 1;

  /**
   * The vtable for the current table.
   *
   * @type {Array.<number>}
   * @private
   */
  this.vtable = null;

  /**
   * The amount of fields we're actually using.
   *
   * @type {number}
   * @private
   */
  this.vtable_in_use = 0;

  /**
   * Whether we are currently serializing a table.
   *
   * @type {boolean}
   * @private
   */
  this.isNested = false;

  /**
   * Starting offset of the current struct/table.
   *
   * @type {number}
   * @private
   */
  this.object_start = 0;

  /**
   * List of offsets of all vtables.
   *
   * @type {Array.<number>}
   * @private
   */
  this.vtables = [];

  /**
   * For the current vector being built.
   *
   * @type {number}
   * @private
   */
  this.vector_num_elems = 0;

  /**
   * False omits default values from the serialized data
   *
   * @type {boolean}
   * @private
   */
  this.force_defaults = false;
};

/**
 * In order to save space, fields that are set to their default value
 * don't get serialized into the buffer. Forcing defaults provides a
 * way to manually disable this optimization.
 *
 * @param {boolean} forceDefaults true always serializes default values
 */
flatbuffers.Builder.prototype.forceDefaults = function(forceDefaults) {
  this.force_defaults = forceDefaults;
};

/**
 * Get the ByteBuffer representing the FlatBuffer. Only call this after you've
 * called finish(). The actual data starts at the ByteBuffer's current position,
 * not necessarily at 0.
 *
 * @returns {flatbuffers.ByteBuffer}
 */
flatbuffers.Builder.prototype.dataBuffer = function() {
  return this.bb;
};

/**
 * Get the bytes representing the FlatBuffer. Only call this after you've
 * called finish().
 *
 * @returns {Uint8Array}
 */
flatbuffers.Builder.prototype.asUint8Array = function() {
  return this.bb.bytes().subarray(this.bb.position(), this.bb.position() + this.offset());
};

/// @cond FLATBUFFERS_INTERNAL
/**
 * Prepare to write an element of `size` after `additional_bytes` have been
 * written, e.g. if you write a string, you need to align such the int length
 * field is aligned to 4 bytes, and the string data follows it directly. If all
 * you need to do is alignment, `additional_bytes` will be 0.
 *
 * @param {number} size This is the of the new element to write
 * @param {number} additional_bytes The padding size
 */
flatbuffers.Builder.prototype.prep = function(size, additional_bytes) {
  // Track the biggest thing we've ever aligned to.
  if (size > this.minalign) {
    this.minalign = size;
  }

  // Find the amount of alignment needed such that `size` is properly
  // aligned after `additional_bytes`
  var align_size = ((~(this.bb.capacity() - this.space + additional_bytes)) + 1) & (size - 1);

  // Reallocate the buffer if needed.
  while (this.space < align_size + size + additional_bytes) {
    var old_buf_size = this.bb.capacity();
    this.bb = flatbuffers.Builder.growByteBuffer(this.bb);
    this.space += this.bb.capacity() - old_buf_size;
  }

  this.pad(align_size);
};

/**
 * @param {number} byte_size
 */
flatbuffers.Builder.prototype.pad = function(byte_size) {
  for (var i = 0; i < byte_size; i++) {
    this.bb.writeInt8(--this.space, 0);
  }
};

/**
 * @param {number} value
 */
flatbuffers.Builder.prototype.writeInt8 = function(value) {
  this.bb.writeInt8(this.space -= 1, value);
};

/**
 * @param {number} value
 */
flatbuffers.Builder.prototype.writeInt16 = function(value) {
  this.bb.writeInt16(this.space -= 2, value);
};

/**
 * @param {number} value
 */
flatbuffers.Builder.prototype.writeInt32 = function(value) {
  this.bb.writeInt32(this.space -= 4, value);
};

/**
 * @param {flatbuffers.Long} value
 */
flatbuffers.Builder.prototype.writeInt64 = function(value) {
  this.bb.writeInt64(this.space -= 8, value);
};

/**
 * @param {number} value
 */
flatbuffers.Builder.prototype.writeFloat32 = function(value) {
  this.bb.writeFloat32(this.space -= 4, value);
};

/**
 * @param {number} value
 */
flatbuffers.Builder.prototype.writeFloat64 = function(value) {
  this.bb.writeFloat64(this.space -= 8, value);
};
/// @endcond

/**
 * Add an `int8` to the buffer, properly aligned, and grows the buffer (if necessary).
 * @param {number} value The `int8` to add the the buffer.
 */
flatbuffers.Builder.prototype.addInt8 = function(value) {
  this.prep(1, 0);
  this.writeInt8(value);
};

/**
 * Add an `int16` to the buffer, properly aligned, and grows the buffer (if necessary).
 * @param {number} value The `int16` to add the the buffer.
 */
flatbuffers.Builder.prototype.addInt16 = function(value) {
  this.prep(2, 0);
  this.writeInt16(value);
};

/**
 * Add an `int32` to the buffer, properly aligned, and grows the buffer (if necessary).
 * @param {number} value The `int32` to add the the buffer.
 */
flatbuffers.Builder.prototype.addInt32 = function(value) {
  this.prep(4, 0);
  this.writeInt32(value);
};

/**
 * Add an `int64` to the buffer, properly aligned, and grows the buffer (if necessary).
 * @param {flatbuffers.Long} value The `int64` to add the the buffer.
 */
flatbuffers.Builder.prototype.addInt64 = function(value) {
  this.prep(8, 0);
  this.writeInt64(value);
};

/**
 * Add a `float32` to the buffer, properly aligned, and grows the buffer (if necessary).
 * @param {number} value The `float32` to add the the buffer.
 */
flatbuffers.Builder.prototype.addFloat32 = function(value) {
  this.prep(4, 0);
  this.writeFloat32(value);
};

/**
 * Add a `float64` to the buffer, properly aligned, and grows the buffer (if necessary).
 * @param {number} value The `float64` to add the the buffer.
 */
flatbuffers.Builder.prototype.addFloat64 = function(value) {
  this.prep(8, 0);
  this.writeFloat64(value);
};

/// @cond FLATBUFFERS_INTERNAL
/**
 * @param {number} voffset
 * @param {number} value
 * @param {number} defaultValue
 */
flatbuffers.Builder.prototype.addFieldInt8 = function(voffset, value, defaultValue) {
  if (this.force_defaults || value != defaultValue) {
    this.addInt8(value);
    this.slot(voffset);
  }
};

/**
 * @param {number} voffset
 * @param {number} value
 * @param {number} defaultValue
 */
flatbuffers.Builder.prototype.addFieldInt16 = function(voffset, value, defaultValue) {
  if (this.force_defaults || value != defaultValue) {
    this.addInt16(value);
    this.slot(voffset);
  }
};

/**
 * @param {number} voffset
 * @param {number} value
 * @param {number} defaultValue
 */
flatbuffers.Builder.prototype.addFieldInt32 = function(voffset, value, defaultValue) {
  if (this.force_defaults || value != defaultValue) {
    this.addInt32(value);
    this.slot(voffset);
  }
};

/**
 * @param {number} voffset
 * @param {flatbuffers.Long} value
 * @param {flatbuffers.Long} defaultValue
 */
flatbuffers.Builder.prototype.addFieldInt64 = function(voffset, value, defaultValue) {
  if (this.force_defaults || !value.equals(defaultValue)) {
    this.addInt64(value);
    this.slot(voffset);
  }
};

/**
 * @param {number} voffset
 * @param {number} value
 * @param {number} defaultValue
 */
flatbuffers.Builder.prototype.addFieldFloat32 = function(voffset, value, defaultValue) {
  if (this.force_defaults || value != defaultValue) {
    this.addFloat32(value);
    this.slot(voffset);
  }
};

/**
 * @param {number} voffset
 * @param {number} value
 * @param {number} defaultValue
 */
flatbuffers.Builder.prototype.addFieldFloat64 = function(voffset, value, defaultValue) {
  if (this.force_defaults || value != defaultValue) {
    this.addFloat64(value);
    this.slot(voffset);
  }
};

/**
 * @param {number} voffset
 * @param {flatbuffers.Offset} value
 * @param {flatbuffers.Offset} defaultValue
 */
flatbuffers.Builder.prototype.addFieldOffset = function(voffset, value, defaultValue) {
  if (this.force_defaults || value != defaultValue) {
    this.addOffset(value);
    this.slot(voffset);
  }
};

/**
 * Structs are stored inline, so nothing additional is being added. `d` is always 0.
 *
 * @param {number} voffset
 * @param {flatbuffers.Offset} value
 * @param {flatbuffers.Offset} defaultValue
 */
flatbuffers.Builder.prototype.addFieldStruct = function(voffset, value, defaultValue) {
  if (value != defaultValue) {
    this.nested(value);
    this.slot(voffset);
  }
};

/**
 * Structures are always stored inline, they need to be created right
 * where they're used.  You'll get this assertion failure if you
 * created it elsewhere.
 *
 * @param {flatbuffers.Offset} obj The offset of the created object
 */
flatbuffers.Builder.prototype.nested = function(obj) {
  if (obj != this.offset()) {
    throw new Error('FlatBuffers: struct must be serialized inline.');
  }
};

/**
 * Should not be creating any other object, string or vector
 * while an object is being constructed
 */
flatbuffers.Builder.prototype.notNested = function() {
  if (this.isNested) {
    throw new Error('FlatBuffers: object serialization must not be nested.');
  }
};

/**
 * Set the current vtable at `voffset` to the current location in the buffer.
 *
 * @param {number} voffset
 */
flatbuffers.Builder.prototype.slot = function(voffset) {
  this.vtable[voffset] = this.offset();
};

/**
 * @returns {flatbuffers.Offset} Offset relative to the end of the buffer.
 */
flatbuffers.Builder.prototype.offset = function() {
  return this.bb.capacity() - this.space;
};

/**
 * Doubles the size of the backing ByteBuffer and copies the old data towards
 * the end of the new buffer (since we build the buffer backwards).
 *
 * @param {flatbuffers.ByteBuffer} bb The current buffer with the existing data
 * @returns {flatbuffers.ByteBuffer} A new byte buffer with the old data copied
 * to it. The data is located at the end of the buffer.
 *
 * uint8Array.set() formally takes {Array<number>|ArrayBufferView}, so to pass
 * it a uint8Array we need to suppress the type check:
 * @suppress {checkTypes}
 */
flatbuffers.Builder.growByteBuffer = function(bb) {
  var old_buf_size = bb.capacity();

  // Ensure we don't grow beyond what fits in an int.
  if (old_buf_size & 0xC0000000) {
    throw new Error('FlatBuffers: cannot grow buffer beyond 2 gigabytes.');
  }

  var new_buf_size = old_buf_size << 1;
  var nbb = flatbuffers.ByteBuffer.allocate(new_buf_size);
  nbb.setPosition(new_buf_size - old_buf_size);
  nbb.bytes().set(bb.bytes(), new_buf_size - old_buf_size);
  return nbb;
};
/// @endcond

/**
 * Adds on offset, relative to where it will be written.
 *
 * @param {flatbuffers.Offset} offset The offset to add.
 */
flatbuffers.Builder.prototype.addOffset = function(offset) {
  this.prep(flatbuffers.SIZEOF_INT, 0); // Ensure alignment is already done.
  this.writeInt32(this.offset() - offset + flatbuffers.SIZEOF_INT);
};

/// @cond FLATBUFFERS_INTERNAL
/**
 * Start encoding a new object in the buffer.  Users will not usually need to
 * call this directly. The FlatBuffers compiler will generate helper methods
 * that call this method internally.
 *
 * @param {number} numfields
 */
flatbuffers.Builder.prototype.startObject = function(numfields) {
  this.notNested();
  if (this.vtable == null) {
    this.vtable = [];
  }
  this.vtable_in_use = numfields;
  for (var i = 0; i < numfields; i++) {
    this.vtable[i] = 0; // This will push additional elements as needed
  }
  this.isNested = true;
  this.object_start = this.offset();
};

/**
 * Finish off writing the object that is under construction.
 *
 * @returns {flatbuffers.Offset} The offset to the object inside `dataBuffer`
 */
flatbuffers.Builder.prototype.endObject = function() {
  if (this.vtable == null || !this.isNested) {
    throw new Error('FlatBuffers: endObject called without startObject');
  }

  this.addInt32(0);
  var vtableloc = this.offset();

  // Trim trailing zeroes.
  var i = this.vtable_in_use - 1;
  for (; i >= 0 && this.vtable[i] == 0; i--) {}
  var trimmed_size = i + 1;

  // Write out the current vtable.
  for (; i >= 0; i--) {
    // Offset relative to the start of the table.
    this.addInt16(this.vtable[i] != 0 ? vtableloc - this.vtable[i] : 0);
  }

  var standard_fields = 2; // The fields below:
  this.addInt16(vtableloc - this.object_start);
  var len = (trimmed_size + standard_fields) * flatbuffers.SIZEOF_SHORT;
  this.addInt16(len);

  // Search for an existing vtable that matches the current one.
  var existing_vtable = 0;
  var vt1 = this.space;
outer_loop:
  for (i = 0; i < this.vtables.length; i++) {
    var vt2 = this.bb.capacity() - this.vtables[i];
    if (len == this.bb.readInt16(vt2)) {
      for (var j = flatbuffers.SIZEOF_SHORT; j < len; j += flatbuffers.SIZEOF_SHORT) {
        if (this.bb.readInt16(vt1 + j) != this.bb.readInt16(vt2 + j)) {
          continue outer_loop;
        }
      }
      existing_vtable = this.vtables[i];
      break;
    }
  }

  if (existing_vtable) {
    // Found a match:
    // Remove the current vtable.
    this.space = this.bb.capacity() - vtableloc;

    // Point table to existing vtable.
    this.bb.writeInt32(this.space, existing_vtable - vtableloc);
  } else {
    // No match:
    // Add the location of the current vtable to the list of vtables.
    this.vtables.push(this.offset());

    // Point table to current vtable.
    this.bb.writeInt32(this.bb.capacity() - vtableloc, this.offset() - vtableloc);
  }

  this.isNested = false;
  return vtableloc;
};
/// @endcond

/**
 * Finalize a buffer, poiting to the given `root_table`.
 *
 * @param {flatbuffers.Offset} root_table
 * @param {string=} opt_file_identifier
 */
flatbuffers.Builder.prototype.finish = function(root_table, opt_file_identifier) {
  if (opt_file_identifier) {
    var file_identifier = opt_file_identifier;
    this.prep(this.minalign, flatbuffers.SIZEOF_INT +
      flatbuffers.FILE_IDENTIFIER_LENGTH);
    if (file_identifier.length != flatbuffers.FILE_IDENTIFIER_LENGTH) {
      throw new Error('FlatBuffers: file identifier must be length ' +
        flatbuffers.FILE_IDENTIFIER_LENGTH);
    }
    for (var i = flatbuffers.FILE_IDENTIFIER_LENGTH - 1; i >= 0; i--) {
      this.writeInt8(file_identifier.charCodeAt(i));
    }
  }
  this.prep(this.minalign, flatbuffers.SIZEOF_INT);
  this.addOffset(root_table);
  this.bb.setPosition(this.space);
};

/// @cond FLATBUFFERS_INTERNAL
/**
 * This checks a required field has been set in a given table that has
 * just been constructed.
 *
 * @param {flatbuffers.Offset} table
 * @param {number} field
 */
flatbuffers.Builder.prototype.requiredField = function(table, field) {
  var table_start = this.bb.capacity() - table;
  var vtable_start = table_start - this.bb.readInt32(table_start);
  var ok = this.bb.readInt16(vtable_start + field) != 0;

  // If this fails, the caller will show what field needs to be set.
  if (!ok) {
    throw new Error('FlatBuffers: field ' + field + ' must be set');
  }
};

/**
 * Start a new array/vector of objects.  Users usually will not call
 * this directly. The FlatBuffers compiler will create a start/end
 * method for vector types in generated code.
 *
 * @param {number} elem_size The size of each element in the array
 * @param {number} num_elems The number of elements in the array
 * @param {number} alignment The alignment of the array
 */
flatbuffers.Builder.prototype.startVector = function(elem_size, num_elems, alignment) {
  this.notNested();
  this.vector_num_elems = num_elems;
  this.prep(flatbuffers.SIZEOF_INT, elem_size * num_elems);
  this.prep(alignment, elem_size * num_elems); // Just in case alignment > int.
};

/**
 * Finish off the creation of an array and all its elements. The array must be
 * created with `startVector`.
 *
 * @returns {flatbuffers.Offset} The offset at which the newly created array
 * starts.
 */
flatbuffers.Builder.prototype.endVector = function() {
  this.writeInt32(this.vector_num_elems);
  return this.offset();
};
/// @endcond

/**
 * Encode the string `s` in the buffer using UTF-8. If a Uint8Array is passed
 * instead of a string, it is assumed to contain valid UTF-8 encoded data.
 *
 * @param {string|Uint8Array} s The string to encode
 * @return {flatbuffers.Offset} The offset in the buffer where the encoded string starts
 */
flatbuffers.Builder.prototype.createString = function(s) {
  if (s instanceof Uint8Array) {
    var utf8 = s;
  } else {
    var utf8 = [];
    var i = 0;

    while (i < s.length) {
      var codePoint;

      // Decode UTF-16
      var a = s.charCodeAt(i++);
      if (a < 0xD800 || a >= 0xDC00) {
        codePoint = a;
      } else {
        var b = s.charCodeAt(i++);
        codePoint = (a << 10) + b + (0x10000 - (0xD800 << 10) - 0xDC00);
      }

      // Encode UTF-8
      if (codePoint < 0x80) {
        utf8.push(codePoint);
      } else {
        if (codePoint < 0x800) {
          utf8.push(((codePoint >> 6) & 0x1F) | 0xC0);
        } else {
          if (codePoint < 0x10000) {
            utf8.push(((codePoint >> 12) & 0x0F) | 0xE0);
          } else {
            utf8.push(
              ((codePoint >> 18) & 0x07) | 0xF0,
              ((codePoint >> 12) & 0x3F) | 0x80);
          }
          utf8.push(((codePoint >> 6) & 0x3F) | 0x80);
        }
        utf8.push((codePoint & 0x3F) | 0x80);
      }
    }
  }

  this.addInt8(0);
  this.startVector(1, utf8.length, 1);
  this.bb.setPosition(this.space -= utf8.length);
  for (var i = 0, offset = this.space, bytes = this.bb.bytes(); i < utf8.length; i++) {
    bytes[offset++] = utf8[i];
  }
  return this.endVector();
};

/**
 * A helper function to avoid generated code depending on this file directly.
 *
 * @param {number} low
 * @param {number} high
 * @returns {flatbuffers.Long}
 */
flatbuffers.Builder.prototype.createLong = function(low, high) {
  return flatbuffers.Long.create(low, high);
};
////////////////////////////////////////////////////////////////////////////////
/// @cond FLATBUFFERS_INTERNAL
/**
 * Create a new ByteBuffer with a given array of bytes (`Uint8Array`).
 *
 * @constructor
 * @param {Uint8Array} bytes
 */
flatbuffers.ByteBuffer = function(bytes) {
  /**
   * @type {Uint8Array}
   * @private
   */
  this.bytes_ = bytes;

  /**
   * @type {number}
   * @private
   */
  this.position_ = 0;
};

/**
 * Create and allocate a new ByteBuffer with a given size.
 *
 * @param {number} byte_size
 * @returns {flatbuffers.ByteBuffer}
 */
flatbuffers.ByteBuffer.allocate = function(byte_size) {
  return new flatbuffers.ByteBuffer(new Uint8Array(byte_size));
};

/**
 * Get the underlying `Uint8Array`.
 *
 * @returns {Uint8Array}
 */
flatbuffers.ByteBuffer.prototype.bytes = function() {
  return this.bytes_;
};

/**
 * Get the buffer's position.
 *
 * @returns {number}
 */
flatbuffers.ByteBuffer.prototype.position = function() {
  return this.position_;
};

/**
 * Set the buffer's position.
 *
 * @param {number} position
 */
flatbuffers.ByteBuffer.prototype.setPosition = function(position) {
  this.position_ = position;
};

/**
 * Get the buffer's capacity.
 *
 * @returns {number}
 */
flatbuffers.ByteBuffer.prototype.capacity = function() {
  return this.bytes_.length;
};

/**
 * @param {number} offset
 * @returns {number}
 */
flatbuffers.ByteBuffer.prototype.readInt8 = function(offset) {
  return this.readUint8(offset) << 24 >> 24;
};

/**
 * @param {number} offset
 * @returns {number}
 */
flatbuffers.ByteBuffer.prototype.readUint8 = function(offset) {
  return this.bytes_[offset];
};

/**
 * @param {number} offset
 * @returns {number}
 */
flatbuffers.ByteBuffer.prototype.readInt16 = function(offset) {
  return this.readUint16(offset) << 16 >> 16;
};

/**
 * @param {number} offset
 * @returns {number}
 */
flatbuffers.ByteBuffer.prototype.readUint16 = function(offset) {
  return this.bytes_[offset] | this.bytes_[offset + 1] << 8;
};

/**
 * @param {number} offset
 * @returns {number}
 */
flatbuffers.ByteBuffer.prototype.readInt32 = function(offset) {
  return this.bytes_[offset] | this.bytes_[offset + 1] << 8 | this.bytes_[offset + 2] << 16 | this.bytes_[offset + 3] << 24;
};

/**
 * @param {number} offset
 * @returns {number}
 */
flatbuffers.ByteBuffer.prototype.readUint32 = function(offset) {
  return this.readInt32(offset) >>> 0;
};

/**
 * @param {number} offset
 * @returns {flatbuffers.Long}
 */
flatbuffers.ByteBuffer.prototype.readInt64 = function(offset) {
  return new flatbuffers.Long(this.readInt32(offset), this.readInt32(offset + 4));
};

/**
 * @param {number} offset
 * @returns {flatbuffers.Long}
 */
flatbuffers.ByteBuffer.prototype.readUint64 = function(offset) {
  return new flatbuffers.Long(this.readUint32(offset), this.readUint32(offset + 4));
};

/**
 * @param {number} offset
 * @returns {number}
 */
flatbuffers.ByteBuffer.prototype.readFloat32 = function(offset) {
  flatbuffers.int32[0] = this.readInt32(offset);
  return flatbuffers.float32[0];
};

/**
 * @param {number} offset
 * @returns {number}
 */
flatbuffers.ByteBuffer.prototype.readFloat64 = function(offset) {
  flatbuffers.int32[flatbuffers.isLittleEndian ? 0 : 1] = this.readInt32(offset);
  flatbuffers.int32[flatbuffers.isLittleEndian ? 1 : 0] = this.readInt32(offset + 4);
  return flatbuffers.float64[0];
};

/**
 * @param {number} offset
 * @param {number|boolean} value
 */
flatbuffers.ByteBuffer.prototype.writeInt8 = function(offset, value) {
  this.bytes_[offset] = /** @type {number} */(value);
};

/**
 * @param {number} offset
 * @param {number} value
 */
flatbuffers.ByteBuffer.prototype.writeUint8 = function(offset, value) {
  this.bytes_[offset] = value;
};

/**
 * @param {number} offset
 * @param {number} value
 */
flatbuffers.ByteBuffer.prototype.writeInt16 = function(offset, value) {
  this.bytes_[offset] = value;
  this.bytes_[offset + 1] = value >> 8;
};

/**
 * @param {number} offset
 * @param {number} value
 */
flatbuffers.ByteBuffer.prototype.writeUint16 = function(offset, value) {
    this.bytes_[offset] = value;
    this.bytes_[offset + 1] = value >> 8;
};

/**
 * @param {number} offset
 * @param {number} value
 */
flatbuffers.ByteBuffer.prototype.writeInt32 = function(offset, value) {
  this.bytes_[offset] = value;
  this.bytes_[offset + 1] = value >> 8;
  this.bytes_[offset + 2] = value >> 16;
  this.bytes_[offset + 3] = value >> 24;
};

/**
 * @param {number} offset
 * @param {number} value
 */
flatbuffers.ByteBuffer.prototype.writeUint32 = function(offset, value) {
    this.bytes_[offset] = value;
    this.bytes_[offset + 1] = value >> 8;
    this.bytes_[offset + 2] = value >> 16;
    this.bytes_[offset + 3] = value >> 24;
};

/**
 * @param {number} offset
 * @param {flatbuffers.Long} value
 */
flatbuffers.ByteBuffer.prototype.writeInt64 = function(offset, value) {
  this.writeInt32(offset, value.low);
  this.writeInt32(offset + 4, value.high);
};

/**
 * @param {number} offset
 * @param {flatbuffers.Long} value
 */
flatbuffers.ByteBuffer.prototype.writeUint64 = function(offset, value) {
    this.writeUint32(offset, value.low);
    this.writeUint32(offset + 4, value.high);
};

/**
 * @param {number} offset
 * @param {number} value
 */
flatbuffers.ByteBuffer.prototype.writeFloat32 = function(offset, value) {
  flatbuffers.float32[0] = value;
  this.writeInt32(offset, flatbuffers.int32[0]);
};

/**
 * @param {number} offset
 * @param {number} value
 */
flatbuffers.ByteBuffer.prototype.writeFloat64 = function(offset, value) {
  flatbuffers.float64[0] = value;
  this.writeInt32(offset, flatbuffers.int32[flatbuffers.isLittleEndian ? 0 : 1]);
  this.writeInt32(offset + 4, flatbuffers.int32[flatbuffers.isLittleEndian ? 1 : 0]);
};

/**
 * Return the file identifier.   Behavior is undefined for FlatBuffers whose
 * schema does not include a file_identifier (likely points at padding or the
 * start of a the root vtable).
 * @returns {string}
 */
flatbuffers.ByteBuffer.prototype.getBufferIdentifier = function() {
  if (this.bytes_.length < this.position_ + flatbuffers.SIZEOF_INT +
      flatbuffers.FILE_IDENTIFIER_LENGTH) {
    throw new Error(
        'FlatBuffers: ByteBuffer is too short to contain an identifier.');
  }
  var result = "";
  for (var i = 0; i < flatbuffers.FILE_IDENTIFIER_LENGTH; i++) {
    result += String.fromCharCode(
        this.readInt8(this.position_ + flatbuffers.SIZEOF_INT + i));
  }
  return result;
};

/**
 * Look up a field in the vtable, return an offset into the object, or 0 if the
 * field is not present.
 *
 * @param {number} bb_pos
 * @param {number} vtable_offset
 * @returns {number}
 */
flatbuffers.ByteBuffer.prototype.__offset = function(bb_pos, vtable_offset) {
  var vtable = bb_pos - this.readInt32(bb_pos);
  return vtable_offset < this.readInt16(vtable) ? this.readInt16(vtable + vtable_offset) : 0;
};

/**
 * Initialize any Table-derived type to point to the union at the given offset.
 *
 * @param {flatbuffers.Table} t
 * @param {number} offset
 * @returns {flatbuffers.Table}
 */
flatbuffers.ByteBuffer.prototype.__union = function(t, offset) {
  t.bb_pos = offset + this.readInt32(offset);
  t.bb = this;
  return t;
};

/**
 * Create a JavaScript string from UTF-8 data stored inside the FlatBuffer.
 * This allocates a new string and converts to wide chars upon each access.
 *
 * To avoid the conversion to UTF-16, pass flatbuffers.Encoding.UTF8_BYTES as
 * the "optionalEncoding" argument. This is useful for avoiding conversion to
 * and from UTF-16 when the data will just be packaged back up in another
 * FlatBuffer later on.
 *
 * @param {number} offset
 * @param {flatbuffers.Encoding=} opt_encoding Defaults to UTF16_STRING
 * @returns {string|Uint8Array}
 */
flatbuffers.ByteBuffer.prototype.__string = function(offset, opt_encoding) {
  offset += this.readInt32(offset);

  var length = this.readInt32(offset);
  var result = '';
  var i = 0;

  offset += flatbuffers.SIZEOF_INT;

  if (opt_encoding === flatbuffers.Encoding.UTF8_BYTES) {
    return this.bytes_.subarray(offset, offset + length);
  }

  while (i < length) {
    var codePoint;

    // Decode UTF-8
    var a = this.readUint8(offset + i++);
    if (a < 0xC0) {
      codePoint = a;
    } else {
      var b = this.readUint8(offset + i++);
      if (a < 0xE0) {
        codePoint =
          ((a & 0x1F) << 6) |
          (b & 0x3F);
      } else {
        var c = this.readUint8(offset + i++);
        if (a < 0xF0) {
          codePoint =
            ((a & 0x0F) << 12) |
            ((b & 0x3F) << 6) |
            (c & 0x3F);
        } else {
          var d = this.readUint8(offset + i++);
          codePoint =
            ((a & 0x07) << 18) |
            ((b & 0x3F) << 12) |
            ((c & 0x3F) << 6) |
            (d & 0x3F);
        }
      }
    }

    // Encode UTF-16
    if (codePoint < 0x10000) {
      result += String.fromCharCode(codePoint);
    } else {
      codePoint -= 0x10000;
      result += String.fromCharCode(
        (codePoint >> 10) + 0xD800,
        (codePoint & ((1 << 10) - 1)) + 0xDC00);
    }
  }

  return result;
};

/**
 * Retrieve the relative offset stored at "offset"
 * @param {number} offset
 * @returns {number}
 */
flatbuffers.ByteBuffer.prototype.__indirect = function(offset) {
  return offset + this.readInt32(offset);
};

/**
 * Get the start of data of a vector whose offset is stored at "offset" in this object.
 *
 * @param {number} offset
 * @returns {number}
 */
flatbuffers.ByteBuffer.prototype.__vector = function(offset) {
  return offset + this.readInt32(offset) + flatbuffers.SIZEOF_INT; // data starts after the length
};

/**
 * Get the length of a vector whose offset is stored at "offset" in this object.
 *
 * @param {number} offset
 * @returns {number}
 */
flatbuffers.ByteBuffer.prototype.__vector_len = function(offset) {
  return this.readInt32(offset + this.readInt32(offset));
};

/**
 * @param {string} ident
 * @returns {boolean}
 */
flatbuffers.ByteBuffer.prototype.__has_identifier = function(ident) {
  if (ident.length != flatbuffers.FILE_IDENTIFIER_LENGTH) {
    throw new Error('FlatBuffers: file identifier must be length ' +
                    flatbuffers.FILE_IDENTIFIER_LENGTH);
  }
  for (var i = 0; i < flatbuffers.FILE_IDENTIFIER_LENGTH; i++) {
    if (ident.charCodeAt(i) != this.readInt8(this.position_ + flatbuffers.SIZEOF_INT + i)) {
      return false;
    }
  }
  return true;
};

/**
 * A helper function to avoid generated code depending on this file directly.
 *
 * @param {number} low
 * @param {number} high
 * @returns {flatbuffers.Long}
 */
flatbuffers.ByteBuffer.prototype.createLong = function(low, high) {
  return flatbuffers.Long.create(low, high);
};

// Exports for Node.js and RequireJS


/// @endcond
/// @}


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ITERATOR_DONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArrowJSON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ReadableInterop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AsyncQueue; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__adapters__ = __webpack_require__(85);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.


/** @ignore */
var ITERATOR_DONE = Object.freeze({ done: true, value: void (0) });
/** @ignore */
var ArrowJSON = /** @class */ (function () {
    // @ts-ignore
    function ArrowJSON(_json) {
        this._json = _json;
    }
    Object.defineProperty(ArrowJSON.prototype, "schema", {
        get: function () { return this._json['schema']; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArrowJSON.prototype, "batches", {
        get: function () { return (this._json['batches'] || []); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArrowJSON.prototype, "dictionaries", {
        get: function () { return (this._json['dictionaries'] || []); },
        enumerable: true,
        configurable: true
    });
    return ArrowJSON;
}());

/** @ignore */
var ReadableInterop = /** @class */ (function () {
    function ReadableInterop() {
    }
    ReadableInterop.prototype.tee = function () {
        return this._getDOMStream().tee();
    };
    ReadableInterop.prototype.pipe = function (writable, options) {
        return this._getNodeStream().pipe(writable, options);
    };
    ReadableInterop.prototype.pipeTo = function (writable, options) { return this._getDOMStream().pipeTo(writable, options); };
    ReadableInterop.prototype.pipeThrough = function (duplex, options) {
        return this._getDOMStream().pipeThrough(duplex, options);
    };
    ReadableInterop.prototype._getDOMStream = function () {
        return this._DOMStream || (this._DOMStream = this.toDOMStream());
    };
    ReadableInterop.prototype._getNodeStream = function () {
        return this._nodeStream || (this._nodeStream = this.toNodeStream());
    };
    return ReadableInterop;
}());

/** @ignore */
var AsyncQueue = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](AsyncQueue, _super);
    function AsyncQueue() {
        var _this = _super.call(this) || this;
        _this._values = [];
        _this.resolvers = [];
        _this._closedPromise = new Promise(function (r) { return _this._closedPromiseResolve = r; });
        return _this;
    }
    Object.defineProperty(AsyncQueue.prototype, "closed", {
        get: function () { return this._closedPromise; },
        enumerable: true,
        configurable: true
    });
    AsyncQueue.prototype.cancel = function (reason) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () { return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.return(reason)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        }); });
    };
    AsyncQueue.prototype.write = function (value) {
        if (this._ensureOpen()) {
            this.resolvers.length <= 0
                ? (this._values.push(value))
                : (this.resolvers.shift().resolve({ done: false, value: value }));
        }
    };
    AsyncQueue.prototype.abort = function (value) {
        if (this._closedPromiseResolve) {
            this.resolvers.length <= 0
                ? (this._error = { error: value })
                : (this.resolvers.shift().reject({ done: true, value: value }));
        }
    };
    AsyncQueue.prototype.close = function () {
        if (this._closedPromiseResolve) {
            var resolvers = this.resolvers;
            while (resolvers.length > 0) {
                resolvers.shift().resolve(ITERATOR_DONE);
            }
            this._closedPromiseResolve();
            this._closedPromiseResolve = undefined;
        }
    };
    AsyncQueue.prototype[Symbol.asyncIterator] = function () { return this; };
    AsyncQueue.prototype.toDOMStream = function (options) {
        return __WEBPACK_IMPORTED_MODULE_1__adapters__["a" /* default */].toDOMStream((this._closedPromiseResolve || this._error)
            ? this
            : this._values, options);
    };
    AsyncQueue.prototype.toNodeStream = function (options) {
        return __WEBPACK_IMPORTED_MODULE_1__adapters__["a" /* default */].toNodeStream((this._closedPromiseResolve || this._error)
            ? this
            : this._values, options);
    };
    AsyncQueue.prototype.throw = function (_) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () { return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.abort(_)];
                case 1:
                    _a.sent();
                    return [2 /*return*/, ITERATOR_DONE];
            }
        }); });
    };
    AsyncQueue.prototype.return = function (_) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () { return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.close()];
                case 1:
                    _a.sent();
                    return [2 /*return*/, ITERATOR_DONE];
            }
        }); });
    };
    AsyncQueue.prototype.read = function (size) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () { return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.next(size, 'read')];
                case 1: return [2 /*return*/, (_a.sent()).value];
            }
        }); });
    };
    AsyncQueue.prototype.peek = function (size) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () { return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.next(size, 'peek')];
                case 1: return [2 /*return*/, (_a.sent()).value];
            }
        }); });
    };
    AsyncQueue.prototype.next = function () {
        var _this = this;
        var _args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            _args[_i] = arguments[_i];
        }
        if (this._values.length > 0) {
            return Promise.resolve({ done: false, value: this._values.shift() });
        }
        else if (this._error) {
            return Promise.reject({ done: true, value: this._error.error });
        }
        else if (!this._closedPromiseResolve) {
            return Promise.resolve(ITERATOR_DONE);
        }
        else {
            return new Promise(function (resolve, reject) {
                _this.resolvers.push({ resolve: resolve, reject: reject });
            });
        }
    };
    AsyncQueue.prototype._ensureOpen = function () {
        if (this._closedPromiseResolve) {
            return true;
        }
        throw new Error(this + " is closed");
    };
    return AsyncQueue;
}(ReadableInterop));




/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Message; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RecordBatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DictionaryBatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BufferRegion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FieldNode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_flatbuffers__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fb_Schema__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fb_Message__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__schema__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_buffer__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__enum__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__visitor_typeassembler__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__json__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__type__ = __webpack_require__(3);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.









var Long = __WEBPACK_IMPORTED_MODULE_1_flatbuffers__["a" /* flatbuffers */].Long;
var Builder = __WEBPACK_IMPORTED_MODULE_1_flatbuffers__["a" /* flatbuffers */].Builder;
var ByteBuffer = __WEBPACK_IMPORTED_MODULE_1_flatbuffers__["a" /* flatbuffers */].ByteBuffer;
var Type = __WEBPACK_IMPORTED_MODULE_2__fb_Schema__["a" /* org */].apache.arrow.flatbuf.Type;
var _Field = __WEBPACK_IMPORTED_MODULE_2__fb_Schema__["a" /* org */].apache.arrow.flatbuf.Field;
var _Schema = __WEBPACK_IMPORTED_MODULE_2__fb_Schema__["a" /* org */].apache.arrow.flatbuf.Schema;
var _Buffer = __WEBPACK_IMPORTED_MODULE_2__fb_Schema__["a" /* org */].apache.arrow.flatbuf.Buffer;
var _Message = __WEBPACK_IMPORTED_MODULE_3__fb_Message__["a" /* org */].apache.arrow.flatbuf.Message;
var _KeyValue = __WEBPACK_IMPORTED_MODULE_2__fb_Schema__["a" /* org */].apache.arrow.flatbuf.KeyValue;
var _FieldNode = __WEBPACK_IMPORTED_MODULE_3__fb_Message__["a" /* org */].apache.arrow.flatbuf.FieldNode;
var _Endianness = __WEBPACK_IMPORTED_MODULE_2__fb_Schema__["a" /* org */].apache.arrow.flatbuf.Endianness;
var _RecordBatch = __WEBPACK_IMPORTED_MODULE_3__fb_Message__["a" /* org */].apache.arrow.flatbuf.RecordBatch;
var _DictionaryBatch = __WEBPACK_IMPORTED_MODULE_3__fb_Message__["a" /* org */].apache.arrow.flatbuf.DictionaryBatch;

/** @ignore */
var Message = /** @class */ (function () {
    function Message(bodyLength, version, headerType, header) {
        this._version = version;
        this._headerType = headerType;
        this.body = new Uint8Array(0);
        header && (this._createHeader = function () { return header; });
        this._bodyLength = typeof bodyLength === 'number' ? bodyLength : bodyLength.low;
    }
    /** @nocollapse */
    Message.fromJSON = function (msg, headerType) {
        var message = new Message(0, __WEBPACK_IMPORTED_MODULE_6__enum__["MetadataVersion"].V4, headerType);
        message._createHeader = messageHeaderFromJSON(msg, headerType);
        return message;
    };
    /** @nocollapse */
    Message.decode = function (buf) {
        buf = new ByteBuffer(Object(__WEBPACK_IMPORTED_MODULE_5__util_buffer__["e" /* toUint8Array */])(buf));
        var _message = _Message.getRootAsMessage(buf);
        var bodyLength = _message.bodyLength();
        var version = _message.version();
        var headerType = _message.headerType();
        var message = new Message(bodyLength, version, headerType);
        message._createHeader = decodeMessageHeader(_message, headerType);
        return message;
    };
    /** @nocollapse */
    Message.encode = function (message) {
        var b = new Builder(), headerOffset = -1;
        if (message.isSchema()) {
            headerOffset = __WEBPACK_IMPORTED_MODULE_4__schema__["b" /* Schema */].encode(b, message.header());
        }
        else if (message.isRecordBatch()) {
            headerOffset = RecordBatch.encode(b, message.header());
        }
        else if (message.isDictionaryBatch()) {
            headerOffset = DictionaryBatch.encode(b, message.header());
        }
        _Message.startMessage(b);
        _Message.addVersion(b, __WEBPACK_IMPORTED_MODULE_6__enum__["MetadataVersion"].V4);
        _Message.addHeader(b, headerOffset);
        _Message.addHeaderType(b, message.headerType);
        _Message.addBodyLength(b, new Long(message.bodyLength, 0));
        _Message.finishMessageBuffer(b, _Message.endMessage(b));
        return b.asUint8Array();
    };
    /** @nocollapse */
    Message.from = function (header, bodyLength) {
        if (bodyLength === void 0) { bodyLength = 0; }
        if (header instanceof __WEBPACK_IMPORTED_MODULE_4__schema__["b" /* Schema */]) {
            return new Message(0, __WEBPACK_IMPORTED_MODULE_6__enum__["MetadataVersion"].V4, __WEBPACK_IMPORTED_MODULE_6__enum__["MessageHeader"].Schema, header);
        }
        if (header instanceof RecordBatch) {
            return new Message(bodyLength, __WEBPACK_IMPORTED_MODULE_6__enum__["MetadataVersion"].V4, __WEBPACK_IMPORTED_MODULE_6__enum__["MessageHeader"].RecordBatch, header);
        }
        if (header instanceof DictionaryBatch) {
            return new Message(bodyLength, __WEBPACK_IMPORTED_MODULE_6__enum__["MetadataVersion"].V4, __WEBPACK_IMPORTED_MODULE_6__enum__["MessageHeader"].DictionaryBatch, header);
        }
        throw new Error("Unrecognized Message header: " + header);
    };
    Object.defineProperty(Message.prototype, "type", {
        get: function () { return this.headerType; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Message.prototype, "version", {
        get: function () { return this._version; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Message.prototype, "headerType", {
        get: function () { return this._headerType; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Message.prototype, "bodyLength", {
        get: function () { return this._bodyLength; },
        enumerable: true,
        configurable: true
    });
    Message.prototype.header = function () { return this._createHeader(); };
    Message.prototype.isSchema = function () { return this.headerType === __WEBPACK_IMPORTED_MODULE_6__enum__["MessageHeader"].Schema; };
    Message.prototype.isRecordBatch = function () { return this.headerType === __WEBPACK_IMPORTED_MODULE_6__enum__["MessageHeader"].RecordBatch; };
    Message.prototype.isDictionaryBatch = function () { return this.headerType === __WEBPACK_IMPORTED_MODULE_6__enum__["MessageHeader"].DictionaryBatch; };
    return Message;
}());

/** @ignore */
var RecordBatch = /** @class */ (function () {
    function RecordBatch(length, nodes, buffers) {
        this._nodes = nodes;
        this._buffers = buffers;
        this._length = typeof length === 'number' ? length : length.low;
    }
    Object.defineProperty(RecordBatch.prototype, "nodes", {
        get: function () { return this._nodes; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecordBatch.prototype, "length", {
        get: function () { return this._length; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecordBatch.prototype, "buffers", {
        get: function () { return this._buffers; },
        enumerable: true,
        configurable: true
    });
    return RecordBatch;
}());

/** @ignore */
var DictionaryBatch = /** @class */ (function () {
    function DictionaryBatch(data, id, isDelta) {
        if (isDelta === void 0) { isDelta = false; }
        this._data = data;
        this._isDelta = isDelta;
        this._id = typeof id === 'number' ? id : id.low;
    }
    Object.defineProperty(DictionaryBatch.prototype, "id", {
        get: function () { return this._id; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DictionaryBatch.prototype, "data", {
        get: function () { return this._data; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DictionaryBatch.prototype, "isDelta", {
        get: function () { return this._isDelta; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DictionaryBatch.prototype, "length", {
        get: function () { return this.data.length; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DictionaryBatch.prototype, "nodes", {
        get: function () { return this.data.nodes; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DictionaryBatch.prototype, "buffers", {
        get: function () { return this.data.buffers; },
        enumerable: true,
        configurable: true
    });
    return DictionaryBatch;
}());

/** @ignore */
var BufferRegion = /** @class */ (function () {
    function BufferRegion(offset, length) {
        this.offset = typeof offset === 'number' ? offset : offset.low;
        this.length = typeof length === 'number' ? length : length.low;
    }
    return BufferRegion;
}());

/** @ignore */
var FieldNode = /** @class */ (function () {
    function FieldNode(length, nullCount) {
        this.length = typeof length === 'number' ? length : length.low;
        this.nullCount = typeof nullCount === 'number' ? nullCount : nullCount.low;
    }
    return FieldNode;
}());

/** @ignore */
function messageHeaderFromJSON(message, type) {
    return (function () {
        switch (type) {
            case __WEBPACK_IMPORTED_MODULE_6__enum__["MessageHeader"].Schema: return __WEBPACK_IMPORTED_MODULE_4__schema__["b" /* Schema */].fromJSON(message);
            case __WEBPACK_IMPORTED_MODULE_6__enum__["MessageHeader"].RecordBatch: return RecordBatch.fromJSON(message);
            case __WEBPACK_IMPORTED_MODULE_6__enum__["MessageHeader"].DictionaryBatch: return DictionaryBatch.fromJSON(message);
        }
        throw new Error("Unrecognized Message type: { name: " + __WEBPACK_IMPORTED_MODULE_6__enum__["MessageHeader"][type] + ", type: " + type + " }");
    });
}
/** @ignore */
function decodeMessageHeader(message, type) {
    return (function () {
        switch (type) {
            case __WEBPACK_IMPORTED_MODULE_6__enum__["MessageHeader"].Schema: return __WEBPACK_IMPORTED_MODULE_4__schema__["b" /* Schema */].decode(message.header(new _Schema()));
            case __WEBPACK_IMPORTED_MODULE_6__enum__["MessageHeader"].RecordBatch: return RecordBatch.decode(message.header(new _RecordBatch()), message.version());
            case __WEBPACK_IMPORTED_MODULE_6__enum__["MessageHeader"].DictionaryBatch: return DictionaryBatch.decode(message.header(new _DictionaryBatch()), message.version());
        }
        throw new Error("Unrecognized Message type: { name: " + __WEBPACK_IMPORTED_MODULE_6__enum__["MessageHeader"][type] + ", type: " + type + " }");
    });
}
__WEBPACK_IMPORTED_MODULE_4__schema__["a" /* Field */]['encode'] = encodeField;
__WEBPACK_IMPORTED_MODULE_4__schema__["a" /* Field */]['decode'] = decodeField;
__WEBPACK_IMPORTED_MODULE_4__schema__["a" /* Field */]['fromJSON'] = __WEBPACK_IMPORTED_MODULE_8__json__["b" /* fieldFromJSON */];
__WEBPACK_IMPORTED_MODULE_4__schema__["b" /* Schema */]['encode'] = encodeSchema;
__WEBPACK_IMPORTED_MODULE_4__schema__["b" /* Schema */]['decode'] = decodeSchema;
__WEBPACK_IMPORTED_MODULE_4__schema__["b" /* Schema */]['fromJSON'] = __WEBPACK_IMPORTED_MODULE_8__json__["d" /* schemaFromJSON */];
RecordBatch['encode'] = encodeRecordBatch;
RecordBatch['decode'] = decodeRecordBatch;
RecordBatch['fromJSON'] = __WEBPACK_IMPORTED_MODULE_8__json__["c" /* recordBatchFromJSON */];
DictionaryBatch['encode'] = encodeDictionaryBatch;
DictionaryBatch['decode'] = decodeDictionaryBatch;
DictionaryBatch['fromJSON'] = __WEBPACK_IMPORTED_MODULE_8__json__["a" /* dictionaryBatchFromJSON */];
FieldNode['encode'] = encodeFieldNode;
FieldNode['decode'] = decodeFieldNode;
BufferRegion['encode'] = encodeBufferRegion;
BufferRegion['decode'] = decodeBufferRegion;
/** @ignore */
function decodeSchema(_schema, dictionaries, dictionaryFields) {
    if (dictionaries === void 0) { dictionaries = new Map(); }
    if (dictionaryFields === void 0) { dictionaryFields = new Map(); }
    var fields = decodeSchemaFields(_schema, dictionaries, dictionaryFields);
    return new __WEBPACK_IMPORTED_MODULE_4__schema__["b" /* Schema */](fields, decodeCustomMetadata(_schema), dictionaries, dictionaryFields);
}
/** @ignore */
function decodeRecordBatch(batch, version) {
    if (version === void 0) { version = __WEBPACK_IMPORTED_MODULE_6__enum__["MetadataVersion"].V4; }
    return new RecordBatch(batch.length(), decodeFieldNodes(batch), decodeBuffers(batch, version));
}
/** @ignore */
function decodeDictionaryBatch(batch, version) {
    if (version === void 0) { version = __WEBPACK_IMPORTED_MODULE_6__enum__["MetadataVersion"].V4; }
    return new DictionaryBatch(RecordBatch.decode(batch.data(), version), batch.id(), batch.isDelta());
}
/** @ignore */
function decodeBufferRegion(b) {
    return new BufferRegion(b.offset(), b.length());
}
/** @ignore */
function decodeFieldNode(f) {
    return new FieldNode(f.length(), f.nullCount());
}
/** @ignore */
function decodeFieldNodes(batch) {
    var nodes = [];
    for (var f = void 0, i = -1, j = -1, n = batch.nodesLength(); ++i < n;) {
        if (f = batch.nodes(i)) {
            nodes[++j] = FieldNode.decode(f);
        }
    }
    return nodes;
}
/** @ignore */
function decodeBuffers(batch, version) {
    var bufferRegions = [];
    for (var b = void 0, i = -1, j = -1, n = batch.buffersLength(); ++i < n;) {
        if (b = batch.buffers(i)) {
            // If this Arrow buffer was written before version 4,
            // advance the buffer's bb_pos 8 bytes to skip past
            // the now-removed page_id field
            if (version < __WEBPACK_IMPORTED_MODULE_6__enum__["MetadataVersion"].V4) {
                b.bb_pos += (8 * (i + 1));
            }
            bufferRegions[++j] = BufferRegion.decode(b);
        }
    }
    return bufferRegions;
}
/** @ignore */
function decodeSchemaFields(schema, dictionaries, dictionaryFields) {
    var fields = [];
    for (var f = void 0, i = -1, j = -1, n = schema.fieldsLength(); ++i < n;) {
        if (f = schema.fields(i)) {
            fields[++j] = __WEBPACK_IMPORTED_MODULE_4__schema__["a" /* Field */].decode(f, dictionaries, dictionaryFields);
        }
    }
    return fields;
}
/** @ignore */
function decodeFieldChildren(field, dictionaries, dictionaryFields) {
    var children = [];
    for (var f = void 0, i = -1, j = -1, n = field.childrenLength(); ++i < n;) {
        if (f = field.children(i)) {
            children[++j] = __WEBPACK_IMPORTED_MODULE_4__schema__["a" /* Field */].decode(f, dictionaries, dictionaryFields);
        }
    }
    return children;
}
/** @ignore */
function decodeField(f, dictionaries, dictionaryFields) {
    var id;
    var field;
    var type;
    var keys;
    var dictType;
    var dictMeta;
    var dictField;
    // If no dictionary encoding, or in the process of decoding the children of a dictionary-encoded field
    if (!dictionaries || !dictionaryFields || !(dictMeta = f.dictionary())) {
        type = decodeFieldType(f, decodeFieldChildren(f, dictionaries, dictionaryFields));
        field = new __WEBPACK_IMPORTED_MODULE_4__schema__["a" /* Field */](f.name(), type, f.nullable(), decodeCustomMetadata(f));
    }
    // tslint:disable
    // If dictionary encoded and the first time we've seen this dictionary id, decode
    // the data type and child fields, then wrap in a Dictionary type and insert the
    // data type into the dictionary types map.
    else if (!dictionaries.has(id = dictMeta.id().low)) {
        // a dictionary index defaults to signed 32 bit int if unspecified
        keys = (keys = dictMeta.indexType()) ? decodeIndexType(keys) : new __WEBPACK_IMPORTED_MODULE_9__type__["Int32"]();
        dictionaries.set(id, type = decodeFieldType(f, decodeFieldChildren(f)));
        dictType = new __WEBPACK_IMPORTED_MODULE_9__type__["Dictionary"](type, keys, id, dictMeta.isOrdered());
        dictField = new __WEBPACK_IMPORTED_MODULE_4__schema__["a" /* Field */](f.name(), dictType, f.nullable(), decodeCustomMetadata(f));
        dictionaryFields.set(id, [field = dictField]);
    }
    // If dictionary encoded, and have already seen this dictionary Id in the schema, then reuse the
    // data type and wrap in a new Dictionary type and field.
    else {
        // a dictionary index defaults to signed 32 bit int if unspecified
        keys = (keys = dictMeta.indexType()) ? decodeIndexType(keys) : new __WEBPACK_IMPORTED_MODULE_9__type__["Int32"]();
        dictType = new __WEBPACK_IMPORTED_MODULE_9__type__["Dictionary"](dictionaries.get(id), keys, id, dictMeta.isOrdered());
        dictField = new __WEBPACK_IMPORTED_MODULE_4__schema__["a" /* Field */](f.name(), dictType, f.nullable(), decodeCustomMetadata(f));
        dictionaryFields.get(id).push(field = dictField);
    }
    return field || null;
}
/** @ignore */
function decodeCustomMetadata(parent) {
    var data = new Map();
    if (parent) {
        for (var entry = void 0, key = void 0, i = -1, n = parent.customMetadataLength() | 0; ++i < n;) {
            if ((entry = parent.customMetadata(i)) && (key = entry.key()) != null) {
                data.set(key, entry.value());
            }
        }
    }
    return data;
}
/** @ignore */
function decodeIndexType(_type) {
    return new __WEBPACK_IMPORTED_MODULE_9__type__["Int"](_type.isSigned(), _type.bitWidth());
}
/** @ignore */
function decodeFieldType(f, children) {
    var typeId = f.typeType();
    switch (typeId) {
        case Type.NONE: return new __WEBPACK_IMPORTED_MODULE_9__type__["DataType"]();
        case Type.Null: return new __WEBPACK_IMPORTED_MODULE_9__type__["Null"]();
        case Type.Binary: return new __WEBPACK_IMPORTED_MODULE_9__type__["Binary"]();
        case Type.Utf8: return new __WEBPACK_IMPORTED_MODULE_9__type__["Utf8"]();
        case Type.Bool: return new __WEBPACK_IMPORTED_MODULE_9__type__["Bool"]();
        case Type.List: return new __WEBPACK_IMPORTED_MODULE_9__type__["List"]((children || [])[0]);
        case Type.Struct_: return new __WEBPACK_IMPORTED_MODULE_9__type__["Struct"](children || []);
    }
    switch (typeId) {
        case Type.Int: {
            var t = f.type(new __WEBPACK_IMPORTED_MODULE_2__fb_Schema__["a" /* org */].apache.arrow.flatbuf.Int());
            return new __WEBPACK_IMPORTED_MODULE_9__type__["Int"](t.isSigned(), t.bitWidth());
        }
        case Type.FloatingPoint: {
            var t = f.type(new __WEBPACK_IMPORTED_MODULE_2__fb_Schema__["a" /* org */].apache.arrow.flatbuf.FloatingPoint());
            return new __WEBPACK_IMPORTED_MODULE_9__type__["Float"](t.precision());
        }
        case Type.Decimal: {
            var t = f.type(new __WEBPACK_IMPORTED_MODULE_2__fb_Schema__["a" /* org */].apache.arrow.flatbuf.Decimal());
            return new __WEBPACK_IMPORTED_MODULE_9__type__["Decimal"](t.scale(), t.precision());
        }
        case Type.Date: {
            var t = f.type(new __WEBPACK_IMPORTED_MODULE_2__fb_Schema__["a" /* org */].apache.arrow.flatbuf.Date());
            return new __WEBPACK_IMPORTED_MODULE_9__type__["Date_"](t.unit());
        }
        case Type.Time: {
            var t = f.type(new __WEBPACK_IMPORTED_MODULE_2__fb_Schema__["a" /* org */].apache.arrow.flatbuf.Time());
            return new __WEBPACK_IMPORTED_MODULE_9__type__["Time"](t.unit(), t.bitWidth());
        }
        case Type.Timestamp: {
            var t = f.type(new __WEBPACK_IMPORTED_MODULE_2__fb_Schema__["a" /* org */].apache.arrow.flatbuf.Timestamp());
            return new __WEBPACK_IMPORTED_MODULE_9__type__["Timestamp"](t.unit(), t.timezone());
        }
        case Type.Interval: {
            var t = f.type(new __WEBPACK_IMPORTED_MODULE_2__fb_Schema__["a" /* org */].apache.arrow.flatbuf.Interval());
            return new __WEBPACK_IMPORTED_MODULE_9__type__["Interval"](t.unit());
        }
        case Type.Union: {
            var t = f.type(new __WEBPACK_IMPORTED_MODULE_2__fb_Schema__["a" /* org */].apache.arrow.flatbuf.Union());
            return new __WEBPACK_IMPORTED_MODULE_9__type__["Union"](t.mode(), t.typeIdsArray() || [], children || []);
        }
        case Type.FixedSizeBinary: {
            var t = f.type(new __WEBPACK_IMPORTED_MODULE_2__fb_Schema__["a" /* org */].apache.arrow.flatbuf.FixedSizeBinary());
            return new __WEBPACK_IMPORTED_MODULE_9__type__["FixedSizeBinary"](t.byteWidth());
        }
        case Type.FixedSizeList: {
            var t = f.type(new __WEBPACK_IMPORTED_MODULE_2__fb_Schema__["a" /* org */].apache.arrow.flatbuf.FixedSizeList());
            return new __WEBPACK_IMPORTED_MODULE_9__type__["FixedSizeList"](t.listSize(), (children || [])[0]);
        }
        case Type.Map: {
            var t = f.type(new __WEBPACK_IMPORTED_MODULE_2__fb_Schema__["a" /* org */].apache.arrow.flatbuf.Map());
            return new __WEBPACK_IMPORTED_MODULE_9__type__["Map_"](children || [], t.keysSorted());
        }
    }
    throw new Error("Unrecognized type: \"" + Type[typeId] + "\" (" + typeId + ")");
}
/** @ignore */
function encodeSchema(b, schema) {
    var fieldOffsets = schema.fields.map(function (f) { return __WEBPACK_IMPORTED_MODULE_4__schema__["a" /* Field */].encode(b, f); });
    _Schema.startFieldsVector(b, fieldOffsets.length);
    var fieldsVectorOffset = _Schema.createFieldsVector(b, fieldOffsets);
    var metadataOffset = !(schema.metadata && schema.metadata.size > 0) ? -1 :
        _Schema.createCustomMetadataVector(b, __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](schema.metadata).map(function (_a) {
            var _b = __WEBPACK_IMPORTED_MODULE_0_tslib__["i" /* __read */](_a, 2), k = _b[0], v = _b[1];
            var key = b.createString("" + k);
            var val = b.createString("" + v);
            _KeyValue.startKeyValue(b);
            _KeyValue.addKey(b, key);
            _KeyValue.addValue(b, val);
            return _KeyValue.endKeyValue(b);
        }));
    _Schema.startSchema(b);
    _Schema.addFields(b, fieldsVectorOffset);
    _Schema.addEndianness(b, platformIsLittleEndian ? _Endianness.Little : _Endianness.Big);
    if (metadataOffset !== -1) {
        _Schema.addCustomMetadata(b, metadataOffset);
    }
    return _Schema.endSchema(b);
}
/** @ignore */
function encodeField(b, field) {
    var nameOffset = -1;
    var typeOffset = -1;
    var dictionaryOffset = -1;
    var type = field.type;
    var typeId = field.typeId;
    if (!__WEBPACK_IMPORTED_MODULE_9__type__["DataType"].isDictionary(type)) {
        typeOffset = __WEBPACK_IMPORTED_MODULE_7__visitor_typeassembler__["a" /* instance */].visit(type, b);
    }
    else {
        typeId = type.dictionary.typeId;
        dictionaryOffset = __WEBPACK_IMPORTED_MODULE_7__visitor_typeassembler__["a" /* instance */].visit(type, b);
        typeOffset = __WEBPACK_IMPORTED_MODULE_7__visitor_typeassembler__["a" /* instance */].visit(type.dictionary, b);
    }
    var childOffsets = (type.children || []).map(function (f) { return __WEBPACK_IMPORTED_MODULE_4__schema__["a" /* Field */].encode(b, f); });
    var childrenVectorOffset = _Field.createChildrenVector(b, childOffsets);
    var metadataOffset = !(field.metadata && field.metadata.size > 0) ? -1 :
        _Field.createCustomMetadataVector(b, __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](field.metadata).map(function (_a) {
            var _b = __WEBPACK_IMPORTED_MODULE_0_tslib__["i" /* __read */](_a, 2), k = _b[0], v = _b[1];
            var key = b.createString("" + k);
            var val = b.createString("" + v);
            _KeyValue.startKeyValue(b);
            _KeyValue.addKey(b, key);
            _KeyValue.addValue(b, val);
            return _KeyValue.endKeyValue(b);
        }));
    if (field.name) {
        nameOffset = b.createString(field.name);
    }
    _Field.startField(b);
    _Field.addType(b, typeOffset);
    _Field.addTypeType(b, typeId);
    _Field.addChildren(b, childrenVectorOffset);
    _Field.addNullable(b, !!field.nullable);
    if (nameOffset !== -1) {
        _Field.addName(b, nameOffset);
    }
    if (dictionaryOffset !== -1) {
        _Field.addDictionary(b, dictionaryOffset);
    }
    if (metadataOffset !== -1) {
        _Field.addCustomMetadata(b, metadataOffset);
    }
    return _Field.endField(b);
}
/** @ignore */
function encodeRecordBatch(b, recordBatch) {
    var nodes = recordBatch.nodes || [];
    var buffers = recordBatch.buffers || [];
    _RecordBatch.startNodesVector(b, nodes.length);
    nodes.slice().reverse().forEach(function (n) { return FieldNode.encode(b, n); });
    var nodesVectorOffset = b.endVector();
    _RecordBatch.startBuffersVector(b, buffers.length);
    buffers.slice().reverse().forEach(function (b_) { return BufferRegion.encode(b, b_); });
    var buffersVectorOffset = b.endVector();
    _RecordBatch.startRecordBatch(b);
    _RecordBatch.addLength(b, new Long(recordBatch.length, 0));
    _RecordBatch.addNodes(b, nodesVectorOffset);
    _RecordBatch.addBuffers(b, buffersVectorOffset);
    return _RecordBatch.endRecordBatch(b);
}
/** @ignore */
function encodeDictionaryBatch(b, dictionaryBatch) {
    var dataOffset = RecordBatch.encode(b, dictionaryBatch.data);
    _DictionaryBatch.startDictionaryBatch(b);
    _DictionaryBatch.addId(b, new Long(dictionaryBatch.id, 0));
    _DictionaryBatch.addIsDelta(b, dictionaryBatch.isDelta);
    _DictionaryBatch.addData(b, dataOffset);
    return _DictionaryBatch.endDictionaryBatch(b);
}
/** @ignore */
function encodeFieldNode(b, node) {
    return _FieldNode.createFieldNode(b, new Long(node.length, 0), new Long(node.nullCount, 0));
}
/** @ignore */
function encodeBufferRegion(b, node) {
    return _Buffer.createBuffer(b, new Long(node.offset, 0), new Long(node.length, 0));
}
/** @ignore */
var platformIsLittleEndian = (function () {
    var buffer = new ArrayBuffer(2);
    new DataView(buffer).setInt16(0, 256, true /* littleEndian */);
    // Int16Array uses the platform's endianness.
    return new Int16Array(buffer)[0] === 256;
})();



/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(24);
var global = __webpack_require__(6);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(26) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(29);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(32);
var toLength = __webpack_require__(15);
var toAbsoluteIndex = __webpack_require__(54);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(30);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(56);
var createDesc = __webpack_require__(39);
var toIObject = __webpack_require__(32);
var toPrimitive = __webpack_require__(38);
var has = __webpack_require__(19);
var IE8_DOM_DEFINE = __webpack_require__(88);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(14) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 56 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(27);
var IObject = __webpack_require__(52);
var toObject = __webpack_require__(17);
var toLength = __webpack_require__(15);
var asc = __webpack_require__(151);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(1);

$export($export.S, 'Array', { isArray: __webpack_require__(66) });


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Row; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__schema__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_pretty__ = __webpack_require__(201);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.




/** @ignore */ var columnDescriptor = { enumerable: true, configurable: false, get: function () { } };
/** @ignore */ var lengthDescriptor = { writable: false, enumerable: false, configurable: false, value: -1 };
/** @ignore */ var rowIndexDescriptor = { writable: false, enumerable: false, configurable: true, value: null };
/** @ignore */ var rowParentDescriptor = { writable: false, enumerable: false, configurable: false, value: null };
/** @ignore */ var row = { parent: rowParentDescriptor, rowIndex: rowIndexDescriptor };
/** @ignore */
var Row = /** @class */ (function () {
    function Row(fields, fieldsAreEnumerable) {
        var _this = this;
        lengthDescriptor.value = fields.length;
        Object.defineProperty(this, 'length', lengthDescriptor);
        fields.forEach(function (field, columnIndex) {
            columnDescriptor.get = _this._bindGetter(columnIndex);
            // set configurable to true to ensure Object.defineProperty
            // doesn't throw in the case of duplicate column names
            columnDescriptor.configurable = true;
            columnDescriptor.enumerable = fieldsAreEnumerable;
            Object.defineProperty(_this, field.name, columnDescriptor);
            columnDescriptor.configurable = false;
            columnDescriptor.enumerable = !fieldsAreEnumerable;
            Object.defineProperty(_this, columnIndex, columnDescriptor);
            columnDescriptor.get = null;
        });
    }
    /** @nocollapse */
    Row.new = function (schemaOrFields, fieldsAreEnumerable) {
        if (fieldsAreEnumerable === void 0) { fieldsAreEnumerable = false; }
        var schema, fields;
        if (Array.isArray(schemaOrFields)) {
            fields = schemaOrFields;
        }
        else {
            schema = schemaOrFields;
            fieldsAreEnumerable = true;
            fields = Object.keys(schema).map(function (x) { return new __WEBPACK_IMPORTED_MODULE_1__schema__["a" /* Field */](x, schema[x]); });
        }
        return new Row(fields, fieldsAreEnumerable);
    };
    Row.prototype[Symbol.iterator] = function () {
        var i, n;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
            switch (_a.label) {
                case 0:
                    i = -1, n = this.length;
                    _a.label = 1;
                case 1:
                    if (!(++i < n)) return [3 /*break*/, 4];
                    return [4 /*yield*/, this[i]];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [3 /*break*/, 1];
                case 4: return [2 /*return*/];
            }
        });
    };
    Row.prototype._bindGetter = function (colIndex) {
        return function () {
            var child = this.parent.getChildAt(colIndex);
            return child ? child.get(this.rowIndex) : null;
        };
    };
    Row.prototype.get = function (key) { return this[key]; };
    Row.prototype.bind = function (parent, rowIndex) {
        rowIndexDescriptor.value = rowIndex;
        rowParentDescriptor.value = parent;
        var bound = Object.create(this, row);
        rowIndexDescriptor.value = null;
        rowParentDescriptor.value = null;
        return bound;
    };
    Row.prototype.toJSON = function () {
        var _this = this;
        return __WEBPACK_IMPORTED_MODULE_2__type__["DataType"].isStruct(this.parent.type) ? __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](this) :
            Object.getOwnPropertyNames(this).reduce(function (props, prop) {
                return (props[prop] = _this[prop]) && props || props;
            }, {});
    };
    Row.prototype.toString = function () {
        var _this = this;
        return __WEBPACK_IMPORTED_MODULE_2__type__["DataType"].isStruct(this.parent.type) ?
            __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](this).map(function (x) { return Object(__WEBPACK_IMPORTED_MODULE_3__util_pretty__["a" /* valueToString */])(x); }).join(', ') :
            Object.getOwnPropertyNames(this).reduce(function (props, prop) {
                return (props[prop] = Object(__WEBPACK_IMPORTED_MODULE_3__util_pretty__["a" /* valueToString */])(_this[prop])) && props || props;
            }, {});
    };
    return Row;
}());




/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RecordBatch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__table__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__schema__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__type__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vector_struct__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vector_chunked__ = __webpack_require__(47);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.







var RecordBatch = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](RecordBatch, _super);
    function RecordBatch() {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        var schema = args[0];
        var data;
        var children;
        if (typeof args[1] === 'number') {
            var fields = schema.fields;
            var _b = __WEBPACK_IMPORTED_MODULE_0_tslib__["i" /* __read */](args, 3), numRows = _b[1], childData = _b[2];
            data = __WEBPACK_IMPORTED_MODULE_1__data__["Data"].Struct(new __WEBPACK_IMPORTED_MODULE_4__type__["Struct"](fields), 0, numRows, 0, null, childData);
        }
        else {
            _a = __WEBPACK_IMPORTED_MODULE_0_tslib__["i" /* __read */](args, 3), data = _a[1], children = _a[2];
        }
        _this = _super.call(this, data, children) || this;
        _this._schema = schema;
        return _this;
    }
    /** @nocollapse */
    RecordBatch.from = function (vectors, names) {
        if (names === void 0) { names = []; }
        return new RecordBatch(__WEBPACK_IMPORTED_MODULE_3__schema__["b" /* Schema */].from(vectors, names), vectors.reduce(function (len, vec) { return Math.max(len, vec.length); }, 0), vectors);
    };
    RecordBatch.prototype.clone = function (data, children) {
        if (children === void 0) { children = this._children; }
        return new RecordBatch(this._schema, data, children);
    };
    RecordBatch.prototype.concat = function () {
        var others = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            others[_i] = arguments[_i];
        }
        var schema = this._schema, chunks = __WEBPACK_IMPORTED_MODULE_6__vector_chunked__["a" /* Chunked */].flatten.apply(__WEBPACK_IMPORTED_MODULE_6__vector_chunked__["a" /* Chunked */], __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */]([this], others));
        return new __WEBPACK_IMPORTED_MODULE_2__table__["Table"](schema, chunks.map(function (_a) {
            var data = _a.data;
            return new RecordBatch(schema, data);
        }));
    };
    Object.defineProperty(RecordBatch.prototype, "schema", {
        get: function () { return this._schema; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecordBatch.prototype, "numCols", {
        get: function () { return this._schema.fields.length; },
        enumerable: true,
        configurable: true
    });
    RecordBatch.prototype.select = function () {
        var columnNames = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            columnNames[_i] = arguments[_i];
        }
        var _a;
        var fields = this._schema.fields;
        var schema = (_a = this._schema).select.apply(_a, __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](columnNames));
        var childNames = columnNames.reduce(function (xs, x) { return (xs[x] = true) && xs; }, {});
        var childData = this.data.childData.filter(function (_, i) { return childNames[fields[i].name]; });
        var structData = __WEBPACK_IMPORTED_MODULE_1__data__["Data"].Struct(new __WEBPACK_IMPORTED_MODULE_4__type__["Struct"](schema.fields), 0, this.length, 0, null, childData);
        return new RecordBatch(schema, structData);
    };
    return RecordBatch;
}(__WEBPACK_IMPORTED_MODULE_5__vector_struct__["a" /* StructVector */]));




/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsyncByteQueue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ByteStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AsyncByteStream; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__adapters__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_utf8__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__interfaces__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_buffer__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_compat__ = __webpack_require__(37);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.






/** @ignore */
var AsyncByteQueue = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](AsyncByteQueue, _super);
    function AsyncByteQueue() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AsyncByteQueue.prototype.write = function (value) {
        if ((value = Object(__WEBPACK_IMPORTED_MODULE_4__util_buffer__["e" /* toUint8Array */])(value)).byteLength > 0) {
            return _super.prototype.write.call(this, value);
        }
    };
    AsyncByteQueue.prototype.toString = function (sync) {
        if (sync === void 0) { sync = false; }
        return sync
            ? Object(__WEBPACK_IMPORTED_MODULE_2__util_utf8__["a" /* decodeUtf8 */])(this.toUint8Array(true))
            : this.toUint8Array(false).then(__WEBPACK_IMPORTED_MODULE_2__util_utf8__["a" /* decodeUtf8 */]);
    };
    AsyncByteQueue.prototype.toUint8Array = function (sync) {
        var _this = this;
        if (sync === void 0) { sync = false; }
        return sync ? Object(__WEBPACK_IMPORTED_MODULE_4__util_buffer__["b" /* joinUint8Arrays */])(this._values)[0] : (function () { return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](_this, void 0, void 0, function () {
            var e_1, _a, buffers, byteLength, _b, _c, chunk, e_1_1;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_d) {
                switch (_d.label) {
                    case 0:
                        buffers = [], byteLength = 0;
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 6, 7, 12]);
                        _b = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __asyncValues */](this);
                        _d.label = 2;
                    case 2: return [4 /*yield*/, _b.next()];
                    case 3:
                        if (!(_c = _d.sent(), !_c.done)) return [3 /*break*/, 5];
                        chunk = _c.value;
                        buffers.push(chunk);
                        byteLength += chunk.byteLength;
                        _d.label = 4;
                    case 4: return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 12];
                    case 6:
                        e_1_1 = _d.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 12];
                    case 7:
                        _d.trys.push([7, , 10, 11]);
                        if (!(_c && !_c.done && (_a = _b.return))) return [3 /*break*/, 9];
                        return [4 /*yield*/, _a.call(_b)];
                    case 8:
                        _d.sent();
                        _d.label = 9;
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        if (e_1) throw e_1.error;
                        return [7 /*endfinally*/];
                    case 11: return [7 /*endfinally*/];
                    case 12: return [2 /*return*/, Object(__WEBPACK_IMPORTED_MODULE_4__util_buffer__["b" /* joinUint8Arrays */])(buffers, byteLength)[0]];
                }
            });
        }); })();
    };
    return AsyncByteQueue;
}(__WEBPACK_IMPORTED_MODULE_3__interfaces__["b" /* AsyncQueue */]));

/** @ignore */
var ByteStream = /** @class */ (function () {
    function ByteStream(source) {
        if (source) {
            this.source = new ByteStreamSource(__WEBPACK_IMPORTED_MODULE_1__adapters__["a" /* default */].fromIterable(source));
        }
    }
    ByteStream.prototype[Symbol.iterator] = function () { return this; };
    ByteStream.prototype.next = function (value) { return this.source.next(value); };
    ByteStream.prototype.throw = function (value) { return this.source.throw(value); };
    ByteStream.prototype.return = function (value) { return this.source.return(value); };
    ByteStream.prototype.peek = function (size) { return this.source.peek(size); };
    ByteStream.prototype.read = function (size) { return this.source.read(size); };
    return ByteStream;
}());

/** @ignore */
var AsyncByteStream = /** @class */ (function () {
    function AsyncByteStream(source) {
        if (source instanceof AsyncByteStream) {
            this.source = source.source;
        }
        else if (source instanceof AsyncByteQueue) {
            this.source = new AsyncByteStreamSource(__WEBPACK_IMPORTED_MODULE_1__adapters__["a" /* default */].fromAsyncIterable(source));
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_5__util_compat__["i" /* isReadableNodeStream */])(source)) {
            this.source = new AsyncByteStreamSource(__WEBPACK_IMPORTED_MODULE_1__adapters__["a" /* default */].fromNodeStream(source));
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_5__util_compat__["c" /* isFetchResponse */])(source)) {
            this.source = new AsyncByteStreamSource(__WEBPACK_IMPORTED_MODULE_1__adapters__["a" /* default */].fromDOMStream(source.body));
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_5__util_compat__["e" /* isIterable */])(source)) {
            this.source = new AsyncByteStreamSource(__WEBPACK_IMPORTED_MODULE_1__adapters__["a" /* default */].fromIterable(source));
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_5__util_compat__["g" /* isPromise */])(source)) {
            this.source = new AsyncByteStreamSource(__WEBPACK_IMPORTED_MODULE_1__adapters__["a" /* default */].fromAsyncIterable(source));
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_5__util_compat__["b" /* isAsyncIterable */])(source)) {
            this.source = new AsyncByteStreamSource(__WEBPACK_IMPORTED_MODULE_1__adapters__["a" /* default */].fromAsyncIterable(source));
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_5__util_compat__["h" /* isReadableDOMStream */])(source)) {
            this.source = new AsyncByteStreamSource(__WEBPACK_IMPORTED_MODULE_1__adapters__["a" /* default */].fromDOMStream(source));
        }
    }
    AsyncByteStream.prototype[Symbol.asyncIterator] = function () { return this; };
    AsyncByteStream.prototype.next = function (value) { return this.source.next(value); };
    AsyncByteStream.prototype.throw = function (value) { return this.source.throw(value); };
    AsyncByteStream.prototype.return = function (value) { return this.source.return(value); };
    Object.defineProperty(AsyncByteStream.prototype, "closed", {
        get: function () { return this.source.closed; },
        enumerable: true,
        configurable: true
    });
    AsyncByteStream.prototype.cancel = function (reason) { return this.source.cancel(reason); };
    AsyncByteStream.prototype.peek = function (size) { return this.source.peek(size); };
    AsyncByteStream.prototype.read = function (size) { return this.source.read(size); };
    return AsyncByteStream;
}());

/** @ignore */
var ByteStreamSource = /** @class */ (function () {
    function ByteStreamSource(source) {
        this.source = source;
    }
    ByteStreamSource.prototype.cancel = function (reason) { this.return(reason); };
    ByteStreamSource.prototype.peek = function (size) { return this.next(size, 'peek').value; };
    ByteStreamSource.prototype.read = function (size) { return this.next(size, 'read').value; };
    ByteStreamSource.prototype.next = function (size, cmd) {
        if (cmd === void 0) { cmd = 'read'; }
        return this.source.next({ cmd: cmd, size: size });
    };
    ByteStreamSource.prototype.throw = function (value) { return Object.create((this.source.throw && this.source.throw(value)) || __WEBPACK_IMPORTED_MODULE_3__interfaces__["c" /* ITERATOR_DONE */]); };
    ByteStreamSource.prototype.return = function (value) { return Object.create((this.source.return && this.source.return(value)) || __WEBPACK_IMPORTED_MODULE_3__interfaces__["c" /* ITERATOR_DONE */]); };
    return ByteStreamSource;
}());
/** @ignore */
var AsyncByteStreamSource = /** @class */ (function () {
    function AsyncByteStreamSource(source) {
        var _this = this;
        this.source = source;
        this._closedPromise = new Promise(function (r) { return _this._closedPromiseResolve = r; });
    }
    AsyncByteStreamSource.prototype.cancel = function (reason) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () { return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.return(reason)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        }); });
    };
    Object.defineProperty(AsyncByteStreamSource.prototype, "closed", {
        get: function () { return this._closedPromise; },
        enumerable: true,
        configurable: true
    });
    AsyncByteStreamSource.prototype.read = function (size) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () { return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.next(size, 'read')];
                case 1: return [2 /*return*/, (_a.sent()).value];
            }
        }); });
    };
    AsyncByteStreamSource.prototype.peek = function (size) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () { return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.next(size, 'peek')];
                case 1: return [2 /*return*/, (_a.sent()).value];
            }
        }); });
    };
    AsyncByteStreamSource.prototype.next = function (size, cmd) {
        if (cmd === void 0) { cmd = 'read'; }
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () { return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.source.next({ cmd: cmd, size: size })];
                case 1: return [2 /*return*/, (_a.sent())];
            }
        }); });
    };
    AsyncByteStreamSource.prototype.throw = function (value) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () {
            var result, _a;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.source.throw;
                        if (!_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.source.throw(value)];
                    case 1:
                        _a = (_b.sent());
                        _b.label = 2;
                    case 2:
                        result = (_a) || __WEBPACK_IMPORTED_MODULE_3__interfaces__["c" /* ITERATOR_DONE */];
                        this._closedPromiseResolve && this._closedPromiseResolve();
                        this._closedPromiseResolve = undefined;
                        return [2 /*return*/, Object.create(result)];
                }
            });
        });
    };
    AsyncByteStreamSource.prototype.return = function (value) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () {
            var result, _a;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.source.return;
                        if (!_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.source.return(value)];
                    case 1:
                        _a = (_b.sent());
                        _b.label = 2;
                    case 2:
                        result = (_a) || __WEBPACK_IMPORTED_MODULE_3__interfaces__["c" /* ITERATOR_DONE */];
                        this._closedPromiseResolve && this._closedPromiseResolve();
                        this._closedPromiseResolve = undefined;
                        return [2 /*return*/, Object.create(result)];
                }
            });
        });
    };
    return AsyncByteStreamSource;
}());



/***/ }),
/* 62 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(10);
var document = __webpack_require__(6).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(51)('keys');
var uid = __webpack_require__(25);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 65 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(29);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var defined = __webpack_require__(33);
var fails = __webpack_require__(8);
var spaces = __webpack_require__(92);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(93)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(41);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(155);
var redefine = __webpack_require__(20);
var hide = __webpack_require__(16);
var fails = __webpack_require__(8);
var defined = __webpack_require__(33);
var wks = __webpack_require__(4);
var regexpExec = __webpack_require__(71);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(156);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(6);
var has = __webpack_require__(19);
var cof = __webpack_require__(29);
var inheritIfRequired = __webpack_require__(158);
var toPrimitive = __webpack_require__(38);
var fails = __webpack_require__(8);
var gOPN = __webpack_require__(42).f;
var gOPD = __webpack_require__(55).f;
var dP = __webpack_require__(13).f;
var $trim = __webpack_require__(67).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(40)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(14) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(20)(global, NUMBER, $Number);
}


/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(9);
var aFunction = __webpack_require__(28);
var SPECIES = __webpack_require__(4)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(20);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(41);
var test = {};
test[__webpack_require__(4)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(20)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $indexOf = __webpack_require__(53)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(34)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(110)('asyncIterator');


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(6);
var has = __webpack_require__(19);
var DESCRIPTORS = __webpack_require__(14);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(20);
var META = __webpack_require__(182).KEY;
var $fails = __webpack_require__(8);
var shared = __webpack_require__(51);
var setToStringTag = __webpack_require__(43);
var uid = __webpack_require__(25);
var wks = __webpack_require__(4);
var wksExt = __webpack_require__(111);
var wksDefine = __webpack_require__(110);
var enumKeys = __webpack_require__(183);
var isArray = __webpack_require__(66);
var anObject = __webpack_require__(9);
var isObject = __webpack_require__(10);
var toIObject = __webpack_require__(32);
var toPrimitive = __webpack_require__(38);
var createDesc = __webpack_require__(39);
var _create = __webpack_require__(40);
var gOPNExt = __webpack_require__(184);
var $GOPD = __webpack_require__(55);
var $DP = __webpack_require__(13);
var $keys = __webpack_require__(31);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(42).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(56).f = $propertyIsEnumerable;
  __webpack_require__(80).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(26)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(16)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 80 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate (y) {
        var date;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            var args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays (ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays :
            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
            : (m) ? weekdays[m.day()] : weekdays;
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                __webpack_require__(189)("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    var MS_PER_SECOND = 1000;
    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':   return months;
                case 'quarter': return months / 3;
                case 'year':    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asQuarters     = makeAs('Q');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asQuarters     = asQuarters;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.24.0';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(188)(module)))

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Table", function() { return Table; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__column__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__schema__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_compat__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__recordbatch__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ipc_reader__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vector_index__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ipc_writer__ = __webpack_require__(214);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.








var Table = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Table, _super);
    function Table() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        var schema = null;
        if (args[0] instanceof __WEBPACK_IMPORTED_MODULE_2__schema__["b" /* Schema */]) {
            schema = args.shift();
        }
        var chunks = args.reduce(function flatten(xs, x) {
            return Array.isArray(x) ? x.reduce(flatten, xs) : __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](xs, [x]);
        }, []).filter(function (x) { return x instanceof __WEBPACK_IMPORTED_MODULE_4__recordbatch__["a" /* RecordBatch */]; });
        if (!schema && !(schema = chunks[0] && chunks[0].schema)) {
            throw new TypeError('Table must be initialized with a Schema or at least one RecordBatch');
        }
        if (!chunks[0]) {
            chunks[0] = new __WEBPACK_IMPORTED_MODULE_4__recordbatch__["a" /* RecordBatch */](schema, 0, []);
        }
        _this = _super.call(this, chunks[0].type, chunks) || this;
        _this._schema = schema;
        _this._chunks = chunks;
        return _this;
    }
    /** @nocollapse */
    Table.empty = function () { return new Table(new __WEBPACK_IMPORTED_MODULE_2__schema__["b" /* Schema */]([]), []); };
    /** @nocollapse */
    Table.from = function (source) {
        var _this = this;
        if (!source) {
            return Table.empty();
        }
        var reader = __WEBPACK_IMPORTED_MODULE_5__ipc_reader__["a" /* RecordBatchReader */].from(source);
        if (Object(__WEBPACK_IMPORTED_MODULE_3__util_compat__["g" /* isPromise */])(reader)) {
            return (function () { return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](_this, void 0, void 0, function () { var _a, _b; return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _b = (_a = Table).from;
                        return [4 /*yield*/, reader];
                    case 1: return [4 /*yield*/, _b.apply(_a, [_c.sent()])];
                    case 2: return [2 /*return*/, _c.sent()];
                }
            }); }); })();
        }
        if (reader.isSync() && (reader = reader.open())) {
            return !reader.schema ? Table.empty() : new Table(reader.schema, __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](reader));
        }
        return (function (opening) { return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](_this, void 0, void 0, function () {
            var e_1, _a, reader, schema, batches, reader_1, reader_1_1, batch, e_1_1;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, opening];
                    case 1:
                        reader = _b.sent();
                        schema = reader.schema;
                        batches = [];
                        if (!schema) return [3 /*break*/, 14];
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 7, 8, 13]);
                        reader_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __asyncValues */](reader);
                        _b.label = 3;
                    case 3: return [4 /*yield*/, reader_1.next()];
                    case 4:
                        if (!(reader_1_1 = _b.sent(), !reader_1_1.done)) return [3 /*break*/, 6];
                        batch = reader_1_1.value;
                        batches.push(batch);
                        _b.label = 5;
                    case 5: return [3 /*break*/, 3];
                    case 6: return [3 /*break*/, 13];
                    case 7:
                        e_1_1 = _b.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 13];
                    case 8:
                        _b.trys.push([8, , 11, 12]);
                        if (!(reader_1_1 && !reader_1_1.done && (_a = reader_1.return))) return [3 /*break*/, 10];
                        return [4 /*yield*/, _a.call(reader_1)];
                    case 9:
                        _b.sent();
                        _b.label = 10;
                    case 10: return [3 /*break*/, 12];
                    case 11:
                        if (e_1) throw e_1.error;
                        return [7 /*endfinally*/];
                    case 12: return [7 /*endfinally*/];
                    case 13: return [2 /*return*/, new Table(schema, batches)];
                    case 14: return [2 /*return*/, Table.empty()];
                }
            });
        }); })(reader.open());
    };
    /** @nocollapse */
    Table.fromAsync = function (source) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () {
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Table.from(source)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /** @nocollapse */
    Table.fromVectors = function (vectors, names) {
        return new Table(__WEBPACK_IMPORTED_MODULE_4__recordbatch__["a" /* RecordBatch */].from(vectors, names));
    };
    /** @nocollapse */
    Table.fromStruct = function (struct) {
        var schema = new __WEBPACK_IMPORTED_MODULE_2__schema__["b" /* Schema */](struct.type.children);
        var chunks = (struct instanceof __WEBPACK_IMPORTED_MODULE_6__vector_index__["a" /* Chunked */] ? struct.chunks : [struct]);
        return new Table(schema, chunks.map(function (chunk) { return new __WEBPACK_IMPORTED_MODULE_4__recordbatch__["a" /* RecordBatch */](schema, chunk.data); }));
    };
    Object.defineProperty(Table.prototype, "schema", {
        get: function () { return this._schema; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Table.prototype, "length", {
        get: function () { return this._length; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Table.prototype, "chunks", {
        get: function () { return this._chunks; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Table.prototype, "numCols", {
        get: function () { return this._numChildren; },
        enumerable: true,
        configurable: true
    });
    Table.prototype.clone = function (chunks) {
        if (chunks === void 0) { chunks = this._chunks; }
        return new Table(this._schema, chunks);
    };
    Table.prototype.getColumnAt = function (index) {
        return this.getChildAt(index);
    };
    Table.prototype.getColumn = function (name) {
        return this.getColumnAt(this.getColumnIndex(name));
    };
    Table.prototype.getColumnIndex = function (name) {
        return this._schema.fields.findIndex(function (f) { return f.name === name; });
    };
    Table.prototype.getChildAt = function (index) {
        if (index < 0 || index >= this.numChildren) {
            return null;
        }
        var schema = this._schema;
        var column, field, chunks;
        var columns = this._children || (this._children = []);
        if (column = columns[index]) {
            return column;
        }
        if (field = (schema.fields || [])[index]) {
            chunks = this._chunks
                .map(function (chunk) { return chunk.getChildAt(index); })
                .filter(function (vec) { return vec != null; });
            if (chunks.length > 0) {
                return (columns[index] = new __WEBPACK_IMPORTED_MODULE_1__column__["a" /* Column */](field, chunks));
            }
        }
        return null;
    };
    // @ts-ignore
    Table.prototype.serialize = function (encoding, stream) {
        if (encoding === void 0) { encoding = 'binary'; }
        if (stream === void 0) { stream = true; }
        var writer = !stream
            ? __WEBPACK_IMPORTED_MODULE_7__ipc_writer__["a" /* RecordBatchFileWriter */]
            : __WEBPACK_IMPORTED_MODULE_7__ipc_writer__["b" /* RecordBatchStreamWriter */];
        return writer.writeAll(this._chunks).toUint8Array(true);
    };
    Table.prototype.count = function () {
        return this._length;
    };
    Table.prototype.select = function () {
        var columnNames = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            columnNames[_i] = arguments[_i];
        }
        return new Table(this._chunks.map(function (batch) { return batch.select.apply(batch, __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](columnNames)); }));
    };
    return Table;
}(__WEBPACK_IMPORTED_MODULE_6__vector_index__["a" /* Chunked */]));




/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Column; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vector_chunked__ = __webpack_require__(47);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.


var Column = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Column, _super);
    function Column(field, vectors, offsets) {
        if (vectors === void 0) { vectors = []; }
        var _this = this;
        vectors = __WEBPACK_IMPORTED_MODULE_1__vector_chunked__["a" /* Chunked */].flatten.apply(__WEBPACK_IMPORTED_MODULE_1__vector_chunked__["a" /* Chunked */], __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](vectors));
        _this = _super.call(this, field.type, vectors, offsets) || this;
        _this._field = field;
        if (vectors.length === 1 && !(_this instanceof SingleChunkColumn)) {
            return new SingleChunkColumn(field, vectors[0], _this._chunkOffsets);
        }
        return _this;
    }
    Object.defineProperty(Column.prototype, "field", {
        get: function () { return this._field; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "name", {
        get: function () { return this._field.name; },
        enumerable: true,
        configurable: true
    });
    Column.prototype.clone = function (chunks) {
        if (chunks === void 0) { chunks = this._chunks; }
        return new Column(this._field, chunks);
    };
    Column.prototype.getChildAt = function (index) {
        if (index < 0 || index >= this.numChildren) {
            return null;
        }
        var columns = this._children || (this._children = []);
        var column, field, chunks;
        if (column = columns[index]) {
            return column;
        }
        if (field = (this.type.children || [])[index]) {
            chunks = this._chunks
                .map(function (vector) { return vector.getChildAt(index); })
                .filter(function (vec) { return vec != null; });
            if (chunks.length > 0) {
                return (columns[index] = new Column(field, chunks));
            }
        }
        return null;
    };
    return Column;
}(__WEBPACK_IMPORTED_MODULE_1__vector_chunked__["a" /* Chunked */]));

var SingleChunkColumn = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](SingleChunkColumn, _super);
    function SingleChunkColumn(field, vector, offsets) {
        var _this = _super.call(this, field, [vector], offsets) || this;
        _this._chunk = vector;
        return _this;
    }
    SingleChunkColumn.prototype.search = function (index, then) {
        return then ? then(this, 0, index) : [0, index];
    };
    SingleChunkColumn.prototype.isValid = function (index) {
        return this._chunk.isValid(index);
    };
    SingleChunkColumn.prototype.get = function (index) {
        return this._chunk.get(index);
    };
    SingleChunkColumn.prototype.set = function (index, value) {
        this._chunk.set(index, value);
    };
    SingleChunkColumn.prototype.indexOf = function (element, offset) {
        return this._chunk.indexOf(element, offset);
    };
    return SingleChunkColumn;
}(Column));



/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export clampIndex */
/* harmony export (immutable) */ __webpack_exports__["a"] = clampRange;
/* harmony export (immutable) */ __webpack_exports__["b"] = createElementComparator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vector__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vector_row__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_buffer__ = __webpack_require__(11);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.



/** @ignore */
function clampIndex(source, index, then) {
    var length = source.length;
    var adjust = index > -1 ? index : (length + (index % length));
    return then ? then(source, adjust) : adjust;
}
/** @ignore */
var tmp;
/** @ignore */
function clampRange(source, begin, end, then) {
    // Adjust args similar to Array.prototype.slice. Normalize begin/end to
    // clamp between 0 and length, and wrap around on negative indices, e.g.
    // slice(-1, 5) or slice(5, -1)
    var _a = source.length, len = _a === void 0 ? 0 : _a;
    var lhs = typeof begin !== 'number' ? 0 : begin;
    var rhs = typeof end !== 'number' ? len : end;
    // wrap around on negative start/end positions
    (lhs < 0) && (lhs = ((lhs % len) + len) % len);
    (rhs < 0) && (rhs = ((rhs % len) + len) % len);
    // ensure lhs <= rhs
    (rhs < lhs) && (tmp = lhs, lhs = rhs, rhs = tmp);
    // ensure rhs <= length
    (rhs > len) && (rhs = len);
    return then ? then(source, lhs, rhs) : [lhs, rhs];
}
/** @ignore */
function createElementComparator(search) {
    // Compare primitives
    if (search == null || typeof search !== 'object') {
        return function (value) { return value === search; };
    }
    // Compare Dates
    if (search instanceof Date) {
        var valueOfSearch_1 = search.valueOf();
        return function (value) { return value instanceof Date ? (value.valueOf() === valueOfSearch_1) : false; };
    }
    if (ArrayBuffer.isView(search)) {
        return function (value) { return value ? Object(__WEBPACK_IMPORTED_MODULE_2__util_buffer__["a" /* compareArrayLike */])(search, value) : false; };
    }
    // Compare Array-likes
    if (Array.isArray(search)) {
        var n_1 = search.length;
        var fns_1 = [];
        for (var i = -1; ++i < n_1;) {
            fns_1[i] = createElementComparator(search[i]);
        }
        return function (value) {
            if (!value || value.length !== n_1) {
                return false;
            }
            // Handle the case where the search element is an Array, but the
            // values are Rows or Vectors, e.g. list.indexOf(['foo', 'bar'])
            if ((value instanceof __WEBPACK_IMPORTED_MODULE_1__vector_row__["a" /* Row */]) || (value instanceof __WEBPACK_IMPORTED_MODULE_0__vector__["Vector"])) {
                for (var i = -1, n_2 = value.length; ++i < n_2;) {
                    if (!(fns_1[i](value.get(i)))) {
                        return false;
                    }
                }
                return true;
            }
            for (var i = -1, n_3 = value.length; ++i < n_3;) {
                if (!(fns_1[i](value[i]))) {
                    return false;
                }
            }
            return true;
        };
    }
    // Compare Rows and Vectors
    if ((search instanceof __WEBPACK_IMPORTED_MODULE_1__vector_row__["a" /* Row */]) || (search instanceof __WEBPACK_IMPORTED_MODULE_0__vector__["Vector"])) {
        var n_4 = search.length;
        var C_1 = search.constructor;
        var fns_2 = [];
        for (var i = -1; ++i < n_4;) {
            fns_2[i] = createElementComparator(search.get(i));
        }
        return function (value) {
            if (!(value instanceof C_1)) {
                return false;
            }
            if (!(value.length === n_4)) {
                return false;
            }
            for (var i = -1; ++i < n_4;) {
                if (!(fns_2[i](value.get(i)))) {
                    return false;
                }
            }
            return true;
        };
    }
    // Compare non-empty Objects
    var keys = Object.keys(search);
    if (keys.length > 0) {
        var n_5 = keys.length;
        var fns_3 = [];
        for (var i = -1; ++i < n_5;) {
            fns_3[i] = createElementComparator(search[keys[i]]);
        }
        return function (value) {
            if (!value || typeof value !== 'object') {
                return false;
            }
            for (var i = -1; ++i < n_5;) {
                if (!(fns_3[i](value[keys[i]]))) {
                    return false;
                }
            }
            return true;
        };
    }
    // No valid comparator
    return function () { return false; };
}



/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_buffer__ = __webpack_require__(11);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.


/** @ignore */
/* harmony default export */ __webpack_exports__["a"] = ({
    fromIterable: function (source) {
        return pump(fromIterable(source));
    },
    fromAsyncIterable: function (source) {
        return pump(fromAsyncIterable(source));
    },
    fromDOMStream: function (source) {
        return pump(fromDOMStream(source));
    },
    fromNodeStream: function (stream) {
        return pump(fromNodeStream(stream));
    },
    // @ts-ignore
    toDOMStream: function (source, options) {
        throw new Error("\"toDOMStream\" not available in this environment");
    },
    // @ts-ignore
    toNodeStream: function (source, options) {
        throw new Error("\"toNodeStream\" not available in this environment");
    },
});
/** @ignore */
var pump = function (iterator) { iterator.next(); return iterator; };
/** @ignore */
function fromIterable(source) {
    function byteRange() {
        var _a;
        if (cmd === 'peek') {
            return Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["b" /* joinUint8Arrays */])(buffers, size)[0];
        }
        _a = __WEBPACK_IMPORTED_MODULE_0_tslib__["i" /* __read */](Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["b" /* joinUint8Arrays */])(buffers, size), 3), buffer = _a[0], buffers = _a[1], bufferLength = _a[2];
        return buffer;
    }
    var _a, _b, _c, done, threw, buffers, buffer, cmd, size, bufferLength, it, e_1;
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_d) {
        switch (_d.label) {
            case 0:
                threw = false;
                buffers = [];
                bufferLength = 0;
                return [4 /*yield*/, null];
            case 1:
                // Yield so the caller can inject the read command before creating the source Iterator
                (_a = _d.sent(), cmd = _a.cmd, size = _a.size);
                it = Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["g" /* toUint8ArrayIterator */])(source)[Symbol.iterator]();
                _d.label = 2;
            case 2:
                _d.trys.push([2, 9, 10, 11]);
                _d.label = 3;
            case 3:
                // read the next value
                (_b = isNaN(size - bufferLength) ?
                    it.next(undefined) : it.next(size - bufferLength), done = _b.done, buffer = _b.value);
                // if chunk is not null or empty, push it onto the queue
                if (!done && buffer.byteLength > 0) {
                    buffers.push(buffer);
                    bufferLength += buffer.byteLength;
                }
                if (!(done || size <= bufferLength)) return [3 /*break*/, 7];
                _d.label = 4;
            case 4: return [4 /*yield*/, byteRange()];
            case 5:
                (_c = _d.sent(), cmd = _c.cmd, size = _c.size);
                _d.label = 6;
            case 6:
                if (size < bufferLength) return [3 /*break*/, 4];
                _d.label = 7;
            case 7:
                if (!done) return [3 /*break*/, 3];
                _d.label = 8;
            case 8: return [3 /*break*/, 11];
            case 9:
                e_1 = _d.sent();
                (threw = true) && (typeof it.throw === 'function') && (it.throw(e_1));
                return [3 /*break*/, 11];
            case 10:
                (threw === false) && (typeof it.return === 'function') && (it.return());
                return [7 /*endfinally*/];
            case 11: return [2 /*return*/];
        }
    });
}
/** @ignore */
function fromAsyncIterable(source) {
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __asyncGenerator */](this, arguments, function fromAsyncIterable_1() {
        function byteRange() {
            var _a;
            if (cmd === 'peek') {
                return Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["b" /* joinUint8Arrays */])(buffers, size)[0];
            }
            _a = __WEBPACK_IMPORTED_MODULE_0_tslib__["i" /* __read */](Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["b" /* joinUint8Arrays */])(buffers, size), 3), buffer = _a[0], buffers = _a[1], bufferLength = _a[2];
            return buffer;
        }
        var _a, _b, _c, done, threw, buffers, buffer, cmd, size, bufferLength, it, _d, e_2, _e, _f;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_g) {
            switch (_g.label) {
                case 0:
                    threw = false;
                    buffers = [];
                    bufferLength = 0;
                    return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __await */](null)];
                case 1: return [4 /*yield*/, _g.sent()];
                case 2:
                    // Yield so the caller can inject the read command before creating the source AsyncIterator
                    (_a = _g.sent(), cmd = _a.cmd, size = _a.size);
                    it = Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["f" /* toUint8ArrayAsyncIterator */])(source)[Symbol.asyncIterator]();
                    _g.label = 3;
                case 3:
                    _g.trys.push([3, 15, 18, 21]);
                    _g.label = 4;
                case 4:
                    if (!isNaN(size - bufferLength)) return [3 /*break*/, 6];
                    return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __await */](it.next(undefined))];
                case 5:
                    _d = _g.sent();
                    return [3 /*break*/, 8];
                case 6: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __await */](it.next(size - bufferLength))];
                case 7:
                    _d = _g.sent();
                    _g.label = 8;
                case 8:
                    // read the next value
                    (_b = _d, done = _b.done, buffer = _b.value);
                    // if chunk is not null or empty, push it onto the queue
                    if (!done && buffer.byteLength > 0) {
                        buffers.push(buffer);
                        bufferLength += buffer.byteLength;
                    }
                    if (!(done || size <= bufferLength)) return [3 /*break*/, 13];
                    _g.label = 9;
                case 9: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __await */](byteRange())];
                case 10: return [4 /*yield*/, _g.sent()];
                case 11:
                    (_c = _g.sent(), cmd = _c.cmd, size = _c.size);
                    _g.label = 12;
                case 12:
                    if (size < bufferLength) return [3 /*break*/, 9];
                    _g.label = 13;
                case 13:
                    if (!done) return [3 /*break*/, 4];
                    _g.label = 14;
                case 14: return [3 /*break*/, 21];
                case 15:
                    e_2 = _g.sent();
                    _e = (threw = true) && (typeof it.throw === 'function');
                    if (!_e) return [3 /*break*/, 17];
                    return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __await */](it.throw(e_2))];
                case 16:
                    _e = (_g.sent());
                    _g.label = 17;
                case 17:
                    _e;
                    return [3 /*break*/, 21];
                case 18:
                    _f = (threw === false) && (typeof it.return === 'function');
                    if (!_f) return [3 /*break*/, 20];
                    return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __await */](it.return())];
                case 19:
                    _f = (_g.sent());
                    _g.label = 20;
                case 20:
                    _f;
                    return [7 /*endfinally*/];
                case 21: return [2 /*return*/];
            }
        });
    });
}
// All this manual Uint8Array chunk management can be avoided if/when engines
// add support for ArrayBuffer.transfer() or ArrayBuffer.prototype.realloc():
// https://github.com/domenic/proposal-arraybuffer-transfer
/** @ignore */
function fromDOMStream(source) {
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __asyncGenerator */](this, arguments, function fromDOMStream_1() {
        function byteRange() {
            var _a;
            if (cmd === 'peek') {
                return Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["b" /* joinUint8Arrays */])(buffers, size)[0];
            }
            _a = __WEBPACK_IMPORTED_MODULE_0_tslib__["i" /* __read */](Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["b" /* joinUint8Arrays */])(buffers, size), 3), buffer = _a[0], buffers = _a[1], bufferLength = _a[2];
            return buffer;
        }
        var _a, _b, _c, done, threw, buffers, buffer, cmd, size, bufferLength, it, _d, e_3, _e, _f;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_g) {
            switch (_g.label) {
                case 0:
                    done = false, threw = false;
                    buffers = [];
                    bufferLength = 0;
                    return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __await */](null)];
                case 1: return [4 /*yield*/, _g.sent()];
                case 2:
                    // Yield so the caller can inject the read command before we establish the ReadableStream lock
                    (_a = _g.sent(), cmd = _a.cmd, size = _a.size);
                    it = new AdaptiveByteReader(source);
                    _g.label = 3;
                case 3:
                    _g.trys.push([3, 15, 18, 22]);
                    _g.label = 4;
                case 4:
                    if (!isNaN(size - bufferLength)) return [3 /*break*/, 6];
                    return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __await */](it['read'](undefined))];
                case 5:
                    _d = _g.sent();
                    return [3 /*break*/, 8];
                case 6: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __await */](it['read'](size - bufferLength))];
                case 7:
                    _d = _g.sent();
                    _g.label = 8;
                case 8:
                    // read the next value
                    (_b = _d, done = _b.done, buffer = _b.value);
                    // if chunk is not null or empty, push it onto the queue
                    if (!done && buffer.byteLength > 0) {
                        buffers.push(Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["e" /* toUint8Array */])(buffer));
                        bufferLength += buffer.byteLength;
                    }
                    if (!(done || size <= bufferLength)) return [3 /*break*/, 13];
                    _g.label = 9;
                case 9: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __await */](byteRange())];
                case 10: return [4 /*yield*/, _g.sent()];
                case 11:
                    (_c = _g.sent(), cmd = _c.cmd, size = _c.size);
                    _g.label = 12;
                case 12:
                    if (size < bufferLength) return [3 /*break*/, 9];
                    _g.label = 13;
                case 13:
                    if (!done) return [3 /*break*/, 4];
                    _g.label = 14;
                case 14: return [3 /*break*/, 22];
                case 15:
                    e_3 = _g.sent();
                    _e = (threw = true);
                    if (!_e) return [3 /*break*/, 17];
                    return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __await */](it['cancel'](e_3))];
                case 16:
                    _e = (_g.sent());
                    _g.label = 17;
                case 17:
                    _e;
                    return [3 /*break*/, 22];
                case 18:
                    if (!(threw === false)) return [3 /*break*/, 20];
                    return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __await */](it['cancel']())];
                case 19:
                    _f = (_g.sent());
                    return [3 /*break*/, 21];
                case 20:
                    _f = source['locked'] && it.releaseLock();
                    _g.label = 21;
                case 21:
                    _f;
                    return [7 /*endfinally*/];
                case 22: return [2 /*return*/];
            }
        });
    });
}
/** @ignore */
var AdaptiveByteReader = /** @class */ (function () {
    function AdaptiveByteReader(source) {
        this.source = source;
        this.byobReader = null;
        this.defaultReader = null;
        try {
            this.supportsBYOB = !!(this.reader = this.getBYOBReader());
        }
        catch (e) {
            this.supportsBYOB = !!!(this.reader = this.getDefaultReader());
        }
    }
    Object.defineProperty(AdaptiveByteReader.prototype, "closed", {
        get: function () {
            return this.reader ? this.reader['closed'].catch(function () { }) : Promise.resolve();
        },
        enumerable: true,
        configurable: true
    });
    AdaptiveByteReader.prototype.releaseLock = function () {
        if (this.reader) {
            this.reader.releaseLock();
        }
        this.reader = this.byobReader = this.defaultReader = null;
    };
    AdaptiveByteReader.prototype.cancel = function (reason) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () {
            var _a, reader, source, _b;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this, reader = _a.reader, source = _a.source;
                        _b = reader;
                        if (!_b) return [3 /*break*/, 2];
                        return [4 /*yield*/, reader['cancel'](reason)];
                    case 1:
                        _b = (_c.sent());
                        _c.label = 2;
                    case 2:
                        _b;
                        source && (source['locked'] && this.releaseLock());
                        return [2 /*return*/];
                }
            });
        });
    };
    AdaptiveByteReader.prototype.read = function (size) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () {
            var result, _a;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (size === 0) {
                            return [2 /*return*/, { done: this.reader == null, value: new Uint8Array(0) }];
                        }
                        if (!(!this.supportsBYOB || typeof size !== 'number')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getDefaultReader().read()];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.readFromBYOBReader(size)];
                    case 3:
                        _a = _b.sent();
                        _b.label = 4;
                    case 4:
                        result = _a;
                        !result.done && (result.value = Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["e" /* toUint8Array */])(result));
                        return [2 /*return*/, result];
                }
            });
        });
    };
    AdaptiveByteReader.prototype.getDefaultReader = function () {
        if (this.byobReader) {
            this.releaseLock();
        }
        if (!this.defaultReader) {
            this.defaultReader = this.source['getReader']();
            // We have to catch and swallow errors here to avoid uncaught promise rejection exceptions
            // that seem to be raised when we call `releaseLock()` on this reader. I'm still mystified
            // about why these errors are raised, but I'm sure there's some important spec reason that
            // I haven't considered. I hate to employ such an anti-pattern here, but it seems like the
            // only solution in this case :/
            this.defaultReader['closed'].catch(function () { });
        }
        return (this.reader = this.defaultReader);
    };
    AdaptiveByteReader.prototype.getBYOBReader = function () {
        if (this.defaultReader) {
            this.releaseLock();
        }
        if (!this.byobReader) {
            this.byobReader = this.source['getReader']({ mode: 'byob' });
            // We have to catch and swallow errors here to avoid uncaught promise rejection exceptions
            // that seem to be raised when we call `releaseLock()` on this reader. I'm still mystified
            // about why these errors are raised, but I'm sure there's some important spec reason that
            // I haven't considered. I hate to employ such an anti-pattern here, but it seems like the
            // only solution in this case :/
            this.byobReader['closed'].catch(function () { });
        }
        return (this.reader = this.byobReader);
    };
    // This strategy plucked from the example in the streams spec:
    // https://streams.spec.whatwg.org/#example-manual-read-bytes
    AdaptiveByteReader.prototype.readFromBYOBReader = function (size) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () {
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, readInto(this.getBYOBReader(), new ArrayBuffer(size), 0, size)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return AdaptiveByteReader;
}());
/** @ignore */
function readInto(reader, buffer, offset, size) {
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () {
        var _a, done, value;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (offset >= size) {
                        return [2 /*return*/, { done: false, value: new Uint8Array(buffer, 0, size) }];
                    }
                    return [4 /*yield*/, reader.read(new Uint8Array(buffer, offset, size - offset))];
                case 1:
                    _a = _b.sent(), done = _a.done, value = _a.value;
                    if (!(((offset += value.byteLength) < size) && !done)) return [3 /*break*/, 3];
                    return [4 /*yield*/, readInto(reader, value.buffer, offset, size)];
                case 2: return [2 /*return*/, _b.sent()];
                case 3: return [2 /*return*/, { done: done, value: new Uint8Array(value.buffer, 0, offset) }];
            }
        });
    });
}
/** @ignore */
var onEvent = function (stream, event) {
    var handler = function (_) { return resolve([event, _]); };
    var resolve;
    return [event, handler, new Promise(function (r) { return (resolve = r) && stream['once'](event, handler); })];
};
/** @ignore */
function fromNodeStream(stream) {
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __asyncGenerator */](this, arguments, function fromNodeStream_1() {
        function byteRange() {
            var _a;
            if (cmd === 'peek') {
                return Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["b" /* joinUint8Arrays */])(buffers, size)[0];
            }
            _a = __WEBPACK_IMPORTED_MODULE_0_tslib__["i" /* __read */](Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["b" /* joinUint8Arrays */])(buffers, size), 3), buffer = _a[0], buffers = _a[1], bufferLength = _a[2];
            return buffer;
        }
        function cleanup(events, err) {
            var _this = this;
            buffer = buffers = null;
            return new Promise(function (resolve, reject) { return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](_this, void 0, void 0, function () {
                var e_4, _a, events_1, events_1_1, _b, evt, fn, destroy;
                return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_c) {
                    try {
                        for (events_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["k" /* __values */](events), events_1_1 = events_1.next(); !events_1_1.done; events_1_1 = events_1.next()) {
                            _b = __WEBPACK_IMPORTED_MODULE_0_tslib__["i" /* __read */](events_1_1.value, 2), evt = _b[0], fn = _b[1];
                            stream['off'](evt, fn);
                        }
                    }
                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                    finally {
                        try {
                            if (events_1_1 && !events_1_1.done && (_a = events_1.return)) _a.call(events_1);
                        }
                        finally { if (e_4) throw e_4.error; }
                    }
                    try {
                        destroy = stream['destroy'];
                        destroy && destroy.call(stream, err);
                        err = undefined;
                    }
                    catch (e) {
                        err = e || err;
                    }
                    finally {
                        err != null ? reject(err) : resolve();
                    }
                    return [2 /*return*/];
                });
            }); });
        }
        var _a, _b, _c, events, event, done, err, cmd, size, bufferLength, buffers, buffer;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_d) {
            switch (_d.label) {
                case 0:
                    events = [];
                    event = 'error';
                    done = false, err = null;
                    bufferLength = 0;
                    buffers = [];
                    return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __await */](null)];
                case 1: return [4 /*yield*/, _d.sent()];
                case 2:
                    // Yield so the caller can inject the read command before we
                    // add the listener for the source stream's 'readable' event.
                    (_a = _d.sent(), cmd = _a.cmd, size = _a.size);
                    if (!stream['isTTY']) return [3 /*break*/, 6];
                    return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __await */](new Uint8Array(0))];
                case 3: return [4 /*yield*/, _d.sent()];
                case 4: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __await */].apply(void 0, [_d.sent()])];
                case 5: return [2 /*return*/, _d.sent()];
                case 6:
                    _d.trys.push([6, , 15, 17]);
                    // initialize the stream event handlers
                    events[0] = onEvent(stream, 'end');
                    events[1] = onEvent(stream, 'error');
                    _d.label = 7;
                case 7:
                    events[2] = onEvent(stream, 'readable');
                    return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __await */](Promise.race(events.map(function (x) { return x[2]; })))];
                case 8:
                    // wait on the first message event from the stream
                    _b = __WEBPACK_IMPORTED_MODULE_0_tslib__["i" /* __read */].apply(void 0, [_d.sent(), 2]), event = _b[0], err = _b[1];
                    // if the stream emitted an Error, rethrow it
                    if (event === 'error') {
                        return [3 /*break*/, 14];
                    }
                    if (!(done = event === 'end')) {
                        // If the size is NaN, request to read everything in the stream's internal buffer
                        if (!isFinite(size - bufferLength)) {
                            buffer = Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["e" /* toUint8Array */])(stream['read'](undefined));
                        }
                        else {
                            buffer = Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["e" /* toUint8Array */])(stream['read'](size - bufferLength));
                            // If the byteLength is 0, then the requested amount is more than the stream has
                            // in its internal buffer. In this case the stream needs a "kick" to tell it to
                            // continue emitting readable events, so request to read everything the stream
                            // has in its internal buffer right now.
                            if (buffer.byteLength < (size - bufferLength)) {
                                buffer = Object(__WEBPACK_IMPORTED_MODULE_1__util_buffer__["e" /* toUint8Array */])(stream['read'](undefined));
                            }
                        }
                        // if chunk is not null or empty, push it onto the queue
                        if (buffer.byteLength > 0) {
                            buffers.push(buffer);
                            bufferLength += buffer.byteLength;
                        }
                    }
                    if (!(done || size <= bufferLength)) return [3 /*break*/, 13];
                    _d.label = 9;
                case 9: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __await */](byteRange())];
                case 10: return [4 /*yield*/, _d.sent()];
                case 11:
                    (_c = _d.sent(), cmd = _c.cmd, size = _c.size);
                    _d.label = 12;
                case 12:
                    if (size < bufferLength) return [3 /*break*/, 9];
                    _d.label = 13;
                case 13:
                    if (!done) return [3 /*break*/, 7];
                    _d.label = 14;
                case 14: return [3 /*break*/, 17];
                case 15: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __await */](cleanup(events, event === 'error' ? err : null))];
                case 16:
                    _d.sent();
                    return [7 /*endfinally*/];
                case 17: return [2 /*return*/];
            }
        });
    });
}



/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StructVector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__row__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vector__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__type__ = __webpack_require__(3);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.





var StructVector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](StructVector, _super);
    function StructVector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StructVector.prototype.asMap = function (keysSorted) {
        if (keysSorted === void 0) { keysSorted = false; }
        return __WEBPACK_IMPORTED_MODULE_2__vector__["Vector"].new(this.data.clone(new __WEBPACK_IMPORTED_MODULE_4__type__["Map_"](this.type.children, keysSorted)));
    };
    Object.defineProperty(StructVector.prototype, "rowProxy", {
        get: function () {
            return this._rowProxy || (this._rowProxy = __WEBPACK_IMPORTED_MODULE_1__row__["a" /* Row */].new(this.type.children || [], false));
        },
        enumerable: true,
        configurable: true
    });
    return StructVector;
}(__WEBPACK_IMPORTED_MODULE_3__base__["a" /* BaseVector */]));




/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(143)
var ieee754 = __webpack_require__(144)
var isArray = __webpack_require__(145)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62)))

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(14) && !__webpack_require__(8)(function () {
  return Object.defineProperty(__webpack_require__(63)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(19);
var toIObject = __webpack_require__(32);
var arrayIndexOf = __webpack_require__(53)(false);
var IE_PROTO = __webpack_require__(64)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(6).document;
module.exports = document && document.documentElement;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(10);
var anObject = __webpack_require__(9);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(27)(Function.call, __webpack_require__(55).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(30);
var defined = __webpack_require__(33);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(35);
var ITERATOR = __webpack_require__(4)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(41);
var ITERATOR = __webpack_require__(4)('iterator');
var Iterators = __webpack_require__(35);
module.exports = __webpack_require__(24).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(27);
var invoke = __webpack_require__(97);
var html = __webpack_require__(90);
var cel = __webpack_require__(63);
var global = __webpack_require__(6);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(29)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 97 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(28);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(6);
var dP = __webpack_require__(13);
var DESCRIPTORS = __webpack_require__(14);
var SPECIES = __webpack_require__(4)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(4)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(26);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(20);
var hide = __webpack_require__(16);
var Iterators = __webpack_require__(35);
var $iterCreate = __webpack_require__(169);
var setToStringTag = __webpack_require__(43);
var getPrototypeOf = __webpack_require__(102);
var ITERATOR = __webpack_require__(4)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(19);
var toObject = __webpack_require__(17);
var IE_PROTO = __webpack_require__(64)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(4)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(16)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(17);
var $keys = __webpack_require__(31);

__webpack_require__(171)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(106);
var anObject = __webpack_require__(9);
var speciesConstructor = __webpack_require__(74);
var advanceStringIndex = __webpack_require__(68);
var toLength = __webpack_require__(15);
var callRegExpExec = __webpack_require__(69);
var regexpExec = __webpack_require__(71);
var fails = __webpack_require__(8);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(70)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(10);
var cof = __webpack_require__(29);
var MATCH = __webpack_require__(4)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(6);
var hide = __webpack_require__(16);
var uid = __webpack_require__(25);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(30);
var toLength = __webpack_require__(15);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(17);
var toAbsoluteIndex = __webpack_require__(54);
var toLength = __webpack_require__(15);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(6);
var core = __webpack_require__(24);
var LIBRARY = __webpack_require__(26);
var wksExt = __webpack_require__(111);
var defineProperty = __webpack_require__(13).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(4);


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.is_valid_date = is_valid_date;
exports.DateParser = exports.DATE_PARSE_CANDIDATES = void 0;

__webpack_require__(23);

__webpack_require__(78);

__webpack_require__(79);

__webpack_require__(45);

__webpack_require__(58);

__webpack_require__(77);

var _moment = _interopRequireDefault(__webpack_require__(81));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var DATE_PARSE_CANDIDATES = [_moment["default"].ISO_8601, _moment["default"].RFC_2822, "YYYY-MM-DD\\DHH:mm:ss.SSSS", "MM-DD-YYYY", "MM/DD/YYYY", "M/D/YYYY", "M/D/YY", "DD MMM YYYY", "HH:mm:ss.SSS"];
/**
 *
 *
 * @export
 * @param {string} x
 * @returns
 */

exports.DATE_PARSE_CANDIDATES = DATE_PARSE_CANDIDATES;

function is_valid_date(x) {
  return (0, _moment["default"])(x, DATE_PARSE_CANDIDATES, true).isValid();
}
/**
 *
 *
 * @export
 * @class DateParser
 */


var DateParser =
/*#__PURE__*/
function () {
  function DateParser() {
    _classCallCheck(this, DateParser);

    this.date_types = [];
    this.date_candidates = DATE_PARSE_CANDIDATES.slice();
    this.date_exclusions = [];
  }

  _createClass(DateParser, [{
    key: "parse",
    value: function parse(input) {
      if (this.date_exclusions.indexOf(input) > -1) {
        return null;
      } else {
        var val = input;

        var type = _typeof(val);

        if (val.getMonth) {
          return val;
        } else if (type === "string") {
          val = (0, _moment["default"])(input, this.date_types, true);

          if (!val.isValid() || this.date_types.length === 0) {
            for (var _iterator = this.date_candidates, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
              var _ref;

              if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
              } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
              }

              var candidate = _ref;
              val = (0, _moment["default"])(input, candidate, true);

              if (val.isValid()) {
                this.date_types.push(candidate);
                this.date_candidates.splice(this.date_candidates.indexOf(candidate), 1);
                return val.toDate();
              }
            }

            this.date_exclusions.push(input);
            return null;
          }

          return val.toDate();
        } else if (type === "number") {
          return new Date(val);
        }

        throw new Error("Unparseable date ".concat(val));
      }
    }
  }]);

  return DateParser;
}();

exports.DateParser = DateParser;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get_column_type = get_column_type;
exports.bindall = bindall;
exports.detectNode = detectNode;
exports.detectChrome = detectChrome;
exports.detectIE = void 0;

__webpack_require__(23);

__webpack_require__(192);

__webpack_require__(193);

__webpack_require__(196);

__webpack_require__(77);

__webpack_require__(197);

__webpack_require__(78);

__webpack_require__(79);

__webpack_require__(45);

__webpack_require__(58);

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/******************************************************************************
 *
 * Copyright (c) 2017, the Perspective Authors.
 *
 * This file is part of the Perspective library, distributed under the terms of
 * the Apache License 2.0.  The full license can be found in the LICENSE file.
 *
 */

/**
 * Gets human-readable types for a column
 * @private
 * @returns {string}
 */
function get_column_type(val) {
  if (val >= 1 && val <= 4) {
    return "integer";
  } else if (val === 19) {
    return "string";
  } else if (val === 10 || val === 9) {
    return "float";
  } else if (val === 11) {
    return "boolean";
  } else if (val === 12) {
    return "datetime";
  } else if (val === 13) {
    return "date";
  } else {
    console.warn("Unknown type for value ".concat(val, " with JS type ").concat(_typeof(val)));
  }
}
/**
 * Bind all methods in a class to the class instance.  It is sad that this is
 * necessary.
 *
 * @export
 * @param {*} self
 */


function bindall(self) {
  for (var _iterator = Object.getOwnPropertyNames(self.constructor.prototype), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var key = _ref;
    var value = self[key];

    if (key !== "constructor" && typeof value === "function") {
      self[key] = value.bind(self);
    }
  }
}
/**
 * Detect Node.js.
 *
 * Returns
 * -------
 * True if the current script is running in Node.js.
 */


function detectNode() {
  return typeof window === "undefined";
}
/**
 * Detect Internet Explorer.
 *
 * Returns
 * -------
 * True if the current script is running in Internet Explorer.
 */


var detectIE = __webpack_require__(199);
/**
 * Detect Chrome.
 *
 * Returns
 * -------
 * Detect if the current script is running in Chrome.
 */


exports.detectIE = detectIE;

function detectChrome() {
  var isChromium = window.chrome,
      winNav = window.navigator,
      vendorName = winNav.vendor,
      isOpera = winNav.userAgent.indexOf("OPR") > -1,
      isIEedge = winNav.userAgent.indexOf("Edge") > -1,
      isIOSChrome = winNav.userAgent.match("CriOS");

  if (isIOSChrome) {
    return true;
  } else if (isChromium !== null && typeof isChromium !== "undefined" && vendorName === "Google Inc." && isOpera === false && isIEedge === false) {
    return true;
  } else {
    return false;
  }
}

if (!String.prototype.includes) {
  String.prototype.includes = function (search, start) {
    if (typeof start !== "number") {
      start = 0;
    }

    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
} // from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/includes


if (!Array.prototype.includes) {
  Object.defineProperty(Array.prototype, "includes", {
    value: function value(searchElement, fromIndex) {
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      } // 1. Let O be ? ToObject(this value).


      var o = Object(this); // 2. Let len be ? ToLength(? Get(O, "length")).

      var len = o.length >>> 0; // 3. If len is 0, return false.

      if (len === 0) {
        return false;
      } // 4. Let n be ? ToInteger(fromIndex).
      //    (If fromIndex is undefined, this step produces the value 0.)


      var n = fromIndex | 0; // 5. If n ≥ 0, then
      //  a. Let k be n.
      // 6. Else n < 0,
      //  a. Let k be len + n.
      //  b. If k < 0, let k be 0.

      var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

      function sameValueZero(x, y) {
        return x === y || typeof x === "number" && typeof y === "number" && isNaN(x) && isNaN(y);
      } // 7. Repeat, while k < len


      while (k < len) {
        // a. Let elementK be the result of ? Get(O, ! ToString(k)).
        // b. If SameValueZero(searchElement, elementK) is true, return true.
        if (sameValueZero(o[k], searchElement)) {
          return true;
        } // c. Increase k by 1.


        k++;
      } // 8. Return false


      return false;
    }
  });
}


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return org; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Schema__ = __webpack_require__(46);
// automatically generated by the FlatBuffers compiler, do not modify

var org;
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                flatbuf.Schema = __WEBPACK_IMPORTED_MODULE_0__Schema__["a" /* org */].apache.arrow.flatbuf.Schema;
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * ----------------------------------------------------------------------
 * The root Message type
 * This union enables us to easily send different message types without
 * redundant storage, and in the future we can easily add new message types.
 *
 * Arrow implementations do not need to implement all of the message types,
 * which may include experimental metadata types. For maximum compatibility,
 * it is best to send data using RecordBatch
 *
 * @enum
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var MessageHeader;
                (function (MessageHeader) {
                    MessageHeader[MessageHeader["NONE"] = 0] = "NONE";
                    MessageHeader[MessageHeader["Schema"] = 1] = "Schema";
                    MessageHeader[MessageHeader["DictionaryBatch"] = 2] = "DictionaryBatch";
                    MessageHeader[MessageHeader["RecordBatch"] = 3] = "RecordBatch";
                    MessageHeader[MessageHeader["Tensor"] = 4] = "Tensor";
                })(MessageHeader = flatbuf.MessageHeader || (flatbuf.MessageHeader = {}));
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * ----------------------------------------------------------------------
 * Data structures for describing a table row batch (a collection of
 * equal-length Arrow arrays)
 * Metadata about a field at some level of a nested type tree (but not
 * its children).
 *
 * For example, a List<Int16> with values [[1, 2, 3], null, [4], [5, 6], null]
 * would have {length: 5, null_count: 2} for its List node, and {length: 6,
 * null_count: 0} for its Int16 node, as separate FieldNode structs
 *
 * @constructor
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var FieldNode = /** @class */ (function () {
                    function FieldNode() {
                        /**
                         * @type {number}
                         */
                        this.bb_pos = 0;
                    }
                    /**
                     * @param {number} i
                     * @param {flatbuffers.ByteBuffer} bb
                     * @returns {FieldNode}
                     */
                    FieldNode.prototype.__init = function (i, bb) {
                        this.bb_pos = i;
                        this.bb = bb;
                        return this;
                    };
                    /**
                     * The number of value slots in the Arrow array at this level of a nested
                     * tree
                     *
                     * @returns {flatbuffers.Long}
                     */
                    FieldNode.prototype.length = function () {
                        return this.bb.readInt64(this.bb_pos);
                    };
                    /**
                     * The number of observed nulls. Fields with null_count == 0 may choose not
                     * to write their physical validity bitmap out as a materialized buffer,
                     * instead setting the length of the bitmap buffer to 0.
                     *
                     * @returns {flatbuffers.Long}
                     */
                    FieldNode.prototype.nullCount = function () {
                        return this.bb.readInt64(this.bb_pos + 8);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {flatbuffers.Long} length
                     * @param {flatbuffers.Long} null_count
                     * @returns {flatbuffers.Offset}
                     */
                    FieldNode.createFieldNode = function (builder, length, null_count) {
                        builder.prep(8, 16);
                        builder.writeInt64(null_count);
                        builder.writeInt64(length);
                        return builder.offset();
                    };
                    return FieldNode;
                }());
                flatbuf.FieldNode = FieldNode;
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * A data header describing the shared memory layout of a "record" or "row"
 * batch. Some systems call this a "row batch" internally and others a "record
 * batch".
 *
 * @constructor
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var RecordBatch = /** @class */ (function () {
                    function RecordBatch() {
                        /**
                         * @type {number}
                         */
                        this.bb_pos = 0;
                    }
                    /**
                     * @param {number} i
                     * @param {flatbuffers.ByteBuffer} bb
                     * @returns {RecordBatch}
                     */
                    RecordBatch.prototype.__init = function (i, bb) {
                        this.bb_pos = i;
                        this.bb = bb;
                        return this;
                    };
                    /**
                     * @param {flatbuffers.ByteBuffer} bb
                     * @param {RecordBatch=} obj
                     * @returns {RecordBatch}
                     */
                    RecordBatch.getRootAsRecordBatch = function (bb, obj) {
                        return (obj || new RecordBatch).__init(bb.readInt32(bb.position()) + bb.position(), bb);
                    };
                    /**
                     * number of records / rows. The arrays in the batch should all have this
                     * length
                     *
                     * @returns {flatbuffers.Long}
                     */
                    RecordBatch.prototype.length = function () {
                        var offset = this.bb.__offset(this.bb_pos, 4);
                        return offset ? this.bb.readInt64(this.bb_pos + offset) : this.bb.createLong(0, 0);
                    };
                    /**
                     * Nodes correspond to the pre-ordered flattened logical schema
                     *
                     * @param {number} index
                     * @param {org.apache.arrow.flatbuf.FieldNode=} obj
                     * @returns {org.apache.arrow.flatbuf.FieldNode}
                     */
                    RecordBatch.prototype.nodes = function (index, obj) {
                        var offset = this.bb.__offset(this.bb_pos, 6);
                        return offset ? (obj || new org.apache.arrow.flatbuf.FieldNode).__init(this.bb.__vector(this.bb_pos + offset) + index * 16, this.bb) : null;
                    };
                    /**
                     * @returns {number}
                     */
                    RecordBatch.prototype.nodesLength = function () {
                        var offset = this.bb.__offset(this.bb_pos, 6);
                        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
                    };
                    /**
                     * Buffers correspond to the pre-ordered flattened buffer tree
                     *
                     * The number of buffers appended to this list depends on the schema. For
                     * example, most primitive arrays will have 2 buffers, 1 for the validity
                     * bitmap and 1 for the values. For struct arrays, there will only be a
                     * single buffer for the validity (nulls) bitmap
                     *
                     * @param {number} index
                     * @param {org.apache.arrow.flatbuf.Buffer=} obj
                     * @returns {org.apache.arrow.flatbuf.Buffer}
                     */
                    RecordBatch.prototype.buffers = function (index, obj) {
                        var offset = this.bb.__offset(this.bb_pos, 8);
                        return offset ? (obj || new __WEBPACK_IMPORTED_MODULE_0__Schema__["a" /* org */].apache.arrow.flatbuf.Buffer).__init(this.bb.__vector(this.bb_pos + offset) + index * 16, this.bb) : null;
                    };
                    /**
                     * @returns {number}
                     */
                    RecordBatch.prototype.buffersLength = function () {
                        var offset = this.bb.__offset(this.bb_pos, 8);
                        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     */
                    RecordBatch.startRecordBatch = function (builder) {
                        builder.startObject(3);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {flatbuffers.Long} length
                     */
                    RecordBatch.addLength = function (builder, length) {
                        builder.addFieldInt64(0, length, builder.createLong(0, 0));
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {flatbuffers.Offset} nodesOffset
                     */
                    RecordBatch.addNodes = function (builder, nodesOffset) {
                        builder.addFieldOffset(1, nodesOffset, 0);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {number} numElems
                     */
                    RecordBatch.startNodesVector = function (builder, numElems) {
                        builder.startVector(16, numElems, 8);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {flatbuffers.Offset} buffersOffset
                     */
                    RecordBatch.addBuffers = function (builder, buffersOffset) {
                        builder.addFieldOffset(2, buffersOffset, 0);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {number} numElems
                     */
                    RecordBatch.startBuffersVector = function (builder, numElems) {
                        builder.startVector(16, numElems, 8);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @returns {flatbuffers.Offset}
                     */
                    RecordBatch.endRecordBatch = function (builder) {
                        var offset = builder.endObject();
                        return offset;
                    };
                    return RecordBatch;
                }());
                flatbuf.RecordBatch = RecordBatch;
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * For sending dictionary encoding information. Any Field can be
 * dictionary-encoded, but in this case none of its children may be
 * dictionary-encoded.
 * There is one vector / column per dictionary, but that vector / column
 * may be spread across multiple dictionary batches by using the isDelta
 * flag
 *
 * @constructor
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var DictionaryBatch = /** @class */ (function () {
                    function DictionaryBatch() {
                        /**
                         * @type {number}
                         */
                        this.bb_pos = 0;
                    }
                    /**
                     * @param {number} i
                     * @param {flatbuffers.ByteBuffer} bb
                     * @returns {DictionaryBatch}
                     */
                    DictionaryBatch.prototype.__init = function (i, bb) {
                        this.bb_pos = i;
                        this.bb = bb;
                        return this;
                    };
                    /**
                     * @param {flatbuffers.ByteBuffer} bb
                     * @param {DictionaryBatch=} obj
                     * @returns {DictionaryBatch}
                     */
                    DictionaryBatch.getRootAsDictionaryBatch = function (bb, obj) {
                        return (obj || new DictionaryBatch).__init(bb.readInt32(bb.position()) + bb.position(), bb);
                    };
                    /**
                     * @returns {flatbuffers.Long}
                     */
                    DictionaryBatch.prototype.id = function () {
                        var offset = this.bb.__offset(this.bb_pos, 4);
                        return offset ? this.bb.readInt64(this.bb_pos + offset) : this.bb.createLong(0, 0);
                    };
                    /**
                     * @param {org.apache.arrow.flatbuf.RecordBatch=} obj
                     * @returns {org.apache.arrow.flatbuf.RecordBatch|null}
                     */
                    DictionaryBatch.prototype.data = function (obj) {
                        var offset = this.bb.__offset(this.bb_pos, 6);
                        return offset ? (obj || new org.apache.arrow.flatbuf.RecordBatch).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
                    };
                    /**
                     * If isDelta is true the values in the dictionary are to be appended to a
                     * dictionary with the indicated id
                     *
                     * @returns {boolean}
                     */
                    DictionaryBatch.prototype.isDelta = function () {
                        var offset = this.bb.__offset(this.bb_pos, 8);
                        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     */
                    DictionaryBatch.startDictionaryBatch = function (builder) {
                        builder.startObject(3);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {flatbuffers.Long} id
                     */
                    DictionaryBatch.addId = function (builder, id) {
                        builder.addFieldInt64(0, id, builder.createLong(0, 0));
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {flatbuffers.Offset} dataOffset
                     */
                    DictionaryBatch.addData = function (builder, dataOffset) {
                        builder.addFieldOffset(1, dataOffset, 0);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {boolean} isDelta
                     */
                    DictionaryBatch.addIsDelta = function (builder, isDelta) {
                        builder.addFieldInt8(2, +isDelta, +false);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @returns {flatbuffers.Offset}
                     */
                    DictionaryBatch.endDictionaryBatch = function (builder) {
                        var offset = builder.endObject();
                        return offset;
                    };
                    return DictionaryBatch;
                }());
                flatbuf.DictionaryBatch = DictionaryBatch;
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * @constructor
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var Message = /** @class */ (function () {
                    function Message() {
                        /**
                         * @type {number}
                         */
                        this.bb_pos = 0;
                    }
                    /**
                     * @param {number} i
                     * @param {flatbuffers.ByteBuffer} bb
                     * @returns {Message}
                     */
                    Message.prototype.__init = function (i, bb) {
                        this.bb_pos = i;
                        this.bb = bb;
                        return this;
                    };
                    /**
                     * @param {flatbuffers.ByteBuffer} bb
                     * @param {Message=} obj
                     * @returns {Message}
                     */
                    Message.getRootAsMessage = function (bb, obj) {
                        return (obj || new Message).__init(bb.readInt32(bb.position()) + bb.position(), bb);
                    };
                    /**
                     * @returns {org.apache.arrow.flatbuf.MetadataVersion}
                     */
                    Message.prototype.version = function () {
                        var offset = this.bb.__offset(this.bb_pos, 4);
                        return offset ? /** @type {org.apache.arrow.flatbuf.MetadataVersion} */ (this.bb.readInt16(this.bb_pos + offset)) : __WEBPACK_IMPORTED_MODULE_0__Schema__["a" /* org */].apache.arrow.flatbuf.MetadataVersion.V1;
                    };
                    /**
                     * @returns {org.apache.arrow.flatbuf.MessageHeader}
                     */
                    Message.prototype.headerType = function () {
                        var offset = this.bb.__offset(this.bb_pos, 6);
                        return offset ? /** @type {org.apache.arrow.flatbuf.MessageHeader} */ (this.bb.readUint8(this.bb_pos + offset)) : org.apache.arrow.flatbuf.MessageHeader.NONE;
                    };
                    /**
                     * @param {flatbuffers.Table} obj
                     * @returns {?flatbuffers.Table}
                     */
                    Message.prototype.header = function (obj) {
                        var offset = this.bb.__offset(this.bb_pos, 8);
                        return offset ? this.bb.__union(obj, this.bb_pos + offset) : null;
                    };
                    /**
                     * @returns {flatbuffers.Long}
                     */
                    Message.prototype.bodyLength = function () {
                        var offset = this.bb.__offset(this.bb_pos, 10);
                        return offset ? this.bb.readInt64(this.bb_pos + offset) : this.bb.createLong(0, 0);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     */
                    Message.startMessage = function (builder) {
                        builder.startObject(4);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {org.apache.arrow.flatbuf.MetadataVersion} version
                     */
                    Message.addVersion = function (builder, version) {
                        builder.addFieldInt16(0, version, __WEBPACK_IMPORTED_MODULE_0__Schema__["a" /* org */].apache.arrow.flatbuf.MetadataVersion.V1);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {org.apache.arrow.flatbuf.MessageHeader} headerType
                     */
                    Message.addHeaderType = function (builder, headerType) {
                        builder.addFieldInt8(1, headerType, org.apache.arrow.flatbuf.MessageHeader.NONE);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {flatbuffers.Offset} headerOffset
                     */
                    Message.addHeader = function (builder, headerOffset) {
                        builder.addFieldOffset(2, headerOffset, 0);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {flatbuffers.Long} bodyLength
                     */
                    Message.addBodyLength = function (builder, bodyLength) {
                        builder.addFieldInt64(3, bodyLength, builder.createLong(0, 0));
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @returns {flatbuffers.Offset}
                     */
                    Message.endMessage = function (builder) {
                        var offset = builder.endObject();
                        return offset;
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {flatbuffers.Offset} offset
                     */
                    Message.finishMessageBuffer = function (builder, offset) {
                        builder.finish(offset);
                    };
                    return Message;
                }());
                flatbuf.Message = Message;
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));



/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Footer_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FileBlock; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fb_File__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_flatbuffers__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__schema__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enum__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_buffer__ = __webpack_require__(11);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.

/* tslint:disable:class-name */


var Long = __WEBPACK_IMPORTED_MODULE_2_flatbuffers__["a" /* flatbuffers */].Long;
var Builder = __WEBPACK_IMPORTED_MODULE_2_flatbuffers__["a" /* flatbuffers */].Builder;
var ByteBuffer = __WEBPACK_IMPORTED_MODULE_2_flatbuffers__["a" /* flatbuffers */].ByteBuffer;
var _Block = __WEBPACK_IMPORTED_MODULE_1__fb_File__["a" /* org */].apache.arrow.flatbuf.Block;
var _Footer = __WEBPACK_IMPORTED_MODULE_1__fb_File__["a" /* org */].apache.arrow.flatbuf.Footer;



/** @ignore */
var Footer_ = /** @class */ (function () {
    function Footer_(schema, version, recordBatches, dictionaryBatches) {
        if (version === void 0) { version = __WEBPACK_IMPORTED_MODULE_4__enum__["MetadataVersion"].V4; }
        this.schema = schema;
        this.version = version;
        recordBatches && (this._recordBatches = recordBatches);
        dictionaryBatches && (this._dictionaryBatches = dictionaryBatches);
    }
    /** @nocollapse */
    Footer_.decode = function (buf) {
        buf = new ByteBuffer(Object(__WEBPACK_IMPORTED_MODULE_5__util_buffer__["e" /* toUint8Array */])(buf));
        var footer = _Footer.getRootAsFooter(buf);
        var schema = __WEBPACK_IMPORTED_MODULE_3__schema__["b" /* Schema */].decode(footer.schema());
        return new OffHeapFooter(schema, footer);
    };
    /** @nocollapse */
    Footer_.encode = function (footer) {
        var b = new Builder();
        var schemaOffset = __WEBPACK_IMPORTED_MODULE_3__schema__["b" /* Schema */].encode(b, footer.schema);
        _Footer.startRecordBatchesVector(b, footer.numRecordBatches);
        __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](footer.recordBatches()).slice().reverse().forEach(function (rb) { return FileBlock.encode(b, rb); });
        var recordBatchesOffset = b.endVector();
        _Footer.startDictionariesVector(b, footer.numDictionaries);
        __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](footer.dictionaryBatches()).slice().reverse().forEach(function (db) { return FileBlock.encode(b, db); });
        var dictionaryBatchesOffset = b.endVector();
        _Footer.startFooter(b);
        _Footer.addSchema(b, schemaOffset);
        _Footer.addVersion(b, __WEBPACK_IMPORTED_MODULE_4__enum__["MetadataVersion"].V4);
        _Footer.addRecordBatches(b, recordBatchesOffset);
        _Footer.addDictionaries(b, dictionaryBatchesOffset);
        _Footer.finishFooterBuffer(b, _Footer.endFooter(b));
        return b.asUint8Array();
    };
    Object.defineProperty(Footer_.prototype, "numRecordBatches", {
        get: function () { return this._recordBatches.length; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Footer_.prototype, "numDictionaries", {
        get: function () { return this._dictionaryBatches.length; },
        enumerable: true,
        configurable: true
    });
    Footer_.prototype.recordBatches = function () {
        var block, i, n;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
            switch (_a.label) {
                case 0:
                    block = void 0, i = -1, n = this.numRecordBatches;
                    _a.label = 1;
                case 1:
                    if (!(++i < n)) return [3 /*break*/, 4];
                    if (!(block = this.getRecordBatch(i))) return [3 /*break*/, 3];
                    return [4 /*yield*/, block];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [3 /*break*/, 1];
                case 4: return [2 /*return*/];
            }
        });
    };
    Footer_.prototype.dictionaryBatches = function () {
        var block, i, n;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
            switch (_a.label) {
                case 0:
                    block = void 0, i = -1, n = this.numDictionaries;
                    _a.label = 1;
                case 1:
                    if (!(++i < n)) return [3 /*break*/, 4];
                    if (!(block = this.getDictionaryBatch(i))) return [3 /*break*/, 3];
                    return [4 /*yield*/, block];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [3 /*break*/, 1];
                case 4: return [2 /*return*/];
            }
        });
    };
    Footer_.prototype.getRecordBatch = function (index) {
        return index >= 0
            && index < this.numRecordBatches
            && this._recordBatches[index] || null;
    };
    Footer_.prototype.getDictionaryBatch = function (index) {
        return index >= 0
            && index < this.numDictionaries
            && this._dictionaryBatches[index] || null;
    };
    return Footer_;
}());

/** @ignore */
var OffHeapFooter = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](OffHeapFooter, _super);
    function OffHeapFooter(schema, _footer) {
        var _this = _super.call(this, schema, _footer.version()) || this;
        _this._footer = _footer;
        return _this;
    }
    Object.defineProperty(OffHeapFooter.prototype, "numRecordBatches", {
        get: function () { return this._footer.recordBatchesLength(); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffHeapFooter.prototype, "numDictionaries", {
        get: function () { return this._footer.dictionariesLength(); },
        enumerable: true,
        configurable: true
    });
    OffHeapFooter.prototype.getRecordBatch = function (index) {
        if (index >= 0 && index < this.numRecordBatches) {
            var fileBlock = this._footer.recordBatches(index);
            if (fileBlock) {
                return FileBlock.decode(fileBlock);
            }
        }
        return null;
    };
    OffHeapFooter.prototype.getDictionaryBatch = function (index) {
        if (index >= 0 && index < this.numDictionaries) {
            var fileBlock = this._footer.dictionaries(index);
            if (fileBlock) {
                return FileBlock.decode(fileBlock);
            }
        }
        return null;
    };
    return OffHeapFooter;
}(Footer_));
/** @ignore */
var FileBlock = /** @class */ (function () {
    function FileBlock(metaDataLength, bodyLength, offset) {
        this.metaDataLength = metaDataLength;
        this.offset = typeof offset === 'number' ? offset : offset.low;
        this.bodyLength = typeof bodyLength === 'number' ? bodyLength : bodyLength.low;
    }
    /** @nocollapse */
    FileBlock.decode = function (block) {
        return new FileBlock(block.metaDataLength(), block.bodyLength(), block.offset());
    };
    /** @nocollapse */
    FileBlock.encode = function (b, fileBlock) {
        var metaDataLength = fileBlock.metaDataLength;
        var offset = new Long(fileBlock.offset, 0);
        var bodyLength = new Long(fileBlock.bodyLength, 0);
        return _Block.createBlock(b, offset, metaDataLength, bodyLength);
    };
    return FileBlock;
}());




/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RandomAccessFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsyncRandomAccessFile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stream__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_buffer__ = __webpack_require__(11);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.



/** @ignore */
var RandomAccessFile = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](RandomAccessFile, _super);
    function RandomAccessFile(buffer, byteLength) {
        var _this = _super.call(this) || this;
        _this.position = 0;
        _this.buffer = Object(__WEBPACK_IMPORTED_MODULE_2__util_buffer__["e" /* toUint8Array */])(buffer);
        _this.size = typeof byteLength === 'undefined' ? _this.buffer.byteLength : byteLength;
        return _this;
    }
    RandomAccessFile.prototype.readInt32 = function (position) {
        var _a = this.readAt(position, 4), buffer = _a.buffer, byteOffset = _a.byteOffset;
        return new DataView(buffer, byteOffset).getInt32(0, true);
    };
    RandomAccessFile.prototype.seek = function (position) {
        this.position = Math.min(position, this.size);
        return position < this.size;
    };
    RandomAccessFile.prototype.read = function (nBytes) {
        var _a = this, buffer = _a.buffer, size = _a.size, position = _a.position;
        if (buffer && position < size) {
            if (typeof nBytes !== 'number') {
                nBytes = Infinity;
            }
            this.position = Math.min(size, position + Math.min(size - position, nBytes));
            return buffer.subarray(position, this.position);
        }
        return null;
    };
    RandomAccessFile.prototype.readAt = function (position, nBytes) {
        var buf = this.buffer;
        var end = Math.min(this.size, position + nBytes);
        return buf ? buf.subarray(position, end) : new Uint8Array(nBytes);
    };
    RandomAccessFile.prototype.close = function () { this.buffer && (this.buffer = null); };
    RandomAccessFile.prototype.throw = function (value) { this.close(); return { done: true, value: value }; };
    RandomAccessFile.prototype.return = function (value) { this.close(); return { done: true, value: value }; };
    return RandomAccessFile;
}(__WEBPACK_IMPORTED_MODULE_1__stream__["c" /* ByteStream */]));

/** @ignore */
var AsyncRandomAccessFile = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](AsyncRandomAccessFile, _super);
    function AsyncRandomAccessFile(file, byteLength) {
        var _this = _super.call(this) || this;
        _this.position = 0;
        _this._handle = file;
        if (typeof byteLength === 'number') {
            _this.size = byteLength;
        }
        else {
            _this._pending = (function () { return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](_this, void 0, void 0, function () {
                var _a;
                return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            delete this._pending;
                            _a = this;
                            return [4 /*yield*/, file.stat()];
                        case 1:
                            _a.size = (_b.sent()).size;
                            return [2 /*return*/];
                    }
                });
            }); })();
        }
        return _this;
    }
    AsyncRandomAccessFile.prototype.readInt32 = function (position) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () {
            var _a, buffer, byteOffset;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.readAt(position, 4)];
                    case 1:
                        _a = _b.sent(), buffer = _a.buffer, byteOffset = _a.byteOffset;
                        return [2 /*return*/, new DataView(buffer, byteOffset).getInt32(0, true)];
                }
            });
        });
    };
    AsyncRandomAccessFile.prototype.seek = function (position) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () {
            var _a;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this._pending;
                        if (!_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._pending];
                    case 1:
                        _a = (_b.sent());
                        _b.label = 2;
                    case 2:
                        _a;
                        this.position = Math.min(position, this.size);
                        return [2 /*return*/, position < this.size];
                }
            });
        });
    };
    AsyncRandomAccessFile.prototype.read = function (nBytes) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () {
            var _a, _b, file, size, position, pos, offset, bytesRead, end, buffer;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this._pending;
                        if (!_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._pending];
                    case 1:
                        _a = (_c.sent());
                        _c.label = 2;
                    case 2:
                        _a;
                        _b = this, file = _b._handle, size = _b.size, position = _b.position;
                        if (!(file && position < size)) return [3 /*break*/, 6];
                        if (typeof nBytes !== 'number') {
                            nBytes = Infinity;
                        }
                        pos = position, offset = 0, bytesRead = 0;
                        end = Math.min(size, pos + Math.min(size - pos, nBytes));
                        buffer = new Uint8Array(Math.max(0, (this.position = end) - pos));
                        _c.label = 3;
                    case 3:
                        if (!((pos += bytesRead) < end && (offset += bytesRead) < buffer.byteLength)) return [3 /*break*/, 5];
                        return [4 /*yield*/, file.read(buffer, offset, buffer.byteLength - offset, pos)];
                    case 4:
                        (bytesRead = (_c.sent()).bytesRead);
                        return [3 /*break*/, 3];
                    case 5: return [2 /*return*/, buffer];
                    case 6: return [2 /*return*/, null];
                }
            });
        });
    };
    AsyncRandomAccessFile.prototype.readAt = function (position, nBytes) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () {
            var _a, _b, file, size, end, buffer;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this._pending;
                        if (!_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._pending];
                    case 1:
                        _a = (_c.sent());
                        _c.label = 2;
                    case 2:
                        _a;
                        _b = this, file = _b._handle, size = _b.size;
                        if (!(file && (position + nBytes) < size)) return [3 /*break*/, 4];
                        end = Math.min(size, position + nBytes);
                        buffer = new Uint8Array(end - position);
                        return [4 /*yield*/, file.read(buffer, 0, nBytes, position)];
                    case 3: return [2 /*return*/, (_c.sent()).buffer];
                    case 4: return [2 /*return*/, new Uint8Array(nBytes)];
                }
            });
        });
    };
    AsyncRandomAccessFile.prototype.close = function () {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () { var f, _a; return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_b) {
            switch (_b.label) {
                case 0:
                    f = this._handle;
                    this._handle = null;
                    _a = f;
                    if (!_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, f.close()];
                case 1:
                    _a = (_b.sent());
                    _b.label = 2;
                case 2:
                    _a;
                    return [2 /*return*/];
            }
        }); });
    };
    AsyncRandomAccessFile.prototype.throw = function (value) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () { return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.close()];
                case 1:
                    _a.sent();
                    return [2 /*return*/, { done: true, value: value }];
            }
        }); });
    };
    AsyncRandomAccessFile.prototype.return = function (value) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () { return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.close()];
                case 1:
                    _a.sent();
                    return [2 /*return*/, { done: true, value: value }];
            }
        }); });
    };
    return AsyncRandomAccessFile;
}(__WEBPACK_IMPORTED_MODULE_1__stream__["b" /* AsyncByteStream */]));




/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BaseInt64 */
/* unused harmony export Uint64 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Int64; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Int128; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.

/** @ignore */
var carryBit16 = 1 << 16;
/** @ignore */
function intAsHex(value) {
    if (value < 0) {
        value = 0xFFFFFFFF + value + 1;
    }
    return "0x" + value.toString(16);
}
/** @ignore */
var kInt32DecimalDigits = 8;
/** @ignore */
var kPowersOfTen = [1,
    10,
    100,
    1000,
    10000,
    100000,
    1000000,
    10000000,
    100000000];
var BaseInt64 = /** @class */ (function () {
    function BaseInt64(buffer) {
        this.buffer = buffer;
    }
    BaseInt64.prototype.high = function () { return this.buffer[1]; };
    BaseInt64.prototype.low = function () { return this.buffer[0]; };
    BaseInt64.prototype._times = function (other) {
        // Break the left and right numbers into 16 bit chunks
        // so that we can multiply them without overflow.
        var L = new Uint32Array([
            this.buffer[1] >>> 16,
            this.buffer[1] & 0xFFFF,
            this.buffer[0] >>> 16,
            this.buffer[0] & 0xFFFF
        ]);
        var R = new Uint32Array([
            other.buffer[1] >>> 16,
            other.buffer[1] & 0xFFFF,
            other.buffer[0] >>> 16,
            other.buffer[0] & 0xFFFF
        ]);
        var product = L[3] * R[3];
        this.buffer[0] = product & 0xFFFF;
        var sum = product >>> 16;
        product = L[2] * R[3];
        sum += product;
        product = (L[3] * R[2]) >>> 0;
        sum += product;
        this.buffer[0] += sum << 16;
        this.buffer[1] = (sum >>> 0 < product ? carryBit16 : 0);
        this.buffer[1] += sum >>> 16;
        this.buffer[1] += L[1] * R[3] + L[2] * R[2] + L[3] * R[1];
        this.buffer[1] += (L[0] * R[3] + L[1] * R[2] + L[2] * R[1] + L[3] * R[0]) << 16;
        return this;
    };
    BaseInt64.prototype._plus = function (other) {
        var sum = (this.buffer[0] + other.buffer[0]) >>> 0;
        this.buffer[1] += other.buffer[1];
        if (sum < (this.buffer[0] >>> 0)) {
            ++this.buffer[1];
        }
        this.buffer[0] = sum;
    };
    BaseInt64.prototype.lessThan = function (other) {
        return this.buffer[1] < other.buffer[1] ||
            (this.buffer[1] === other.buffer[1] && this.buffer[0] < other.buffer[0]);
    };
    BaseInt64.prototype.equals = function (other) {
        return this.buffer[1] === other.buffer[1] && this.buffer[0] == other.buffer[0];
    };
    BaseInt64.prototype.greaterThan = function (other) {
        return other.lessThan(this);
    };
    BaseInt64.prototype.hex = function () {
        return intAsHex(this.buffer[1]) + " " + intAsHex(this.buffer[0]);
    };
    return BaseInt64;
}());

var Uint64 = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Uint64, _super);
    function Uint64() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Uint64.prototype.times = function (other) {
        this._times(other);
        return this;
    };
    Uint64.prototype.plus = function (other) {
        this._plus(other);
        return this;
    };
    /** @nocollapse */
    Uint64.from = function (val, out_buffer) {
        if (out_buffer === void 0) { out_buffer = new Uint32Array(2); }
        return Uint64.fromString(typeof (val) === 'string' ? val : val.toString(), out_buffer);
    };
    /** @nocollapse */
    Uint64.fromNumber = function (num, out_buffer) {
        if (out_buffer === void 0) { out_buffer = new Uint32Array(2); }
        // Always parse numbers as strings - pulling out high and low bits
        // directly seems to lose precision sometimes
        // For example:
        //     > -4613034156400212000 >>> 0
        //     721782784
        // The correct lower 32-bits are 721782752
        return Uint64.fromString(num.toString(), out_buffer);
    };
    /** @nocollapse */
    Uint64.fromString = function (str, out_buffer) {
        if (out_buffer === void 0) { out_buffer = new Uint32Array(2); }
        var length = str.length;
        var out = new Uint64(out_buffer);
        for (var posn = 0; posn < length;) {
            var group = kInt32DecimalDigits < length - posn ?
                kInt32DecimalDigits : length - posn;
            var chunk = new Uint64(new Uint32Array([parseInt(str.substr(posn, group), 10), 0]));
            var multiple = new Uint64(new Uint32Array([kPowersOfTen[group], 0]));
            out.times(multiple);
            out.plus(chunk);
            posn += group;
        }
        return out;
    };
    /** @nocollapse */
    Uint64.convertArray = function (values) {
        var data = new Uint32Array(values.length * 2);
        for (var i = -1, n = values.length; ++i < n;) {
            Uint64.from(values[i], new Uint32Array(data.buffer, data.byteOffset + 2 * i * 4, 2));
        }
        return data;
    };
    /** @nocollapse */
    Uint64.multiply = function (left, right) {
        var rtrn = new Uint64(new Uint32Array(left.buffer));
        return rtrn.times(right);
    };
    /** @nocollapse */
    Uint64.add = function (left, right) {
        var rtrn = new Uint64(new Uint32Array(left.buffer));
        return rtrn.plus(right);
    };
    return Uint64;
}(BaseInt64));

var Int64 = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Int64, _super);
    function Int64() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Int64.prototype.negate = function () {
        this.buffer[0] = ~this.buffer[0] + 1;
        this.buffer[1] = ~this.buffer[1];
        if (this.buffer[0] == 0) {
            ++this.buffer[1];
        }
        return this;
    };
    Int64.prototype.times = function (other) {
        this._times(other);
        return this;
    };
    Int64.prototype.plus = function (other) {
        this._plus(other);
        return this;
    };
    Int64.prototype.lessThan = function (other) {
        // force high bytes to be signed
        var this_high = this.buffer[1] << 0;
        var other_high = other.buffer[1] << 0;
        return this_high < other_high ||
            (this_high === other_high && this.buffer[0] < other.buffer[0]);
    };
    /** @nocollapse */
    Int64.from = function (val, out_buffer) {
        if (out_buffer === void 0) { out_buffer = new Uint32Array(2); }
        return Int64.fromString(typeof (val) === 'string' ? val : val.toString(), out_buffer);
    };
    /** @nocollapse */
    Int64.fromNumber = function (num, out_buffer) {
        if (out_buffer === void 0) { out_buffer = new Uint32Array(2); }
        // Always parse numbers as strings - pulling out high and low bits
        // directly seems to lose precision sometimes
        // For example:
        //     > -4613034156400212000 >>> 0
        //     721782784
        // The correct lower 32-bits are 721782752
        return Int64.fromString(num.toString(), out_buffer);
    };
    /** @nocollapse */
    Int64.fromString = function (str, out_buffer) {
        if (out_buffer === void 0) { out_buffer = new Uint32Array(2); }
        // TODO: Assert that out_buffer is 0 and length = 2
        var negate = str.startsWith('-');
        var length = str.length;
        var out = new Int64(out_buffer);
        for (var posn = negate ? 1 : 0; posn < length;) {
            var group = kInt32DecimalDigits < length - posn ?
                kInt32DecimalDigits : length - posn;
            var chunk = new Int64(new Uint32Array([parseInt(str.substr(posn, group), 10), 0]));
            var multiple = new Int64(new Uint32Array([kPowersOfTen[group], 0]));
            out.times(multiple);
            out.plus(chunk);
            posn += group;
        }
        return negate ? out.negate() : out;
    };
    /** @nocollapse */
    Int64.convertArray = function (values) {
        var data = new Uint32Array(values.length * 2);
        for (var i = -1, n = values.length; ++i < n;) {
            Int64.from(values[i], new Uint32Array(data.buffer, data.byteOffset + 2 * i * 4, 2));
        }
        return data;
    };
    /** @nocollapse */
    Int64.multiply = function (left, right) {
        var rtrn = new Int64(new Uint32Array(left.buffer));
        return rtrn.times(right);
    };
    /** @nocollapse */
    Int64.add = function (left, right) {
        var rtrn = new Int64(new Uint32Array(left.buffer));
        return rtrn.plus(right);
    };
    return Int64;
}(BaseInt64));

var Int128 = /** @class */ (function () {
    function Int128(buffer) {
        this.buffer = buffer;
        // buffer[3] MSB (high)
        // buffer[2]
        // buffer[1]
        // buffer[0] LSB (low)
    }
    Int128.prototype.high = function () {
        return new Int64(new Uint32Array(this.buffer.buffer, this.buffer.byteOffset + 8, 2));
    };
    Int128.prototype.low = function () {
        return new Int64(new Uint32Array(this.buffer.buffer, this.buffer.byteOffset, 2));
    };
    Int128.prototype.negate = function () {
        this.buffer[0] = ~this.buffer[0] + 1;
        this.buffer[1] = ~this.buffer[1];
        this.buffer[2] = ~this.buffer[2];
        this.buffer[3] = ~this.buffer[3];
        if (this.buffer[0] == 0) {
            ++this.buffer[1];
        }
        if (this.buffer[1] == 0) {
            ++this.buffer[2];
        }
        if (this.buffer[2] == 0) {
            ++this.buffer[3];
        }
        return this;
    };
    Int128.prototype.times = function (other) {
        // Break the left and right numbers into 32 bit chunks
        // so that we can multiply them without overflow.
        var L0 = new Uint64(new Uint32Array([this.buffer[3], 0]));
        var L1 = new Uint64(new Uint32Array([this.buffer[2], 0]));
        var L2 = new Uint64(new Uint32Array([this.buffer[1], 0]));
        var L3 = new Uint64(new Uint32Array([this.buffer[0], 0]));
        var R0 = new Uint64(new Uint32Array([other.buffer[3], 0]));
        var R1 = new Uint64(new Uint32Array([other.buffer[2], 0]));
        var R2 = new Uint64(new Uint32Array([other.buffer[1], 0]));
        var R3 = new Uint64(new Uint32Array([other.buffer[0], 0]));
        var product = Uint64.multiply(L3, R3);
        this.buffer[0] = product.low();
        var sum = new Uint64(new Uint32Array([product.high(), 0]));
        product = Uint64.multiply(L2, R3);
        sum.plus(product);
        product = Uint64.multiply(L3, R2);
        sum.plus(product);
        this.buffer[1] = sum.low();
        this.buffer[3] = (sum.lessThan(product) ? 1 : 0);
        this.buffer[2] = sum.high();
        var high = new Uint64(new Uint32Array(this.buffer.buffer, this.buffer.byteOffset + 8, 2));
        high.plus(Uint64.multiply(L1, R3))
            .plus(Uint64.multiply(L2, R2))
            .plus(Uint64.multiply(L3, R1));
        this.buffer[3] += Uint64.multiply(L0, R3)
            .plus(Uint64.multiply(L1, R2))
            .plus(Uint64.multiply(L2, R1))
            .plus(Uint64.multiply(L3, R0)).low();
        return this;
    };
    Int128.prototype.plus = function (other) {
        var sums = new Uint32Array(4);
        sums[3] = (this.buffer[3] + other.buffer[3]) >>> 0;
        sums[2] = (this.buffer[2] + other.buffer[2]) >>> 0;
        sums[1] = (this.buffer[1] + other.buffer[1]) >>> 0;
        sums[0] = (this.buffer[0] + other.buffer[0]) >>> 0;
        if (sums[0] < (this.buffer[0] >>> 0)) {
            ++sums[1];
        }
        if (sums[1] < (this.buffer[1] >>> 0)) {
            ++sums[2];
        }
        if (sums[2] < (this.buffer[2] >>> 0)) {
            ++sums[3];
        }
        this.buffer[3] = sums[3];
        this.buffer[2] = sums[2];
        this.buffer[1] = sums[1];
        this.buffer[0] = sums[0];
        return this;
    };
    Int128.prototype.hex = function () {
        return intAsHex(this.buffer[3]) + " " + intAsHex(this.buffer[2]) + " " + intAsHex(this.buffer[1]) + " " + intAsHex(this.buffer[0]);
    };
    /** @nocollapse */
    Int128.multiply = function (left, right) {
        var rtrn = new Int128(new Uint32Array(left.buffer));
        return rtrn.times(right);
    };
    /** @nocollapse */
    Int128.add = function (left, right) {
        var rtrn = new Int128(new Uint32Array(left.buffer));
        return rtrn.plus(right);
    };
    /** @nocollapse */
    Int128.from = function (val, out_buffer) {
        if (out_buffer === void 0) { out_buffer = new Uint32Array(4); }
        return Int128.fromString(typeof (val) === 'string' ? val : val.toString(), out_buffer);
    };
    /** @nocollapse */
    Int128.fromNumber = function (num, out_buffer) {
        if (out_buffer === void 0) { out_buffer = new Uint32Array(4); }
        // Always parse numbers as strings - pulling out high and low bits
        // directly seems to lose precision sometimes
        // For example:
        //     > -4613034156400212000 >>> 0
        //     721782784
        // The correct lower 32-bits are 721782752
        return Int128.fromString(num.toString(), out_buffer);
    };
    /** @nocollapse */
    Int128.fromString = function (str, out_buffer) {
        if (out_buffer === void 0) { out_buffer = new Uint32Array(4); }
        // TODO: Assert that out_buffer is 0 and length = 4
        var negate = str.startsWith('-');
        var length = str.length;
        var out = new Int128(out_buffer);
        for (var posn = negate ? 1 : 0; posn < length;) {
            var group = kInt32DecimalDigits < length - posn ?
                kInt32DecimalDigits : length - posn;
            var chunk = new Int128(new Uint32Array([parseInt(str.substr(posn, group), 10), 0, 0, 0]));
            var multiple = new Int128(new Uint32Array([kPowersOfTen[group], 0, 0, 0]));
            out.times(multiple);
            out.plus(chunk);
            posn += group;
        }
        return negate ? out.negate() : out;
    };
    /** @nocollapse */
    Int128.convertArray = function (values) {
        // TODO: Distinguish between string and number at compile-time
        var data = new Uint32Array(values.length * 4);
        for (var i = -1, n = values.length; ++i < n;) {
            Int128.from(values[i], new Uint32Array(data.buffer, data.byteOffset + 4 * 4 * i, 4));
        }
        return data;
    };
    return Int128;
}());




/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MessageReader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsyncMessageReader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return JSONMessageReader; });
/* unused harmony export PADDING */
/* unused harmony export MAGIC_STR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MAGIC; });
/* harmony export (immutable) */ __webpack_exports__["e"] = checkForMagicArrowString;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return magicLength; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return magicAndPadding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return magicX2AndPadding; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enum__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_flatbuffers__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata_message__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_compat__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__io_file__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_buffer__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__io_stream__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__io_interfaces__ = __webpack_require__(49);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.



var ByteBuffer = __WEBPACK_IMPORTED_MODULE_2_flatbuffers__["a" /* flatbuffers */].ByteBuffer;






/** @ignore */ var invalidMessageType = function (type) { return "Expected " + __WEBPACK_IMPORTED_MODULE_1__enum__["MessageHeader"][type] + " Message in stream, but was null or length 0."; };
/** @ignore */ var nullMessage = function (type) { return "Header pointer of flatbuffer-encoded " + __WEBPACK_IMPORTED_MODULE_1__enum__["MessageHeader"][type] + " Message is null or length 0."; };
/** @ignore */ var invalidMessageMetadata = function (expected, actual) { return "Expected to read " + expected + " metadata bytes, but only read " + actual + "."; };
/** @ignore */ var invalidMessageBodyLength = function (expected, actual) { return "Expected to read " + expected + " bytes for message body, but only read " + actual + "."; };
/** @ignore */
var MessageReader = /** @class */ (function () {
    function MessageReader(source) {
        this.source = source instanceof __WEBPACK_IMPORTED_MODULE_7__io_stream__["c" /* ByteStream */] ? source : new __WEBPACK_IMPORTED_MODULE_7__io_stream__["c" /* ByteStream */](source);
    }
    MessageReader.prototype[Symbol.iterator] = function () { return this; };
    MessageReader.prototype.next = function () {
        var r;
        if ((r = this.readMetadataLength()).done) {
            return __WEBPACK_IMPORTED_MODULE_8__io_interfaces__["c" /* ITERATOR_DONE */];
        }
        if ((r = this.readMetadata(r.value)).done) {
            return __WEBPACK_IMPORTED_MODULE_8__io_interfaces__["c" /* ITERATOR_DONE */];
        }
        return r;
    };
    MessageReader.prototype.throw = function (value) { return this.source.throw(value); };
    MessageReader.prototype.return = function (value) { return this.source.return(value); };
    MessageReader.prototype.readMessage = function (type) {
        var r;
        if ((r = this.next()).done) {
            return null;
        }
        if ((type != null) && r.value.headerType !== type) {
            throw new Error(invalidMessageType(type));
        }
        return r.value;
    };
    MessageReader.prototype.readMessageBody = function (bodyLength) {
        if (bodyLength <= 0) {
            return new Uint8Array(0);
        }
        var buf = Object(__WEBPACK_IMPORTED_MODULE_6__util_buffer__["e" /* toUint8Array */])(this.source.read(bodyLength));
        if (buf.byteLength < bodyLength) {
            throw new Error(invalidMessageBodyLength(bodyLength, buf.byteLength));
        }
        // 1. Work around bugs in fs.ReadStream's internal Buffer pooling, see: https://github.com/nodejs/node/issues/24817
        // 2. Work around https://github.com/whatwg/streams/blob/0ebe4b042e467d9876d80ae045de3843092ad797/reference-implementation/lib/helpers.js#L126
        return /* 1. */ (buf.byteOffset % 8 === 0) &&
            /* 2. */ (buf.byteOffset + buf.byteLength) <= buf.buffer.byteLength ? buf : buf.slice();
    };
    MessageReader.prototype.readSchema = function (throwIfNull) {
        if (throwIfNull === void 0) { throwIfNull = false; }
        var type = __WEBPACK_IMPORTED_MODULE_1__enum__["MessageHeader"].Schema;
        var message = this.readMessage(type);
        var schema = message && message.header();
        if (throwIfNull && !schema) {
            throw new Error(nullMessage(type));
        }
        return schema;
    };
    MessageReader.prototype.readMetadataLength = function () {
        var buf = this.source.read(PADDING);
        var bb = buf && new ByteBuffer(buf);
        var len = +(bb && bb.readInt32(0));
        return { done: len <= 0, value: len };
    };
    MessageReader.prototype.readMetadata = function (metadataLength) {
        var buf = this.source.read(metadataLength);
        if (!buf) {
            return __WEBPACK_IMPORTED_MODULE_8__io_interfaces__["c" /* ITERATOR_DONE */];
        }
        if (buf.byteLength < metadataLength) {
            throw new Error(invalidMessageMetadata(metadataLength, buf.byteLength));
        }
        return { done: false, value: __WEBPACK_IMPORTED_MODULE_3__metadata_message__["d" /* Message */].decode(buf) };
    };
    return MessageReader;
}());

/** @ignore */
var AsyncMessageReader = /** @class */ (function () {
    function AsyncMessageReader(source, byteLength) {
        this.source = source instanceof __WEBPACK_IMPORTED_MODULE_7__io_stream__["b" /* AsyncByteStream */] ? source
            : Object(__WEBPACK_IMPORTED_MODULE_4__util_compat__["d" /* isFileHandle */])(source)
                ? new __WEBPACK_IMPORTED_MODULE_5__io_file__["a" /* AsyncRandomAccessFile */](source, byteLength)
                : new __WEBPACK_IMPORTED_MODULE_7__io_stream__["b" /* AsyncByteStream */](source);
    }
    AsyncMessageReader.prototype[Symbol.asyncIterator] = function () { return this; };
    AsyncMessageReader.prototype.next = function () {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () {
            var r;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.readMetadataLength()];
                    case 1:
                        if ((r = _a.sent()).done) {
                            return [2 /*return*/, __WEBPACK_IMPORTED_MODULE_8__io_interfaces__["c" /* ITERATOR_DONE */]];
                        }
                        return [4 /*yield*/, this.readMetadata(r.value)];
                    case 2:
                        if ((r = _a.sent()).done) {
                            return [2 /*return*/, __WEBPACK_IMPORTED_MODULE_8__io_interfaces__["c" /* ITERATOR_DONE */]];
                        }
                        return [2 /*return*/, r];
                }
            });
        });
    };
    AsyncMessageReader.prototype.throw = function (value) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () { return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.source.throw(value)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); });
    };
    AsyncMessageReader.prototype.return = function (value) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () { return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.source.return(value)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); });
    };
    AsyncMessageReader.prototype.readMessage = function (type) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () {
            var r;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.next()];
                    case 1:
                        if ((r = _a.sent()).done) {
                            return [2 /*return*/, null];
                        }
                        if ((type != null) && r.value.headerType !== type) {
                            throw new Error(invalidMessageType(type));
                        }
                        return [2 /*return*/, r.value];
                }
            });
        });
    };
    AsyncMessageReader.prototype.readMessageBody = function (bodyLength) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () {
            var buf, _a;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (bodyLength <= 0) {
                            return [2 /*return*/, new Uint8Array(0)];
                        }
                        _a = __WEBPACK_IMPORTED_MODULE_6__util_buffer__["e" /* toUint8Array */];
                        return [4 /*yield*/, this.source.read(bodyLength)];
                    case 1:
                        buf = _a.apply(void 0, [_b.sent()]);
                        if (buf.byteLength < bodyLength) {
                            throw new Error(invalidMessageBodyLength(bodyLength, buf.byteLength));
                        }
                        // 1. Work around bugs in fs.ReadStream's internal Buffer pooling, see: https://github.com/nodejs/node/issues/24817
                        // 2. Work around https://github.com/whatwg/streams/blob/0ebe4b042e467d9876d80ae045de3843092ad797/reference-implementation/lib/helpers.js#L126
                        return [2 /*return*/, /* 1. */ (buf.byteOffset % 8 === 0) &&
                                /* 2. */ (buf.byteOffset + buf.byteLength) <= buf.buffer.byteLength ? buf : buf.slice()];
                }
            });
        });
    };
    AsyncMessageReader.prototype.readSchema = function (throwIfNull) {
        if (throwIfNull === void 0) { throwIfNull = false; }
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () {
            var type, message, schema;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        type = __WEBPACK_IMPORTED_MODULE_1__enum__["MessageHeader"].Schema;
                        return [4 /*yield*/, this.readMessage(type)];
                    case 1:
                        message = _a.sent();
                        schema = message && message.header();
                        if (throwIfNull && !schema) {
                            throw new Error(nullMessage(type));
                        }
                        return [2 /*return*/, schema];
                }
            });
        });
    };
    AsyncMessageReader.prototype.readMetadataLength = function () {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () {
            var buf, bb, len;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.source.read(PADDING)];
                    case 1:
                        buf = _a.sent();
                        bb = buf && new ByteBuffer(buf);
                        len = +(bb && bb.readInt32(0));
                        return [2 /*return*/, { done: len <= 0, value: len }];
                }
            });
        });
    };
    AsyncMessageReader.prototype.readMetadata = function (metadataLength) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () {
            var buf;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.source.read(metadataLength)];
                    case 1:
                        buf = _a.sent();
                        if (!buf) {
                            return [2 /*return*/, __WEBPACK_IMPORTED_MODULE_8__io_interfaces__["c" /* ITERATOR_DONE */]];
                        }
                        if (buf.byteLength < metadataLength) {
                            throw new Error(invalidMessageMetadata(metadataLength, buf.byteLength));
                        }
                        return [2 /*return*/, { done: false, value: __WEBPACK_IMPORTED_MODULE_3__metadata_message__["d" /* Message */].decode(buf) }];
                }
            });
        });
    };
    return AsyncMessageReader;
}());

/** @ignore */
var JSONMessageReader = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](JSONMessageReader, _super);
    function JSONMessageReader(source) {
        var _this = _super.call(this, new Uint8Array(0)) || this;
        _this._schema = false;
        _this._body = [];
        _this._batchIndex = 0;
        _this._dictionaryIndex = 0;
        _this._json = source instanceof __WEBPACK_IMPORTED_MODULE_8__io_interfaces__["a" /* ArrowJSON */] ? source : new __WEBPACK_IMPORTED_MODULE_8__io_interfaces__["a" /* ArrowJSON */](source);
        return _this;
    }
    JSONMessageReader.prototype.next = function () {
        var _a = this, _json = _a._json, _batchIndex = _a._batchIndex, _dictionaryIndex = _a._dictionaryIndex;
        var numBatches = _json.batches.length;
        var numDictionaries = _json.dictionaries.length;
        if (!this._schema) {
            this._schema = true;
            var message = __WEBPACK_IMPORTED_MODULE_3__metadata_message__["d" /* Message */].fromJSON(_json.schema, __WEBPACK_IMPORTED_MODULE_1__enum__["MessageHeader"].Schema);
            return { value: message, done: _batchIndex >= numBatches && _dictionaryIndex >= numDictionaries };
        }
        if (_dictionaryIndex < numDictionaries) {
            var batch = _json.dictionaries[this._dictionaryIndex++];
            this._body = batch['data']['columns'];
            var message = __WEBPACK_IMPORTED_MODULE_3__metadata_message__["d" /* Message */].fromJSON(batch, __WEBPACK_IMPORTED_MODULE_1__enum__["MessageHeader"].DictionaryBatch);
            return { done: false, value: message };
        }
        if (_batchIndex < numBatches) {
            var batch = _json.batches[this._batchIndex++];
            this._body = batch['columns'];
            var message = __WEBPACK_IMPORTED_MODULE_3__metadata_message__["d" /* Message */].fromJSON(batch, __WEBPACK_IMPORTED_MODULE_1__enum__["MessageHeader"].RecordBatch);
            return { done: false, value: message };
        }
        this._body = [];
        return __WEBPACK_IMPORTED_MODULE_8__io_interfaces__["c" /* ITERATOR_DONE */];
    };
    JSONMessageReader.prototype.readMessageBody = function (_bodyLength) {
        return flattenDataSources(this._body);
        function flattenDataSources(xs) {
            return (xs || []).reduce(function (buffers, column) { return __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](buffers, (column['VALIDITY'] && [column['VALIDITY']] || []), (column['TYPE'] && [column['TYPE']] || []), (column['OFFSET'] && [column['OFFSET']] || []), (column['DATA'] && [column['DATA']] || []), flattenDataSources(column['children'])); }, []);
        }
    };
    JSONMessageReader.prototype.readMessage = function (type) {
        var r;
        if ((r = this.next()).done) {
            return null;
        }
        if ((type != null) && r.value.headerType !== type) {
            throw new Error(invalidMessageType(type));
        }
        return r.value;
    };
    JSONMessageReader.prototype.readSchema = function () {
        var type = __WEBPACK_IMPORTED_MODULE_1__enum__["MessageHeader"].Schema;
        var message = this.readMessage(type);
        var schema = message && message.header();
        if (!message || !schema) {
            throw new Error(nullMessage(type));
        }
        return schema;
    };
    return JSONMessageReader;
}(MessageReader));

/** @ignore */
var PADDING = 4;
/** @ignore */
var MAGIC_STR = 'ARROW1';
/** @ignore */
var MAGIC = new Uint8Array(MAGIC_STR.length);
for (var i = 0; i < MAGIC_STR.length; i += 1 | 0) {
    MAGIC[i] = MAGIC_STR.charCodeAt(i);
}
/** @ignore */
function checkForMagicArrowString(buffer, index) {
    if (index === void 0) { index = 0; }
    for (var i = -1, n = MAGIC.length; ++i < n;) {
        if (MAGIC[i] !== buffer[index + i]) {
            return false;
        }
    }
    return true;
}
/** @ignore */
var magicLength = MAGIC.length;
/** @ignore */
var magicAndPadding = magicLength + PADDING;
/** @ignore */
var magicX2AndPadding = magicLength * 2 + PADDING;



/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BinaryVector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vector__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__type__ = __webpack_require__(3);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.




var BinaryVector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](BinaryVector, _super);
    function BinaryVector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BinaryVector.prototype.asUtf8 = function () {
        return __WEBPACK_IMPORTED_MODULE_1__vector__["Vector"].new(this.data.clone(new __WEBPACK_IMPORTED_MODULE_3__type__["Utf8"]()));
    };
    return BinaryVector;
}(__WEBPACK_IMPORTED_MODULE_2__base__["a" /* BaseVector */]));




/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BoolVector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vector__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_bit__ = __webpack_require__(22);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.






var BoolVector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](BoolVector, _super);
    function BoolVector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /** @nocollapse */
    BoolVector.from = function (data) {
        var length = 0, bitmap = Object(__WEBPACK_IMPORTED_MODULE_5__util_bit__["d" /* packBools */])(function () {
            var e_1, _a, data_1, data_1_1, x, e_1_1;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, 6, 7]);
                        data_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["k" /* __values */](data), data_1_1 = data_1.next();
                        _b.label = 1;
                    case 1:
                        if (!!data_1_1.done) return [3 /*break*/, 4];
                        x = data_1_1.value;
                        length++;
                        return [4 /*yield*/, x];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        data_1_1 = data_1.next();
                        return [3 /*break*/, 1];
                    case 4: return [3 /*break*/, 7];
                    case 5:
                        e_1_1 = _b.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 7];
                    case 6:
                        try {
                            if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        }());
        return __WEBPACK_IMPORTED_MODULE_3__vector__["Vector"].new(__WEBPACK_IMPORTED_MODULE_1__data__["Data"].Bool(new __WEBPACK_IMPORTED_MODULE_2__type__["Bool"](), 0, length, 0, null, bitmap));
    };
    return BoolVector;
}(__WEBPACK_IMPORTED_MODULE_4__base__["a" /* BaseVector */]));




/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DateVector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DateDayVector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DateMillisecondVector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vector__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__enum__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_int__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__type__ = __webpack_require__(3);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.







var DateVector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](DateVector, _super);
    function DateVector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /** @nocollapse */
    DateVector.from = function (data, unit) {
        if (unit === void 0) { unit = __WEBPACK_IMPORTED_MODULE_3__enum__["DateUnit"].MILLISECOND; }
        switch (unit) {
            case __WEBPACK_IMPORTED_MODULE_3__enum__["DateUnit"].DAY: {
                var values = Int32Array.from(data.map(function (d) { return d.valueOf() / 86400000; }));
                return __WEBPACK_IMPORTED_MODULE_2__vector__["Vector"].new(__WEBPACK_IMPORTED_MODULE_1__data__["Data"].Date(new __WEBPACK_IMPORTED_MODULE_6__type__["DateDay"](), 0, data.length, 0, null, values));
            }
            case __WEBPACK_IMPORTED_MODULE_3__enum__["DateUnit"].MILLISECOND: {
                var values = __WEBPACK_IMPORTED_MODULE_5__util_int__["b" /* Int64 */].convertArray(data.map(function (d) { return d.valueOf(); }));
                return __WEBPACK_IMPORTED_MODULE_2__vector__["Vector"].new(__WEBPACK_IMPORTED_MODULE_1__data__["Data"].Date(new __WEBPACK_IMPORTED_MODULE_6__type__["DateMillisecond"](), 0, data.length, 0, null, values));
            }
        }
        throw new TypeError("Unrecognized date unit \"" + __WEBPACK_IMPORTED_MODULE_3__enum__["DateUnit"][unit] + "\"");
    };
    return DateVector;
}(__WEBPACK_IMPORTED_MODULE_4__base__["a" /* BaseVector */]));

var DateDayVector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](DateDayVector, _super);
    function DateDayVector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DateDayVector;
}(DateVector));

var DateMillisecondVector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](DateMillisecondVector, _super);
    function DateMillisecondVector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DateMillisecondVector;
}(DateVector));




/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DecimalVector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base__ = __webpack_require__(5);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.


var DecimalVector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](DecimalVector, _super);
    function DecimalVector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DecimalVector;
}(__WEBPACK_IMPORTED_MODULE_1__base__["a" /* BaseVector */]));




/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DictionaryVector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vector__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__type__ = __webpack_require__(3);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.





var DictionaryVector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](DictionaryVector, _super);
    function DictionaryVector(data) {
        var _this = _super.call(this, data) || this;
        _this._indices = __WEBPACK_IMPORTED_MODULE_2__vector__["Vector"].new(data.clone(_this.type.indices));
        return _this;
    }
    /** @nocollapse */
    DictionaryVector.from = function (values, indices, keys) {
        var type = new __WEBPACK_IMPORTED_MODULE_4__type__["Dictionary"](values.type, indices, null, null, values);
        return __WEBPACK_IMPORTED_MODULE_2__vector__["Vector"].new(__WEBPACK_IMPORTED_MODULE_1__data__["Data"].Dictionary(type, 0, keys.length, 0, null, keys));
    };
    Object.defineProperty(DictionaryVector.prototype, "indices", {
        // protected _bindDataAccessors() {}
        get: function () { return this._indices; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DictionaryVector.prototype, "dictionary", {
        get: function () { return this.data.type.dictionaryVector; },
        enumerable: true,
        configurable: true
    });
    DictionaryVector.prototype.isValid = function (index) { return this._indices.isValid(index); };
    DictionaryVector.prototype.reverseLookup = function (value) { return this.dictionary.indexOf(value); };
    DictionaryVector.prototype.getKey = function (idx) { return this._indices.get(idx); };
    DictionaryVector.prototype.getValue = function (key) { return this.dictionary.get(key); };
    DictionaryVector.prototype.setKey = function (idx, key) { return this._indices.set(idx, key); };
    DictionaryVector.prototype.setValue = function (key, value) { return this.dictionary.set(key, value); };
    return DictionaryVector;
}(__WEBPACK_IMPORTED_MODULE_3__base__["a" /* BaseVector */]));




/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FixedSizeBinaryVector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base__ = __webpack_require__(5);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.


var FixedSizeBinaryVector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](FixedSizeBinaryVector, _super);
    function FixedSizeBinaryVector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FixedSizeBinaryVector;
}(__WEBPACK_IMPORTED_MODULE_1__base__["a" /* BaseVector */]));




/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FixedSizeListVector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base__ = __webpack_require__(5);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.


var FixedSizeListVector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](FixedSizeListVector, _super);
    function FixedSizeListVector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FixedSizeListVector;
}(__WEBPACK_IMPORTED_MODULE_1__base__["a" /* BaseVector */]));




/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FloatVector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Float16Vector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Float32Vector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Float64Vector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vector__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__type__ = __webpack_require__(3);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.





var FloatVector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](FloatVector, _super);
    function FloatVector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /** @nocollapse */
    FloatVector.from = function (data) {
        switch (data.constructor) {
            case Uint16Array: return __WEBPACK_IMPORTED_MODULE_2__vector__["Vector"].new(__WEBPACK_IMPORTED_MODULE_1__data__["Data"].Float(new __WEBPACK_IMPORTED_MODULE_4__type__["Float16"](), 0, data.length, 0, null, data));
            case Float32Array: return __WEBPACK_IMPORTED_MODULE_2__vector__["Vector"].new(__WEBPACK_IMPORTED_MODULE_1__data__["Data"].Float(new __WEBPACK_IMPORTED_MODULE_4__type__["Float32"](), 0, data.length, 0, null, data));
            case Float64Array: return __WEBPACK_IMPORTED_MODULE_2__vector__["Vector"].new(__WEBPACK_IMPORTED_MODULE_1__data__["Data"].Float(new __WEBPACK_IMPORTED_MODULE_4__type__["Float64"](), 0, data.length, 0, null, data));
        }
        throw new TypeError('Unrecognized Float data');
    };
    return FloatVector;
}(__WEBPACK_IMPORTED_MODULE_3__base__["a" /* BaseVector */]));

var Float16Vector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Float16Vector, _super);
    function Float16Vector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Float16Vector;
}(FloatVector));

var Float32Vector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Float32Vector, _super);
    function Float32Vector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Float32Vector;
}(FloatVector));

var Float64Vector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Float64Vector, _super);
    function Float64Vector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Float64Vector;
}(FloatVector));




/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IntervalVector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IntervalDayTimeVector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IntervalYearMonthVector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base__ = __webpack_require__(5);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.


var IntervalVector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](IntervalVector, _super);
    function IntervalVector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return IntervalVector;
}(__WEBPACK_IMPORTED_MODULE_1__base__["a" /* BaseVector */]));

var IntervalDayTimeVector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](IntervalDayTimeVector, _super);
    function IntervalDayTimeVector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return IntervalDayTimeVector;
}(IntervalVector));

var IntervalYearMonthVector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](IntervalYearMonthVector, _super);
    function IntervalYearMonthVector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return IntervalYearMonthVector;
}(IntervalVector));




/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return IntVector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Int8Vector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Int16Vector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Int32Vector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Int64Vector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return Uint8Vector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Uint16Vector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Uint32Vector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return Uint64Vector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vector__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__type__ = __webpack_require__(3);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.





var IntVector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](IntVector, _super);
    function IntVector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /** @nocollapse */
    IntVector.from = function (data, is64) {
        if (is64 === true) {
            return data instanceof Int32Array
                ? __WEBPACK_IMPORTED_MODULE_2__vector__["Vector"].new(__WEBPACK_IMPORTED_MODULE_1__data__["Data"].Int(new __WEBPACK_IMPORTED_MODULE_4__type__["Int64"](), 0, data.length, 0, null, data))
                : __WEBPACK_IMPORTED_MODULE_2__vector__["Vector"].new(__WEBPACK_IMPORTED_MODULE_1__data__["Data"].Int(new __WEBPACK_IMPORTED_MODULE_4__type__["Uint64"](), 0, data.length, 0, null, data));
        }
        switch (data.constructor) {
            case Int8Array: return __WEBPACK_IMPORTED_MODULE_2__vector__["Vector"].new(__WEBPACK_IMPORTED_MODULE_1__data__["Data"].Int(new __WEBPACK_IMPORTED_MODULE_4__type__["Int8"](), 0, data.length, 0, null, data));
            case Int16Array: return __WEBPACK_IMPORTED_MODULE_2__vector__["Vector"].new(__WEBPACK_IMPORTED_MODULE_1__data__["Data"].Int(new __WEBPACK_IMPORTED_MODULE_4__type__["Int16"](), 0, data.length, 0, null, data));
            case Int32Array: return __WEBPACK_IMPORTED_MODULE_2__vector__["Vector"].new(__WEBPACK_IMPORTED_MODULE_1__data__["Data"].Int(new __WEBPACK_IMPORTED_MODULE_4__type__["Int32"](), 0, data.length, 0, null, data));
            case Uint8Array: return __WEBPACK_IMPORTED_MODULE_2__vector__["Vector"].new(__WEBPACK_IMPORTED_MODULE_1__data__["Data"].Int(new __WEBPACK_IMPORTED_MODULE_4__type__["Uint8"](), 0, data.length, 0, null, data));
            case Uint16Array: return __WEBPACK_IMPORTED_MODULE_2__vector__["Vector"].new(__WEBPACK_IMPORTED_MODULE_1__data__["Data"].Int(new __WEBPACK_IMPORTED_MODULE_4__type__["Uint16"](), 0, data.length, 0, null, data));
            case Uint32Array: return __WEBPACK_IMPORTED_MODULE_2__vector__["Vector"].new(__WEBPACK_IMPORTED_MODULE_1__data__["Data"].Int(new __WEBPACK_IMPORTED_MODULE_4__type__["Uint32"](), 0, data.length, 0, null, data));
        }
        throw new TypeError('Unrecognized Int data');
    };
    return IntVector;
}(__WEBPACK_IMPORTED_MODULE_3__base__["a" /* BaseVector */]));

var Int8Vector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Int8Vector, _super);
    function Int8Vector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Int8Vector;
}(IntVector));

var Int16Vector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Int16Vector, _super);
    function Int16Vector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Int16Vector;
}(IntVector));

var Int32Vector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Int32Vector, _super);
    function Int32Vector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Int32Vector;
}(IntVector));

var Int64Vector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Int64Vector, _super);
    function Int64Vector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Int64Vector;
}(IntVector));

var Uint8Vector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Uint8Vector, _super);
    function Uint8Vector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Uint8Vector;
}(IntVector));

var Uint16Vector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Uint16Vector, _super);
    function Uint16Vector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Uint16Vector;
}(IntVector));

var Uint32Vector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Uint32Vector, _super);
    function Uint32Vector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Uint32Vector;
}(IntVector));

var Uint64Vector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Uint64Vector, _super);
    function Uint64Vector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Uint64Vector;
}(IntVector));




/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListVector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base__ = __webpack_require__(5);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.


var ListVector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](ListVector, _super);
    function ListVector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ListVector;
}(__WEBPACK_IMPORTED_MODULE_1__base__["a" /* BaseVector */]));




/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MapVector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__row__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vector__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__type__ = __webpack_require__(3);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.





var MapVector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](MapVector, _super);
    function MapVector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MapVector.prototype.asStruct = function () {
        return __WEBPACK_IMPORTED_MODULE_2__vector__["Vector"].new(this.data.clone(new __WEBPACK_IMPORTED_MODULE_4__type__["Struct"](this.type.children)));
    };
    Object.defineProperty(MapVector.prototype, "rowProxy", {
        get: function () {
            return this._rowProxy || (this._rowProxy = __WEBPACK_IMPORTED_MODULE_1__row__["a" /* Row */].new(this.type.children || [], true));
        },
        enumerable: true,
        configurable: true
    });
    return MapVector;
}(__WEBPACK_IMPORTED_MODULE_3__base__["a" /* BaseVector */]));




/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NullVector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base__ = __webpack_require__(5);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.


var NullVector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](NullVector, _super);
    function NullVector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NullVector;
}(__WEBPACK_IMPORTED_MODULE_1__base__["a" /* BaseVector */]));




/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TimestampVector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TimestampSecondVector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TimestampMillisecondVector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TimestampMicrosecondVector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TimestampNanosecondVector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base__ = __webpack_require__(5);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.


var TimestampVector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](TimestampVector, _super);
    function TimestampVector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TimestampVector;
}(__WEBPACK_IMPORTED_MODULE_1__base__["a" /* BaseVector */]));

var TimestampSecondVector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](TimestampSecondVector, _super);
    function TimestampSecondVector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TimestampSecondVector;
}(TimestampVector));

var TimestampMillisecondVector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](TimestampMillisecondVector, _super);
    function TimestampMillisecondVector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TimestampMillisecondVector;
}(TimestampVector));

var TimestampMicrosecondVector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](TimestampMicrosecondVector, _super);
    function TimestampMicrosecondVector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TimestampMicrosecondVector;
}(TimestampVector));

var TimestampNanosecondVector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](TimestampNanosecondVector, _super);
    function TimestampNanosecondVector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TimestampNanosecondVector;
}(TimestampVector));




/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TimeVector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TimeSecondVector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TimeMillisecondVector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TimeMicrosecondVector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TimeNanosecondVector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base__ = __webpack_require__(5);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.


var TimeVector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](TimeVector, _super);
    function TimeVector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TimeVector;
}(__WEBPACK_IMPORTED_MODULE_1__base__["a" /* BaseVector */]));

var TimeSecondVector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](TimeSecondVector, _super);
    function TimeSecondVector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TimeSecondVector;
}(TimeVector));

var TimeMillisecondVector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](TimeMillisecondVector, _super);
    function TimeMillisecondVector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TimeMillisecondVector;
}(TimeVector));

var TimeMicrosecondVector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](TimeMicrosecondVector, _super);
    function TimeMicrosecondVector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TimeMicrosecondVector;
}(TimeVector));

var TimeNanosecondVector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](TimeNanosecondVector, _super);
    function TimeNanosecondVector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TimeNanosecondVector;
}(TimeVector));




/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UnionVector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DenseUnionVector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SparseUnionVector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base__ = __webpack_require__(5);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.


var UnionVector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](UnionVector, _super);
    function UnionVector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(UnionVector.prototype, "typeIdToChildIndex", {
        get: function () { return this.type.typeIdToChildIndex; },
        enumerable: true,
        configurable: true
    });
    return UnionVector;
}(__WEBPACK_IMPORTED_MODULE_1__base__["a" /* BaseVector */]));

var DenseUnionVector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](DenseUnionVector, _super);
    function DenseUnionVector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(DenseUnionVector.prototype, "valueOffsets", {
        get: function () { return this.data.valueOffsets; },
        enumerable: true,
        configurable: true
    });
    return DenseUnionVector;
}(UnionVector));

var SparseUnionVector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](SparseUnionVector, _super);
    function SparseUnionVector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SparseUnionVector;
}(UnionVector));




/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Utf8Vector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vector__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__type__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_utf8__ = __webpack_require__(36);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.






var Utf8Vector = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](Utf8Vector, _super);
    function Utf8Vector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /** @nocollapse */
    Utf8Vector.from = function (values) {
        var length = values.length;
        var data = Object(__WEBPACK_IMPORTED_MODULE_5__util_utf8__["b" /* encodeUtf8 */])(values.join(''));
        var offsets = values.reduce(function (offsets, str, idx) { return ((!(offsets[idx + 1] = offsets[idx] + str.length) || true) && offsets); }, new Uint32Array(values.length + 1));
        return __WEBPACK_IMPORTED_MODULE_2__vector__["Vector"].new(__WEBPACK_IMPORTED_MODULE_1__data__["Data"].Utf8(new __WEBPACK_IMPORTED_MODULE_4__type__["Utf8"](), 0, length, 0, null, offsets, data));
    };
    Utf8Vector.prototype.asBinary = function () {
        return __WEBPACK_IMPORTED_MODULE_2__vector__["Vector"].new(this.data.clone(new __WEBPACK_IMPORTED_MODULE_4__type__["Binary"]()));
    };
    return Utf8Vector;
}(__WEBPACK_IMPORTED_MODULE_3__base__["a" /* BaseVector */]));




/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GetVisitor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return instance; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_bn__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__visitor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_utf8__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enum__ = __webpack_require__(2);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.





var GetVisitor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](GetVisitor, _super);
    function GetVisitor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return GetVisitor;
}(__WEBPACK_IMPORTED_MODULE_2__visitor__["Visitor"]));

/** @ignore */ var epochDaysToMs = function (data, index) { return 86400000 * data[index]; };
/** @ignore */ var epochMillisecondsLongToMs = function (data, index) { return 4294967296 * (data[index + 1]) + (data[index] >>> 0); };
/** @ignore */ var epochMicrosecondsLongToMs = function (data, index) { return 4294967296 * (data[index + 1] / 1000) + ((data[index] >>> 0) / 1000); };
/** @ignore */ var epochNanosecondsLongToMs = function (data, index) { return 4294967296 * (data[index + 1] / 1000000) + ((data[index] >>> 0) / 1000000); };
/** @ignore */ var epochMillisecondsToDate = function (epochMs) { return new Date(epochMs); };
/** @ignore */ var epochDaysToDate = function (data, index) { return epochMillisecondsToDate(epochDaysToMs(data, index)); };
/** @ignore */ var epochMillisecondsLongToDate = function (data, index) { return epochMillisecondsToDate(epochMillisecondsLongToMs(data, index)); };
/** @ignore */
var getNull = function (_vector, _index) { return null; };
/** @ignore */
var getVariableWidthBytes = function (values, valueOffsets, index) {
    var _a = index, x = valueOffsets[_a], _b = index + 1, y = valueOffsets[_b];
    return x != null && y != null ? values.subarray(x, y) : null;
};
/** @ignore */
var getBool = function (_a, index) {
    var offset = _a.offset, values = _a.values;
    var idx = offset + index;
    var byte = values[idx >> 3];
    return (byte & 1 << (idx % 8)) !== 0;
};
/** @ignore */
var getDateDay = function (_a, index) {
    var values = _a.values;
    return epochDaysToDate(values, index);
};
/** @ignore */
var getDateMillisecond = function (_a, index) {
    var values = _a.values;
    return epochMillisecondsLongToDate(values, index * 2);
};
/** @ignore */
var getNumeric = function (_a, index) {
    var stride = _a.stride, values = _a.values;
    return values[stride * index];
};
/** @ignore */
var getFloat16 = function (_a, index) {
    var stride = _a.stride, values = _a.values;
    return (values[stride * index] - 32767) / 32767;
};
/** @ignore */
var getBigInts = function (_a, index) {
    var stride = _a.stride, values = _a.values, type = _a.type;
    return __WEBPACK_IMPORTED_MODULE_1__util_bn__["a" /* BN */].new(values.subarray(stride * index, stride * (index + 1)), type.isSigned);
};
/** @ignore */
var getFixedSizeBinary = function (_a, index) {
    var stride = _a.stride, values = _a.values;
    return values.subarray(stride * index, stride * (index + 1));
};
/** @ignore */
var getBinary = function (_a, index) {
    var values = _a.values, valueOffsets = _a.valueOffsets;
    return getVariableWidthBytes(values, valueOffsets, index);
};
/** @ignore */
var getUtf8 = function (_a, index) {
    var values = _a.values, valueOffsets = _a.valueOffsets;
    var bytes = getVariableWidthBytes(values, valueOffsets, index);
    return bytes !== null ? Object(__WEBPACK_IMPORTED_MODULE_3__util_utf8__["a" /* decodeUtf8 */])(bytes) : null;
};
/* istanbul ignore next */
/** @ignore */
var getInt = function (vector, index) { return (vector.type.bitWidth < 64
    ? getNumeric(vector, index)
    : getBigInts(vector, index)); };
/* istanbul ignore next */
/** @ignore */
var getFloat = function (vector, index) { return (vector.type.precision !== __WEBPACK_IMPORTED_MODULE_4__enum__["Precision"].HALF
    ? getNumeric(vector, index)
    : getFloat16(vector, index)); };
/* istanbul ignore next */
/** @ignore */
var getDate = function (vector, index) { return (vector.type.unit === __WEBPACK_IMPORTED_MODULE_4__enum__["DateUnit"].DAY
    ? getDateDay(vector, index)
    : getDateMillisecond(vector, index)); };
/** @ignore */
var getTimestampSecond = function (_a, index) {
    var values = _a.values;
    return 1000 * epochMillisecondsLongToMs(values, index * 2);
};
/** @ignore */
var getTimestampMillisecond = function (_a, index) {
    var values = _a.values;
    return epochMillisecondsLongToMs(values, index * 2);
};
/** @ignore */
var getTimestampMicrosecond = function (_a, index) {
    var values = _a.values;
    return epochMicrosecondsLongToMs(values, index * 2);
};
/** @ignore */
var getTimestampNanosecond = function (_a, index) {
    var values = _a.values;
    return epochNanosecondsLongToMs(values, index * 2);
};
/* istanbul ignore next */
/** @ignore */
var getTimestamp = function (vector, index) {
    switch (vector.type.unit) {
        case __WEBPACK_IMPORTED_MODULE_4__enum__["TimeUnit"].SECOND: return getTimestampSecond(vector, index);
        case __WEBPACK_IMPORTED_MODULE_4__enum__["TimeUnit"].MILLISECOND: return getTimestampMillisecond(vector, index);
        case __WEBPACK_IMPORTED_MODULE_4__enum__["TimeUnit"].MICROSECOND: return getTimestampMicrosecond(vector, index);
        case __WEBPACK_IMPORTED_MODULE_4__enum__["TimeUnit"].NANOSECOND: return getTimestampNanosecond(vector, index);
    }
};
/** @ignore */
var getTimeSecond = function (_a, index) {
    var values = _a.values, stride = _a.stride;
    return values[stride * index];
};
/** @ignore */
var getTimeMillisecond = function (_a, index) {
    var values = _a.values, stride = _a.stride;
    return values[stride * index];
};
/** @ignore */
var getTimeMicrosecond = function (_a, index) {
    var values = _a.values;
    return __WEBPACK_IMPORTED_MODULE_1__util_bn__["a" /* BN */].new(values.subarray(2 * index, 2 * (index + 1)), true);
};
/** @ignore */
var getTimeNanosecond = function (_a, index) {
    var values = _a.values;
    return __WEBPACK_IMPORTED_MODULE_1__util_bn__["a" /* BN */].new(values.subarray(2 * index, 2 * (index + 1)), true);
};
/* istanbul ignore next */
/** @ignore */
var getTime = function (vector, index) {
    switch (vector.type.unit) {
        case __WEBPACK_IMPORTED_MODULE_4__enum__["TimeUnit"].SECOND: return getTimeSecond(vector, index);
        case __WEBPACK_IMPORTED_MODULE_4__enum__["TimeUnit"].MILLISECOND: return getTimeMillisecond(vector, index);
        case __WEBPACK_IMPORTED_MODULE_4__enum__["TimeUnit"].MICROSECOND: return getTimeMicrosecond(vector, index);
        case __WEBPACK_IMPORTED_MODULE_4__enum__["TimeUnit"].NANOSECOND: return getTimeNanosecond(vector, index);
    }
};
/** @ignore */
var getDecimal = function (_a, index) {
    var values = _a.values;
    return __WEBPACK_IMPORTED_MODULE_1__util_bn__["a" /* BN */].new(values.subarray(4 * index, 4 * (index + 1)), false);
};
/** @ignore */
var getList = function (vector, index) {
    var child = vector.getChildAt(0), valueOffsets = vector.valueOffsets, stride = vector.stride;
    return child.slice(valueOffsets[index * stride], valueOffsets[(index * stride) + 1]);
};
/** @ignore */
var getNested = function (vector, index) {
    return vector.rowProxy.bind(vector, index);
};
/* istanbul ignore next */
/** @ignore */
var getUnion = function (vector, index) {
    return vector.type.mode === __WEBPACK_IMPORTED_MODULE_4__enum__["UnionMode"].Dense ?
        getDenseUnion(vector, index) :
        getSparseUnion(vector, index);
};
/** @ignore */
var getDenseUnion = function (vector, index) {
    var typeIds = vector.typeIds, typeIdToChildIndex = vector.type.typeIdToChildIndex;
    var child = vector.getChildAt(typeIdToChildIndex[typeIds[index]]);
    return child ? child.get(vector.valueOffsets[index]) : null;
};
/** @ignore */
var getSparseUnion = function (vector, index) {
    var typeIds = vector.typeIds, typeIdToChildIndex = vector.type.typeIdToChildIndex;
    var child = vector.getChildAt(typeIdToChildIndex[typeIds[index]]);
    return child ? child.get(index) : null;
};
/** @ignore */
var getDictionary = function (vector, index) {
    return vector.getValue(vector.getKey(index));
};
/* istanbul ignore next */
/** @ignore */
var getInterval = function (vector, index) {
    return (vector.type.unit === __WEBPACK_IMPORTED_MODULE_4__enum__["IntervalUnit"].DAY_TIME)
        ? getIntervalDayTime(vector, index)
        : getIntervalYearMonth(vector, index);
};
/** @ignore */
var getIntervalDayTime = function (_a, index) {
    var values = _a.values;
    return values.subarray(2 * index, 2 * (index + 1));
};
/** @ignore */
var getIntervalYearMonth = function (_a, index) {
    var values = _a.values;
    var interval = values[index];
    var int32s = new Int32Array(2);
    int32s[0] = interval / 12 | 0; /* years */
    int32s[1] = interval % 12 | 0; /* months */
    return int32s;
};
/** @ignore */
var getFixedSizeList = function (vector, index) {
    var child = vector.getChildAt(0), stride = vector.stride;
    return child.slice(index * stride, (index + 1) * stride);
};
GetVisitor.prototype.visitNull = getNull;
GetVisitor.prototype.visitBool = getBool;
GetVisitor.prototype.visitInt = getInt;
GetVisitor.prototype.visitInt8 = getNumeric;
GetVisitor.prototype.visitInt16 = getNumeric;
GetVisitor.prototype.visitInt32 = getNumeric;
GetVisitor.prototype.visitInt64 = getBigInts;
GetVisitor.prototype.visitUint8 = getNumeric;
GetVisitor.prototype.visitUint16 = getNumeric;
GetVisitor.prototype.visitUint32 = getNumeric;
GetVisitor.prototype.visitUint64 = getBigInts;
GetVisitor.prototype.visitFloat = getFloat;
GetVisitor.prototype.visitFloat16 = getFloat16;
GetVisitor.prototype.visitFloat32 = getNumeric;
GetVisitor.prototype.visitFloat64 = getNumeric;
GetVisitor.prototype.visitUtf8 = getUtf8;
GetVisitor.prototype.visitBinary = getBinary;
GetVisitor.prototype.visitFixedSizeBinary = getFixedSizeBinary;
GetVisitor.prototype.visitDate = getDate;
GetVisitor.prototype.visitDateDay = getDateDay;
GetVisitor.prototype.visitDateMillisecond = getDateMillisecond;
GetVisitor.prototype.visitTimestamp = getTimestamp;
GetVisitor.prototype.visitTimestampSecond = getTimestampSecond;
GetVisitor.prototype.visitTimestampMillisecond = getTimestampMillisecond;
GetVisitor.prototype.visitTimestampMicrosecond = getTimestampMicrosecond;
GetVisitor.prototype.visitTimestampNanosecond = getTimestampNanosecond;
GetVisitor.prototype.visitTime = getTime;
GetVisitor.prototype.visitTimeSecond = getTimeSecond;
GetVisitor.prototype.visitTimeMillisecond = getTimeMillisecond;
GetVisitor.prototype.visitTimeMicrosecond = getTimeMicrosecond;
GetVisitor.prototype.visitTimeNanosecond = getTimeNanosecond;
GetVisitor.prototype.visitDecimal = getDecimal;
GetVisitor.prototype.visitList = getList;
GetVisitor.prototype.visitStruct = getNested;
GetVisitor.prototype.visitUnion = getUnion;
GetVisitor.prototype.visitDenseUnion = getDenseUnion;
GetVisitor.prototype.visitSparseUnion = getSparseUnion;
GetVisitor.prototype.visitDictionary = getDictionary;
GetVisitor.prototype.visitInterval = getInterval;
GetVisitor.prototype.visitIntervalDayTime = getIntervalDayTime;
GetVisitor.prototype.visitIntervalYearMonth = getIntervalYearMonth;
GetVisitor.prototype.visitFixedSizeList = getFixedSizeList;
GetVisitor.prototype.visitMap = getNested;
/** @ignore */
var instance = new GetVisitor();



/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BN; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__buffer__ = __webpack_require__(11);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.
var _a;

/** @ignore */
var BigNumNMixin = (_a = {
        toJSON: function () { return "\"" + bignumToString(this) + "\""; },
        valueOf: function () { return bignumToNumber(this); },
        toString: function () { return bignumToString(this); }
    },
    _a[Symbol.toPrimitive] = function (hint) {
        if (hint === 'number') {
            return bignumToNumber(this);
        }
        /** @suppress {missingRequire} */
        return hint === 'string' || typeof BigInt !== 'function' ?
            bignumToString(this) : BigInt(bignumToString(this));
    },
    _a);
/** @ignore */
var SignedBigNumNMixin = Object.assign({}, BigNumNMixin, { signed: true, constructor: undefined });
/** @ignore */
var UnsignedBigNumNMixin = Object.assign({}, BigNumNMixin, { signed: false, constructor: undefined });
/** @ignore */
var BN = /** @class */ (function () {
    function BN(input, signed) {
        if (signed === void 0) { signed = input instanceof Int32Array; }
        return BN.new(input, signed);
    }
    /** @nocollapse */
    BN.new = function (input, signed) {
        if (signed === void 0) { signed = (input instanceof Int8Array || input instanceof Int16Array || input instanceof Int32Array); }
        return (signed === true) ? BN.signed(input) : BN.unsigned(input);
    };
    /** @nocollapse */
    BN.signed = function (input) {
        var Ctor = ArrayBuffer.isView(input) ? input.constructor : Int32Array;
        var _a = Object(__WEBPACK_IMPORTED_MODULE_0__buffer__["d" /* toArrayBufferView */])(Ctor, input), buffer = _a.buffer, byteOffset = _a.byteOffset, length = _a.length;
        var bn = new Ctor(buffer, byteOffset, length);
        return Object.assign(bn, SignedBigNumNMixin);
    };
    /** @nocollapse */
    BN.unsigned = function (input) {
        var Ctor = ArrayBuffer.isView(input) ? input.constructor : Uint32Array;
        var _a = Object(__WEBPACK_IMPORTED_MODULE_0__buffer__["d" /* toArrayBufferView */])(Ctor, input), buffer = _a.buffer, byteOffset = _a.byteOffset, length = _a.length;
        var bn = new Ctor(buffer, byteOffset, length);
        return Object.assign(bn, UnsignedBigNumNMixin);
    };
    return BN;
}());

/** @ignore */
function bignumToNumber(_a) {
    var buffer = _a.buffer, byteOffset = _a.byteOffset, length = _a.length;
    var int64 = 0;
    var words = new Uint32Array(buffer, byteOffset, length);
    for (var i = 0, n = words.length; i < n;) {
        int64 += words[i++] + (words[i++] * (Math.pow(i, 32)));
        // int64 += (words[i++] >>> 0) + (words[i++] * (i ** 32));
    }
    return int64;
}
/** @ignore */
function bignumToString(_a) {
    var buffer = _a.buffer, byteOffset = _a.byteOffset, length = _a.length;
    var string = '', i = -1;
    var base64 = new Uint32Array(2);
    var base32 = new Uint16Array(buffer, byteOffset, length * 2);
    var checks = new Uint32Array((base32 = new Uint16Array(base32).reverse()).buffer);
    var n = base32.length - 1;
    do {
        for (base64[0] = base32[i = 0]; i < n;) {
            base32[i++] = base64[1] = base64[0] / 10;
            base64[0] = ((base64[0] - base64[1] * 10) << 16) + base32[i];
        }
        base32[i] = base64[1] = base64[0] / 10;
        base64[0] = base64[0] - base64[1] * 10;
        string = "" + base64[0] + string;
    } while (checks[0] || checks[1] || checks[2] || checks[3]);
    return string ? string : "0";
}



/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IteratorVisitor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return instance; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enum__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__visitor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_bit__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__get__ = __webpack_require__(136);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.





var IteratorVisitor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](IteratorVisitor, _super);
    function IteratorVisitor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return IteratorVisitor;
}(__WEBPACK_IMPORTED_MODULE_2__visitor__["Visitor"]));

/** @ignore */
function nullableIterator(vector) {
    var getFn = __WEBPACK_IMPORTED_MODULE_4__get__["a" /* instance */].getVisitFn(vector);
    return Object(__WEBPACK_IMPORTED_MODULE_3__util_bit__["c" /* iterateBits */])(vector.nullBitmap, vector.offset, vector.length, vector, function (vec, idx, nullByte, nullBit) {
        return ((nullByte & 1 << nullBit) !== 0) ? getFn(vec, idx) : null;
    });
}
/** @ignore */
function vectorIterator(vector) {
    // If nullable, iterate manually
    if (vector.nullCount > 0) {
        return nullableIterator(vector);
    }
    var type = vector.type, typeId = vector.typeId, length = vector.length;
    // Fast case, defer to native iterators if possible
    if (vector.stride === 1 && ((typeId === __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].Timestamp) ||
        (typeId === __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].Int && type.bitWidth !== 64) ||
        (typeId === __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].Time && type.bitWidth !== 64) ||
        (typeId === __WEBPACK_IMPORTED_MODULE_1__enum__["Type"].Float && type.precision > 0 /* Precision.HALF */))) {
        return vector.values.subarray(0, length)[Symbol.iterator]();
    }
    // Otherwise, iterate manually
    return (function (getFn) {
        var index;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
            switch (_a.label) {
                case 0:
                    index = -1;
                    _a.label = 1;
                case 1:
                    if (!(++index < length)) return [3 /*break*/, 4];
                    return [4 /*yield*/, getFn(vector, index)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [3 /*break*/, 1];
                case 4: return [2 /*return*/];
            }
        });
    })(__WEBPACK_IMPORTED_MODULE_4__get__["a" /* instance */].getVisitFn(vector));
}
IteratorVisitor.prototype.visitNull = vectorIterator;
IteratorVisitor.prototype.visitBool = vectorIterator;
IteratorVisitor.prototype.visitInt = vectorIterator;
IteratorVisitor.prototype.visitInt8 = vectorIterator;
IteratorVisitor.prototype.visitInt16 = vectorIterator;
IteratorVisitor.prototype.visitInt32 = vectorIterator;
IteratorVisitor.prototype.visitInt64 = vectorIterator;
IteratorVisitor.prototype.visitUint8 = vectorIterator;
IteratorVisitor.prototype.visitUint16 = vectorIterator;
IteratorVisitor.prototype.visitUint32 = vectorIterator;
IteratorVisitor.prototype.visitUint64 = vectorIterator;
IteratorVisitor.prototype.visitFloat = vectorIterator;
IteratorVisitor.prototype.visitFloat16 = vectorIterator;
IteratorVisitor.prototype.visitFloat32 = vectorIterator;
IteratorVisitor.prototype.visitFloat64 = vectorIterator;
IteratorVisitor.prototype.visitUtf8 = vectorIterator;
IteratorVisitor.prototype.visitBinary = vectorIterator;
IteratorVisitor.prototype.visitFixedSizeBinary = vectorIterator;
IteratorVisitor.prototype.visitDate = vectorIterator;
IteratorVisitor.prototype.visitDateDay = vectorIterator;
IteratorVisitor.prototype.visitDateMillisecond = vectorIterator;
IteratorVisitor.prototype.visitTimestamp = vectorIterator;
IteratorVisitor.prototype.visitTimestampSecond = vectorIterator;
IteratorVisitor.prototype.visitTimestampMillisecond = vectorIterator;
IteratorVisitor.prototype.visitTimestampMicrosecond = vectorIterator;
IteratorVisitor.prototype.visitTimestampNanosecond = vectorIterator;
IteratorVisitor.prototype.visitTime = vectorIterator;
IteratorVisitor.prototype.visitTimeSecond = vectorIterator;
IteratorVisitor.prototype.visitTimeMillisecond = vectorIterator;
IteratorVisitor.prototype.visitTimeMicrosecond = vectorIterator;
IteratorVisitor.prototype.visitTimeNanosecond = vectorIterator;
IteratorVisitor.prototype.visitDecimal = vectorIterator;
IteratorVisitor.prototype.visitList = vectorIterator;
IteratorVisitor.prototype.visitStruct = vectorIterator;
IteratorVisitor.prototype.visitUnion = vectorIterator;
IteratorVisitor.prototype.visitDenseUnion = vectorIterator;
IteratorVisitor.prototype.visitSparseUnion = vectorIterator;
IteratorVisitor.prototype.visitDictionary = vectorIterator;
IteratorVisitor.prototype.visitInterval = vectorIterator;
IteratorVisitor.prototype.visitIntervalDayTime = vectorIterator;
IteratorVisitor.prototype.visitIntervalYearMonth = vectorIterator;
IteratorVisitor.prototype.visitFixedSizeList = vectorIterator;
IteratorVisitor.prototype.visitMap = vectorIterator;
/** @ignore */
var instance = new IteratorVisitor();



/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* @license
Papa Parse
v4.6.3
https://github.com/mholt/PapaParse
License: MIT
*/
Array.isArray||(Array.isArray=function(e){return"[object Array]"===Object.prototype.toString.call(e)}),function(e,t){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof module&&"undefined"!=typeof exports?module.exports=t():e.Papa=t()}(this,function(){"use strict";var s,e,f="undefined"!=typeof self?self:"undefined"!=typeof window?window:void 0!==f?f:{},n=!f.document&&!!f.postMessage,o=n&&/(\?|&)papaworker(=|&|$)/.test(f.location.search),a=!1,h={},u=0,k={parse:function(e,t){var r=(t=t||{}).dynamicTyping||!1;z(r)&&(t.dynamicTypingFunction=r,r={});if(t.dynamicTyping=r,t.transform=!!z(t.transform)&&t.transform,t.worker&&k.WORKERS_SUPPORTED){var i=function(){if(!k.WORKERS_SUPPORTED)return!1;if(!a&&null===k.SCRIPT_PATH)throw new Error("Script path cannot be determined automatically when Papa Parse is loaded asynchronously. You need to set Papa.SCRIPT_PATH manually.");var e=k.SCRIPT_PATH||s;e+=(-1!==e.indexOf("?")?"&":"?")+"papaworker";var t=new f.Worker(e);return t.onmessage=m,t.id=u++,h[t.id]=t}();return i.userStep=t.step,i.userChunk=t.chunk,i.userComplete=t.complete,i.userError=t.error,t.step=z(t.step),t.chunk=z(t.chunk),t.complete=z(t.complete),t.error=z(t.error),delete t.worker,void i.postMessage({input:e,config:t,workerId:i.id})}var n=null;k.NODE_STREAM_INPUT,"string"==typeof e?n=t.download?new c(t):new _(t):!0===e.readable&&z(e.read)&&z(e.on)?n=new g(t):(f.File&&e instanceof File||e instanceof Object)&&(n=new p(t));return n.stream(e)},unparse:function(e,t){var i=!1,g=!0,m=",",y="\r\n",n='"',r=!1;!function(){if("object"!=typeof t)return;"string"!=typeof t.delimiter||k.BAD_DELIMITERS.filter(function(e){return-1!==t.delimiter.indexOf(e)}).length||(m=t.delimiter);("boolean"==typeof t.quotes||Array.isArray(t.quotes))&&(i=t.quotes);"boolean"!=typeof t.skipEmptyLines&&"string"!=typeof t.skipEmptyLines||(r=t.skipEmptyLines);"string"==typeof t.newline&&(y=t.newline);"string"==typeof t.quoteChar&&(n=t.quoteChar);"boolean"==typeof t.header&&(g=t.header)}();var s=new RegExp(M(n),"g");"string"==typeof e&&(e=JSON.parse(e));if(Array.isArray(e)){if(!e.length||Array.isArray(e[0]))return o(null,e,r);if("object"==typeof e[0])return o(a(e[0]),e,r)}else if("object"==typeof e)return"string"==typeof e.data&&(e.data=JSON.parse(e.data)),Array.isArray(e.data)&&(e.fields||(e.fields=e.meta&&e.meta.fields),e.fields||(e.fields=Array.isArray(e.data[0])?e.fields:a(e.data[0])),Array.isArray(e.data[0])||"object"==typeof e.data[0]||(e.data=[e.data])),o(e.fields||[],e.data||[],r);throw"exception: Unable to serialize unrecognized input";function a(e){if("object"!=typeof e)return[];var t=[];for(var r in e)t.push(r);return t}function o(e,t,r){var i="";"string"==typeof e&&(e=JSON.parse(e)),"string"==typeof t&&(t=JSON.parse(t));var n=Array.isArray(e)&&0<e.length,s=!Array.isArray(t[0]);if(n&&g){for(var a=0;a<e.length;a++)0<a&&(i+=m),i+=v(e[a],a);0<t.length&&(i+=y)}for(var o=0;o<t.length;o++){var h=n?e.length:t[o].length,u=!1,f=n?0===Object.keys(t[o]).length:0===t[o].length;if(r&&!n&&(u="greedy"===r?""===t[o].join("").trim():1===t[o].length&&0===t[o][0].length),"greedy"===r&&n){for(var d=[],l=0;l<h;l++){var c=s?e[l]:l;d.push(t[o][c])}u=""===d.join("").trim()}if(!u){for(var p=0;p<h;p++){0<p&&!f&&(i+=m);var _=n&&s?e[p]:p;i+=v(t[o][_],p)}o<t.length-1&&(!r||0<h&&!f)&&(i+=y)}}return i}function v(e,t){if(null==e)return"";if(e.constructor===Date)return JSON.stringify(e).slice(1,25);e=e.toString().replace(s,n+n);var r="boolean"==typeof i&&i||Array.isArray(i)&&i[t]||function(e,t){for(var r=0;r<t.length;r++)if(-1<e.indexOf(t[r]))return!0;return!1}(e,k.BAD_DELIMITERS)||-1<e.indexOf(m)||" "===e.charAt(0)||" "===e.charAt(e.length-1);return r?n+e+n:e}}};if(k.RECORD_SEP=String.fromCharCode(30),k.UNIT_SEP=String.fromCharCode(31),k.BYTE_ORDER_MARK="\ufeff",k.BAD_DELIMITERS=["\r","\n",'"',k.BYTE_ORDER_MARK],k.WORKERS_SUPPORTED=!n&&!!f.Worker,k.SCRIPT_PATH=null,k.NODE_STREAM_INPUT=1,k.LocalChunkSize=10485760,k.RemoteChunkSize=5242880,k.DefaultDelimiter=",",k.Parser=v,k.ParserHandle=r,k.NetworkStreamer=c,k.FileStreamer=p,k.StringStreamer=_,k.ReadableStreamStreamer=g,f.jQuery){var d=f.jQuery;d.fn.parse=function(o){var r=o.config||{},h=[];return this.each(function(e){if(!("INPUT"===d(this).prop("tagName").toUpperCase()&&"file"===d(this).attr("type").toLowerCase()&&f.FileReader)||!this.files||0===this.files.length)return!0;for(var t=0;t<this.files.length;t++)h.push({file:this.files[t],inputElem:this,instanceConfig:d.extend({},r)})}),e(),this;function e(){if(0!==h.length){var e,t,r,i,n=h[0];if(z(o.before)){var s=o.before(n.file,n.inputElem);if("object"==typeof s){if("abort"===s.action)return e="AbortError",t=n.file,r=n.inputElem,i=s.reason,void(z(o.error)&&o.error({name:e},t,r,i));if("skip"===s.action)return void u();"object"==typeof s.config&&(n.instanceConfig=d.extend(n.instanceConfig,s.config))}else if("skip"===s)return void u()}var a=n.instanceConfig.complete;n.instanceConfig.complete=function(e){z(a)&&a(e,n.file,n.inputElem),u()},k.parse(n.file,n.instanceConfig)}else z(o.complete)&&o.complete()}function u(){h.splice(0,1),e()}}}function l(e){this._handle=null,this._finished=!1,this._completed=!1,this._input=null,this._baseIndex=0,this._partialLine="",this._rowCount=0,this._start=0,this._nextChunk=null,this.isFirstChunk=!0,this._completeResults={data:[],errors:[],meta:{}},function(e){var t=E(e);t.chunkSize=parseInt(t.chunkSize),e.step||e.chunk||(t.chunkSize=null);this._handle=new r(t),(this._handle.streamer=this)._config=t}.call(this,e),this.parseChunk=function(e,t){if(this.isFirstChunk&&z(this._config.beforeFirstChunk)){var r=this._config.beforeFirstChunk(e);void 0!==r&&(e=r)}this.isFirstChunk=!1;var i=this._partialLine+e;this._partialLine="";var n=this._handle.parse(i,this._baseIndex,!this._finished);if(!this._handle.paused()&&!this._handle.aborted()){var s=n.meta.cursor;this._finished||(this._partialLine=i.substring(s-this._baseIndex),this._baseIndex=s),n&&n.data&&(this._rowCount+=n.data.length);var a=this._finished||this._config.preview&&this._rowCount>=this._config.preview;if(o)f.postMessage({results:n,workerId:k.WORKER_ID,finished:a});else if(z(this._config.chunk)&&!t){if(this._config.chunk(n,this._handle),this._handle.paused()||this._handle.aborted())return;n=void 0,this._completeResults=void 0}return this._config.step||this._config.chunk||(this._completeResults.data=this._completeResults.data.concat(n.data),this._completeResults.errors=this._completeResults.errors.concat(n.errors),this._completeResults.meta=n.meta),this._completed||!a||!z(this._config.complete)||n&&n.meta.aborted||(this._config.complete(this._completeResults,this._input),this._completed=!0),a||n&&n.meta.paused||this._nextChunk(),n}},this._sendError=function(e){z(this._config.error)?this._config.error(e):o&&this._config.error&&f.postMessage({workerId:k.WORKER_ID,error:e,finished:!1})}}function c(e){var i;(e=e||{}).chunkSize||(e.chunkSize=k.RemoteChunkSize),l.call(this,e),this._nextChunk=n?function(){this._readChunk(),this._chunkLoaded()}:function(){this._readChunk()},this.stream=function(e){this._input=e,this._nextChunk()},this._readChunk=function(){if(this._finished)this._chunkLoaded();else{if(i=new XMLHttpRequest,this._config.withCredentials&&(i.withCredentials=this._config.withCredentials),n||(i.onload=w(this._chunkLoaded,this),i.onerror=w(this._chunkError,this)),i.open("GET",this._input,!n),this._config.downloadRequestHeaders){var e=this._config.downloadRequestHeaders;for(var t in e)i.setRequestHeader(t,e[t])}if(this._config.chunkSize){var r=this._start+this._config.chunkSize-1;i.setRequestHeader("Range","bytes="+this._start+"-"+r),i.setRequestHeader("If-None-Match","webkit-no-cache")}try{i.send()}catch(e){this._chunkError(e.message)}n&&0===i.status?this._chunkError():this._start+=this._config.chunkSize}},this._chunkLoaded=function(){4===i.readyState&&(i.status<200||400<=i.status?this._chunkError():(this._finished=!this._config.chunkSize||this._start>function(e){var t=e.getResponseHeader("Content-Range");if(null===t)return-1;return parseInt(t.substr(t.lastIndexOf("/")+1))}(i),this.parseChunk(i.responseText)))},this._chunkError=function(e){var t=i.statusText||e;this._sendError(new Error(t))}}function p(e){var i,n;(e=e||{}).chunkSize||(e.chunkSize=k.LocalChunkSize),l.call(this,e);var s="undefined"!=typeof FileReader;this.stream=function(e){this._input=e,n=e.slice||e.webkitSlice||e.mozSlice,s?((i=new FileReader).onload=w(this._chunkLoaded,this),i.onerror=w(this._chunkError,this)):i=new FileReaderSync,this._nextChunk()},this._nextChunk=function(){this._finished||this._config.preview&&!(this._rowCount<this._config.preview)||this._readChunk()},this._readChunk=function(){var e=this._input;if(this._config.chunkSize){var t=Math.min(this._start+this._config.chunkSize,this._input.size);e=n.call(e,this._start,t)}var r=i.readAsText(e,this._config.encoding);s||this._chunkLoaded({target:{result:r}})},this._chunkLoaded=function(e){this._start+=this._config.chunkSize,this._finished=!this._config.chunkSize||this._start>=this._input.size,this.parseChunk(e.target.result)},this._chunkError=function(){this._sendError(i.error)}}function _(e){var r;l.call(this,e=e||{}),this.stream=function(e){return r=e,this._nextChunk()},this._nextChunk=function(){if(!this._finished){var e=this._config.chunkSize,t=e?r.substr(0,e):r;return r=e?r.substr(e):"",this._finished=!r,this.parseChunk(t)}}}function g(e){l.call(this,e=e||{});var t=[],r=!0,i=!1;this.pause=function(){l.prototype.pause.apply(this,arguments),this._input.pause()},this.resume=function(){l.prototype.resume.apply(this,arguments),this._input.resume()},this.stream=function(e){this._input=e,this._input.on("data",this._streamData),this._input.on("end",this._streamEnd),this._input.on("error",this._streamError)},this._checkIsFinished=function(){i&&1===t.length&&(this._finished=!0)},this._nextChunk=function(){this._checkIsFinished(),t.length?this.parseChunk(t.shift()):r=!0},this._streamData=w(function(e){try{t.push("string"==typeof e?e:e.toString(this._config.encoding)),r&&(r=!1,this._checkIsFinished(),this.parseChunk(t.shift()))}catch(e){this._streamError(e)}},this),this._streamError=w(function(e){this._streamCleanUp(),this._sendError(e)},this),this._streamEnd=w(function(){this._streamCleanUp(),i=!0,this._streamData("")},this),this._streamCleanUp=w(function(){this._input.removeListener("data",this._streamData),this._input.removeListener("end",this._streamEnd),this._input.removeListener("error",this._streamError)},this)}function r(g){var a,o,h,i=/^\s*-?(\d*\.?\d+|\d+\.?\d*)(e[-+]?\d+)?\s*$/i,n=/(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/,t=this,r=0,s=0,u=!1,e=!1,f=[],d={data:[],errors:[],meta:{}};if(z(g.step)){var l=g.step;g.step=function(e){if(d=e,p())c();else{if(c(),0===d.data.length)return;r+=e.data.length,g.preview&&r>g.preview?o.abort():l(d,t)}}}function m(e){return"greedy"===g.skipEmptyLines?""===e.join("").trim():1===e.length&&0===e[0].length}function c(){if(d&&h&&(y("Delimiter","UndetectableDelimiter","Unable to auto-detect delimiting character; defaulted to '"+k.DefaultDelimiter+"'"),h=!1),g.skipEmptyLines)for(var e=0;e<d.data.length;e++)m(d.data[e])&&d.data.splice(e--,1);return p()&&function(){if(!d)return;for(var e=0;p()&&e<d.data.length;e++)for(var t=0;t<d.data[e].length;t++){var r=d.data[e][t];g.trimHeaders&&(r=r.trim()),f.push(r)}d.data.splice(0,1)}(),function(){if(!d||!g.header&&!g.dynamicTyping&&!g.transform)return d;for(var e=0;e<d.data.length;e++){var t,r=g.header?{}:[];for(t=0;t<d.data[e].length;t++){var i=t,n=d.data[e][t];g.header&&(i=t>=f.length?"__parsed_extra":f[t]),g.transform&&(n=g.transform(n,i)),n=_(i,n),"__parsed_extra"===i?(r[i]=r[i]||[],r[i].push(n)):r[i]=n}d.data[e]=r,g.header&&(t>f.length?y("FieldMismatch","TooManyFields","Too many fields: expected "+f.length+" fields but parsed "+t,s+e):t<f.length&&y("FieldMismatch","TooFewFields","Too few fields: expected "+f.length+" fields but parsed "+t,s+e))}g.header&&d.meta&&(d.meta.fields=f);return s+=d.data.length,d}()}function p(){return g.header&&0===f.length}function _(e,t){return r=e,g.dynamicTypingFunction&&void 0===g.dynamicTyping[r]&&(g.dynamicTyping[r]=g.dynamicTypingFunction(r)),!0===(g.dynamicTyping[r]||g.dynamicTyping)?"true"===t||"TRUE"===t||"false"!==t&&"FALSE"!==t&&(i.test(t)?parseFloat(t):n.test(t)?new Date(t):""===t?null:t):t;var r}function y(e,t,r,i){d.errors.push({type:e,code:t,message:r,row:i})}this.parse=function(e,t,r){var i=g.quoteChar||'"';if(g.newline||(g.newline=function(e,t){e=e.substr(0,1048576);var r=new RegExp(M(t)+"([^]*?)"+M(t),"gm"),i=(e=e.replace(r,"")).split("\r"),n=e.split("\n"),s=1<n.length&&n[0].length<i[0].length;if(1===i.length||s)return"\n";for(var a=0,o=0;o<i.length;o++)"\n"===i[o][0]&&a++;return a>=i.length/2?"\r\n":"\r"}(e,i)),h=!1,g.delimiter)z(g.delimiter)&&(g.delimiter=g.delimiter(e),d.meta.delimiter=g.delimiter);else{var n=function(e,t,r,i){for(var n,s,a,o=[",","\t","|",";",k.RECORD_SEP,k.UNIT_SEP],h=0;h<o.length;h++){var u=o[h],f=0,d=0,l=0;a=void 0;for(var c=new v({comments:i,delimiter:u,newline:t,preview:10}).parse(e),p=0;p<c.data.length;p++)if(r&&m(c.data[p]))l++;else{var _=c.data[p].length;d+=_,void 0!==a?1<_&&(f+=Math.abs(_-a),a=_):a=0}0<c.data.length&&(d/=c.data.length-l),(void 0===s||s<f)&&1.99<d&&(s=f,n=u)}return{successful:!!(g.delimiter=n),bestDelimiter:n}}(e,g.newline,g.skipEmptyLines,g.comments);n.successful?g.delimiter=n.bestDelimiter:(h=!0,g.delimiter=k.DefaultDelimiter),d.meta.delimiter=g.delimiter}var s=E(g);return g.preview&&g.header&&s.preview++,a=e,o=new v(s),d=o.parse(a,t,r),c(),u?{meta:{paused:!0}}:d||{meta:{paused:!1}}},this.paused=function(){return u},this.pause=function(){u=!0,o.abort(),a=a.substr(o.getCharIndex())},this.resume=function(){u=!1,t.streamer.parseChunk(a,!0)},this.aborted=function(){return e},this.abort=function(){e=!0,o.abort(),d.meta.aborted=!0,z(g.complete)&&g.complete(d),a=""}}function M(e){return e.replace(/[.*+?^${}()|[\]\\]/g,"\\$&")}function v(e){var S,O=(e=e||{}).delimiter,x=e.newline,T=e.comments,I=e.step,A=e.preview,D=e.fastMode,L=S=void 0===e.quoteChar?'"':e.quoteChar;if(void 0!==e.escapeChar&&(L=e.escapeChar),("string"!=typeof O||-1<k.BAD_DELIMITERS.indexOf(O))&&(O=","),T===O)throw"Comment character same as delimiter";!0===T?T="#":("string"!=typeof T||-1<k.BAD_DELIMITERS.indexOf(T))&&(T=!1),"\n"!==x&&"\r"!==x&&"\r\n"!==x&&(x="\n");var P=0,F=!1;this.parse=function(i,t,r){if("string"!=typeof i)throw"Input must be a string";var n=i.length,e=O.length,s=x.length,a=T.length,o=z(I),h=[],u=[],f=[],d=P=0;if(!i)return C();if(D||!1!==D&&-1===i.indexOf(S)){for(var l=i.split(x),c=0;c<l.length;c++){if(f=l[c],P+=f.length,c!==l.length-1)P+=x.length;else if(r)return C();if(!T||f.substr(0,a)!==T){if(o){if(h=[],k(f.split(O)),R(),F)return C()}else k(f.split(O));if(A&&A<=c)return h=h.slice(0,A),C(!0)}}return C()}for(var p,_=i.indexOf(O,P),g=i.indexOf(x,P),m=new RegExp(M(L)+M(S),"g");;)if(i[P]!==S)if(T&&0===f.length&&i.substr(P,a)===T){if(-1===g)return C();P=g+s,g=i.indexOf(x,P),_=i.indexOf(O,P)}else if(-1!==_&&(_<g||-1===g))f.push(i.substring(P,_)),P=_+e,_=i.indexOf(O,P);else{if(-1===g)break;if(f.push(i.substring(P,g)),w(g+s),o&&(R(),F))return C();if(A&&h.length>=A)return C(!0)}else for(p=P,P++;;){if(-1===(p=i.indexOf(S,p+1)))return r||u.push({type:"Quotes",code:"MissingQuotes",message:"Quoted field unterminated",row:h.length,index:P}),E();if(p===n-1)return E(i.substring(P,p).replace(m,S));if(S!==L||i[p+1]!==L){if(S===L||0===p||i[p-1]!==L){var y=b(-1===g?_:Math.min(_,g));if(i[p+1+y]===O){f.push(i.substring(P,p).replace(m,S)),P=p+1+y+e,_=i.indexOf(O,P),g=i.indexOf(x,P);break}var v=b(g);if(i.substr(p+1+v,s)===x){if(f.push(i.substring(P,p).replace(m,S)),w(p+1+v+s),_=i.indexOf(O,P),o&&(R(),F))return C();if(A&&h.length>=A)return C(!0);break}u.push({type:"Quotes",code:"InvalidQuotes",message:"Trailing quote on quoted field is malformed",row:h.length,index:P}),p++}}else p++}return E();function k(e){h.push(e),d=P}function b(e){var t=0;if(-1!==e){var r=i.substring(p+1,e);r&&""===r.trim()&&(t=r.length)}return t}function E(e){return r||(void 0===e&&(e=i.substr(P)),f.push(e),P=n,k(f),o&&R()),C()}function w(e){P=e,k(f),f=[],g=i.indexOf(x,P)}function C(e){return{data:h,errors:u,meta:{delimiter:O,linebreak:x,aborted:F,truncated:!!e,cursor:d+(t||0)}}}function R(){I(C()),h=[],u=[]}},this.abort=function(){F=!0},this.getCharIndex=function(){return P}}function m(e){var t=e.data,r=h[t.workerId],i=!1;if(t.error)r.userError(t.error,t.file);else if(t.results&&t.results.data){var n={abort:function(){i=!0,y(t.workerId,{data:[],errors:[],meta:{aborted:!0}})},pause:b,resume:b};if(z(r.userStep)){for(var s=0;s<t.results.data.length&&(r.userStep({data:[t.results.data[s]],errors:t.results.errors,meta:t.results.meta},n),!i);s++);delete t.results}else z(r.userChunk)&&(r.userChunk(t.results,n,t.file),delete t.results)}t.finished&&!i&&y(t.workerId,t.results)}function y(e,t){var r=h[e];z(r.userComplete)&&r.userComplete(t),r.terminate(),delete h[e]}function b(){throw"Not implemented."}function E(e){if("object"!=typeof e||null===e)return e;var t=Array.isArray(e)?[]:{};for(var r in e)t[r]=E(e[r]);return t}function w(e,t){return function(){e.apply(t,arguments)}}function z(e){return"function"==typeof e}return o?f.onmessage=function(e){var t=e.data;void 0===k.WORKER_ID&&t&&(k.WORKER_ID=t.workerId);if("string"==typeof t.input)f.postMessage({workerId:k.WORKER_ID,results:k.parse(t.input,t.config),finished:!0});else if(f.File&&t.input instanceof File||t.input instanceof Object){var r=k.parse(t.input,t.config);r&&f.postMessage({workerId:k.WORKER_ID,results:r,finished:!0})}}:k.WORKERS_SUPPORTED&&(e=document.getElementsByTagName("script"),s=e.length?e[e.length-1].src:"",document.body?document.addEventListener("DOMContentLoaded",function(){a=!0},!0):a=!0),(c.prototype=Object.create(l.prototype)).constructor=c,(p.prototype=Object.create(l.prototype)).constructor=p,(_.prototype=Object.create(_.prototype)).constructor=_,(g.prototype=Object.create(l.prototype)).constructor=g,k});

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/******************************************************************************
 *
 * Copyright (c) 2017, the Perspective Authors.
 *
 * This file is part of the Perspective library, distributed under the terms of
 * the Apache License 2.0.  The full license can be found in the LICENSE file.
 *
 */
var load_perspective = __webpack_require__(141).load_perspective;

var perspective = __webpack_require__(142)["default"];

if (global.document !== undefined && typeof WebAssembly !== "undefined") {
  module.exports = global.perspective = perspective(load_perspective({
    wasmJSMethod: "native-wasm",
    printErr: function printErr(x) {
      return console.error(x);
    },
    print: function print(x) {
      return console.log(x);
    }
  }));
} else {
  module.exports = global.perspective = perspective(load_perspective);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62)))

/***/ }),
/* 141 */
/***/ (function(module, exports) {


var window = window || {};

exports.load_perspective = function (Module) {
    var e;e||(e=typeof Module !== 'undefined' ? Module : {});var aa={},p;for(p in e)e.hasOwnProperty(p)&&(aa[p]=e[p]);e.arguments=[];e.thisProgram="./this.program";e.quit=function(a,b){throw b;};e.preRun=[];e.postRun=[];var q="";q=self.location.href;q=0!==q.indexOf("blob:")?q.substr(0,q.lastIndexOf("/")+1):"";e.read=function(a){var b=new XMLHttpRequest;b.open("GET",a,!1);b.send(null);return b.responseText};
e.readBinary=function(a){var b=new XMLHttpRequest;b.open("GET",a,!1);b.responseType="arraybuffer";b.send(null);return new Uint8Array(b.response)};e.readAsync=function(a,b,c){var d=new XMLHttpRequest;d.open("GET",a,!0);d.responseType="arraybuffer";d.onload=function(){200==d.status||0==d.status&&d.response?b(d.response):c()};d.onerror=c;d.send(null)};e.setWindowTitle=function(a){document.title=a};
var ca=e.print||("undefined"!==typeof console?console.log.bind(console):"undefined"!==typeof print?print:null),r=e.printErr||("undefined"!==typeof printErr?printErr:"undefined"!==typeof console&&console.warn.bind(console)||ca);for(p in aa)aa.hasOwnProperty(p)&&(e[p]=aa[p]);aa=void 0;function da(a){var b=u[ea>>2];a=b+a+15&-16;if(a<=v)u[ea>>2]=a;else if(!fa(a))return 0;return b}var ha={"f64-rem":function(a,b){return a%b},"debugger":function(){debugger}};"object"!==typeof WebAssembly&&r("no native wasm support detected");
var ia,ja=!1,ka="undefined"!==typeof TextDecoder?new TextDecoder("utf8"):void 0;
function la(a,b,c){var d=b+c;for(c=b;a[c]&&!(c>=d);)++c;if(16<c-b&&a.subarray&&ka)return ka.decode(a.subarray(b,c));for(d="";b<c;){var f=a[b++];if(f&128){var g=a[b++]&63;if(192==(f&224))d+=String.fromCharCode((f&31)<<6|g);else{var h=a[b++]&63;f=224==(f&240)?(f&15)<<12|g<<6|h:(f&7)<<18|g<<12|h<<6|a[b++]&63;65536>f?d+=String.fromCharCode(f):(f-=65536,d+=String.fromCharCode(55296|f>>10,56320|f&1023))}}else d+=String.fromCharCode(f)}return d}function w(a){return a?la(x,a,void 0):""}
function ma(a,b,c,d){if(0<d){d=c+d-1;for(var f=0;f<a.length;++f){var g=a.charCodeAt(f);if(55296<=g&&57343>=g){var h=a.charCodeAt(++f);g=65536+((g&1023)<<10)|h&1023}if(127>=g){if(c>=d)break;b[c++]=g}else{if(2047>=g){if(c+1>=d)break;b[c++]=192|g>>6}else{if(65535>=g){if(c+2>=d)break;b[c++]=224|g>>12}else{if(c+3>=d)break;b[c++]=240|g>>18;b[c++]=128|g>>12&63}b[c++]=128|g>>6&63}b[c++]=128|g&63}}b[c]=0}}
function na(a){for(var b=0,c=0;c<a.length;++c){var d=a.charCodeAt(c);55296<=d&&57343>=d&&(d=65536+((d&1023)<<10)|a.charCodeAt(++c)&1023);127>=d?++b:b=2047>=d?b+2:65535>=d?b+3:b+4}return b}"undefined"!==typeof TextDecoder&&new TextDecoder("utf-16le");function oa(a){var b=na(a)+1,c=pa(b);ma(a,y,c,b);return c}function qa(a){0<a%65536&&(a+=65536-a%65536);return a}var z,y,x,ra,sa,u,A,ta,ua;
function va(){e.HEAP8=y=new Int8Array(z);e.HEAP16=ra=new Int16Array(z);e.HEAP32=u=new Int32Array(z);e.HEAPU8=x=new Uint8Array(z);e.HEAPU16=sa=new Uint16Array(z);e.HEAPU32=A=new Uint32Array(z);e.HEAPF32=ta=new Float32Array(z);e.HEAPF64=ua=new Float64Array(z)}var ea=38656,v=e.TOTAL_MEMORY||16777216;5242880>v&&r("TOTAL_MEMORY should be larger than TOTAL_STACK, was "+v+"! (TOTAL_STACK=5242880)");
e.buffer?z=e.buffer:("object"===typeof WebAssembly&&"function"===typeof WebAssembly.Memory?(ia=new WebAssembly.Memory({initial:v/65536}),z=ia.buffer):z=new ArrayBuffer(v),e.buffer=z);va();u[ea>>2]=5281792;function wa(a){for(;0<a.length;){var b=a.shift();if("function"==typeof b)b();else{var c=b.Ub;"number"===typeof c?void 0===b.Eb?e.dynCall_v(c):e.dynCall_vi(c,b.Eb):c(void 0===b.Eb?null:b.Eb)}}}var xa=[],ya=[],za=[],Aa=[],B=!1;function Ba(){var a=e.preRun.shift();xa.unshift(a)}var C=0,Ca=null,Da=null;
e.preloadedImages={};e.preloadedAudios={};function Ea(){var a=D;return String.prototype.startsWith?a.startsWith("data:application/octet-stream;base64,"):0===a.indexOf("data:application/octet-stream;base64,")}var D="psp.async.wasm";if(!Ea()){var Fa=D;D=e.locateFile?e.locateFile(Fa,q):q+Fa}function Ga(){try{if(e.wasmBinary)return new Uint8Array(e.wasmBinary);if(e.readBinary)return e.readBinary(D);throw"both async and sync fetching of the wasm failed";}catch(a){E(a)}}
function Ha(){return e.wasmBinary||"function"!==typeof fetch?new Promise(function(a){a(Ga())}):fetch(D,{credentials:"same-origin"}).then(function(a){if(!a.ok)throw"failed to load wasm binary file at '"+D+"'";return a.arrayBuffer()}).catch(function(){return Ga()})}
function Ia(a){function b(a){e.asm=a.exports;C--;e.monitorRunDependencies&&e.monitorRunDependencies(C);0==C&&(null!==Ca&&(clearInterval(Ca),Ca=null),Da&&(a=Da,Da=null,a()))}function c(a){b(a.instance)}function d(a){Ha().then(function(a){return WebAssembly.instantiate(a,f)}).then(a,function(a){r("failed to asynchronously prepare wasm: "+a);E(a)})}var f={env:a,global:{NaN:NaN,Infinity:Infinity},"global.Math":Math,asm2wasm:ha};C++;e.monitorRunDependencies&&e.monitorRunDependencies(C);if(e.instantiateWasm)try{return e.instantiateWasm(f,
b)}catch(g){return r("Module.instantiateWasm callback failed with error: "+g),!1}e.wasmBinary||"function"!==typeof WebAssembly.instantiateStreaming||Ea()||"function"!==typeof fetch?d(c):WebAssembly.instantiateStreaming(fetch(D,{credentials:"same-origin"}),f).then(c,function(a){r("wasm streaming compile failed: "+a);r("falling back to ArrayBuffer instantiation");d(c)});return{}}
e.asm=function(a,b){b.memory=ia;b.table=new WebAssembly.Table({initial:1462,maximum:1462,element:"anyfunc"});b.__memory_base=1024;b.__table_base=0;return Ia(b)};var Ja=[function(){if("undefined"!==typeof self)if(self.dispatchEvent&&!self.lb&&self.document){self.lb=!0;var a=self.document.createEvent("Event");a.initEvent("perspective-ready",!1,!0);self.dispatchEvent(a)}else!self.document&&self.postMessage&&self.postMessage({})}];ya.push({Ub:function(){Ka()}});var F={};
function La(a){if(La.lb){var b=u[a>>2];var c=u[b>>2]}else La.lb=!0,F.USER=F.LOGNAME="web_user",F.PATH="/",F.PWD="/",F.HOME="/home/web_user",F.LANG="C.UTF-8",F._=e.thisProgram,c=B?G(1024):da(1024),b=B?G(256):da(256),u[b>>2]=c,u[a>>2]=b;a=[];var d=0,f;for(f in F)if("string"===typeof F[f]){var g=f+"="+F[f];a.push(g);d+=g.length}if(1024<d)throw Error("Environment size exceeded TOTAL_ENV_SIZE!");for(f=0;f<a.length;f++){d=g=a[f];for(var h=c,k=0;k<d.length;++k)y[h++>>0]=d.charCodeAt(k);y[h>>0]=0;u[b+4*f>>
2]=c;c+=g.length+1}u[b+4*a.length>>2]=0}function Ma(a){e.___errno_location&&(u[e.___errno_location()>>2]=a);return a}var Na=[null,[],[]],H=0;function I(){H+=4;return u[H-4>>2]}var J={},Oa={};function Pa(a){for(;a.length;){var b=a.pop();a.pop()(b)}}function Qa(a){return this.fromWireType(A[a>>2])}var K={},L={},Ra={};function Sa(a){if(void 0===a)return"_unknown";a=a.replace(/[^a-zA-Z0-9_]/g,"$");var b=a.charCodeAt(0);return 48<=b&&57>=b?"_"+a:a}
function Ta(a,b){a=Sa(a);return(new Function("body","return function "+a+'() {\n    "use strict";    return body.apply(this, arguments);\n};\n'))(b)}function Ua(a){var b=Error,c=Ta(a,function(b){this.name=a;this.message=b;b=Error(b).stack;void 0!==b&&(this.stack=this.toString()+"\n"+b.replace(/^Error(:[^\n]*)?\n/,""))});c.prototype=Object.create(b.prototype);c.prototype.constructor=c;c.prototype.toString=function(){return void 0===this.message?this.name:this.name+": "+this.message};return c}
var Va=void 0;function Wa(a){throw new Va(a);}function M(a,b,c){function d(b){b=c(b);b.length!==a.length&&Wa("Mismatched type converter count");for(var d=0;d<a.length;++d)N(a[d],b[d])}a.forEach(function(a){Ra[a]=b});var f=Array(b.length),g=[],h=0;b.forEach(function(a,b){L.hasOwnProperty(a)?f[b]=L[a]:(g.push(a),K.hasOwnProperty(a)||(K[a]=[]),K[a].push(function(){f[b]=L[a];++h;h===g.length&&d(f)}))});0===g.length&&d(f)}
function Xa(a){switch(a){case 1:return 0;case 2:return 1;case 4:return 2;case 8:return 3;default:throw new TypeError("Unknown type size: "+a);}}var Ya=void 0;function O(a){for(var b="";x[a];)b+=Ya[x[a++]];return b}var P=void 0;function R(a){throw new P(a);}
function N(a,b,c){c=c||{};if(!("argPackAdvance"in b))throw new TypeError("registerType registeredInstance requires argPackAdvance");var d=b.name;a||R('type "'+d+'" must have a positive integer typeid pointer');if(L.hasOwnProperty(a)){if(c.bc)return;R("Cannot register type '"+d+"' twice")}L[a]=b;delete Ra[a];K.hasOwnProperty(a)&&(b=K[a],delete K[a],b.forEach(function(a){a()}))}function Za(a){return{count:a.count,vb:a.vb,xb:a.xb,hb:a.hb,ib:a.ib,mb:a.mb,ob:a.ob}}
function $a(a){R(a.fb.ib.gb.name+" instance already deleted")}var ab=void 0,bb=[];function cb(){for(;bb.length;){var a=bb.pop();a.fb.vb=!1;a["delete"]()}}function S(){}var db={};function eb(a,b,c){if(void 0===a[b].kb){var d=a[b];a[b]=function(){a[b].kb.hasOwnProperty(arguments.length)||R("Function '"+c+"' called with an invalid number of arguments ("+arguments.length+") - expects one of ("+a[b].kb+")!");return a[b].kb[arguments.length].apply(this,arguments)};a[b].kb=[];a[b].kb[d.zb]=d}}
function fb(a,b,c){e.hasOwnProperty(a)?((void 0===c||void 0!==e[a].kb&&void 0!==e[a].kb[c])&&R("Cannot register public name '"+a+"' twice"),eb(e,a,a),e.hasOwnProperty(c)&&R("Cannot register multiple overloads of a function with the same number of arguments ("+c+")!"),e[a].kb[c]=b):(e[a]=b,void 0!==c&&(e[a].wc=c))}function gb(a,b,c,d,f,g,h,k){this.name=a;this.constructor=b;this.wb=c;this.qb=d;this.pb=f;this.Vb=g;this.yb=h;this.Sb=k;this.gc=[]}
function hb(a,b,c){for(;b!==c;)b.yb||R("Expected null or instance of "+c.name+", got an instance of "+b.name),a=b.yb(a),b=b.pb;return a}function ib(a,b){if(null===b)return this.Fb&&R("null is not a valid "+this.name),0;b.fb||R('Cannot pass "'+jb(b)+'" as a '+this.name);b.fb.hb||R("Cannot pass deleted object as a pointer of type "+this.name);return hb(b.fb.hb,b.fb.ib.gb,this.gb)}
function kb(a,b){if(null===b){this.Fb&&R("null is not a valid "+this.name);if(this.Bb){var c=this.Gb();null!==a&&a.push(this.qb,c);return c}return 0}b.fb||R('Cannot pass "'+jb(b)+'" as a '+this.name);b.fb.hb||R("Cannot pass deleted object as a pointer of type "+this.name);!this.Ab&&b.fb.ib.Ab&&R("Cannot convert argument of type "+(b.fb.ob?b.fb.ob.name:b.fb.ib.name)+" to parameter type "+this.name);c=hb(b.fb.hb,b.fb.ib.gb,this.gb);if(this.Bb)switch(void 0===b.fb.mb&&R("Passing raw pointer to smart pointer is illegal"),
this.lc){case 0:b.fb.ob===this?c=b.fb.mb:R("Cannot convert argument of type "+(b.fb.ob?b.fb.ob.name:b.fb.ib.name)+" to parameter type "+this.name);break;case 1:c=b.fb.mb;break;case 2:if(b.fb.ob===this)c=b.fb.mb;else{var d=b.clone();c=this.hc(c,T(function(){d["delete"]()}));null!==a&&a.push(this.qb,c)}break;default:R("Unsupporting sharing policy")}return c}
function lb(a,b){if(null===b)return this.Fb&&R("null is not a valid "+this.name),0;b.fb||R('Cannot pass "'+jb(b)+'" as a '+this.name);b.fb.hb||R("Cannot pass deleted object as a pointer of type "+this.name);b.fb.ib.Ab&&R("Cannot convert argument of type "+b.fb.ib.name+" to parameter type "+this.name);return hb(b.fb.hb,b.fb.ib.gb,this.gb)}function mb(a,b,c){if(b===c)return a;if(void 0===c.pb)return null;a=mb(a,b,c.pb);return null===a?null:c.Sb(a)}var nb={};
function ob(a,b){for(void 0===b&&R("ptr should not be undefined");a.pb;)b=a.yb(b),a=a.pb;return nb[b]}function pb(a,b){b.ib&&b.hb||Wa("makeClassHandle requires ptr and ptrType");!!b.ob!==!!b.mb&&Wa("Both smartPtrType and smartPtr must be specified");b.count={value:1};return Object.create(a,{fb:{value:b}})}
function U(a,b,c,d,f,g,h,k,m,l,n){this.name=a;this.gb=b;this.Fb=c;this.Ab=d;this.Bb=f;this.fc=g;this.lc=h;this.Pb=k;this.Gb=m;this.hc=l;this.qb=n;f||void 0!==b.pb?this.toWireType=kb:(this.toWireType=d?ib:lb,this.nb=null)}function qb(a,b,c){e.hasOwnProperty(a)||Wa("Replacing nonexistant public symbol");void 0!==e[a].kb&&void 0!==c?e[a].kb[c]=b:(e[a]=b,e[a].zb=c)}
function V(a,b){a=O(a);if(void 0!==e["FUNCTION_TABLE_"+a])var c=e["FUNCTION_TABLE_"+a][b];else if("undefined"!==typeof FUNCTION_TABLE)c=FUNCTION_TABLE[b];else{c=e["dynCall_"+a];void 0===c&&(c=e["dynCall_"+a.replace(/f/g,"d")],void 0===c&&R("No dynCall invoker for signature: "+a));for(var d=[],f=1;f<a.length;++f)d.push("a"+f);f="return function "+("dynCall_"+a+"_"+b)+"("+d.join(", ")+") {\n";f+="    return dynCall(rawFunction"+(d.length?", ":"")+d.join(", ")+");\n";c=(new Function("dynCall","rawFunction",
f+"};\n"))(c,b)}"function"!==typeof c&&R("unknown function pointer with signature "+a+": "+b);return c}var rb=void 0;function sb(a){a=tb(a);var b=O(a);W(a);return b}function ub(a,b){function c(a){f[a]||L[a]||(Ra[a]?Ra[a].forEach(c):(d.push(a),f[a]=!0))}var d=[],f={};b.forEach(c);throw new rb(a+": "+d.map(sb).join([", "]));}function vb(a,b){for(var c=[],d=0;d<a;d++)c.push(u[(b>>2)+d]);return c}
function wb(a){var b=Function;if(!(b instanceof Function))throw new TypeError("new_ called with constructor type "+typeof b+" which is not a function");var c=Ta(b.name||"unknownFunctionName",function(){});c.prototype=b.prototype;c=new c;a=b.apply(c,a);return a instanceof Object?a:c}
function xb(a,b,c,d,f){var g=b.length;2>g&&R("argTypes array size mismatch! Must at least get return value and 'this' types!");var h=null!==b[1]&&null!==c,k=!1;for(c=1;c<b.length;++c)if(null!==b[c]&&void 0===b[c].nb){k=!0;break}var m="void"!==b[0].name,l="",n="";for(c=0;c<g-2;++c)l+=(0!==c?", ":"")+"arg"+c,n+=(0!==c?", ":"")+"arg"+c+"Wired";a="return function "+Sa(a)+"("+l+") {\nif (arguments.length !== "+(g-2)+") {\nthrowBindingError('function "+a+" called with ' + arguments.length + ' arguments, expected "+
(g-2)+" args!');\n}\n";k&&(a+="var destructors = [];\n");var t=k?"destructors":"null";l="throwBindingError invoker fn runDestructors retType classParam".split(" ");d=[R,d,f,Pa,b[0],b[1]];h&&(a+="var thisWired = classParam.toWireType("+t+", this);\n");for(c=0;c<g-2;++c)a+="var arg"+c+"Wired = argType"+c+".toWireType("+t+", arg"+c+"); // "+b[c+2].name+"\n",l.push("argType"+c),d.push(b[c+2]);h&&(n="thisWired"+(0<n.length?", ":"")+n);a+=(m?"var rv = ":"")+"invoker(fn"+(0<n.length?", ":"")+n+");\n";if(k)a+=
"runDestructors(destructors);\n";else for(c=h?1:2;c<b.length;++c)g=1===c?"thisWired":"arg"+(c-2)+"Wired",null!==b[c].nb&&(a+=g+"_dtor("+g+"); // "+b[c].name+"\n",l.push(g+"_dtor"),d.push(b[c].nb));m&&(a+="var ret = retType.fromWireType(rv);\nreturn ret;\n");l.push(a+"}\n");return wb(l).apply(null,d)}var yb=[],X=[{},{value:void 0},{value:null},{value:!0},{value:!1}];function zb(a){4<a&&0===--X[a].Hb&&(X[a]=void 0,yb.push(a))}
function T(a){switch(a){case void 0:return 1;case null:return 2;case !0:return 3;case !1:return 4;default:var b=yb.length?yb.pop():X.length;X[b]={Hb:1,value:a};return b}}function Ab(a,b,c){switch(b){case 0:return function(a){return this.fromWireType((c?y:x)[a])};case 1:return function(a){return this.fromWireType((c?ra:sa)[a>>1])};case 2:return function(a){return this.fromWireType((c?u:A)[a>>2])};default:throw new TypeError("Unknown integer type: "+a);}}
function Bb(a,b){var c=L[a];void 0===c&&R(b+" has unknown type "+sb(a));return c}function jb(a){if(null===a)return"null";var b=typeof a;return"object"===b||"array"===b||"function"===b?a.toString():""+a}function Cb(a,b){switch(b){case 2:return function(a){return this.fromWireType(ta[a>>2])};case 3:return function(a){return this.fromWireType(ua[a>>3])};default:throw new TypeError("Unknown float type: "+a);}}
function Db(a,b,c){switch(b){case 0:return c?function(a){return y[a]}:function(a){return x[a]};case 1:return c?function(a){return ra[a>>1]}:function(a){return sa[a>>1]};case 2:return c?function(a){return u[a>>2]}:function(a){return A[a>>2]};default:throw new TypeError("Unknown integer type: "+a);}}function Y(a){a||R("Cannot use deleted val. handle = "+a);return X[a].value}function Eb(a,b){for(var c=Array(a),d=0;d<a;++d)c[d]=Bb(u[(b>>2)+d],"parameter "+d);return c}var Fb={};
function Gb(a){var b=Fb[a];return void 0===b?O(a):b}var Hb=[];function Ib(a){var b=Hb.length;Hb.push(a);return b}var Jb={};function Kb(){void 0===Kb.start&&(Kb.start=Date.now());return 1E3*(Date.now()-Kb.start)|0}function Lb(){E()}
function fa(a){if(2147418112<a)return!1;for(var b=Math.max(v,16777216);b<a;)536870912>=b?b=qa(2*b):b=Math.min(qa((3*b+2147483648)/4),2147418112);a=qa(b);var c=e.buffer.byteLength;try{var d=-1!==ia.grow((a-c)/65536)?e.buffer=ia.buffer:null}catch(f){d=null}if(!d||d.byteLength!=b)return!1;e.buffer=z=d;va();v=b;return!0}function Mb(a){if(0===a)return 0;a=w(a);if(!F.hasOwnProperty(a))return 0;Mb.lb&&W(Mb.lb);a=F[a];var b=na(a)+1,c=G(b);c&&ma(a,y,c,b);Mb.lb=c;return Mb.lb}
function Z(){Z.lb||(Z.lb=[]);Z.lb.push(Nb());return Z.lb.length-1}function Ob(a){return 0===a%4&&(0!==a%100||0===a%400)}function Pb(a,b){for(var c=0,d=0;d<=b;c+=a[d++]);return c}var Qb=[31,29,31,30,31,30,31,31,30,31,30,31],Rb=[31,28,31,30,31,30,31,31,30,31,30,31];
function Sb(a,b){for(a=new Date(a.getTime());0<b;){var c=a.getMonth(),d=(Ob(a.getFullYear())?Qb:Rb)[c];if(b>d-a.getDate())b-=d-a.getDate()+1,a.setDate(1),11>c?a.setMonth(c+1):(a.setMonth(0),a.setFullYear(a.getFullYear()+1));else{a.setDate(a.getDate()+b);break}}return a}
function Tb(a,b,c,d){function f(a,b,c){for(a="number"===typeof a?a.toString():a||"";a.length<b;)a=c[0]+a;return a}function g(a,b){return f(a,b,"0")}function h(a,b){function c(a){return 0>a?-1:0<a?1:0}var d;0===(d=c(a.getFullYear()-b.getFullYear()))&&0===(d=c(a.getMonth()-b.getMonth()))&&(d=c(a.getDate()-b.getDate()));return d}function k(a){switch(a.getDay()){case 0:return new Date(a.getFullYear()-1,11,29);case 1:return a;case 2:return new Date(a.getFullYear(),0,3);case 3:return new Date(a.getFullYear(),
0,2);case 4:return new Date(a.getFullYear(),0,1);case 5:return new Date(a.getFullYear()-1,11,31);case 6:return new Date(a.getFullYear()-1,11,30)}}function m(a){a=Sb(new Date(a.jb+1900,0,1),a.Db);var b=k(new Date(a.getFullYear()+1,0,4));return 0>=h(k(new Date(a.getFullYear(),0,4)),a)?0>=h(b,a)?a.getFullYear()+1:a.getFullYear():a.getFullYear()-1}var l=u[d+40>>2];d={oc:u[d>>2],nc:u[d+4>>2],Cb:u[d+8>>2],ub:u[d+12>>2],sb:u[d+16>>2],jb:u[d+20>>2],Qb:u[d+24>>2],Db:u[d+28>>2],xc:u[d+32>>2],mc:u[d+36>>2],
pc:l?w(l):""};c=w(c);l={"%c":"%a %b %d %H:%M:%S %Y","%D":"%m/%d/%y","%F":"%Y-%m-%d","%h":"%b","%r":"%I:%M:%S %p","%R":"%H:%M","%T":"%H:%M:%S","%x":"%m/%d/%y","%X":"%H:%M:%S"};for(var n in l)c=c.replace(new RegExp(n,"g"),l[n]);var t="Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),ba="January February March April May June July August September October November December".split(" ");l={"%a":function(a){return t[a.Qb].substring(0,3)},"%A":function(a){return t[a.Qb]},"%b":function(a){return ba[a.sb].substring(0,
3)},"%B":function(a){return ba[a.sb]},"%C":function(a){return g((a.jb+1900)/100|0,2)},"%d":function(a){return g(a.ub,2)},"%e":function(a){return f(a.ub,2," ")},"%g":function(a){return m(a).toString().substring(2)},"%G":function(a){return m(a)},"%H":function(a){return g(a.Cb,2)},"%I":function(a){a=a.Cb;0==a?a=12:12<a&&(a-=12);return g(a,2)},"%j":function(a){return g(a.ub+Pb(Ob(a.jb+1900)?Qb:Rb,a.sb-1),3)},"%m":function(a){return g(a.sb+1,2)},"%M":function(a){return g(a.nc,2)},"%n":function(){return"\n"},
"%p":function(a){return 0<=a.Cb&&12>a.Cb?"AM":"PM"},"%S":function(a){return g(a.oc,2)},"%t":function(){return"\t"},"%u":function(a){return(new Date(a.jb+1900,a.sb+1,a.ub,0,0,0,0)).getDay()||7},"%U":function(a){var b=new Date(a.jb+1900,0,1),c=0===b.getDay()?b:Sb(b,7-b.getDay());a=new Date(a.jb+1900,a.sb,a.ub);return 0>h(c,a)?g(Math.ceil((31-c.getDate()+(Pb(Ob(a.getFullYear())?Qb:Rb,a.getMonth()-1)-31)+a.getDate())/7),2):0===h(c,b)?"01":"00"},"%V":function(a){var b=k(new Date(a.jb+1900,0,4)),c=k(new Date(a.jb+
1901,0,4)),d=Sb(new Date(a.jb+1900,0,1),a.Db);return 0>h(d,b)?"53":0>=h(c,d)?"01":g(Math.ceil((b.getFullYear()<a.jb+1900?a.Db+32-b.getDate():a.Db+1-b.getDate())/7),2)},"%w":function(a){return(new Date(a.jb+1900,a.sb+1,a.ub,0,0,0,0)).getDay()},"%W":function(a){var b=new Date(a.jb,0,1),c=1===b.getDay()?b:Sb(b,0===b.getDay()?1:7-b.getDay()+1);a=new Date(a.jb+1900,a.sb,a.ub);return 0>h(c,a)?g(Math.ceil((31-c.getDate()+(Pb(Ob(a.getFullYear())?Qb:Rb,a.getMonth()-1)-31)+a.getDate())/7),2):0===h(c,b)?"01":
"00"},"%y":function(a){return(a.jb+1900).toString().substring(2)},"%Y":function(a){return a.jb+1900},"%z":function(a){a=a.mc;var b=0<=a;a=Math.abs(a)/60;return(b?"+":"-")+String("0000"+(a/60*100+a%60)).slice(-4)},"%Z":function(a){return a.pc},"%%":function(){return"%"}};for(n in l)0<=c.indexOf(n)&&(c=c.replace(new RegExp(n,"g"),l[n](d)));n=Ub(c);if(n.length>b)return 0;y.set(n,a);return n.length-1}Va=e.InternalError=Ua("InternalError");for(var Vb=Array(256),Wb=0;256>Wb;++Wb)Vb[Wb]=String.fromCharCode(Wb);
Ya=Vb;P=e.BindingError=Ua("BindingError");S.prototype.isAliasOf=function(a){if(!(this instanceof S&&a instanceof S))return!1;var b=this.fb.ib.gb,c=this.fb.hb,d=a.fb.ib.gb;for(a=a.fb.hb;b.pb;)c=b.yb(c),b=b.pb;for(;d.pb;)a=d.yb(a),d=d.pb;return b===d&&c===a};S.prototype.clone=function(){this.fb.hb||$a(this);if(this.fb.xb)return this.fb.count.value+=1,this;var a=Object.create(Object.getPrototypeOf(this),{fb:{value:Za(this.fb)}});a.fb.count.value+=1;a.fb.vb=!1;return a};
S.prototype["delete"]=function(){this.fb.hb||$a(this);this.fb.vb&&!this.fb.xb&&R("Object already scheduled for deletion");--this.fb.count.value;if(0===this.fb.count.value){var a=this.fb;a.mb?a.ob.qb(a.mb):a.ib.gb.qb(a.hb)}this.fb.xb||(this.fb.mb=void 0,this.fb.hb=void 0)};S.prototype.isDeleted=function(){return!this.fb.hb};
S.prototype.deleteLater=function(){this.fb.hb||$a(this);this.fb.vb&&!this.fb.xb&&R("Object already scheduled for deletion");bb.push(this);1===bb.length&&ab&&ab(cb);this.fb.vb=!0;return this};U.prototype.Wb=function(a){this.Pb&&(a=this.Pb(a));return a};U.prototype.Jb=function(a){this.qb&&this.qb(a)};U.prototype.argPackAdvance=8;U.prototype.readValueFromPointer=Qa;U.prototype.deleteObject=function(a){if(null!==a)a["delete"]()};
U.prototype.fromWireType=function(a){function b(){return this.Bb?pb(this.gb.wb,{ib:this.fc,hb:c,ob:this,mb:a}):pb(this.gb.wb,{ib:this,hb:a})}var c=this.Wb(a);if(!c)return this.Jb(a),null;var d=ob(this.gb,c);if(void 0!==d){if(0===d.fb.count.value)return d.fb.hb=c,d.fb.mb=a,d.clone();d=d.clone();this.Jb(a);return d}d=this.gb.Vb(c);d=db[d];if(!d)return b.call(this);d=this.Ab?d.Rb:d.pointerType;var f=mb(c,this.gb,d.gb);return null===f?b.call(this):this.Bb?pb(d.gb.wb,{ib:d,hb:f,ob:this,mb:a}):pb(d.gb.wb,
{ib:d,hb:f})};e.getInheritedInstanceCount=function(){return Object.keys(nb).length};e.getLiveInheritedInstances=function(){var a=[],b;for(b in nb)nb.hasOwnProperty(b)&&a.push(nb[b]);return a};e.flushPendingDeletes=cb;e.setDelayFunction=function(a){ab=a;bb.length&&ab&&ab(cb)};rb=e.UnboundTypeError=Ua("UnboundTypeError");e.count_emval_handles=function(){for(var a=0,b=5;b<X.length;++b)void 0!==X[b]&&++a;return a};e.get_first_emval=function(){for(var a=5;a<X.length;++a)if(void 0!==X[a])return X[a];return null};
"undefined"!==typeof dateNow?Lb=dateNow:"object"===typeof performance&&performance&&"function"===typeof performance.now?Lb=function(){return performance.now()}:Lb=Date.now;function Ub(a){var b=Array(na(a)+1);ma(a,b,0,b.length);return b}
var bc=e.asm({},{v:E,n:function(a,b,c,d){E("Assertion failed: "+w(a)+", at: "+[b?w(b):"unknown filename",c,d?w(d):"unknown function"])},ra:La,h:function(a){return G(a)},la:function(){ja=!0;throw"Pure virtual function called!";},g:function(a){"uncaught_exception"in Xb?Xb.Mb++:Xb.Mb=1;throw a;},ha:function(){return!!Xb.Mb},I:function(){},V:function(){Ma(1);return-1},P:Ma,ya:function(a,b){H=b;try{var c=w(I());(void 0).yc(c);return 0}catch(d){return E(d),-d.rb}},xa:function(a,b){H=b;try{var c=J.Nb();
I();var d=I(),f=I(),g=I();(void 0).tc(c,d,g);u[f>>2]=c.position;c.Yb&&0===d&&0===g&&(c.Yb=null);return 0}catch(h){return E(h),-h.rb}},wa:function(a,b){H=b;try{var c=J.Nb(),d=I(),f=I();return J.rc(c,d,f)}catch(g){return E(g),-g.rb}},U:function(a,b){H=b;try{var c=I(),d=I(),f=I();for(b=a=0;b<f;b++){for(var g=u[d+8*b>>2],h=u[d+(8*b+4)>>2],k=0;k<h;k++){var m=x[g+k],l=Na[c];0===m||10===m?((1===c?ca:r)(la(l,0)),l.length=0):l.push(m)}a+=h}return a}catch(n){return E(n),-n.rb}},va:function(a,b){H=b;return-12},
ua:function(a,b){H=b;try{var c=I(),d=I(),f=I(),g=I(),h=I(),k=I();k<<=12;a=!1;if(-1===h){var m=Yb(16384,d);if(!m)return-12;Zb(m,0,d);a=!0}else{var l=(void 0).Xb(h);if(!l)return-9;var n=(void 0).uc(l,x,c,d,k,f,g);m=n.hb;a=n.Ib}J.Ob[m]={ec:m,dc:d,Ib:a,Kb:h,flags:g};return m}catch(t){return E(t),-t.rb}},ta:function(a,b){H=b;try{var c=I();I();var d=I();I();(void 0).sc(c,d);return 0}catch(f){return E(f),-f.rb}},sa:function(a,b){H=b;return 42},H:function(a,b){H=b;return 0},T:function(a,b){H=b;try{var c=
w(I()),d=I(),f=I();return(void 0).open(c,d,f).Kb}catch(g){return E(g),-g.rb}},S:function(a,b){H=b;return 0},O:function(a,b){H=b;try{var c=J.Nb();(void 0).close(c);return 0}catch(d){return E(d),-d.rb}},qa:function(a,b){H=b;try{var c=I(),d=I(),f=J.Ob[c];if(!f)return 0;if(d===f.dc){var g=(void 0).Xb(f.Kb);J.qc(c,g,d,f.flags);(void 0).vc(g);J.Ob[c]=null;f.Ib&&W(f.ec)}return 0}catch(h){return E(h),-h.rb}},G:function(){},K:function(a){var b=Oa[a];delete Oa[a];var c=b.Gb,d=b.qb,f=b.Lb,g=f.map(function(a){return a.ac}).concat(f.map(function(a){return a.jc}));
M([a],g,function(a){var g={};f.forEach(function(b,c){var d=a[c],k=b.Zb,h=b.$b,l=a[c+f.length],m=b.ic,ac=b.kc;g[b.Tb]={read:function(a){return d.fromWireType(k(h,a))},write:function(a,b){var c=[];m(ac,a,l.toWireType(c,b));Pa(c)}}});return[{name:b.name,fromWireType:function(a){var b={},c;for(c in g)b[c]=g[c].read(a);d(a);return b},toWireType:function(a,b){for(var f in g)if(!(f in b))throw new TypeError("Missing field");var k=c();for(f in g)g[f].write(k,b[f]);null!==a&&a.push(d,k);return k},argPackAdvance:8,
readValueFromPointer:Qa,nb:d}]})},pa:function(a,b,c,d,f){var g=Xa(c);b=O(b);N(a,{name:b,fromWireType:function(a){return!!a},toWireType:function(a,b){return b?d:f},argPackAdvance:8,readValueFromPointer:function(a){if(1===c)var d=y;else if(2===c)d=ra;else if(4===c)d=u;else throw new TypeError("Unknown boolean type size: "+b);return this.fromWireType(d[a>>g])},nb:null})},u:function(a,b,c,d,f,g,h,k,m,l,n,t,ba){n=O(n);g=V(f,g);k&&(k=V(h,k));l&&(l=V(m,l));ba=V(t,ba);var Q=Sa(n);fb(Q,function(){ub("Cannot construct "+
n+" due to unbound types",[d])});M([a,b,c],d?[d]:[],function(b){b=b[0];if(d){var c=b.gb;var f=c.wb}else f=S.prototype;b=Ta(Q,function(){if(Object.getPrototypeOf(this)!==h)throw new P("Use 'new' to construct "+n);if(void 0===m.tb)throw new P(n+" has no accessible constructor");var a=m.tb[arguments.length];if(void 0===a)throw new P("Tried to invoke ctor of "+n+" with invalid number of parameters ("+arguments.length+") - expected ("+Object.keys(m.tb).toString()+") parameters instead!");return a.apply(this,
arguments)});var h=Object.create(f,{constructor:{value:b}});b.prototype=h;var m=new gb(n,b,h,ba,c,g,k,l);c=new U(n,m,!0,!1,!1);f=new U(n+"*",m,!1,!1,!1);var t=new U(n+" const*",m,!1,!0,!1);db[a]={pointerType:f,Rb:t};qb(Q,b);return[c,f,t]})},y:function(a,b,c,d,f,g){var h=vb(b,c);f=V(d,f);M([],[a],function(a){a=a[0];var c="constructor "+a.name;void 0===a.gb.tb&&(a.gb.tb=[]);if(void 0!==a.gb.tb[b-1])throw new P("Cannot register multiple constructors with identical number of parameters ("+(b-1)+") for class '"+
a.name+"'! Overload resolution is currently only performed using the parameter count, not actual type info!");a.gb.tb[b-1]=function(){ub("Cannot construct "+a.name+" due to unbound types",h)};M([],h,function(d){a.gb.tb[b-1]=function(){arguments.length!==b-1&&R(c+" called with "+arguments.length+" arguments, expected "+(b-1));var a=[],h=Array(b);h[0]=g;for(var k=1;k<b;++k)h[k]=d[k].toWireType(a,arguments[k-1]);h=f.apply(null,h);Pa(a);return d[0].fromWireType(h)};return[]});return[]})},e:function(a,
b,c,d,f,g,h,k){var m=vb(c,d);b=O(b);g=V(f,g);M([],[a],function(a){function d(){ub("Cannot call "+f+" due to unbound types",m)}a=a[0];var f=a.name+"."+b;k&&a.gb.gc.push(b);var l=a.gb.wb,Q=l[b];void 0===Q||void 0===Q.kb&&Q.className!==a.name&&Q.zb===c-2?(d.zb=c-2,d.className=a.name,l[b]=d):(eb(l,b,f),l[b].kb[c-2]=d);M([],m,function(d){d=xb(f,d,a,g,h);void 0===l[b].kb?(d.zb=c-2,l[b]=d):l[b].kb[c-2]=d;return[]});return[]})},oa:function(a,b){b=O(b);N(a,{name:b,fromWireType:function(a){var b=X[a].value;
zb(a);return b},toWireType:function(a,b){return T(b)},argPackAdvance:8,readValueFromPointer:Qa,nb:null})},na:function(a,b,c,d){function f(){}c=Xa(c);b=O(b);f.values={};N(a,{name:b,constructor:f,fromWireType:function(a){return this.constructor.values[a]},toWireType:function(a,b){return b.value},argPackAdvance:8,readValueFromPointer:Ab(b,c,d),nb:null});fb(b,f)},t:function(a,b,c){var d=Bb(a,"enum");b=O(b);a=d.constructor;d=Object.create(d.constructor.prototype,{value:{value:c},constructor:{value:Ta(d.name+
"_"+b,function(){})}});a.values[c]=d;a[b]=d},R:function(a,b,c){c=Xa(c);b=O(b);N(a,{name:b,fromWireType:function(a){return a},toWireType:function(a,b){if("number"!==typeof b&&"boolean"!==typeof b)throw new TypeError('Cannot convert "'+jb(b)+'" to '+this.name);return b},argPackAdvance:8,readValueFromPointer:Cb(b,c),nb:null})},x:function(a,b,c,d,f,g){var h=vb(b,c);a=O(a);f=V(d,f);fb(a,function(){ub("Cannot call "+a+" due to unbound types",h)},b-1);M([],h,function(c){qb(a,xb(a,[c[0],null].concat(c.slice(1)),
null,f,g),b-1);return[]})},B:function(a,b,c,d,f){function g(a){return a}b=O(b);-1===f&&(f=4294967295);var h=Xa(c);if(0===d){var k=32-8*c;g=function(a){return a<<k>>>k}}var m=-1!=b.indexOf("unsigned");N(a,{name:b,fromWireType:g,toWireType:function(a,c){if("number"!==typeof c&&"boolean"!==typeof c)throw new TypeError('Cannot convert "'+jb(c)+'" to '+this.name);if(c<d||c>f)throw new TypeError('Passing a number "'+jb(c)+'" from JS side to C/C++ side to an argument of type "'+b+'", which is outside the valid range ['+
d+", "+f+"]!");return m?c>>>0:c|0},argPackAdvance:8,readValueFromPointer:Db(b,h,0!==d),nb:null})},w:function(a,b,c){function d(a){a>>=2;var b=A;return new f(b.buffer,b[a+1],b[a])}var f=[Int8Array,Uint8Array,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array][b];c=O(c);N(a,{name:c,fromWireType:d,argPackAdvance:8,readValueFromPointer:d},{bc:!0})},z:function(a,b,c,d,f,g,h,k,m,l,n,t){c=O(c);g=V(f,g);k=V(h,k);l=V(m,l);t=V(n,t);M([a],[b],function(a){a=a[0];return[new U(c,a.gb,!1,!1,
!0,a,d,g,k,l,t)]})},Q:function(a,b){b=O(b);var c="std::string"===b;N(a,{name:b,fromWireType:function(a){var b=A[a>>2];if(c){var d=x[a+4+b],h=0;0!=d&&(h=d,x[a+4+b]=0);var k=a+4;for(d=0;d<=b;++d){var m=a+4+d;if(0==x[m]){k=w(k);if(void 0===l)var l=k;else l+=String.fromCharCode(0),l+=k;k=m+1}}0!=h&&(x[a+4+b]=h)}else{l=Array(b);for(d=0;d<b;++d)l[d]=String.fromCharCode(x[a+4+d]);l=l.join("")}W(a);return l},toWireType:function(a,b){b instanceof ArrayBuffer&&(b=new Uint8Array(b));var d="string"===typeof b;
d||b instanceof Uint8Array||b instanceof Uint8ClampedArray||b instanceof Int8Array||R("Cannot pass non-string to std::string");var f=(c&&d?function(){return na(b)}:function(){return b.length})(),k=G(4+f+1);A[k>>2]=f;if(c&&d)ma(b,x,k+4,f+1);else if(d)for(d=0;d<f;++d){var m=b.charCodeAt(d);255<m&&(W(k),R("String has UTF-16 code units that do not fit in 8 bits"));x[k+4+d]=m}else for(d=0;d<f;++d)x[k+4+d]=b[d];null!==a&&a.push(W,k);return k},argPackAdvance:8,readValueFromPointer:Qa,nb:function(a){W(a)}})},
ma:function(a,b,c){c=O(c);if(2===b){var d=function(){return sa};var f=1}else 4===b&&(d=function(){return A},f=2);N(a,{name:c,fromWireType:function(a){for(var b=d(),c=A[a>>2],g=Array(c),l=a+4>>f,n=0;n<c;++n)g[n]=String.fromCharCode(b[l+n]);W(a);return g.join("")},toWireType:function(a,c){var g=d(),h=c.length,l=G(4+h*b);A[l>>2]=h;for(var n=l+4>>f,t=0;t<h;++t)g[n+t]=c.charCodeAt(t);null!==a&&a.push(W,l);return l},argPackAdvance:8,readValueFromPointer:Qa,nb:function(a){W(a)}})},J:function(a,b,c,d,f,g){Oa[a]=
{name:O(b),Gb:V(c,d),qb:V(f,g),Lb:[]}},A:function(a,b,c,d,f,g,h,k,m,l){Oa[a].Lb.push({Tb:O(b),ac:c,Zb:V(d,f),$b:g,jc:h,ic:V(k,m),kc:l})},ka:function(a,b){b=O(b);N(a,{cc:!0,name:b,argPackAdvance:0,fromWireType:function(){},toWireType:function(){}})},l:function(a,b,c){a=Y(a);b=Bb(b,"emval::as");var d=[],f=T(d);u[c>>2]=f;return b.toWireType(d,a)},F:function(a,b,c,d){a=Y(a);c=Eb(b,c);for(var f=Array(b),g=0;g<b;++g){var h=c[g];f[g]=h.readValueFromPointer(d);d+=h.argPackAdvance}a=a.apply(void 0,f);return T(a)},
p:function(a,b,c,d,f){a=Hb[a];b=Y(b);c=Gb(c);var g=[];u[d>>2]=T(g);return a(b,c,g,f)},q:function(a,b,c,d){a=Hb[a];b=Y(b);c=Gb(c);a(b,c,null,d)},c:zb,r:function(a){if(0===a)return T(Function("return this")());a=Gb(a);return T(Function("return this")()[a])},k:function(a,b){b=Eb(a,b);for(var c=b[0],d=c.name+"_$"+b.slice(1).map(function(a){return a.name}).join("_")+"$",f=["retType"],g=[c],h="",k=0;k<a-1;++k)h+=(0!==k?", ":"")+"arg"+k,f.push("argType"+k),g.push(b[1+k]);d="return function "+Sa("methodCaller_"+
d)+"(handle, name, destructors, args) {\n";var m=0;for(k=0;k<a-1;++k)d+="    var arg"+k+" = argType"+k+".readValueFromPointer(args"+(m?"+"+m:"")+");\n",m+=b[k+1].argPackAdvance;d+="    var rv = handle[name]("+h+");\n";for(k=0;k<a-1;++k)b[k+1].deleteObject&&(d+="    argType"+k+".deleteObject(arg"+k+");\n");c.cc||(d+="    return retType.toWireType(destructors, rv);\n");f.push(d+"};\n");a=wb(f).apply(null,g);return Ib(a)},E:function(a){a=Gb(a);return T(e[a])},i:function(a,b){a=Y(a);b=Y(b);return T(a[b])},
d:function(a){4<a&&(X[a].Hb+=1)},ja:function(a,b){a=Y(a);b=Y(b);return a instanceof b},s:function(a,b,c,d){a=Y(a);var f=Jb[b];if(!f){f="";for(var g=0;g<b;++g)f+=(0!==g?", ":"")+"arg"+g;var h="return function emval_allocator_"+b+"(constructor, argTypes, args) {\n";for(g=0;g<b;++g)h+="var argType"+g+" = requireRegisteredType(Module['HEAP32'][(argTypes >> 2) + "+g+'], "parameter '+g+'");\nvar arg'+g+" = argType"+g+".readValueFromPointer(args);\nargs += argType"+g+"['argPackAdvance'];\n";f=(new Function("requireRegisteredType",
"Module","__emval_register",h+("var obj = new constructor("+f+");\nreturn __emval_register(obj);\n}\n")))(Bb,e,T);Jb[b]=f}return f(a,c,d)},j:function(a){return T(Gb(a))},N:function(){return T({})},f:function(a){Pa(X[a].value);zb(a)},ia:function(a,b,c){a=Y(a);b=Y(b);c=Y(c);a[b]=c},m:function(a,b){a=Bb(a,"_emval_take_value");a=a.readValueFromPointer(b);return T(a)},M:function(a){a=Y(a);return T(typeof a)},b:function(){e.abort()},ga:Kb,L:function(a,b){if(0===a)a=Date.now();else if(1===a&&"object"===
typeof performance&&performance&&"function"===typeof performance.now)a=Lb();else return Ma(22),-1;u[b>>2]=a/1E3|0;u[b+4>>2]=a%1E3*1E6|0;return 0},fa:function(a){return Ja[a]()},ea:function(){return v},da:function(a,b,c){x.set(x.subarray(b,b+c),a)},ca:fa,o:Mb,ba:function(){return 16384},aa:function(a){var b=Date.now();u[a>>2]=b/1E3|0;u[a+4>>2]=b%1E3*1E3|0;return 0},D:function(a){var b=Z.lb[a];Z.lb.splice(a,1);$b(b)},C:Z,$:function(){E("trap!")},_:function(a,b){var c=u[a>>2];a=u[a+4>>2];0!==b&&(u[b>>
2]=0,u[b+4>>2]=0);b=(1E6*c+a/1E3)/1E3;if(self.performance&&self.performance.now)for(c=self.performance.now();self.performance.now()-c<b;);else for(c=Date.now();Date.now()-c<b;);return 0},Z:function(){return 0},Y:function(){Ma(38);return-1},X:function(a,b,c,d){return Tb(a,b,c,d)},W:function(){E("OOM")},a:ea},z);e.asm=bc;
var Xb=e.__ZSt18uncaught_exceptionv=function(){return e.asm.za.apply(null,arguments)},tb=e.___getTypeName=function(){return e.asm.Aa.apply(null,arguments)},W=e._free=function(){return e.asm.Ba.apply(null,arguments)};e._main=function(){return e.asm.Ca.apply(null,arguments)};
var G=e._malloc=function(){return e.asm.Da.apply(null,arguments)},Yb=e._memalign=function(){return e.asm.Ea.apply(null,arguments)},Zb=e._memset=function(){return e.asm.Fa.apply(null,arguments)},Ka=e.globalCtors=function(){return e.asm.bb.apply(null,arguments)},pa=e.stackAlloc=function(){return e.asm.cb.apply(null,arguments)},$b=e.stackRestore=function(){return e.asm.db.apply(null,arguments)},Nb=e.stackSave=function(){return e.asm.eb.apply(null,arguments)};
e.dynCall_i=function(){return e.asm.Ga.apply(null,arguments)};e.dynCall_ii=function(){return e.asm.Ha.apply(null,arguments)};e.dynCall_iii=function(){return e.asm.Ia.apply(null,arguments)};e.dynCall_iiii=function(){return e.asm.Ja.apply(null,arguments)};e.dynCall_iiiii=function(){return e.asm.Ka.apply(null,arguments)};e.dynCall_iiiiid=function(){return e.asm.La.apply(null,arguments)};e.dynCall_iiiiii=function(){return e.asm.Ma.apply(null,arguments)};
e.dynCall_iiiiiid=function(){return e.asm.Na.apply(null,arguments)};e.dynCall_iiiiiii=function(){return e.asm.Oa.apply(null,arguments)};e.dynCall_iiiiiiii=function(){return e.asm.Pa.apply(null,arguments)};e.dynCall_iiiiiiiii=function(){return e.asm.Qa.apply(null,arguments)};e.dynCall_iiiiiiiiiiii=function(){return e.asm.Ra.apply(null,arguments)};e.dynCall_iiiiij=function(){return e.asm.Sa.apply(null,arguments)};e.dynCall_v=function(){return e.asm.Ta.apply(null,arguments)};
e.dynCall_vi=function(){return e.asm.Ua.apply(null,arguments)};e.dynCall_vii=function(){return e.asm.Va.apply(null,arguments)};e.dynCall_viii=function(){return e.asm.Wa.apply(null,arguments)};e.dynCall_viiii=function(){return e.asm.Xa.apply(null,arguments)};e.dynCall_viiiii=function(){return e.asm.Ya.apply(null,arguments)};e.dynCall_viiiiii=function(){return e.asm.Za.apply(null,arguments)};e.dynCall_viiiiiii=function(){return e.asm._a.apply(null,arguments)};
e.dynCall_viiiiiiiiiii=function(){return e.asm.$a.apply(null,arguments)};e.dynCall_viijii=function(){return e.asm.ab.apply(null,arguments)};e.asm=bc;function cc(a){this.name="ExitStatus";this.message="Program terminated with exit("+a+")";this.status=a}cc.prototype=Error();cc.prototype.constructor=cc;Da=function dc(){e.calledRun||ec();e.calledRun||(Da=dc)};
e.callMain=function(a){a=a||[];B||(B=!0,wa(ya));var b=a.length+1,c=pa(4*(b+1));u[c>>2]=oa(e.thisProgram);for(var d=1;d<b;d++)u[(c>>2)+d]=oa(a[d-1]);u[(c>>2)+b]=0;try{var f=e._main(b,c,0);if(!e.noExitRuntime||0!==f){if(!e.noExitRuntime&&(ja=!0,e.onExit))e.onExit(f);e.quit(f,new cc(f))}}catch(g){g instanceof cc||("SimulateInfiniteLoop"==g?e.noExitRuntime=!0:((a=g)&&"object"===typeof g&&g.stack&&(a=[g,g.stack]),r("exception thrown: "+a),e.quit(1,g)))}finally{}};
function ec(a){function b(){if(!e.calledRun&&(e.calledRun=!0,!ja)){B||(B=!0,wa(ya));wa(za);if(e.onRuntimeInitialized)e.onRuntimeInitialized();e._main&&fc&&e.callMain(a);if(e.postRun)for("function"==typeof e.postRun&&(e.postRun=[e.postRun]);e.postRun.length;){var b=e.postRun.shift();Aa.unshift(b)}wa(Aa)}}a=a||e.arguments;if(!(0<C)){if(e.preRun)for("function"==typeof e.preRun&&(e.preRun=[e.preRun]);e.preRun.length;)Ba();wa(xa);0<C||e.calledRun||(e.setStatus?(e.setStatus("Running..."),setTimeout(function(){setTimeout(function(){e.setStatus("")},
1);b()},1)):b())}}e.run=ec;function E(a){if(e.onAbort)e.onAbort(a);void 0!==a?(ca(a),r(a),a=JSON.stringify(a)):a="";ja=!0;throw"abort("+a+"). Build with -s ASSERTIONS=1 for more info.";}e.abort=E;if(e.preInit)for("function"==typeof e.preInit&&(e.preInit=[e.preInit]);0<e.preInit.length;)e.preInit.pop()();var fc=!0;e.noInitialRun&&(fc=!1);e.noExitRuntime=!0;ec();
;
    return Module;
};

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, Buffer) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

__webpack_require__(23);

__webpack_require__(147);

__webpack_require__(149);

__webpack_require__(150);

__webpack_require__(153);

__webpack_require__(154);

__webpack_require__(157);

__webpack_require__(72);

__webpack_require__(159);

__webpack_require__(161);

__webpack_require__(168);

__webpack_require__(44);

__webpack_require__(76);

__webpack_require__(104);

__webpack_require__(105);

__webpack_require__(172);

__webpack_require__(77);

__webpack_require__(173);

__webpack_require__(174);

__webpack_require__(175);

__webpack_require__(176);

__webpack_require__(178);

__webpack_require__(78);

__webpack_require__(79);

__webpack_require__(45);

__webpack_require__(58);

__webpack_require__(185);

var defaults = _interopRequireWildcard(__webpack_require__(186));

var _DataAccessor = __webpack_require__(187);

var _DateParser = __webpack_require__(112);

var _emscripten = __webpack_require__(200);

var _utils = __webpack_require__(113);

var _enum = __webpack_require__(2);

var _table3 = __webpack_require__(82);

var _visitor = __webpack_require__(12);

var _data = __webpack_require__(18);

var _vector = __webpack_require__(7);

var _type2 = __webpack_require__(3);

var _view_formatters = _interopRequireDefault(__webpack_require__(218));

var _papaparse = _interopRequireDefault(__webpack_require__(139));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

// IE fix - chrono::steady_clock depends on performance.now() which does not exist in IE workers
if (global.performance === undefined) {
  global.performance = {
    now: Date.now
  };
}

if (typeof self !== "undefined" && self.performance === undefined) {
  self.performance = {
    now: Date.now
  };
}
/**
 * The main API module for Perspective.
 * @module perspective
 */


function _default(Module) {
  var __MODULE__ = Module;
  var accessor = new _DataAccessor.DataAccessor();
  /******************************************************************************
   *
   * Private
   *
   */

  /**
   * Determines a table's limit index.
   * @private
   * @param {int} limit_index
   * @param {int} new_length
   * @param {int} options_limit
   */

  function calc_limit_index(limit_index, new_length, options_limit) {
    limit_index += new_length;

    if (options_limit) {
      limit_index = limit_index % options_limit;
    }

    return limit_index;
  }
  /**
   * Common logic for creating and registering a gnode/t_table.
   *
   * @param {*} pdata
   * @param {*} pool
   * @param {*} gnode
   * @param {*} computed
   * @param {*} index
   * @param {*} limit
   * @param {*} limit_index
   * @param {*} is_delete
   * @private
   * @returns {Table}
   */


  function make_table(accessor, pool, gnode, computed, index, limit, limit_index, is_update, is_delete, is_arrow) {
    if (is_arrow) {
      for (var _iterator = accessor, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var chunk = _ref;
        gnode = __MODULE__.make_table(pool, gnode, chunk, computed, limit_index, limit || 4294967295, index, is_update, is_delete, is_arrow);
        limit_index = calc_limit_index(limit_index, chunk.cdata[0].length, limit);
      }
    } else {
      gnode = __MODULE__.make_table(pool, gnode, accessor, computed, limit_index, limit || 4294967295, index, is_update, is_delete, is_arrow);
      limit_index = calc_limit_index(limit_index, accessor.row_count, limit);
    }

    return [gnode, limit_index];
  }
  /**
   * Converts arrow data into a canonical representation for
   * interfacing with perspective.
   *
   * @private
   * @param {object} data Array buffer
   * @returns An array containing chunked data objects with five properties:
   * row_count: the number of rows in the chunk
   * is_arrow: internal flag for marking arrow data
   * names: column names for the arrow data
   * types: type mapping for each column
   * cdata: the actual data we load
   */


  function load_arrow_buffer(data) {
    // TODO Need to validate that the names/types passed in match those in the buffer
    var arrow = _table3.Table.from([new Uint8Array(data)]);

    var loader = arrow.schema.fields.reduce(function (loader, field, colIdx) {
      return loader.loadColumn(field, arrow.getColumnAt(colIdx));
    }, new ArrowColumnLoader());
    var nchunks = loader.cdata[0].chunks.length;
    var chunks = [];

    var _loop = function _loop(x) {
      chunks.push({
        row_count: loader.cdata[0].chunks[x].length,
        is_arrow: true,
        names: loader.names,
        types: loader.types,
        cdata: loader.cdata.map(function (y) {
          return y.chunks[x];
        })
      });
    };

    for (var x = 0; x < nchunks; x++) {
      _loop(x);
    }

    return chunks;
  }
  /**
   *
   * @private
   */


  var ArrowColumnLoader =
  /*#__PURE__*/
  function (_Visitor) {
    _inherits(ArrowColumnLoader, _Visitor);

    function ArrowColumnLoader(cdata, names, types) {
      var _this;

      _classCallCheck(this, ArrowColumnLoader);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(ArrowColumnLoader).call(this));
      _this.cdata = cdata || [];
      _this.names = names || [];
      _this.types = types || [];
      return _this;
    }

    _createClass(ArrowColumnLoader, [{
      key: "loadColumn",
      value: function loadColumn(field
      /*: Arrow.type.Field*/
      , column
      /*: Arrow.Vector*/
      ) {
        if (this.visit(field.type)) {
          this.cdata.push(column);
          this.names.push(field.name);
        }

        return this;
      } // visitNull(type/*: Arrow.type.Null*/) {}

    }, {
      key: "visitBool",
      value: function visitBool()
      /* type: Arrow.type.Bool */
      {
        this.types.push(__MODULE__.t_dtype.DTYPE_BOOL);
        return true;
      }
    }, {
      key: "visitInt",
      value: function visitInt(type
      /* : Arrow.type.Int */
      ) {
        var bitWidth = type.bitWidth;

        if (bitWidth === 64) {
          this.types.push(__MODULE__.t_dtype.DTYPE_INT64);
        } else if (bitWidth === 32) {
          this.types.push(__MODULE__.t_dtype.DTYPE_INT32);
        } else if (bitWidth === 16) {
          this.types.push(__MODULE__.t_dtype.DTYPE_INT16);
        } else if (bitWidth === 8) {
          this.types.push(__MODULE__.t_dtype.DTYPE_INT8);
        }

        return true;
      }
    }, {
      key: "visitFloat",
      value: function visitFloat(type
      /* : Arrow.type.Float */
      ) {
        var precision = type.precision;

        if (precision === _enum.Precision.DOUBLE) {
          this.types.push(__MODULE__.t_dtype.DTYPE_FLOAT64);
        } else if (precision === _enum.Precision.SINGLE) {
          this.types.push(__MODULE__.t_dtype.DTYPE_FLOAT32);
        } // todo?
        // else if (type.precision === Arrow.enum_.Precision.HALF) {
        //     this.types.push(__MODULE__.t_dtype.DTYPE_FLOAT16);
        // }


        return true;
      }
    }, {
      key: "visitUtf8",
      value: function visitUtf8()
      /* type: Arrow.type.Utf8 */
      {
        this.types.push(__MODULE__.t_dtype.DTYPE_STR);
        return true;
      }
    }, {
      key: "visitBinary",
      value: function visitBinary()
      /* type: Arrow.type.Binary */
      {
        this.types.push(__MODULE__.t_dtype.DTYPE_STR);
        return true;
      } // visitFixedSizeBinary(type/*: Arrow.type.FixedSizeBinary*/) {}
      // visitDate(type/*: Arrow.type.Date_*/) {}

    }, {
      key: "visitTimestamp",
      value: function visitTimestamp()
      /* type: Arrow.type.Timestamp */
      {
        this.types.push(__MODULE__.t_dtype.DTYPE_TIME);
        return true;
      } // visitTime(type/*: Arrow.type.Time*/) {}
      // visitDecimal(type/*: Arrow.type.Decimal*/) {}
      // visitList(type/*: Arrow.type.List*/) {}
      // visitStruct(type/*: Arrow.type.Struct*/) {}
      // visitUnion(type/*: Arrow.type.Union<any>*/) {}

    }, {
      key: "visitDictionary",
      value: function visitDictionary(type
      /*: Arrow.type.Dictionary */
      ) {
        return this.visit(type.dictionary);
      } // visitInterval(type/*: Arrow.type.Interval*/) {}
      // visitFixedSizeList(type/*: Arrow.type.FixedSizeList*/) {}
      // visitMap(type/*: Arrow.type.Map_*/) {}

    }]);

    return ArrowColumnLoader;
  }(_visitor.Visitor);
  /******************************************************************************
   *
   * View
   *
   */

  /**
   * A View object represents a specific transform (configuration or pivot,
   * filter, sort, etc) configuration on an underlying {@link module:perspective~table}. A View
   * receives all updates from the {@link module:perspective~table} from which it is derived, and
   * can be serialized to JSON or trigger a callback when it is updated.  View
   * objects are immutable, and will remain in memory and actively process
   * updates until its {@link module:perspective~view#delete} method is called.
   *
   * <strong>Note</strong> This constructor is not public - Views are created
   * by invoking the {@link module:perspective~table#view} method.
   *
   * @example
   * // Returns a new View, pivoted in the row space by the "name" column.
   * table.view({row_pivots: ["name"]});
   *
   * @class
   * @hideconstructor
   */


  function view(pool, sides, gnode, config, name, callbacks, table) {
    this._View = undefined;
    this.date_parser = new _DateParser.DateParser();
    this.config = config || {};

    if (sides === 0) {
      this._View = __MODULE__.make_view_zero(pool, gnode, name, defaults.COLUMN_SEPARATOR_STRING, this.config, this.date_parser);
    } else if (sides === 1) {
      this._View = __MODULE__.make_view_one(pool, gnode, name, defaults.COLUMN_SEPARATOR_STRING, this.config, this.date_parser);
    } else if (sides === 2) {
      this._View = __MODULE__.make_view_two(pool, gnode, name, defaults.COLUMN_SEPARATOR_STRING, this.config, this.date_parser);
    }

    this.ctx = this._View.get_context();
    this.column_only = this._View.is_column_only();
    this.callbacks = callbacks;
    this.name = name;
    this.table = table;
    (0, _utils.bindall)(this);
  }
  /**
   * A copy of the config object passed to the {@link table#view} method
   * which created this {@link module:perspective~view}.
   *
   * @returns {object} Shared the same key/values properties as {@link module:perspective~view}
   */


  view.prototype.get_config =
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", JSON.parse(JSON.stringify(this.config)));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
  /**
   * Delete this {@link module:perspective~view} and clean up all resources associated with it.
   * View objects do not stop consuming resources or processing updates when
   * they are garbage collected - you must call this method to reclaim these.
   */

  view.prototype["delete"] =
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2() {
    var i, j, val;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            this._View["delete"]();

            this.ctx["delete"]();
            this.table.views.splice(this.table.views.indexOf(this), 1);
            this.table = undefined;
            i = 0, j = 0;

            while (i < this.callbacks.length) {
              val = this.callbacks[i];
              if (val.view !== this) this.callbacks[j++] = val;
              i++;
            }

            this.callbacks.length = j;

            if (this._delete_callback) {
              this._delete_callback();
            }

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));
  /**
   * How many pivoted sides does this view have?
   *
   * @private
   *
   * @returns {number} sides The number of sides of this `View`.
   */

  view.prototype.sides = function () {
    return this._View.sides();
  };

  view.prototype._num_hidden = function () {
    // Count hidden columns.
    var hidden = 0;

    for (var _iterator2 = this.config.sort, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref4;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref4 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref4 = _i2.value;
      }

      var sort = _ref4;

      if (this.config.columns.indexOf(sort[0]) === -1) {
        hidden++;
      }
    }

    return hidden;
  };

  function col_path_vector_to_string(vector) {
    var extracted = [];

    for (var i = 0; i < vector.size(); i++) {
      extracted.push(__MODULE__.scalar_vec_to_string(vector, i));
    }

    vector["delete"]();
    return extracted;
  }

  var extract_vector_scalar = function extract_vector_scalar(vector) {
    // handles deletion already - do not call delete() on the input vector again
    var extracted = [];

    for (var i = 0; i < vector.size(); i++) {
      var item = vector.get(i);
      extracted.push(col_path_vector_to_string(item));
    }

    vector["delete"]();
    return extracted;
  };
  /**
   * The schema of this {@link module:perspective~view}. A schema is an Object, the keys of which
   * are the columns of this {@link module:perspective~view}, and the values are their string type names.
   * If this {@link module:perspective~view} is aggregated, theses will be the aggregated types;
   * otherwise these types will be the same as the columns in the underlying
   * {@link module:perspective~table}
   *
   * @async
   *
   * @returns {Promise<Object>} A Promise of this {@link module:perspective~view}'s schema.
   */


  view.prototype.schema =
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3() {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", (0, _emscripten.extract_map)(this._View.schema()));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  view.prototype._column_names = function () {
    var skip = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return extract_vector_scalar(this._View.column_names(skip, depth)).map(function (x) {
      return x.join(defaults.COLUMN_SEPARATOR_STRING);
    });
  };

  var to_format =
  /*#__PURE__*/
  function () {
    var _ref6 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee4(options, formatter) {
      var max_cols, max_rows, hidden, viewport, start_row, end_row, start_col, end_col, num_sides, nidx, slice, ns, col_names, data, ridx, row, cidx, col_name, row_path, i, value, _value;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              options = options || {};
              max_cols = this._View.num_columns() + (this.sides() === 0 ? 0 : 1);
              max_rows = this._View.num_rows();
              hidden = this._num_hidden();
              viewport = this.config.viewport ? this.config.viewport : {};
              start_row = options.start_row || (viewport.top ? viewport.top : 0);
              end_row = options.end_row || (viewport.height ? start_row + viewport.height : max_rows);
              start_col = options.start_col || (viewport.left ? viewport.left : 0);
              end_col = Math.min(max_cols, (options.end_col || (viewport.width ? start_col + viewport.width : max_cols)) * (hidden + 1));
              num_sides = this.sides();
              nidx = ["zero", "one", "two"][num_sides];
              slice = __MODULE__["get_data_slice_".concat(nidx)](this._View, start_row, end_row, start_col, end_col);
              ns = slice.get_column_names();
              col_names = extract_vector_scalar(ns).map(function (x) {
                return x.join(defaults.COLUMN_SEPARATOR_STRING);
              });
              data = formatter.initDataValue();
              ridx = start_row;

            case 16:
              if (!(ridx < end_row)) {
                _context4.next = 33;
                break;
              }

              row = formatter.initRowValue();
              cidx = start_col;

            case 19:
              if (!(cidx < end_col)) {
                _context4.next = 29;
                break;
              }

              col_name = col_names[cidx];

              if (!((cidx - (num_sides > 0 ? 1 : 0)) % (this.config.columns.length + hidden) >= this.config.columns.length)) {
                _context4.next = 25;
                break;
              }

              return _context4.abrupt("continue", 26);

            case 25:
              if (cidx === start_col && num_sides !== 0) {
                if (!this.column_only) {
                  row_path = slice.get_row_path(ridx);
                  formatter.initColumnValue(data, row, "__ROW_PATH__");

                  for (i = 0; i < row_path.size(); i++) {
                    value = __MODULE__.scalar_vec_to_val(row_path, i);
                    formatter.addColumnValue(data, row, "__ROW_PATH__", value);
                  }

                  row_path["delete"]();
                }
              } else {
                _value = __MODULE__["get_from_data_slice_".concat(nidx)](slice, ridx, cidx);
                formatter.setColumnValue(data, row, col_name, _value);
              }

            case 26:
              cidx++;
              _context4.next = 19;
              break;

            case 29:
              formatter.addRow(data, row);

            case 30:
              ridx++;
              _context4.next = 16;
              break;

            case 33:
              return _context4.abrupt("return", formatter.formatData(data, options.config));

            case 34:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    return function to_format(_x, _x2) {
      return _ref6.apply(this, arguments);
    };
  }();
  /**
   * Serializes this view to JSON data in a column-oriented format.
   *
   * @async
   *
   * @param {Object} [options] An optional configuration object.
   * @param {number} options.start_row The starting row index from which
   * to serialize.
   * @param {number} options.end_row The ending row index from which
   * to serialize.
   * @param {number} options.start_col The starting column index from which
   * to serialize.
   * @param {number} options.end_col The ending column index from which
   * to serialize.
   *
   * @returns {Promise<Array>} A Promise resolving to An array of Objects
   * representing the rows of this {@link module:perspective~view}.  If this {@link module:perspective~view} had a
   * "row_pivots" config parameter supplied when constructed, each row Object
   * will have a "__ROW_PATH__" key, whose value specifies this row's
   * aggregated path.  If this {@link module:perspective~view} had a "column_pivots" config
   * parameter supplied, the keys of this object will be comma-prepended with
   * their comma-separated column paths.
   */


  view.prototype.to_columns =
  /*#__PURE__*/
  function () {
    var _ref7 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee5(options) {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", to_format.call(this, options, _view_formatters["default"].jsonTableFormatter));

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    return function (_x3) {
      return _ref7.apply(this, arguments);
    };
  }();
  /**
   * Serializes this view to JSON data in a row-oriented format.
   *
   * @async
   *
   * @param {Object} [options] An optional configuration object.
   * @param {number} options.start_row The starting row index from which
   * to serialize.
   * @param {number} options.end_row The ending row index from which
   * to serialize.
   * @param {number} options.start_col The starting column index from which
   * to serialize.
   * @param {number} options.end_col The ending column index from which
   * to serialize.
   *
   * @returns {Promise<Array>} A Promise resolving to An array of Objects
   * representing the rows of this {@link module:perspective~view}.  If this {@link module:perspective~view} had a
   * "row_pivots" config parameter supplied when constructed, each row Object
   * will have a "__ROW_PATH__" key, whose value specifies this row's
   * aggregated path.  If this {@link module:perspective~view} had a "column_pivots" config
   * parameter supplied, the keys of this object will be comma-prepended with
   * their comma-separated column paths.
   */


  view.prototype.to_json =
  /*#__PURE__*/
  function () {
    var _ref8 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee6(options) {
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", to_format.call(this, options, _view_formatters["default"].jsonFormatter));

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    return function (_x4) {
      return _ref8.apply(this, arguments);
    };
  }();
  /**
   * Serializes this view to CSV data in a standard format.
   *
   * @async
   *
   * @param {Object} [options] An optional configuration object.
   * @param {number} options.start_row The starting row index from which
   * to serialize.
   * @param {number} options.end_row The ending row index from which
   * to serialize.
   * @param {number} options.start_col The starting column index from which
   * to serialize.
   * @param {number} options.end_col The ending column index from which
   * to serialize.
   * @param {Object} options.config A config object for the Papaparse {@link https://www.papaparse.com/docs#json-to-csv}
   * config object.
   *
   * @returns {Promise<string>} A Promise resolving to a string in CSV format
   * representing the rows of this {@link module:perspective~view}.  If this {@link module:perspective~view} had a
   * "row_pivots" config parameter supplied when constructed, each row
   * will have prepended those values specified by this row's
   * aggregated path.  If this {@link module:perspective~view} had a "column_pivots" config
   * parameter supplied, the keys of this object will be comma-prepended with
   * their comma-separated column paths.
   */


  view.prototype.to_csv =
  /*#__PURE__*/
  function () {
    var _ref9 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee7(options) {
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", to_format.call(this, options, _view_formatters["default"].csvFormatter));

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));

    return function (_x5) {
      return _ref9.apply(this, arguments);
    };
  }();
  /**
   * Serializes a view column into a TypedArray.
   *
   * @async
   *
   * @param {string} column_name The name of the column to serialize.
   *
   * @returns {Promise<TypedArray>} A promise resolving to a TypedArray
   * representing the data of the column as retrieved from the {@link module:perspective~view} - all
   * pivots, aggregates, sorts, and filters have been applied onto the values
   * inside the TypedArray. The TypedArray will be constructed based on data type -
   * integers will resolve to Int8Array, Int16Array, or Int32Array. Floats resolve to
   * Float32Array or Float64Array. If the column cannot be found, or is not of an
   * integer/float type, the Promise returns undefined.
   */


  view.prototype.col_to_js_typed_array =
  /*#__PURE__*/
  function () {
    var _ref10 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee8(col_name) {
      var options,
          names,
          num_rows,
          column_pivot_only,
          idx,
          start_row,
          end_row,
          _args8 = arguments;
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              options = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : {};
              _context8.next = 3;
              return this._column_names();

            case 3:
              names = _context8.sent;
              _context8.next = 6;
              return this.num_rows();

            case 6:
              num_rows = _context8.sent;
              column_pivot_only = this.config.row_pivots[0] === "psp_okey" || this.column_only === true;
              idx = names.indexOf(col_name);
              start_row = options.start_row || 0;
              end_row = (options.end_row || num_rows) + (column_pivot_only ? 1 : 0); // type-checking is handled in c++ to accomodate column-pivoted views

              if (!(idx === -1)) {
                _context8.next = 13;
                break;
              }

              return _context8.abrupt("return", undefined);

            case 13:
              if (!(this.sides() === 0)) {
                _context8.next = 17;
                break;
              }

              return _context8.abrupt("return", __MODULE__.col_to_js_typed_array_zero(this._View, idx, false, start_row, end_row));

            case 17:
              if (!(this.sides() === 1)) {
                _context8.next = 21;
                break;
              }

              return _context8.abrupt("return", __MODULE__.col_to_js_typed_array_one(this._View, idx + 1, false, start_row, end_row));

            case 21:
              return _context8.abrupt("return", __MODULE__.col_to_js_typed_array_two(this._View, idx + 1, column_pivot_only, start_row, end_row));

            case 22:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, this);
    }));

    return function (_x6) {
      return _ref10.apply(this, arguments);
    };
  }();
  /**
   * Serializes a view to arrow.
   *
   * @async
   *
   * @param {Object} [options] An optional configuration object.
   * @param {number} options.start_row The starting row index from which
   * to serialize.
   * @param {number} options.end_row The ending row index from which
   * to serialize.
   * @param {number} options.start_col The starting column index from which
   * to serialize.
   * @param {number} options.end_col The ending column index from which
   * to serialize.
   *
   * @returns {Promise<TypedArray>} A Table in the Apache Arrow format containing
   * data from the view.
   */


  view.prototype.to_arrow =
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee9() {
    var options,
        names,
        schema,
        vectors,
        start_col,
        end_col,
        i,
        name,
        col_path,
        type,
        _ref12,
        _ref13,
        vals,
        nullCount,
        nullArray,
        _ref14,
        _ref15,
        _vals,
        _nullCount,
        _nullArray,
        _ref16,
        _ref17,
        _vals2,
        _nullCount2,
        _nullArray2,
        _ref18,
        _ref19,
        _vals3,
        offsets,
        indices,
        _nullCount3,
        _nullArray3,
        utf8Vector,
        _type,
        _args9 = arguments;

    return regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            options = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : {};
            _context9.next = 3;
            return this._column_names();

          case 3:
            names = _context9.sent;
            _context9.next = 6;
            return this.schema();

          case 6:
            schema = _context9.sent;
            vectors = [];
            start_col = options.start_col || 0;
            end_col = options.end_col || names.length;
            i = start_col;

          case 11:
            if (!(i < end_col)) {
              _context9.next = 67;
              break;
            }

            name = names[i];
            col_path = name.split(defaults.COLUMN_SEPARATOR_STRING);
            type = schema[col_path[col_path.length - 1]];

            if (!(type === "float")) {
              _context9.next = 26;
              break;
            }

            _context9.next = 18;
            return this.col_to_js_typed_array(name, options);

          case 18:
            _ref12 = _context9.sent;
            _ref13 = _slicedToArray(_ref12, 3);
            vals = _ref13[0];
            nullCount = _ref13[1];
            nullArray = _ref13[2];
            vectors.push(_vector.Vector["new"](_data.Data.Float(new _type2.Float64(), 0, vals.length, nullCount, nullArray, vals)));
            _context9.next = 64;
            break;

          case 26:
            if (!(type === "integer")) {
              _context9.next = 37;
              break;
            }

            _context9.next = 29;
            return this.col_to_js_typed_array(name, options);

          case 29:
            _ref14 = _context9.sent;
            _ref15 = _slicedToArray(_ref14, 3);
            _vals = _ref15[0];
            _nullCount = _ref15[1];
            _nullArray = _ref15[2];
            vectors.push(_vector.Vector["new"](_data.Data.Int(new _type2.Int32(), 0, _vals.length, _nullCount, _nullArray, _vals)));
            _context9.next = 64;
            break;

          case 37:
            if (!(type === "date" || type === "datetime")) {
              _context9.next = 48;
              break;
            }

            _context9.next = 40;
            return this.col_to_js_typed_array(name, options);

          case 40:
            _ref16 = _context9.sent;
            _ref17 = _slicedToArray(_ref16, 3);
            _vals2 = _ref17[0];
            _nullCount2 = _ref17[1];
            _nullArray2 = _ref17[2];
            vectors.push(_vector.Vector["new"](_data.Data.Timestamp(new _type2.TimestampSecond(), 0, _vals2.length, _nullCount2, _nullArray2, _vals2)));
            _context9.next = 64;
            break;

          case 48:
            if (!(type === "string")) {
              _context9.next = 63;
              break;
            }

            _context9.next = 51;
            return this.col_to_js_typed_array(name, options);

          case 51:
            _ref18 = _context9.sent;
            _ref19 = _slicedToArray(_ref18, 5);
            _vals3 = _ref19[0];
            offsets = _ref19[1];
            indices = _ref19[2];
            _nullCount3 = _ref19[3];
            _nullArray3 = _ref19[4];
            utf8Vector = _vector.Vector["new"](_data.Data.Utf8(new _type2.Utf8(), 0, offsets.length - 1, 0, null, offsets, _vals3));
            _type = new _type2.Dictionary(utf8Vector.type, new _type2.Uint32(), null, null, utf8Vector);
            vectors.push(_vector.Vector["new"](_data.Data.Dictionary(_type, 0, indices.length, _nullCount3, _nullArray3, indices)));
            _context9.next = 64;
            break;

          case 63:
            throw new Error("Type ".concat(type, " not supported"));

          case 64:
            i++;
            _context9.next = 11;
            break;

          case 67:
            return _context9.abrupt("return", _table3.Table.fromVectors(vectors, names.slice(start_col, end_col)).serialize("binary", false).buffer);

          case 68:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, this);
  }));
  /**
   * The number of aggregated rows in this {@link module:perspective~view}.  This is affected by
   * the "row_pivots" configuration parameter supplied to this {@link module:perspective~view}'s
   * contructor.
   *
   * @async
   *
   * @returns {Promise<number>} The number of aggregated rows.
   */

  view.prototype.num_rows =
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee10() {
    return regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            return _context10.abrupt("return", this._View.num_rows());

          case 1:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, this);
  }));
  /**
   * The number of aggregated columns in this {@link view}.  This is affected by
   * the "column_pivots" configuration parameter supplied to this {@link view}'s
   * contructor.
   *
   * @async
   *
   * @returns {Promise<number>} The number of aggregated columns.
   */

  view.prototype.num_columns =
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee11() {
    var ncols, nhidden;
    return regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            ncols = this._View.num_columns();
            nhidden = this._num_hidden();
            return _context11.abrupt("return", ncols - ncols / (this.config.columns.length + nhidden) * nhidden);

          case 3:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, this);
  }));
  /**
   * Whether this row at index `idx` is in an expanded or collapsed state.
   *
   * @async
   *
   * @returns {Promise<bool>} Whether this row is expanded.
   */

  view.prototype.get_row_expanded =
  /*#__PURE__*/
  function () {
    var _ref22 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee12(idx) {
      return regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              return _context12.abrupt("return", this._View.get_row_expanded(idx));

            case 1:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, this);
    }));

    return function (_x7) {
      return _ref22.apply(this, arguments);
    };
  }();
  /**
   * Expands the row at index `idx`.
   *
   * @async
   *
   * @returns {Promise<void>}
   */


  view.prototype.expand =
  /*#__PURE__*/
  function () {
    var _ref23 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee13(idx) {
      return regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              return _context13.abrupt("return", this._View.expand(idx, this.config.row_pivots.length));

            case 1:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, this);
    }));

    return function (_x8) {
      return _ref23.apply(this, arguments);
    };
  }();
  /**
   * Collapses the row at index `idx`.
   *
   * @async
   *
   * @returns {Promise<void>}
   */


  view.prototype.collapse =
  /*#__PURE__*/
  function () {
    var _ref24 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee14(idx) {
      return regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              return _context14.abrupt("return", this._View.collapse(idx));

            case 1:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, this);
    }));

    return function (_x9) {
      return _ref24.apply(this, arguments);
    };
  }();
  /**
   * Set expansion `depth` of the pivot tree.
   *
   */


  view.prototype.set_depth =
  /*#__PURE__*/
  function () {
    var _ref25 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee15(depth) {
      return regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              return _context15.abrupt("return", this._View.set_depth(depth, this.config.row_pivots.length));

            case 1:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, this);
    }));

    return function (_x10) {
      return _ref25.apply(this, arguments);
    };
  }();
  /**
   * Returns the data of all changed rows in JSON format, or for 1+ sided contexts
   * the entire dataset of the view.
   * @private
   */


  view.prototype._get_step_delta =
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee16() {
    var _this2 = this;

    var delta, data, rows, x, results;
    return regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            delta = this._View.get_step_delta(0, 2147483647);

            if (!(delta.cells.size() === 0)) {
              _context16.next = 7;
              break;
            }

            _context16.next = 4;
            return this.to_json();

          case 4:
            data = _context16.sent;
            _context16.next = 14;
            break;

          case 7:
            rows = {};

            for (x = 0; x < delta.cells.size(); x++) {
              rows[delta.cells.get(x).row] = true;
            }

            rows = Object.keys(rows);
            _context16.next = 12;
            return Promise.all(rows.map(function (row) {
              return _this2.to_json({
                start_row: Number.parseInt(row),
                end_row: Number.parseInt(row) + 1
              });
            }));

          case 12:
            results = _context16.sent;
            data = [].concat.apply([], results);

          case 14:
            delta.cells["delete"]();
            return _context16.abrupt("return", data);

          case 16:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16, this);
  }));
  /**
   * Returns an array of row indices indicating which rows have been changed
   * in an update.
   * @private
   */

  view.prototype._get_row_delta =
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee17() {
    var d;
    return regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            d = this._View.get_row_delta(0, 2147483647);
            return _context17.abrupt("return", (0, _emscripten.extract_vector)(d.rows));

          case 2:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17, this);
  }));
  /**
   * Register a callback with this {@link module:perspective~view}.  Whenever the {@link module:perspective~view}'s
   * underlying table emits an update, this callback will be invoked with the
   * aggregated row deltas.
   *
   * @param {function} callback A callback function invoked on update.  The
   * parameter to this callback is dependent on the `mode` parameter:
   *     - "none" (default): The callback is invoked without an argument.
   *     - "rows": The callback is invoked with the changed rows.
   */

  view.prototype.on_update = function (_callback) {
    var _this3 = this;

    var _ref28 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref28$mode = _ref28.mode,
        mode = _ref28$mode === void 0 ? "none" : _ref28$mode;

    if (["none", "rows", "pkey"].indexOf(mode) === -1) {
      throw new Error("Invalid update mode \"".concat(mode, "\" - valid modes are \"none\", \"rows\" and \"pkey\"."));
    }

    if (mode === "rows" || mode === "pkey") {
      // Enable deltas only if needed by callback
      if (!this._View._get_deltas_enabled()) {
        this._View._set_deltas_enabled(true);
      }
    }

    this.callbacks.push({
      view: this,
      callback: function () {
        var _callback2 = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee18() {
          return regeneratorRuntime.wrap(function _callee18$(_context18) {
            while (1) {
              switch (_context18.prev = _context18.next) {
                case 0:
                  _context18.t0 = mode;
                  _context18.next = _context18.t0 === "rows" ? 3 : _context18.t0 === "pkey" ? 9 : 15;
                  break;

                case 3:
                  _context18.t1 = _callback;
                  _context18.next = 6;
                  return _this3._get_step_delta();

                case 6:
                  _context18.t2 = _context18.sent;
                  (0, _context18.t1)(_context18.t2);
                  return _context18.abrupt("break", 16);

                case 9:
                  _context18.t3 = _callback;
                  _context18.next = 12;
                  return _this3._get_row_delta();

                case 12:
                  _context18.t4 = _context18.sent;
                  (0, _context18.t3)(_context18.t4);
                  return _context18.abrupt("break", 16);

                case 15:
                  _callback();

                case 16:
                case "end":
                  return _context18.stop();
              }
            }
          }, _callee18);
        }));

        function callback() {
          return _callback2.apply(this, arguments);
        }

        return callback;
      }()
    });
  };

  view.prototype.remove_update = function (callback) {
    this.callbacks = this.callbacks.filter(function (x) {
      return x.callback !== callback;
    });
  };
  /**
   * Register a callback with this {@link module:perspective~view}.  Whenever the {@link module:perspective~view}
   * is deleted, this callback will be invoked.
   *
   * @param {function} callback A callback function invoked on update.  The
   *     parameter to this callback shares a structure with the return type of
   *     {@link module:perspective~view#to_json}.
   */


  view.prototype.on_delete = function (callback) {
    this._delete_callback = callback;
  };

  view.prototype.remove_delete = function () {
    this._delete_callback = undefined;
  };
  /******************************************************************************
   *
   * Table
   *
   */

  /**
   * A Table object is the basic data container in Perspective.  Tables are
   * typed - they have an immutable set of column names, and a known type for
   * each.
   *
   * <strong>Note</strong> This constructor is not public - Tables are created
   * by invoking the {@link module:perspective~table} factory method, either on the perspective
   * module object, or an a {@link module:perspective~worker} instance.
   *
   * @class
   * @hideconstructor
   */


  function _table2(gnode, pool, index, computed, limit, limit_index) {
    this.gnode = gnode;
    this.pool = pool;
    this.name = Math.random() + "";
    this.initialized = false;
    this.index = index;
    this.pool.set_update_delegate(this);
    this.computed = computed || [];
    this.callbacks = [];
    this.views = [];
    this.limit = limit;
    this.limit_index = limit_index;
    (0, _utils.bindall)(this);
  }

  _table2.prototype._update_callback = function () {
    for (var e in this.callbacks) {
      this.callbacks[e].callback();
    }
  };
  /**
   * Remove all rows in this {@link module:perspective~table} while preserving the schema and
   * construction options.
   */


  _table2.prototype.clear = function () {
    this.gnode.reset();
  };
  /**
   * Replace all rows in this {@link module:perspective~table} the input data.
   */


  _table2.prototype.replace = function (data) {
    this.gnode.reset();
    this.update(data);
  };
  /**
   * Delete this {@link module:perspective~table} and clean up all resources associated with it.
   * Table objects do not stop consuming resources or processing updates when
   * they are garbage collected - you must call this method to reclaim these.
   */


  _table2.prototype["delete"] = function () {
    if (this.views.length > 0) {
      throw "Table still has contexts - refusing to delete.";
    }

    this.pool.unregister_gnode(this.gnode.get_id());
    this.gnode["delete"]();
    this.pool["delete"]();

    if (this._delete_callback) {
      this._delete_callback();
    }
  };
  /**
   * Register a callback with this {@link module:perspective~table}.  Whenever the {@link module:perspective~view}
   * is deleted, this callback will be invoked.
   *
   * @param {function} callback A callback function invoked on update.  The
   *     parameter to this callback shares a structure with the return type of
   *     {@link module:perspective~table#to_json}.
   */


  _table2.prototype.on_delete = function (callback) {
    this._delete_callback = callback;
  };
  /**
   * The number of accumulated rows in this {@link module:perspective~table}.  This is affected by
   * the "index" configuration parameter supplied to this {@link module:perspective~view}'s
   * contructor - as rows will be overwritten when they share an idnex column.
   *
   * @async
   *
   * @returns {Promise<number>} The number of accumulated rows.
   */


  _table2.prototype.size =
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee19() {
    return regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            return _context19.abrupt("return", this.gnode.get_table().size());

          case 1:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19, this);
  }));

  _table2.prototype._schema = function (computed) {
    var schema = this.gnode.get_tblschema();
    var columns = schema.columns();
    var types = schema.types();
    var new_schema = {};
    var computed_schema = this.computed_schema();

    for (var key = 0; key < columns.size(); key++) {
      var name = columns.get(key);

      if (name === "psp_okey" && (typeof computed_schema[name] === "undefined" || computed)) {
        continue;
      }

      new_schema[name] = (0, _utils.get_column_type)(types.get(key).value);
    }

    schema["delete"]();
    columns["delete"]();
    types["delete"]();
    return new_schema;
  };
  /**
   * The schema of this {@link module:perspective~table}.  A schema is an Object whose keys are the
   * columns of this {@link module:perspective~table}, and whose values are their string type names.
   *
   * @async
   * @param {boolean} computed Should computed columns be included?
   * (default false)
   * @returns {Promise<Object>} A Promise of this {@link module:perspective~table}'s schema.
   */


  _table2.prototype.schema =
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee20() {
    var computed,
        _args20 = arguments;
    return regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            computed = _args20.length > 0 && _args20[0] !== undefined ? _args20[0] : false;
            return _context20.abrupt("return", this._schema(computed));

          case 2:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20, this);
  }));

  _table2.prototype._computed_schema = function () {
    if (this.computed.length < 0) return {};
    var computed_schema = {};

    for (var i = 0; i < this.computed.length; i++) {
      var column_name = this.computed[i].column;
      var column_type = this.computed[i].type;
      var column = {};
      column.type = column_type;
      column.input_columns = this.computed[i].inputs;
      column.input_type = this.computed[i].input_type;
      column.computation = this.computed[i].computation;
      computed_schema[column_name] = column;
    }

    return computed_schema;
  };
  /**
   * The computed schema of this {@link module:perspective~table}. Returns a schema of only computed
   * columns added by the user, the keys of which are computed columns and the values an
   * Object containing the associated column_name, column_type, and computation.
   *
   * @async
   *
   * @returns {Promise<Object>} A Promise of this {@link module:perspective~table}'s computed schema.
   */


  _table2.prototype.computed_schema =
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee21() {
    return regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            return _context21.abrupt("return", this._computed_schema());

          case 1:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21, this);
  }));

  _table2.prototype._is_date_filter = function (schema) {
    return function (key) {
      return schema[key] === "datetime" || schema[key] === "date";
    };
  };

  _table2.prototype._is_valid_filter = function (filter) {
    var schema = this._schema();

    var isDateFilter = this._is_date_filter(schema);

    var value = isDateFilter(filter[0]) ? new _DateParser.DateParser().parse(filter[2]) : filter[2];
    return typeof value !== "undefined" && value !== null;
  };
  /**
   * Determines whether a given filter is valid.
   *
   * @param {Array<string>} [filter] A filter configuration array to test
   *
   * @returns {boolean} Whether the filter is valid
   */


  _table2.prototype.is_valid_filter = function (filter) {
    return this._is_valid_filter(filter);
  };
  /**
   * Create a new {@link module:perspective~view} from this table with a specified
   * configuration.
   *
   * @param {Object} [config] The configuration object for this {@link module:perspective~view}.
   * @param {Array<string>} [config.row_pivots] An array of column names
   * to use as {@link https://en.wikipedia.org/wiki/Pivot_table#Row_labels Row Pivots}.
   * @param {Array<string>} [config.column_pivots] An array of column names
   * to use as {@link https://en.wikipedia.org/wiki/Pivot_table#Column_labels Column Pivots}.
   * @param {Array<Object>} [config.columns] An array of column names for the
   * output columns.  If none are provided, all columns are output.
   * @param {Object} [config.aggregates] An object, the keys of which are column
   * names, and their respective values ar ethe aggregates calculations to use
   * when this view has `row_pivots`.  A column provided to `config.columns`
   * without an aggregate in this object, will use the default aggregate
   * calculation for its type.
   * @param {Array<Array<string>>} [config.filter] An Array of Filter configurations to
   * apply.  A filter configuration is an array of 3 elements:  A column name,
   * a supported filter comparison string (e.g. '===', '>'), and a value to compare.
   * @param {Array<string>} [config.sort] An Array of Sort configurations to apply.
   * A sort configuration is an array of 2 elements: A column name, and a sort direction,
   * which are: "none", "asc", "desc", "col asc", "col desc", "asc abs", "desc abs", "col asc abs", "col desc abs".
   *
   * @example
   * var view = table.view({
   *      row_pivots: ['region'],
   *      columns: ["region"],
   *      aggregates: {"region": "dominant"},
   *      filter: [['client', 'contains', 'fred']],
   *      sort: [['value', 'asc']]
   * });
   *
   * @returns {view} A new {@link module:perspective~view} object for the supplied configuration,
   * bound to this table
   */


  _table2.prototype.view = function () {
    var _config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var config = {};

    for (var _i3 = 0, _Object$keys = Object.keys(_config); _i3 < _Object$keys.length; _i3++) {
      var key = _Object$keys[_i3];

      if (defaults.CONFIG_ALIASES[key]) {
        if (!config[defaults.CONFIG_ALIASES[key]]) {
          console.warn("Deprecated: \"".concat(key, "\" config parameter, please use \"").concat(defaults.CONFIG_ALIASES[key], "\" instead"));
          config[defaults.CONFIG_ALIASES[key]] = _config[key];
        } else {
          throw new Error("Duplicate configuration parameter \"".concat(key, "\""));
        }
      } else if (key === "aggregate") {
        console.warn("Deprecated: \"aggregate\" config parameter has been replaced by \"aggregates\" and \"columns\"");
        config[key] = _config[key];
      } else if (defaults.CONFIG_VALID_KEYS.indexOf(key) > -1) {
        config[key] = _config[key];
      } else {
        throw new Error("Unrecognized config parameter \"".concat(key, "\""));
      }
    }

    config.row_pivots = config.row_pivots || [];
    config.column_pivots = config.column_pivots || [];
    config.filter = config.filter || [];
    config.sort = config.sort || [];
    var aggregates = config.aggregates || {};

    var schema = this._schema(true);

    if (config.columns === undefined && config.aggregate === undefined) {
      config.columns = this._columns(true);
    }

    if (config.columns) {
      if (config.aggregate) {
        throw new Error("Duplicate configuration parameter \"aggregate\" and \"columns\"");
      }

      config.aggregate = [];

      for (var _iterator3 = config.columns, _isArray3 = Array.isArray(_iterator3), _i4 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
        var _ref32;

        if (_isArray3) {
          if (_i4 >= _iterator3.length) break;
          _ref32 = _iterator3[_i4++];
        } else {
          _i4 = _iterator3.next();
          if (_i4.done) break;
          _ref32 = _i4.value;
        }

        var col = _ref32;
        config.aggregate.push({
          column: col,
          op: aggregates[col] || defaults.AGGREGATE_DEFAULTS[schema[col]]
        });
      }
    } else {
      config.columns = config.aggregate.map(function (x) {
        return Array.isArray(x.column) ? x.column[0] : x.column;
      });
    }

    if (config.sort) {
      for (var _iterator4 = config.sort, _isArray4 = Array.isArray(_iterator4), _i5 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
        var _ref33;

        if (_isArray4) {
          if (_i5 >= _iterator4.length) break;
          _ref33 = _iterator4[_i5++];
        } else {
          _i5 = _iterator4.next();
          if (_i5.done) break;
          _ref33 = _i5.value;
        }

        var sort = _ref33;
        var _name = sort[0];

        if (config.columns.indexOf(_name) === -1) {
          if (config.column_pivots.indexOf(_name) > -1 || config.row_pivots.indexOf(_name) > -1) {
            config.aggregate.push({
              column: _name,
              op: "unique"
            });
          } else {
            config.aggregate.push({
              column: _name,
              op: aggregates[_name] || defaults.AGGREGATE_DEFAULTS[schema[_name]]
            });
          }
        }
      }
    }

    var name = Math.random() + "";
    var sides;

    if (config.row_pivots.length > 0 || config.column_pivots.length > 0) {
      if (config.column_pivots && config.column_pivots.length > 0) {
        sides = 2;
      } else {
        sides = 1;
      }
    } else {
      sides = 0;
    }

    var v = new view(this.pool, sides, this.gnode, config, name, this.callbacks, this);
    this.views.push(v);
    return v;
  };
  /**
   * Updates the rows of a {@link module:perspective~table}. Updated rows are pushed down to any
   * derived {@link module:perspective~view} objects.
   *
   * @param {Object<string, Array>|Array<Object>|string} data The input data
   * for this table.  The supported input types mirror the constructor options, minus
   * the ability to pass a schema (Object<string, string>) as this table has
   * already been constructed, thus its types are set in stone.
   *
   * @see {@link module:perspective~table}
   */


  _table2.prototype.update = function (data) {
    var pdata;

    var cols = this._columns();

    var schema = this.gnode.get_tblschema();
    var types = schema.types();
    var is_arrow = false;
    pdata = accessor;

    if (data instanceof ArrayBuffer) {
      if (this.size() === 0) {
        throw new Error("Overriding Arrow Schema is not supported.");
      }

      pdata = load_arrow_buffer(data, cols, types);
      is_arrow = true;
    } else if (typeof data === "string") {
      if (data[0] === ",") {
        data = "_" + data;
      }

      accessor.init(__MODULE__, _papaparse["default"].parse(data.trim(), {
        header: true
      }).data);
      accessor.names = cols;
      accessor.types = accessor.extract_typevec(types).slice(0, cols.length);
    } else {
      accessor.init(__MODULE__, data);
      accessor.names = cols;
      accessor.types = accessor.extract_typevec(types).slice(0, cols.length);
    }

    if (accessor.row_count === 0) {
      console.warn("table.update called with no data - ignoring");
      return;
    }

    try {
      var _make_table = make_table(pdata, this.pool, this.gnode, this.computed, this.index || "", this.limit, this.limit_index, true, false, is_arrow);

      var _make_table2 = _slicedToArray(_make_table, 2);

      this.limit_index = _make_table2[1];
      this.initialized = true;
    } catch (e) {
      console.error("Update failed: ".concat(e));
    } finally {
      schema["delete"]();
      types["delete"]();
    }
  };
  /**
   * Removes the rows of a {@link module:perspective~table}. Removed rows are pushed down to any
   * derived {@link module:perspective~view} objects.
   *
   * @param {Array<Object>} data An array of primary keys to remove.
   *
   * @see {@link module:perspective~table}
   */


  _table2.prototype.remove = function (data) {
    var _this4 = this;

    var pdata;

    var cols = this._columns();

    var schema = this.gnode.get_tblschema();
    var types = schema.types();
    var is_arrow = false;
    data = data.map(function (idx) {
      return _defineProperty({}, _this4.index, idx);
    });

    if (data instanceof ArrayBuffer) {
      pdata = load_arrow_buffer(data, [this.index], types);
      is_arrow = true;
    } else {
      accessor.init(__MODULE__, data);
      accessor.names = [this.index];
      accessor.types = [accessor.extract_typevec(types)[cols.indexOf(this.index)]];
      pdata = accessor;
    }

    try {
      var _make_table3 = make_table(pdata, this.pool, this.gnode, undefined, this.index || "", this.limit, this.limit_index, false, true, is_arrow);

      var _make_table4 = _slicedToArray(_make_table3, 2);

      this.limit_index = _make_table4[1];
      this.initialized = true;
    } catch (e) {
      console.error("Remove failed", e);
    } finally {
      schema["delete"]();
      types["delete"]();
    }
  };
  /**
   * Create a new table with the addition of new computed columns (defined as javascript functions)
   *
   * @param {Computation} computed A computation specification object
   */


  _table2.prototype.add_computed = function (computed) {
    var pool, gnode;

    try {
      pool = new __MODULE__.t_pool();
      gnode = __MODULE__.clone_gnode_table(pool, this.gnode, computed);

      if (this.computed.length > 0) {
        computed = this.computed.concat(computed);
      }

      return new _table2(gnode, pool, this.index, computed, this.limit, this.limit_index);
    } catch (e) {
      if (pool) {
        pool["delete"]();
      }

      if (gnode) {
        gnode["delete"]();
      }

      throw e;
    }
  };

  _table2.prototype._columns = function () {
    var computed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var schema = this.gnode.get_tblschema();

    var computed_schema = this._computed_schema();

    var cols = schema.columns();
    var names = [];

    for (var cidx = 0; cidx < cols.size(); cidx++) {
      var name = cols.get(cidx);

      if (name !== "psp_okey" && (typeof computed_schema[name] === "undefined" || computed)) {
        names.push(name);
      }
    }

    schema["delete"]();
    cols["delete"]();
    return names;
  };
  /**
   * The column names of this table.
   *
   * @async
   * @param {boolean} computed Should computed columns be included?
   * (default false)
   * @returns {Array<string>} An array of column names for this table.
   */


  _table2.prototype.columns =
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee22() {
    var computed,
        _args22 = arguments;
    return regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            computed = _args22.length > 0 && _args22[0] !== undefined ? _args22[0] : false;
            return _context22.abrupt("return", this._columns(computed));

          case 2:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22, this);
  }));

  _table2.prototype._column_metadata = function () {
    var schema = this.gnode.get_tblschema();

    var computed_schema = this._computed_schema();

    var cols = schema.columns();
    var types = schema.types();
    var metadata = [];

    for (var cidx = 0; cidx < cols.size(); cidx++) {
      var name = cols.get(cidx);
      var meta = {};

      if (name === "psp_okey") {
        continue;
      }

      meta.name = name;
      meta.type = (0, _utils.get_column_type)(types.get(cidx).value);
      var computed_col = computed_schema[name];

      if (computed_col !== undefined) {
        meta.computed = {
          input_columns: computed_col.input_columns,
          input_type: computed_col.input_type,
          computation: computed_col.computation
        };
      } else {
        meta.computed = undefined;
      }

      metadata.push(meta);
    }

    types["delete"]();
    cols["delete"]();
    schema["delete"]();
    return metadata;
  };
  /**
   * Column metadata for this table.
   *
   * If the column is computed, the `computed` property is an Object containing:
   *  - Array `input_columns`
   *  - String `input_type`
   *  - Object `computation`.
   *
   *  Otherwise, `computed` is `undefined`.
   *
   * @async
   *
   * @returns {Array<object>} An array of Objects containing metadata for each column.
   */


  _table2.prototype.column_metadata = function () {
    return this._column_metadata();
  };

  _table2.prototype.execute = function (f) {
    f(this);
  };
  /******************************************************************************
   *
   * Worker API
   *
   */


  function error_to_json(error) {
    var obj = {};

    if (typeof error !== "string") {
      Object.getOwnPropertyNames(error).forEach(function (key) {
        obj[key] = error[key];
      }, error);
    } else {
      obj["message"] = error;
    }

    return obj;
  }

  var Host =
  /*#__PURE__*/
  function () {
    function Host() {
      _classCallCheck(this, Host);

      this._tables = {};
      this._views = {};
    }

    _createClass(Host, [{
      key: "init",
      value: function init(msg) {
        this.post(msg);
      }
    }, {
      key: "post",
      value: function post() {
        throw new Error("post() not implemented!");
      }
    }, {
      key: "clear_views",
      value: function clear_views(client_id) {
        for (var _i6 = 0, _Object$keys2 = Object.keys(this._views); _i6 < _Object$keys2.length; _i6++) {
          var key = _Object$keys2[_i6];

          if (this._views[key].client_id === client_id) {
            try {
              this._views[key]["delete"]();
            } catch (e) {
              console.error(e);
            }

            delete this._views[key];
          }
        }

        console.debug("GC ".concat(Object.keys(this._views).length, " views in memory"));
      }
    }, {
      key: "process",
      value: function process(msg, client_id) {
        var _this5 = this;

        switch (msg.cmd) {
          case "init":
            this.init(msg);
            break;

          case "table":
            this._tables[msg.name] = perspective.table(msg.args[0], msg.options);
            break;

          case "add_computed":
            var _table = this._tables[msg.original];
            var computed = msg.computed; // rehydrate computed column functions

            for (var i = 0; i < computed.length; ++i) {
              var column = computed[i];
              eval("column.func = " + column.func);
            }

            this._tables[msg.name] = _table.add_computed(computed);
            break;

          case "table_generate":
            var g;
            eval("g = " + msg.args);
            g(function (tbl) {
              this._tables[msg.name] = tbl;
              this.post({
                id: msg.id,
                data: "created!"
              });
            });
            break;

          case "table_execute":
            var f;
            eval("f = " + msg.f);
            f(this._tables[msg.name]);
            break;

          case "view":
            this._views[msg.view_name] = this._tables[msg.table_name].view(msg.config);
            this._views[msg.view_name].client_id = client_id;
            break;

          case "table_method":
            {
              var obj = this._tables[msg.name];
              var result;

              try {
                if (msg.subscribe) {
                  obj[msg.method](function (e) {
                    _this5.post({
                      id: msg.id,
                      data: e
                    });
                  });
                } else {
                  result = obj[msg.method].apply(obj, msg.args);

                  if (result && result.then) {
                    result.then(function (data) {
                      if (data) {
                        _this5.post({
                          id: msg.id,
                          data: data
                        });
                      }
                    })["catch"](function (error) {
                      _this5.post({
                        id: msg.id,
                        error: error_to_json(error)
                      });
                    });
                  } else {
                    this.post({
                      id: msg.id,
                      data: result
                    });
                  }
                }
              } catch (e) {
                this.post({
                  id: msg.id,
                  error: error_to_json(e)
                });
                return;
              }

              break;
            }

          case "view_method":
            {
              var _obj = this._views[msg.name];

              if (!_obj) {
                this.post({
                  id: msg.id,
                  error: {
                    message: "View is not initialized"
                  }
                });
                return;
              }

              if (msg.subscribe) {
                try {
                  _obj[msg.method](function (e) {
                    _this5.post({
                      id: msg.id,
                      data: e
                    });
                  });
                } catch (error) {
                  this.post({
                    id: msg.id,
                    error: error_to_json(error)
                  });
                }
              } else {
                _obj[msg.method].apply(_obj, msg.args).then(function (result) {
                  if (msg.method === "delete") {
                    delete _this5._views[msg.name];
                  }

                  if (msg.method === "to_arrow") {
                    _this5.post({
                      id: msg.id,
                      data: result
                    }, [result]);
                  } else {
                    _this5.post({
                      id: msg.id,
                      data: result
                    });
                  }
                })["catch"](function (error) {
                  _this5.post({
                    id: msg.id,
                    error: error_to_json(error)
                  });
                });
              }

              break;
            }
        }
      }
    }]);

    return Host;
  }();

  var WorkerHost =
  /*#__PURE__*/
  function (_Host) {
    _inherits(WorkerHost, _Host);

    function WorkerHost() {
      var _this6;

      _classCallCheck(this, WorkerHost);

      _this6 = _possibleConstructorReturn(this, _getPrototypeOf(WorkerHost).call(this));
      self.addEventListener("message", function (e) {
        return _this6.process(e.data);
      }, false);
      return _this6;
    }

    _createClass(WorkerHost, [{
      key: "post",
      value: function post(msg, transfer) {
        self.postMessage(msg, transfer);
      }
    }, {
      key: "init",
      value: function init(_ref36) {
        var buffer = _ref36.buffer;

        if (typeof WebAssembly === "undefined") {
          console.log("Loading asm.js");
        } else {
          console.log("Loading wasm");
          __MODULE__ = __MODULE__({
            wasmBinary: buffer,
            wasmJSMethod: "native-wasm"
          });
        }
      }
    }]);

    return WorkerHost;
  }(Host);

  if (typeof self !== "undefined" && self.addEventListener) {
    new WorkerHost();
  }
  /******************************************************************************
   *
   * Perspective
   *
   */


  var perspective = {
    __module__: __MODULE__,
    Host: Host,
    worker: function worker() {},

    /**
     * A factory method for constructing {@link module:perspective~table}s.
     *
     * @example
     * // Creating a table directly from node
     * var table = perspective.table([{x: 1}, {x: 2}]);
     *
     * @example
     * // Creating a table from a Web Worker (instantiated via the worker() method).
     * var table = worker.table([{x: 1}, {x: 2}]);
     *
     * @param {Object<string, Array>|Object<string, string>|Array<Object>|string} data The input data
     *     for this table.  When supplied an Object with string values, an empty
     *     table is returned using this Object as a schema.  When an Object with
     *     Array values is supplied, a table is returned using this object's
     *     key/value pairs as name/columns respectively.  When an Array is supplied,
     *     a table is constructed using this Array's objects as rows.  When
     *     a string is supplied, the parameter as parsed as a CSV.
     * @param {Object} [options] An optional options dictionary.
     * @param {string} options.index The name of the column in the resulting
     *     table to treat as an index.  When updating this table, rows sharing an
     *     index of a new row will be overwritten. `index` is mutually exclusive
     *     to `limit`
     * @param {integer} options.limit The maximum number of rows that can be
     *     added to this table.  When exceeded, old rows will be overwritten in
     *     the order they were inserted.  `limit` is mutually exclusive to
     *     `index`.
     *
     * @returns {table} A new {@link module:perspective~table} object.
     */
    table: function table(data, options) {
      options = options || {};
      options.index = options.index || "";
      var data_accessor;
      var is_arrow = false;

      if (data instanceof ArrayBuffer || Buffer && data instanceof Buffer) {
        data_accessor = load_arrow_buffer(data);
        is_arrow = true;
      } else {
        if (typeof data === "string") {
          if (data[0] === ",") {
            data = "_" + data;
          }

          data = _papaparse["default"].parse(data.trim(), {
            dynamicTyping: true,
            header: true
          }).data;
        }

        accessor.clean();
        accessor.init(__MODULE__, data);
        data_accessor = accessor;
      }

      if (options.index && options.limit) {
        throw "Cannot specify both index '".concat(options.index, "' and limit '").concat(options.limit, "'.");
      }

      var gnode,
          pool,
          limit_index = 0;

      try {
        pool = new __MODULE__.t_pool();

        var _make_table5 = make_table(data_accessor, pool, undefined, undefined, options.index, options.limit, limit_index, false, false, is_arrow);

        var _make_table6 = _slicedToArray(_make_table5, 2);

        gnode = _make_table6[0];
        limit_index = _make_table6[1];
        return new _table2(gnode, pool, options.index, undefined, options.limit, limit_index);
      } catch (e) {
        if (pool) {
          pool["delete"]();
        }

        if (gnode) {
          gnode["delete"]();
        }

        console.error("Table initialization failed: ".concat(e));
        throw e;
      }
    }
  };

  for (var _i7 = 0, _Object$keys3 = Object.keys(defaults); _i7 < _Object$keys3.length; _i7++) {
    var prop = _Object$keys3[_i7];
    perspective[prop] = defaults[prop];
  }

  return perspective;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62), __webpack_require__(87).Buffer))

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  for (var i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 144 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 145 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(51)('native-function-to-string', Function.toString);


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(40) });


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(13);
var anObject = __webpack_require__(9);
var getKeys = __webpack_require__(31);

module.exports = __webpack_require__(14) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(1);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(91).set });


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $forEach = __webpack_require__(57)(0);
var STRICT = __webpack_require__(34)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(152);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(10);
var isArray = __webpack_require__(66);
var SPECIES = __webpack_require__(4)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(67)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(9);
var toObject = __webpack_require__(17);
var toLength = __webpack_require__(15);
var toInteger = __webpack_require__(30);
var advanceStringIndex = __webpack_require__(68);
var regExpExec = __webpack_require__(69);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(70)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(71);
__webpack_require__(1)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(9);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $filter = __webpack_require__(57)(2);

$export($export.P + $export.F * !__webpack_require__(34)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(10);
var setPrototypeOf = __webpack_require__(91).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseInt = __webpack_require__(160);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(6).parseInt;
var $trim = __webpack_require__(67).trim;
var ws = __webpack_require__(92);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(26);
var global = __webpack_require__(6);
var ctx = __webpack_require__(27);
var classof = __webpack_require__(41);
var $export = __webpack_require__(1);
var isObject = __webpack_require__(10);
var aFunction = __webpack_require__(28);
var anInstance = __webpack_require__(73);
var forOf = __webpack_require__(162);
var speciesConstructor = __webpack_require__(74);
var task = __webpack_require__(96).set;
var microtask = __webpack_require__(164)();
var newPromiseCapabilityModule = __webpack_require__(98);
var perform = __webpack_require__(165);
var userAgent = __webpack_require__(166);
var promiseResolve = __webpack_require__(167);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(4)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(75)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(43)($Promise, PROMISE);
__webpack_require__(99)(PROMISE);
Wrapper = __webpack_require__(24)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(100)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(27);
var call = __webpack_require__(163);
var isArrayIter = __webpack_require__(94);
var anObject = __webpack_require__(9);
var toLength = __webpack_require__(15);
var getIterFn = __webpack_require__(95);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(9);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(6);
var macrotask = __webpack_require__(96).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(29)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(6);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(9);
var isObject = __webpack_require__(10);
var newPromiseCapability = __webpack_require__(98);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(93)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(101)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(40);
var descriptor = __webpack_require__(39);
var setToStringTag = __webpack_require__(43);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(16)(IteratorPrototype, __webpack_require__(4)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 170 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(1);
var core = __webpack_require__(24);
var fails = __webpack_require__(8);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var aFunction = __webpack_require__(28);
var toObject = __webpack_require__(17);
var fails = __webpack_require__(8);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(34)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : {}
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(13).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(14) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $map = __webpack_require__(57)(1);

$export($export.P + $export.F * !__webpack_require__(34)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $reduce = __webpack_require__(177);

$export($export.P + $export.F * !__webpack_require__(34)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(28);
var toObject = __webpack_require__(17);
var IObject = __webpack_require__(52);
var toLength = __webpack_require__(15);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(179)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(14)) {
  var LIBRARY = __webpack_require__(26);
  var global = __webpack_require__(6);
  var fails = __webpack_require__(8);
  var $export = __webpack_require__(1);
  var $typed = __webpack_require__(107);
  var $buffer = __webpack_require__(180);
  var ctx = __webpack_require__(27);
  var anInstance = __webpack_require__(73);
  var propertyDesc = __webpack_require__(39);
  var hide = __webpack_require__(16);
  var redefineAll = __webpack_require__(75);
  var toInteger = __webpack_require__(30);
  var toLength = __webpack_require__(15);
  var toIndex = __webpack_require__(108);
  var toAbsoluteIndex = __webpack_require__(54);
  var toPrimitive = __webpack_require__(38);
  var has = __webpack_require__(19);
  var classof = __webpack_require__(41);
  var isObject = __webpack_require__(10);
  var toObject = __webpack_require__(17);
  var isArrayIter = __webpack_require__(94);
  var create = __webpack_require__(40);
  var getPrototypeOf = __webpack_require__(102);
  var gOPN = __webpack_require__(42).f;
  var getIterFn = __webpack_require__(95);
  var uid = __webpack_require__(25);
  var wks = __webpack_require__(4);
  var createArrayMethod = __webpack_require__(57);
  var createArrayIncludes = __webpack_require__(53);
  var speciesConstructor = __webpack_require__(74);
  var ArrayIterators = __webpack_require__(44);
  var Iterators = __webpack_require__(35);
  var $iterDetect = __webpack_require__(100);
  var setSpecies = __webpack_require__(99);
  var arrayFill = __webpack_require__(109);
  var arrayCopyWithin = __webpack_require__(181);
  var $DP = __webpack_require__(13);
  var $GOPD = __webpack_require__(55);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(6);
var DESCRIPTORS = __webpack_require__(14);
var LIBRARY = __webpack_require__(26);
var $typed = __webpack_require__(107);
var hide = __webpack_require__(16);
var redefineAll = __webpack_require__(75);
var fails = __webpack_require__(8);
var anInstance = __webpack_require__(73);
var toInteger = __webpack_require__(30);
var toLength = __webpack_require__(15);
var toIndex = __webpack_require__(108);
var gOPN = __webpack_require__(42).f;
var dP = __webpack_require__(13).f;
var arrayFill = __webpack_require__(109);
var setToStringTag = __webpack_require__(43);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(17);
var toAbsoluteIndex = __webpack_require__(54);
var toLength = __webpack_require__(15);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(25)('meta');
var isObject = __webpack_require__(10);
var has = __webpack_require__(19);
var setDesc = __webpack_require__(13).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(8)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(31);
var gOPS = __webpack_require__(80);
var pIE = __webpack_require__(56);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(32);
var gOPN = __webpack_require__(42).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(1);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(23);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TYPED_ARRAY_SENTINEL_VALUE_FLOAT64 = exports.TYPED_ARRAY_SENTINEL_VALUE_FLOAT32 = exports.TYPED_ARRAY_SENTINEL_VALUE_INT32 = exports.TYPED_ARRAY_SENTINEL_VALUE_INT16 = exports.TYPED_ARRAY_SENTINEL_VALUE_INT8 = exports.FILTER_DEFAULTS = exports.TYPE_FILTERS = exports.COLUMN_SEPARATOR_STRING = exports.AGGREGATE_DEFAULTS = exports.TYPE_AGGREGATES = exports.SORT_ORDER_IDS = exports.SORT_ORDERS = exports.CONFIG_VALID_KEYS = exports.CONFIG_ALIASES = void 0;

__webpack_require__(72);

/******************************************************************************
 *
 * Copyright (c) 2017, the Perspective Authors.
 *
 * This file is part of the Perspective library, distributed under the terms of
 * the Apache License 2.0.  The full license can be found in the LICENSE file.
 *
 */
var CONFIG_ALIASES = {
  row_pivot: "row_pivots",
  "row-pivot": "row_pivots",
  "row-pivots": "row_pivots",
  col_pivot: "column_pivots",
  col_pivots: "column_pivots",
  column_pivot: "column_pivots",
  "column-pivot": "column_pivots",
  "column-pivots": "column_pivots",
  filters: "filter",
  sorts: "sort"
};
exports.CONFIG_ALIASES = CONFIG_ALIASES;
var CONFIG_VALID_KEYS = ["viewport", "row_pivots", "column_pivots", "aggregates", "columns", "filter", "sort", "row_pivot_depth", "filter_op"];
exports.CONFIG_VALID_KEYS = CONFIG_VALID_KEYS;
var NUMBER_AGGREGATES = ["any", "avg", "count", "distinct count", "dominant", "first by index", "last by index", "last", "high", "low", "mean", "mean by count", "median", "pct sum parent", "pct sum grand total", "sum", "sum abs", "sum not null", "unique"];
var STRING_AGGREGATES = ["any", "count", "distinct count", "distinct leaf", "dominant", "first by index", "last by index", "last", "mean by count", "unique"];
var BOOLEAN_AGGREGATES = ["any", "count", "distinct count", "distinct leaf", "dominant", "first by index", "last by index", "last", "mean by count", "unique", "and", "or"];
var SORT_ORDERS = ["none", "asc", "desc", "col asc", "col desc", "asc abs", "desc abs", "col asc abs", "col desc abs"];
exports.SORT_ORDERS = SORT_ORDERS;
var SORT_ORDER_IDS = [2, 0, 1, 0, 1, 3, 4, 3, 4];
exports.SORT_ORDER_IDS = SORT_ORDER_IDS;
var TYPE_AGGREGATES = {
  string: STRING_AGGREGATES,
  "float": NUMBER_AGGREGATES,
  integer: NUMBER_AGGREGATES,
  "boolean": BOOLEAN_AGGREGATES,
  datetime: STRING_AGGREGATES,
  date: STRING_AGGREGATES
};
exports.TYPE_AGGREGATES = TYPE_AGGREGATES;
var AGGREGATE_DEFAULTS = {
  string: "distinct count",
  "float": "sum",
  integer: "sum",
  "boolean": "distinct count",
  datetime: "distinct count",
  date: "distinct count"
};
exports.AGGREGATE_DEFAULTS = AGGREGATE_DEFAULTS;
var BOOLEAN_FILTERS = ["&", "|", "==", "!=", "or", "and"];
var NUMBER_FILTERS = ["<", ">", "==", "<=", ">=", "!=", "is nan", "is not nan"];
var STRING_FILTERS = ["==", "contains", "!=", "in", "not in", "begins with", "ends with"];
var DATETIME_FILTERS = ["<", ">", "==", "<=", ">=", "!="];
var COLUMN_SEPARATOR_STRING = "|";
exports.COLUMN_SEPARATOR_STRING = COLUMN_SEPARATOR_STRING;
var TYPE_FILTERS = {
  string: STRING_FILTERS,
  "float": NUMBER_FILTERS,
  integer: NUMBER_FILTERS,
  "boolean": BOOLEAN_FILTERS,
  datetime: DATETIME_FILTERS,
  date: DATETIME_FILTERS
};
exports.TYPE_FILTERS = TYPE_FILTERS;
var FILTER_DEFAULTS = {
  string: "==",
  "float": "==",
  integer: "==",
  "boolean": "==",
  datetime: "==",
  date: "=="
};
exports.FILTER_DEFAULTS = FILTER_DEFAULTS;
var TYPED_ARRAY_SENTINEL_VALUE_INT8 = 255;
exports.TYPED_ARRAY_SENTINEL_VALUE_INT8 = TYPED_ARRAY_SENTINEL_VALUE_INT8;
var TYPED_ARRAY_SENTINEL_VALUE_INT16 = 32767;
exports.TYPED_ARRAY_SENTINEL_VALUE_INT16 = TYPED_ARRAY_SENTINEL_VALUE_INT16;
var TYPED_ARRAY_SENTINEL_VALUE_INT32 = 2147483647;
exports.TYPED_ARRAY_SENTINEL_VALUE_INT32 = TYPED_ARRAY_SENTINEL_VALUE_INT32;
var TYPED_ARRAY_SENTINEL_VALUE_FLOAT32 = 3.40282e38;
exports.TYPED_ARRAY_SENTINEL_VALUE_FLOAT32 = TYPED_ARRAY_SENTINEL_VALUE_FLOAT32;
var TYPED_ARRAY_SENTINEL_VALUE_FLOAT64 = Number.MAX_VALUE;
exports.TYPED_ARRAY_SENTINEL_VALUE_FLOAT64 = TYPED_ARRAY_SENTINEL_VALUE_FLOAT64;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clean_data = clean_data;
exports.DataAccessor = void 0;

__webpack_require__(23);

__webpack_require__(72);

__webpack_require__(45);

__webpack_require__(44);

__webpack_require__(76);

__webpack_require__(104);

__webpack_require__(58);

var _DateParser = __webpack_require__(112);

var _utils = __webpack_require__(113);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var DataAccessor =
/*#__PURE__*/
function () {
  function DataAccessor() {
    _classCallCheck(this, DataAccessor);

    this.data_formats = {
      row: 0,
      column: 1,
      schema: 2
    };
    this.format = undefined;
    this.data = undefined;
    this.names = undefined;
    this.types = undefined;
    this.row_count = undefined;
    this.date_parsers = {};

    this.date_validator = function (val) {
      return (0, _DateParser.is_valid_date)(val);
    };
  }

  _createClass(DataAccessor, [{
    key: "extract_typevec",
    value: function extract_typevec(typevec) {
      var types = [];

      for (var i = 0; i < typevec.size() - 1; i++) {
        types.push(typevec.get(i));
      }

      return types;
    }
  }, {
    key: "is_format",
    value: function is_format(data) {
      if (Array.isArray(data)) {
        return this.data_formats.row;
      } else if (Array.isArray(data[Object.keys(data)[0]])) {
        return this.data_formats.column;
      } else if (typeof data[Object.keys(data)[0]] === "string" || typeof data[Object.keys(data)[0]] === "function") {
        return this.data_formats.schema;
      } else {
        throw "Unknown data format!";
      }
    }
  }, {
    key: "get_row_count",
    value: function get_row_count(data) {
      if (this.format === this.data_formats.row) {
        return data.length;
      } else if (this.format === this.data_formats.column) {
        return data[Object.keys(data)[0]].length;
      } else {
        return 0;
      }
    }
  }, {
    key: "get",
    value: function get(column_name, row_index) {
      var value = undefined;

      if (this.format === this.data_formats.row) {
        var d = this.data[row_index];

        if (d.hasOwnProperty(column_name)) {
          value = d[column_name];
        }
      } else if (this.format === this.data_formats.column) {
        if (this.data.hasOwnProperty(column_name)) {
          value = this.data[column_name][row_index];
        }
      } else if (this.format === this.data_formats.schema) {
        value = undefined;
      } else {
        throw "Unknown data format!";
      }

      return value;
    }
  }, {
    key: "marshal",
    value: function marshal(column_index, row_index, type) {
      var column_name = this.names[column_index];
      var val = clean_data(this.get(column_name, row_index));
      var date_parser;

      if (val === null) {
        return null;
      }

      if (typeof val === "undefined") {
        return undefined;
      }

      if (this.date_parsers[column_name] === undefined) {
        this.date_parsers[column_name] = new _DateParser.DateParser();
      }

      date_parser = this.date_parsers[column_name];

      switch ((0, _utils.get_column_type)(type.value)) {
        case "float":
        case "integer":
          {
            val = Number(val);
            break;
          }

        case "boolean":
          {
            if (typeof val === "string") {
              val.toLowerCase() === "true" ? val = true : val = false;
            } else {
              val = !!val;
            }

            break;
          }

        case "datetime":
        case "date":
          {
            val = date_parser.parse(val);
            break;
          }

        default:
          {
            val += ""; // TODO this is not right - might not be a string.  Need a data cleaner
          }
      }

      return val;
    }
    /**
     * Resets the internal state of the accessor, preventing
     * collisions with previously set data.
     *
     * @private
     */

  }, {
    key: "clean",
    value: function clean() {
      this.date_parsers = {};
      this.names = undefined;
      this.types = undefined;
    }
    /**
     * Links the accessor to a package of data for processing,
     * calculating its format and size.
     *
     * @private
     * @param {object} __MODULE__: the Module object generated by Emscripten
     * @param {object} data
     *
     * @returns An object with 5 properties:
     *    cdata - an array of columnar data.
     *    names - the column names.
     *    types - the column t_dtypes.
     *    row_count - the number of rows per column.
     *    is_arrow - an internal flag marking arrow-formatted data
     */

  }, {
    key: "init",
    value: function init(__MODULE__, data) {
      this.data = data;
      this.format = this.is_format(this.data);
      this.row_count = this.get_row_count(this.data);

      if (this.format === this.data_formats.row) {
        if (data.length > 0) {
          this.names = Object.keys(data[0]);
        } else {
          this.clean.names = [];
        }
      } else if (this.format === this.data_formats.column || this.format === this.data_formats.schema) {
        this.names = Object.keys(data);
      } else {
        throw "Unknown data format!";
      }
    }
  }]);

  return DataAccessor;
}();
/**
 * Coerce string null into value null.
 * @private
 * @param {*} value
 */


exports.DataAccessor = DataAccessor;

function clean_data(value) {
  if (value === null || value === "null") {
    return null;
  } else if (value === undefined || value === "undefined") {
    return undefined;
  } else {
    return value;
  }
}


/***/ }),
/* 188 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./es": 190,
	"./fr": 191
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 189;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(81)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex : monthsRegex,
        monthsShortRegex : monthsRegex,
        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY H:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return es;

})));


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(81)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var fr = moment.defineLocale('fr', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal : function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fr;

})));


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(1);
var $includes = __webpack_require__(53)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(103)('includes');


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(1);
var context = __webpack_require__(194);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(195)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(106);
var defined = __webpack_require__(33);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(4)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(9);
var toLength = __webpack_require__(15);
var advanceStringIndex = __webpack_require__(68);
var regExpExec = __webpack_require__(69);

// @@match logic
__webpack_require__(70)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(1);

$export($export.P, 'Function', { bind: __webpack_require__(198) });


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(28);
var isObject = __webpack_require__(10);
var invoke = __webpack_require__(97);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 199 */
/***/ (function(module, exports) {

/**
 * detect IE
 * returns version of IE or false, if browser is not Internet Explorer
 */
var detectie = function() {
    var ua = window.navigator.userAgent;

    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
       // IE 12 => return version number
       return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }
    // other browser
    return false;
}

module.exports = detectie;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(23);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extract_map = exports.extract_vector = void 0;

__webpack_require__(45);

__webpack_require__(44);

__webpack_require__(76);

/******************************************************************************
 *
 * Copyright (c) 2019, the Perspective Authors.
 *
 * This file is part of the Perspective library, distributed under the terms of
 * the Apache License 2.0.  The full license can be found in the LICENSE file.
 *
 */

/** Translation layer
 * Interface between C++ and JS to handle conversions/data structures that
 * were previously handled in non-portable perspective.js
 */
var extract_vector = function extract_vector(vector) {
  // handles deletion already - do not call delete() on the input vector again
  var extracted = [];

  for (var i = 0; i < vector.size(); i++) {
    var item = vector.get(i);
    extracted.push(item);
  }

  vector["delete"]();
  return extracted;
};

exports.extract_vector = extract_vector;

var extract_map = function extract_map(map) {
  // handles deletion already - do not call delete() on the input map again
  var extracted = {};
  var keys = map.keys();

  for (var i = 0; i < keys.size(); i++) {
    var key = keys.get(i);
    extracted[key] = map.get(key);
  }

  map["delete"]();
  keys["delete"]();
  return extracted;
};

exports.extract_map = extract_map;


/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = valueToString;
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.
/** @ignore */ var undf = void (0);
/** @ignore */
function valueToString(x) {
    if (x === null) {
        return 'null';
    }
    if (x === undf) {
        return 'undefined';
    }
    if (typeof x === 'string') {
        return "\"" + x + "\"";
    }
    // If [Symbol.toPrimitive] is implemented (like in BN)
    // use it instead of JSON.stringify(). This ensures we
    // print BigInts, Decimals, and Binary in their native
    // representation
    if (typeof x[Symbol.toPrimitive] === 'function') {
        return x[Symbol.toPrimitive]('string');
    }
    return ArrayBuffer.isView(x) ? "[" + x + "]" : JSON.stringify(x);
}



/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// This is free and unencumbered software released into the public domain.
// See LICENSE.md for more information.

//
// Utilities
//

/**
 * @param {number} a The number to test.
 * @param {number} min The minimum value in the range, inclusive.
 * @param {number} max The maximum value in the range, inclusive.
 * @return {boolean} True if a >= min and a <= max.
 */
function inRange(a, min, max) {
  return min <= a && a <= max;
}

/**
 * @param {*} o
 * @return {Object}
 */
function ToDictionary(o) {
  if (o === undefined) return {};
  if (o === Object(o)) return o;
  throw TypeError('Could not convert argument to dictionary');
}

/**
 * @param {string} string Input string of UTF-16 code units.
 * @return {!Array.<number>} Code points.
 */
function stringToCodePoints(string) {
  // https://heycam.github.io/webidl/#dfn-obtain-unicode

  // 1. Let S be the DOMString value.
  var s = String(string);

  // 2. Let n be the length of S.
  var n = s.length;

  // 3. Initialize i to 0.
  var i = 0;

  // 4. Initialize U to be an empty sequence of Unicode characters.
  var u = [];

  // 5. While i < n:
  while (i < n) {

    // 1. Let c be the code unit in S at index i.
    var c = s.charCodeAt(i);

    // 2. Depending on the value of c:

    // c < 0xD800 or c > 0xDFFF
    if (c < 0xD800 || c > 0xDFFF) {
      // Append to U the Unicode character with code point c.
      u.push(c);
    }

    // 0xDC00 ≤ c ≤ 0xDFFF
    else if (0xDC00 <= c && c <= 0xDFFF) {
      // Append to U a U+FFFD REPLACEMENT CHARACTER.
      u.push(0xFFFD);
    }

    // 0xD800 ≤ c ≤ 0xDBFF
    else if (0xD800 <= c && c <= 0xDBFF) {
      // 1. If i = n−1, then append to U a U+FFFD REPLACEMENT
      // CHARACTER.
      if (i === n - 1) {
        u.push(0xFFFD);
      }
      // 2. Otherwise, i < n−1:
      else {
        // 1. Let d be the code unit in S at index i+1.
        var d = string.charCodeAt(i + 1);

        // 2. If 0xDC00 ≤ d ≤ 0xDFFF, then:
        if (0xDC00 <= d && d <= 0xDFFF) {
          // 1. Let a be c & 0x3FF.
          var a = c & 0x3FF;

          // 2. Let b be d & 0x3FF.
          var b = d & 0x3FF;

          // 3. Append to U the Unicode character with code point
          // 2^16+2^10*a+b.
          u.push(0x10000 + (a << 10) + b);

          // 4. Set i to i+1.
          i += 1;
        }

        // 3. Otherwise, d < 0xDC00 or d > 0xDFFF. Append to U a
        // U+FFFD REPLACEMENT CHARACTER.
        else  {
          u.push(0xFFFD);
        }
      }
    }

    // 3. Set i to i+1.
    i += 1;
  }

  // 6. Return U.
  return u;
}

/**
 * @param {!Array.<number>} code_points Array of code points.
 * @return {string} string String of UTF-16 code units.
 */
function codePointsToString(code_points) {
  var s = '';
  for (var i = 0; i < code_points.length; ++i) {
    var cp = code_points[i];
    if (cp <= 0xFFFF) {
      s += String.fromCharCode(cp);
    } else {
      cp -= 0x10000;
      s += String.fromCharCode((cp >> 10) + 0xD800,
                               (cp & 0x3FF) + 0xDC00);
    }
  }
  return s;
}


//
// Implementation of Encoding specification
// https://encoding.spec.whatwg.org/
//

//
// 3. Terminology
//

/**
 * End-of-stream is a special token that signifies no more tokens
 * are in the stream.
 * @const
 */ var end_of_stream = -1;

/**
 * A stream represents an ordered sequence of tokens.
 *
 * @constructor
 * @param {!(Array.<number>|Uint8Array)} tokens Array of tokens that provide the
 * stream.
 */
function Stream(tokens) {
  /** @type {!Array.<number>} */
  this.tokens = [].slice.call(tokens);
}

Stream.prototype = {
  /**
   * @return {boolean} True if end-of-stream has been hit.
   */
  endOfStream: function() {
    return !this.tokens.length;
  },

  /**
   * When a token is read from a stream, the first token in the
   * stream must be returned and subsequently removed, and
   * end-of-stream must be returned otherwise.
   *
   * @return {number} Get the next token from the stream, or
   * end_of_stream.
   */
   read: function() {
    if (!this.tokens.length)
      return end_of_stream;
     return this.tokens.shift();
   },

  /**
   * When one or more tokens are prepended to a stream, those tokens
   * must be inserted, in given order, before the first token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The token(s) to prepend to the stream.
   */
  prepend: function(token) {
    if (Array.isArray(token)) {
      var tokens = /**@type {!Array.<number>}*/(token);
      while (tokens.length)
        this.tokens.unshift(tokens.pop());
    } else {
      this.tokens.unshift(token);
    }
  },

  /**
   * When one or more tokens are pushed to a stream, those tokens
   * must be inserted, in given order, after the last token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The tokens(s) to prepend to the stream.
   */
  push: function(token) {
    if (Array.isArray(token)) {
      var tokens = /**@type {!Array.<number>}*/(token);
      while (tokens.length)
        this.tokens.push(tokens.shift());
    } else {
      this.tokens.push(token);
    }
  }
};

//
// 4. Encodings
//

// 4.1 Encoders and decoders

/** @const */
var finished = -1;

/**
 * @param {boolean} fatal If true, decoding errors raise an exception.
 * @param {number=} opt_code_point Override the standard fallback code point.
 * @return {number} The code point to insert on a decoding error.
 */
function decoderError(fatal, opt_code_point) {
  if (fatal)
    throw TypeError('Decoder error');
  return opt_code_point || 0xFFFD;
}

//
// 7. API
//

/** @const */ var DEFAULT_ENCODING = 'utf-8';

// 7.1 Interface TextDecoder

/**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */
function TextDecoder(encoding, options) {
  if (!(this instanceof TextDecoder)) {
    return new TextDecoder(encoding, options);
  }
  encoding = encoding !== undefined ? String(encoding).toLowerCase() : DEFAULT_ENCODING;
  if (encoding !== DEFAULT_ENCODING) {
    throw new Error('Encoding not supported. Only utf-8 is supported');
  }
  options = ToDictionary(options);

  /** @private @type {boolean} */
  this._streaming = false;
  /** @private @type {boolean} */
  this._BOMseen = false;
  /** @private @type {?Decoder} */
  this._decoder = null;
  /** @private @type {boolean} */
  this._fatal = Boolean(options['fatal']);
  /** @private @type {boolean} */
  this._ignoreBOM = Boolean(options['ignoreBOM']);

  Object.defineProperty(this, 'encoding', {value: 'utf-8'});
  Object.defineProperty(this, 'fatal', {value: this._fatal});
  Object.defineProperty(this, 'ignoreBOM', {value: this._ignoreBOM});
}

TextDecoder.prototype = {
  /**
   * @param {ArrayBufferView=} input The buffer of bytes to decode.
   * @param {Object=} options
   * @return {string} The decoded string.
   */
  decode: function decode(input, options) {
    var bytes;
    if (typeof input === 'object' && input instanceof ArrayBuffer) {
      bytes = new Uint8Array(input);
    } else if (typeof input === 'object' && 'buffer' in input &&
               input.buffer instanceof ArrayBuffer) {
      bytes = new Uint8Array(input.buffer,
                             input.byteOffset,
                             input.byteLength);
    } else {
      bytes = new Uint8Array(0);
    }

    options = ToDictionary(options);

    if (!this._streaming) {
      this._decoder = new UTF8Decoder({fatal: this._fatal});
      this._BOMseen = false;
    }
    this._streaming = Boolean(options['stream']);

    var input_stream = new Stream(bytes);

    var code_points = [];

    /** @type {?(number|!Array.<number>)} */
    var result;

    while (!input_stream.endOfStream()) {
      result = this._decoder.handler(input_stream, input_stream.read());
      if (result === finished)
        break;
      if (result === null)
        continue;
      if (Array.isArray(result))
        code_points.push.apply(code_points, /**@type {!Array.<number>}*/(result));
      else
        code_points.push(result);
    }
    if (!this._streaming) {
      do {
        result = this._decoder.handler(input_stream, input_stream.read());
        if (result === finished)
          break;
        if (result === null)
          continue;
        if (Array.isArray(result))
          code_points.push.apply(code_points, /**@type {!Array.<number>}*/(result));
        else
          code_points.push(result);
      } while (!input_stream.endOfStream());
      this._decoder = null;
    }

    if (code_points.length) {
      // If encoding is one of utf-8, utf-16be, and utf-16le, and
      // ignore BOM flag and BOM seen flag are unset, run these
      // subsubsteps:
      if (['utf-8'].indexOf(this.encoding) !== -1 &&
          !this._ignoreBOM && !this._BOMseen) {
        // If token is U+FEFF, set BOM seen flag.
        if (code_points[0] === 0xFEFF) {
          this._BOMseen = true;
          code_points.shift();
        } else {
          // Otherwise, if token is not end-of-stream, set BOM seen
          // flag and append token to output.
          this._BOMseen = true;
        }
      }
    }

    return codePointsToString(code_points);
  }
};

// 7.2 Interface TextEncoder

/**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */
function TextEncoder(encoding, options) {
  if (!(this instanceof TextEncoder))
    return new TextEncoder(encoding, options);
  encoding = encoding !== undefined ? String(encoding).toLowerCase() : DEFAULT_ENCODING;
  if (encoding !== DEFAULT_ENCODING) {
    throw new Error('Encoding not supported. Only utf-8 is supported');
  }
  options = ToDictionary(options);

  /** @private @type {boolean} */
  this._streaming = false;
  /** @private @type {?Encoder} */
  this._encoder = null;
  /** @private @type {{fatal: boolean}} */
  this._options = {fatal: Boolean(options['fatal'])};

  Object.defineProperty(this, 'encoding', {value: 'utf-8'});
}

TextEncoder.prototype = {
  /**
   * @param {string=} opt_string The string to encode.
   * @param {Object=} options
   * @return {Uint8Array} Encoded bytes, as a Uint8Array.
   */
  encode: function encode(opt_string, options) {
    opt_string = opt_string ? String(opt_string) : '';
    options = ToDictionary(options);

    // NOTE: This option is nonstandard. None of the encodings
    // permitted for encoding (i.e. UTF-8, UTF-16) are stateful,
    // so streaming is not necessary.
    if (!this._streaming)
      this._encoder = new UTF8Encoder(this._options);
    this._streaming = Boolean(options['stream']);

    var bytes = [];
    var input_stream = new Stream(stringToCodePoints(opt_string));
    /** @type {?(number|!Array.<number>)} */
    var result;
    while (!input_stream.endOfStream()) {
      result = this._encoder.handler(input_stream, input_stream.read());
      if (result === finished)
        break;
      if (Array.isArray(result))
        bytes.push.apply(bytes, /**@type {!Array.<number>}*/(result));
      else
        bytes.push(result);
    }
    if (!this._streaming) {
      while (true) {
        result = this._encoder.handler(input_stream, input_stream.read());
        if (result === finished)
          break;
        if (Array.isArray(result))
          bytes.push.apply(bytes, /**@type {!Array.<number>}*/(result));
        else
          bytes.push(result);
      }
      this._encoder = null;
    }
    return new Uint8Array(bytes);
  }
};

//
// 8. The encoding
//

// 8.1 utf-8

/**
 * @constructor
 * @implements {Decoder}
 * @param {{fatal: boolean}} options
 */
function UTF8Decoder(options) {
  var fatal = options.fatal;

  // utf-8's decoder's has an associated utf-8 code point, utf-8
  // bytes seen, and utf-8 bytes needed (all initially 0), a utf-8
  // lower boundary (initially 0x80), and a utf-8 upper boundary
  // (initially 0xBF).
  var /** @type {number} */ utf8_code_point = 0,
      /** @type {number} */ utf8_bytes_seen = 0,
      /** @type {number} */ utf8_bytes_needed = 0,
      /** @type {number} */ utf8_lower_boundary = 0x80,
      /** @type {number} */ utf8_upper_boundary = 0xBF;

  /**
   * @param {Stream} stream The stream of bytes being decoded.
   * @param {number} bite The next byte read from the stream.
   * @return {?(number|!Array.<number>)} The next code point(s)
   *     decoded, or null if not enough data exists in the input
   *     stream to decode a complete code point.
   */
  this.handler = function(stream, bite) {
    // 1. If byte is end-of-stream and utf-8 bytes needed is not 0,
    // set utf-8 bytes needed to 0 and return error.
    if (bite === end_of_stream && utf8_bytes_needed !== 0) {
      utf8_bytes_needed = 0;
      return decoderError(fatal);
    }

    // 2. If byte is end-of-stream, return finished.
    if (bite === end_of_stream)
      return finished;

    // 3. If utf-8 bytes needed is 0, based on byte:
    if (utf8_bytes_needed === 0) {

      // 0x00 to 0x7F
      if (inRange(bite, 0x00, 0x7F)) {
        // Return a code point whose value is byte.
        return bite;
      }

      // 0xC2 to 0xDF
      if (inRange(bite, 0xC2, 0xDF)) {
        // Set utf-8 bytes needed to 1 and utf-8 code point to byte
        // − 0xC0.
        utf8_bytes_needed = 1;
        utf8_code_point = bite - 0xC0;
      }

      // 0xE0 to 0xEF
      else if (inRange(bite, 0xE0, 0xEF)) {
        // 1. If byte is 0xE0, set utf-8 lower boundary to 0xA0.
        if (bite === 0xE0)
          utf8_lower_boundary = 0xA0;
        // 2. If byte is 0xED, set utf-8 upper boundary to 0x9F.
        if (bite === 0xED)
          utf8_upper_boundary = 0x9F;
        // 3. Set utf-8 bytes needed to 2 and utf-8 code point to
        // byte − 0xE0.
        utf8_bytes_needed = 2;
        utf8_code_point = bite - 0xE0;
      }

      // 0xF0 to 0xF4
      else if (inRange(bite, 0xF0, 0xF4)) {
        // 1. If byte is 0xF0, set utf-8 lower boundary to 0x90.
        if (bite === 0xF0)
          utf8_lower_boundary = 0x90;
        // 2. If byte is 0xF4, set utf-8 upper boundary to 0x8F.
        if (bite === 0xF4)
          utf8_upper_boundary = 0x8F;
        // 3. Set utf-8 bytes needed to 3 and utf-8 code point to
        // byte − 0xF0.
        utf8_bytes_needed = 3;
        utf8_code_point = bite - 0xF0;
      }

      // Otherwise
      else {
        // Return error.
        return decoderError(fatal);
      }

      // Then (byte is in the range 0xC2 to 0xF4) set utf-8 code
      // point to utf-8 code point << (6 × utf-8 bytes needed) and
      // return continue.
      utf8_code_point = utf8_code_point << (6 * utf8_bytes_needed);
      return null;
    }

    // 4. If byte is not in the range utf-8 lower boundary to utf-8
    // upper boundary, run these substeps:
    if (!inRange(bite, utf8_lower_boundary, utf8_upper_boundary)) {

      // 1. Set utf-8 code point, utf-8 bytes needed, and utf-8
      // bytes seen to 0, set utf-8 lower boundary to 0x80, and set
      // utf-8 upper boundary to 0xBF.
      utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
      utf8_lower_boundary = 0x80;
      utf8_upper_boundary = 0xBF;

      // 2. Prepend byte to stream.
      stream.prepend(bite);

      // 3. Return error.
      return decoderError(fatal);
    }

    // 5. Set utf-8 lower boundary to 0x80 and utf-8 upper boundary
    // to 0xBF.
    utf8_lower_boundary = 0x80;
    utf8_upper_boundary = 0xBF;

    // 6. Increase utf-8 bytes seen by one and set utf-8 code point
    // to utf-8 code point + (byte − 0x80) << (6 × (utf-8 bytes
    // needed − utf-8 bytes seen)).
    utf8_bytes_seen += 1;
    utf8_code_point += (bite - 0x80) << (6 * (utf8_bytes_needed - utf8_bytes_seen));

    // 7. If utf-8 bytes seen is not equal to utf-8 bytes needed,
    // continue.
    if (utf8_bytes_seen !== utf8_bytes_needed)
      return null;

    // 8. Let code point be utf-8 code point.
    var code_point = utf8_code_point;

    // 9. Set utf-8 code point, utf-8 bytes needed, and utf-8 bytes
    // seen to 0.
    utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;

    // 10. Return a code point whose value is code point.
    return code_point;
  };
}

/**
 * @constructor
 * @implements {Encoder}
 * @param {{fatal: boolean}} options
 */
function UTF8Encoder(options) {
  var fatal = options.fatal;
  /**
   * @param {Stream} stream Input stream.
   * @param {number} code_point Next code point read from the stream.
   * @return {(number|!Array.<number>)} Byte(s) to emit.
   */
  this.handler = function(stream, code_point) {
    // 1. If code point is end-of-stream, return finished.
    if (code_point === end_of_stream)
      return finished;

    // 2. If code point is in the range U+0000 to U+007F, return a
    // byte whose value is code point.
    if (inRange(code_point, 0x0000, 0x007f))
      return code_point;

    // 3. Set count and offset based on the range code point is in:
    var count, offset;
    // U+0080 to U+07FF:    1 and 0xC0
    if (inRange(code_point, 0x0080, 0x07FF)) {
      count = 1;
      offset = 0xC0;
    }
    // U+0800 to U+FFFF:    2 and 0xE0
    else if (inRange(code_point, 0x0800, 0xFFFF)) {
      count = 2;
      offset = 0xE0;
    }
    // U+10000 to U+10FFFF: 3 and 0xF0
    else if (inRange(code_point, 0x10000, 0x10FFFF)) {
      count = 3;
      offset = 0xF0;
    }

    // 4.Let bytes be a byte sequence whose first byte is (code
    // point >> (6 × count)) + offset.
    var bytes = [(code_point >> (6 * count)) + offset];

    // 5. Run these substeps while count is greater than 0:
    while (count > 0) {

      // 1. Set temp to code point >> (6 × (count − 1)).
      var temp = code_point >> (6 * (count - 1));

      // 2. Append to bytes 0x80 | (temp & 0x3F).
      bytes.push(0x80 | (temp & 0x3F));

      // 3. Decrease count by one.
      count -= 1;
    }

    // 6. Return bytes bytes, in order.
    return bytes;
  };
}

exports.TextEncoder = TextEncoder;
exports.TextDecoder = TextDecoder;

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RecordBatchReader; });
/* unused harmony export RecordBatchStreamReader */
/* unused harmony export AsyncRecordBatchStreamReader */
/* unused harmony export RecordBatchFileReader */
/* unused harmony export AsyncRecordBatchFileReader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vector__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enum__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata_file__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__io_adapters__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__recordbatch__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__io_stream__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__io_file__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__visitor_vectorloader__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__io_interfaces__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__message__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_compat__ = __webpack_require__(37);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.












var RecordBatchReader = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](RecordBatchReader, _super);
    function RecordBatchReader(impl) {
        var _this = _super.call(this) || this;
        _this._impl = impl;
        return _this;
    }
    Object.defineProperty(RecordBatchReader.prototype, "closed", {
        get: function () { return this._impl.closed; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecordBatchReader.prototype, "schema", {
        get: function () { return this._impl.schema; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecordBatchReader.prototype, "autoDestroy", {
        get: function () { return this._impl.autoDestroy; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecordBatchReader.prototype, "dictionaries", {
        get: function () { return this._impl.dictionaries; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecordBatchReader.prototype, "numDictionaries", {
        get: function () { return this._impl.numDictionaries; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecordBatchReader.prototype, "numRecordBatches", {
        get: function () { return this._impl.numRecordBatches; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecordBatchReader.prototype, "footer", {
        get: function () { return this._impl.isFile() ? this._impl.footer : null; },
        enumerable: true,
        configurable: true
    });
    RecordBatchReader.prototype.isSync = function () { return this._impl.isSync(); };
    RecordBatchReader.prototype.isAsync = function () { return this._impl.isAsync(); };
    RecordBatchReader.prototype.isFile = function () { return this._impl.isFile(); };
    RecordBatchReader.prototype.isStream = function () { return this._impl.isStream(); };
    RecordBatchReader.prototype.next = function () {
        return this._impl.next();
    };
    RecordBatchReader.prototype.throw = function (value) {
        return this._impl.throw(value);
    };
    RecordBatchReader.prototype.return = function (value) {
        return this._impl.return(value);
    };
    RecordBatchReader.prototype.cancel = function () {
        return this._impl.cancel();
    };
    RecordBatchReader.prototype.reset = function (schema) {
        this._impl.reset(schema);
        return this;
    };
    RecordBatchReader.prototype.open = function (options) {
        var _this = this;
        var opening = this._impl.open(options);
        return Object(__WEBPACK_IMPORTED_MODULE_11__util_compat__["g" /* isPromise */])(opening) ? opening.then(function () { return _this; }) : this;
    };
    RecordBatchReader.prototype.readRecordBatch = function (index) {
        return this._impl.isFile() ? this._impl.readRecordBatch(index) : null;
    };
    RecordBatchReader.prototype[Symbol.iterator] = function () {
        return this._impl[Symbol.iterator]();
    };
    RecordBatchReader.prototype[Symbol.asyncIterator] = function () {
        return this._impl[Symbol.asyncIterator]();
    };
    RecordBatchReader.prototype.toDOMStream = function () {
        var _this = this;
        var _a, _b;
        return __WEBPACK_IMPORTED_MODULE_4__io_adapters__["a" /* default */].toDOMStream((this.isSync()
            ? (_a = {}, _a[Symbol.iterator] = function () { return _this; }, _a)
            : (_b = {}, _b[Symbol.asyncIterator] = function () { return _this; }, _b)));
    };
    RecordBatchReader.prototype.toNodeStream = function () {
        var _this = this;
        var _a, _b;
        return __WEBPACK_IMPORTED_MODULE_4__io_adapters__["a" /* default */].toNodeStream((this.isSync()
            ? (_a = {}, _a[Symbol.iterator] = function () { return _this; }, _a)
            : (_b = {}, _b[Symbol.asyncIterator] = function () { return _this; }, _b)), { objectMode: true });
    };
    /** @nocollapse */
    // @ts-ignore
    RecordBatchReader.throughNode = function (options) {
        throw new Error("\"throughNode\" not available in this environment");
    };
    /** @nocollapse */
    RecordBatchReader.throughDOM = function (
    // @ts-ignore
    writableStrategy, 
    // @ts-ignore
    readableStrategy) {
        throw new Error("\"throughDOM\" not available in this environment");
    };
    /** @nocollapse */
    RecordBatchReader.from = function (source) {
        var _this = this;
        if (source instanceof RecordBatchReader) {
            return source;
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_11__util_compat__["a" /* isArrowJSON */])(source)) {
            return fromArrowJSON(source);
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_11__util_compat__["d" /* isFileHandle */])(source)) {
            return fromFileHandle(source);
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_11__util_compat__["g" /* isPromise */])(source)) {
            return (function () { return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](_this, void 0, void 0, function () { var _a, _b; return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _b = (_a = RecordBatchReader).from;
                        return [4 /*yield*/, source];
                    case 1: return [4 /*yield*/, _b.apply(_a, [_c.sent()])];
                    case 2: return [2 /*return*/, _c.sent()];
                }
            }); }); })();
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_11__util_compat__["c" /* isFetchResponse */])(source) || Object(__WEBPACK_IMPORTED_MODULE_11__util_compat__["h" /* isReadableDOMStream */])(source) || Object(__WEBPACK_IMPORTED_MODULE_11__util_compat__["i" /* isReadableNodeStream */])(source) || Object(__WEBPACK_IMPORTED_MODULE_11__util_compat__["b" /* isAsyncIterable */])(source)) {
            return fromAsyncByteStream(new __WEBPACK_IMPORTED_MODULE_6__io_stream__["b" /* AsyncByteStream */](source));
        }
        return fromByteStream(new __WEBPACK_IMPORTED_MODULE_6__io_stream__["c" /* ByteStream */](source));
    };
    /** @nocollapse */
    RecordBatchReader.readAll = function (source) {
        if (source instanceof RecordBatchReader) {
            return source.isSync() ? readAllSync(source) : readAllAsync(source);
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_11__util_compat__["a" /* isArrowJSON */])(source) || ArrayBuffer.isView(source) || Object(__WEBPACK_IMPORTED_MODULE_11__util_compat__["e" /* isIterable */])(source) || Object(__WEBPACK_IMPORTED_MODULE_11__util_compat__["f" /* isIteratorResult */])(source)) {
            return readAllSync(source);
        }
        return readAllAsync(source);
    };
    return RecordBatchReader;
}(__WEBPACK_IMPORTED_MODULE_9__io_interfaces__["d" /* ReadableInterop */]));

//
// Since TS is a structural type system, we define the following subclass stubs
// so that concrete types exist to associate with with the interfaces below.
//
// The implementation for each RecordBatchReader is hidden away in the set of
// `RecordBatchReaderImpl` classes in the second half of this file. This allows
// us to export a single RecordBatchReader class, and swap out the impl based
// on the io primitives or underlying arrow (JSON, file, or stream) at runtime.
//
// Async/await makes our job a bit harder, since it forces everything to be
// either fully sync or fully async. This is why the logic for the reader impls
// has been duplicated into both sync and async variants. Since the RBR
// delegates to its impl, an RBR with an AsyncRecordBatchFileReaderImpl for
// example will return async/await-friendly Promises, but one with a (sync)
// RecordBatchStreamReaderImpl will always return values. Nothing should be
// different about their logic, aside from the async handling. This is also why
// this code looks highly structured, as it should be nearly identical and easy
// to follow.
//
/** @ignore */
var RecordBatchStreamReader = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](RecordBatchStreamReader, _super);
    function RecordBatchStreamReader(_impl) {
        var _this = _super.call(this, _impl) || this;
        _this._impl = _impl;
        return _this;
    }
    RecordBatchStreamReader.prototype[Symbol.iterator] = function () { return this._impl[Symbol.iterator](); };
    RecordBatchStreamReader.prototype[Symbol.asyncIterator] = function () { return __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __asyncGenerator */](this, arguments, function _a() { return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
        switch (_a.label) {
            case 0: return [5 /*yield**/, __WEBPACK_IMPORTED_MODULE_0_tslib__["k" /* __values */](__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __asyncDelegator */](__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __asyncValues */](this[Symbol.iterator]())))];
            case 1: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __await */].apply(void 0, [_a.sent()])];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    }); }); };
    return RecordBatchStreamReader;
}(RecordBatchReader));

/** @ignore */
var AsyncRecordBatchStreamReader = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](AsyncRecordBatchStreamReader, _super);
    function AsyncRecordBatchStreamReader(_impl) {
        var _this = _super.call(this, _impl) || this;
        _this._impl = _impl;
        return _this;
    }
    AsyncRecordBatchStreamReader.prototype[Symbol.iterator] = function () { throw new Error("AsyncRecordBatchStreamReader is not Iterable"); };
    AsyncRecordBatchStreamReader.prototype[Symbol.asyncIterator] = function () { return this._impl[Symbol.asyncIterator](); };
    return AsyncRecordBatchStreamReader;
}(RecordBatchReader));

/** @ignore */
var RecordBatchFileReader = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](RecordBatchFileReader, _super);
    function RecordBatchFileReader(_impl) {
        var _this = _super.call(this, _impl) || this;
        _this._impl = _impl;
        return _this;
    }
    return RecordBatchFileReader;
}(RecordBatchStreamReader));

/** @ignore */
var AsyncRecordBatchFileReader = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](AsyncRecordBatchFileReader, _super);
    function AsyncRecordBatchFileReader(_impl) {
        var _this = _super.call(this, _impl) || this;
        _this._impl = _impl;
        return _this;
    }
    return AsyncRecordBatchFileReader;
}(AsyncRecordBatchStreamReader));

/** @ignore */
var RecordBatchReaderImpl = /** @class */ (function () {
    function RecordBatchReaderImpl(dictionaries) {
        if (dictionaries === void 0) { dictionaries = new Map(); }
        this.closed = false;
        this.autoDestroy = true;
        this._dictionaryIndex = 0;
        this._recordBatchIndex = 0;
        this.dictionaries = dictionaries;
    }
    Object.defineProperty(RecordBatchReaderImpl.prototype, "numDictionaries", {
        get: function () { return this._dictionaryIndex; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecordBatchReaderImpl.prototype, "numRecordBatches", {
        get: function () { return this._recordBatchIndex; },
        enumerable: true,
        configurable: true
    });
    RecordBatchReaderImpl.prototype.isSync = function () { return false; };
    RecordBatchReaderImpl.prototype.isAsync = function () { return false; };
    RecordBatchReaderImpl.prototype.isFile = function () { return false; };
    RecordBatchReaderImpl.prototype.isStream = function () { return false; };
    RecordBatchReaderImpl.prototype.reset = function (schema) {
        this._dictionaryIndex = 0;
        this._recordBatchIndex = 0;
        this.schema = schema;
        this.dictionaries = new Map();
        return this;
    };
    RecordBatchReaderImpl.prototype._loadRecordBatch = function (header, body) {
        return new __WEBPACK_IMPORTED_MODULE_5__recordbatch__["a" /* RecordBatch */](this.schema, header.length, this._loadVectors(header, body, this.schema.fields));
    };
    RecordBatchReaderImpl.prototype._loadDictionaryBatch = function (header, body) {
        var id = header.id, isDelta = header.isDelta, data = header.data;
        var _a = this, dictionaries = _a.dictionaries, schema = _a.schema;
        if (isDelta || !dictionaries.get(id)) {
            var type = schema.dictionaries.get(id);
            var vector_1 = (isDelta ? dictionaries.get(id).concat(__WEBPACK_IMPORTED_MODULE_1__vector__["Vector"].new(this._loadVectors(data, body, [type])[0])) :
                __WEBPACK_IMPORTED_MODULE_1__vector__["Vector"].new(this._loadVectors(data, body, [type])[0]));
            (schema.dictionaryFields.get(id) || []).forEach(function (_a) {
                var type = _a.type;
                return type.dictionaryVector = vector_1;
            });
            return vector_1;
        }
        return dictionaries.get(id);
    };
    RecordBatchReaderImpl.prototype._loadVectors = function (header, body, types) {
        return new __WEBPACK_IMPORTED_MODULE_8__visitor_vectorloader__["b" /* VectorLoader */](body, header.nodes, header.buffers).visitMany(types);
    };
    return RecordBatchReaderImpl;
}());
/** @ignore */
var RecordBatchStreamReaderImpl = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](RecordBatchStreamReaderImpl, _super);
    function RecordBatchStreamReaderImpl(source, dictionaries) {
        var _this = _super.call(this, dictionaries) || this;
        _this._reader = !Object(__WEBPACK_IMPORTED_MODULE_11__util_compat__["a" /* isArrowJSON */])(source)
            ? new __WEBPACK_IMPORTED_MODULE_10__message__["d" /* MessageReader */](_this._handle = source)
            : new __WEBPACK_IMPORTED_MODULE_10__message__["b" /* JSONMessageReader */](_this._handle = source);
        return _this;
    }
    RecordBatchStreamReaderImpl.prototype.isSync = function () { return true; };
    RecordBatchStreamReaderImpl.prototype.isStream = function () { return true; };
    RecordBatchStreamReaderImpl.prototype[Symbol.iterator] = function () {
        return this;
    };
    RecordBatchStreamReaderImpl.prototype.cancel = function () {
        if (!this.closed && (this.closed = true)) {
            this.reset()._reader.return();
            this._reader = null;
            this.dictionaries = null;
        }
    };
    RecordBatchStreamReaderImpl.prototype.open = function (options) {
        if (!this.closed) {
            this.autoDestroy = shouldAutoDestroy(this, options);
            if (!(this.schema || (this.schema = this._reader.readSchema()))) {
                this.cancel();
            }
        }
        return this;
    };
    RecordBatchStreamReaderImpl.prototype.throw = function (value) {
        if (!this.closed && this.autoDestroy && (this.closed = true)) {
            return this.reset()._reader.throw(value);
        }
        return __WEBPACK_IMPORTED_MODULE_9__io_interfaces__["c" /* ITERATOR_DONE */];
    };
    RecordBatchStreamReaderImpl.prototype.return = function (value) {
        if (!this.closed && this.autoDestroy && (this.closed = true)) {
            return this.reset()._reader.return(value);
        }
        return __WEBPACK_IMPORTED_MODULE_9__io_interfaces__["c" /* ITERATOR_DONE */];
    };
    RecordBatchStreamReaderImpl.prototype.next = function () {
        if (this.closed) {
            return __WEBPACK_IMPORTED_MODULE_9__io_interfaces__["c" /* ITERATOR_DONE */];
        }
        var message, reader = this._reader;
        while (message = this._readNextMessageAndValidate()) {
            if (message.isSchema()) {
                this.reset(message.header());
            }
            else if (message.isRecordBatch()) {
                this._recordBatchIndex++;
                var header = message.header();
                var buffer = reader.readMessageBody(message.bodyLength);
                var recordBatch = this._loadRecordBatch(header, buffer);
                return { done: false, value: recordBatch };
            }
            else if (message.isDictionaryBatch()) {
                this._dictionaryIndex++;
                var header = message.header();
                var buffer = reader.readMessageBody(message.bodyLength);
                var vector = this._loadDictionaryBatch(header, buffer);
                this.dictionaries.set(header.id, vector);
            }
        }
        return this.return();
    };
    RecordBatchStreamReaderImpl.prototype._readNextMessageAndValidate = function (type) {
        return this._reader.readMessage(type);
    };
    return RecordBatchStreamReaderImpl;
}(RecordBatchReaderImpl));
/** @ignore */
var AsyncRecordBatchStreamReaderImpl = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](AsyncRecordBatchStreamReaderImpl, _super);
    function AsyncRecordBatchStreamReaderImpl(source, dictionaries) {
        var _this = _super.call(this, dictionaries) || this;
        _this._reader = new __WEBPACK_IMPORTED_MODULE_10__message__["a" /* AsyncMessageReader */](_this._handle = source);
        return _this;
    }
    AsyncRecordBatchStreamReaderImpl.prototype.isAsync = function () { return true; };
    AsyncRecordBatchStreamReaderImpl.prototype.isStream = function () { return true; };
    AsyncRecordBatchStreamReaderImpl.prototype[Symbol.asyncIterator] = function () {
        return this;
    };
    AsyncRecordBatchStreamReaderImpl.prototype.cancel = function () {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () {
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.closed && (this.closed = true))) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.reset()._reader.return()];
                    case 1:
                        _a.sent();
                        this._reader = null;
                        this.dictionaries = null;
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    AsyncRecordBatchStreamReaderImpl.prototype.open = function (options) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () {
            var _a, _b;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!!this.closed) return [3 /*break*/, 4];
                        this.autoDestroy = shouldAutoDestroy(this, options);
                        _a = this.schema;
                        if (_a) return [3 /*break*/, 2];
                        _b = this;
                        return [4 /*yield*/, this._reader.readSchema()];
                    case 1:
                        _a = (_b.schema = (_c.sent()));
                        _c.label = 2;
                    case 2:
                        if (!!(_a)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.cancel()];
                    case 3:
                        _c.sent();
                        _c.label = 4;
                    case 4: return [2 /*return*/, this];
                }
            });
        });
    };
    AsyncRecordBatchStreamReaderImpl.prototype.throw = function (value) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () {
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.closed && this.autoDestroy && (this.closed = true))) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.reset()._reader.throw(value)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/, __WEBPACK_IMPORTED_MODULE_9__io_interfaces__["c" /* ITERATOR_DONE */]];
                }
            });
        });
    };
    AsyncRecordBatchStreamReaderImpl.prototype.return = function (value) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () {
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.closed && this.autoDestroy && (this.closed = true))) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.reset()._reader.return(value)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/, __WEBPACK_IMPORTED_MODULE_9__io_interfaces__["c" /* ITERATOR_DONE */]];
                }
            });
        });
    };
    AsyncRecordBatchStreamReaderImpl.prototype.next = function () {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () {
            var message, reader, header, buffer, recordBatch, header, buffer, vector;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.closed) {
                            return [2 /*return*/, __WEBPACK_IMPORTED_MODULE_9__io_interfaces__["c" /* ITERATOR_DONE */]];
                        }
                        reader = this._reader;
                        _a.label = 1;
                    case 1: return [4 /*yield*/, this._readNextMessageAndValidate()];
                    case 2:
                        if (!(message = _a.sent())) return [3 /*break*/, 9];
                        if (!message.isSchema()) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.reset(message.header())];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 4:
                        if (!message.isRecordBatch()) return [3 /*break*/, 6];
                        this._recordBatchIndex++;
                        header = message.header();
                        return [4 /*yield*/, reader.readMessageBody(message.bodyLength)];
                    case 5:
                        buffer = _a.sent();
                        recordBatch = this._loadRecordBatch(header, buffer);
                        return [2 /*return*/, { done: false, value: recordBatch }];
                    case 6:
                        if (!message.isDictionaryBatch()) return [3 /*break*/, 8];
                        this._dictionaryIndex++;
                        header = message.header();
                        return [4 /*yield*/, reader.readMessageBody(message.bodyLength)];
                    case 7:
                        buffer = _a.sent();
                        vector = this._loadDictionaryBatch(header, buffer);
                        this.dictionaries.set(header.id, vector);
                        _a.label = 8;
                    case 8: return [3 /*break*/, 1];
                    case 9: return [4 /*yield*/, this.return()];
                    case 10: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AsyncRecordBatchStreamReaderImpl.prototype._readNextMessageAndValidate = function (type) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () {
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._reader.readMessage(type)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return AsyncRecordBatchStreamReaderImpl;
}(RecordBatchReaderImpl));
/** @ignore */
var RecordBatchFileReaderImpl = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](RecordBatchFileReaderImpl, _super);
    function RecordBatchFileReaderImpl(source, dictionaries) {
        return _super.call(this, source instanceof __WEBPACK_IMPORTED_MODULE_7__io_file__["b" /* RandomAccessFile */] ? source : new __WEBPACK_IMPORTED_MODULE_7__io_file__["b" /* RandomAccessFile */](source), dictionaries) || this;
    }
    Object.defineProperty(RecordBatchFileReaderImpl.prototype, "footer", {
        get: function () { return this._footer; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecordBatchFileReaderImpl.prototype, "numDictionaries", {
        get: function () { return this._footer ? this._footer.numDictionaries : 0; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecordBatchFileReaderImpl.prototype, "numRecordBatches", {
        get: function () { return this._footer ? this._footer.numRecordBatches : 0; },
        enumerable: true,
        configurable: true
    });
    RecordBatchFileReaderImpl.prototype.isSync = function () { return true; };
    RecordBatchFileReaderImpl.prototype.isFile = function () { return true; };
    RecordBatchFileReaderImpl.prototype.open = function (options) {
        var e_1, _a;
        if (!this.closed && !this._footer) {
            this.schema = (this._footer = this._readFooter()).schema;
            try {
                for (var _b = __WEBPACK_IMPORTED_MODULE_0_tslib__["k" /* __values */](this._footer.dictionaryBatches()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var block = _c.value;
                    block && this._readDictionaryBatch(this._dictionaryIndex++);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return _super.prototype.open.call(this, options);
    };
    RecordBatchFileReaderImpl.prototype.readRecordBatch = function (index) {
        if (this.closed) {
            return null;
        }
        if (!this._footer) {
            this.open();
        }
        var block = this._footer && this._footer.getRecordBatch(index);
        if (block && this._handle.seek(block.offset)) {
            var message = this._reader.readMessage(__WEBPACK_IMPORTED_MODULE_2__enum__["MessageHeader"].RecordBatch);
            if (message && message.isRecordBatch()) {
                var header = message.header();
                var buffer = this._reader.readMessageBody(message.bodyLength);
                var recordBatch = this._loadRecordBatch(header, buffer);
                return recordBatch;
            }
        }
        return null;
    };
    RecordBatchFileReaderImpl.prototype._readDictionaryBatch = function (index) {
        var block = this._footer && this._footer.getDictionaryBatch(index);
        if (block && this._handle.seek(block.offset)) {
            var message = this._reader.readMessage(__WEBPACK_IMPORTED_MODULE_2__enum__["MessageHeader"].DictionaryBatch);
            if (message && message.isDictionaryBatch()) {
                var header = message.header();
                var buffer = this._reader.readMessageBody(message.bodyLength);
                var vector = this._loadDictionaryBatch(header, buffer);
                this.dictionaries.set(header.id, vector);
            }
        }
    };
    RecordBatchFileReaderImpl.prototype._readFooter = function () {
        var _handle = this._handle;
        var offset = _handle.size - __WEBPACK_IMPORTED_MODULE_10__message__["f" /* magicAndPadding */];
        var length = _handle.readInt32(offset);
        var buffer = _handle.readAt(offset - length, length);
        return __WEBPACK_IMPORTED_MODULE_3__metadata_file__["b" /* Footer */].decode(buffer);
    };
    RecordBatchFileReaderImpl.prototype._readNextMessageAndValidate = function (type) {
        if (!this._footer) {
            this.open();
        }
        if (this._footer && this._recordBatchIndex < this.numRecordBatches) {
            var block = this._footer && this._footer.getRecordBatch(this._recordBatchIndex);
            if (block && this._handle.seek(block.offset)) {
                return this._reader.readMessage(type);
            }
        }
        return null;
    };
    return RecordBatchFileReaderImpl;
}(RecordBatchStreamReaderImpl));
/** @ignore */
var AsyncRecordBatchFileReaderImpl = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](AsyncRecordBatchFileReaderImpl, _super);
    function AsyncRecordBatchFileReaderImpl(source) {
        var rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            rest[_i - 1] = arguments[_i];
        }
        var _this = this;
        var byteLength = typeof rest[0] !== 'number' ? rest.shift() : undefined;
        var dictionaries = rest[0] instanceof Map ? rest.shift() : undefined;
        _this = _super.call(this, source instanceof __WEBPACK_IMPORTED_MODULE_7__io_file__["a" /* AsyncRandomAccessFile */] ? source : new __WEBPACK_IMPORTED_MODULE_7__io_file__["a" /* AsyncRandomAccessFile */](source, byteLength), dictionaries) || this;
        return _this;
    }
    Object.defineProperty(AsyncRecordBatchFileReaderImpl.prototype, "footer", {
        get: function () { return this._footer; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AsyncRecordBatchFileReaderImpl.prototype, "numDictionaries", {
        get: function () { return this._footer ? this._footer.numDictionaries : 0; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AsyncRecordBatchFileReaderImpl.prototype, "numRecordBatches", {
        get: function () { return this._footer ? this._footer.numRecordBatches : 0; },
        enumerable: true,
        configurable: true
    });
    AsyncRecordBatchFileReaderImpl.prototype.isFile = function () { return true; };
    AsyncRecordBatchFileReaderImpl.prototype.isAsync = function () { return true; };
    AsyncRecordBatchFileReaderImpl.prototype.open = function (options) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () {
            var e_2, _a, _b, _c, _d, _e, block, _f, e_2_1;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_g) {
                switch (_g.label) {
                    case 0:
                        if (!(!this.closed && !this._footer)) return [3 /*break*/, 10];
                        _b = this;
                        _c = this;
                        return [4 /*yield*/, this._readFooter()];
                    case 1:
                        _b.schema = (_c._footer = _g.sent()).schema;
                        _g.label = 2;
                    case 2:
                        _g.trys.push([2, 8, 9, 10]);
                        _d = __WEBPACK_IMPORTED_MODULE_0_tslib__["k" /* __values */](this._footer.dictionaryBatches()), _e = _d.next();
                        _g.label = 3;
                    case 3:
                        if (!!_e.done) return [3 /*break*/, 7];
                        block = _e.value;
                        _f = block;
                        if (!_f) return [3 /*break*/, 5];
                        return [4 /*yield*/, this._readDictionaryBatch(this._dictionaryIndex++)];
                    case 4:
                        _f = (_g.sent());
                        _g.label = 5;
                    case 5:
                        _f;
                        _g.label = 6;
                    case 6:
                        _e = _d.next();
                        return [3 /*break*/, 3];
                    case 7: return [3 /*break*/, 10];
                    case 8:
                        e_2_1 = _g.sent();
                        e_2 = { error: e_2_1 };
                        return [3 /*break*/, 10];
                    case 9:
                        try {
                            if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                        }
                        finally { if (e_2) throw e_2.error; }
                        return [7 /*endfinally*/];
                    case 10: return [4 /*yield*/, _super.prototype.open.call(this, options)];
                    case 11: return [2 /*return*/, _g.sent()];
                }
            });
        });
    };
    AsyncRecordBatchFileReaderImpl.prototype.readRecordBatch = function (index) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () {
            var block, _a, message, header, buffer, recordBatch;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.closed) {
                            return [2 /*return*/, null];
                        }
                        if (!!this._footer) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.open()];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        block = this._footer && this._footer.getRecordBatch(index);
                        _a = block;
                        if (!_a) return [3 /*break*/, 4];
                        return [4 /*yield*/, this._handle.seek(block.offset)];
                    case 3:
                        _a = (_b.sent());
                        _b.label = 4;
                    case 4:
                        if (!_a) return [3 /*break*/, 7];
                        return [4 /*yield*/, this._reader.readMessage(__WEBPACK_IMPORTED_MODULE_2__enum__["MessageHeader"].RecordBatch)];
                    case 5:
                        message = _b.sent();
                        if (!(message && message.isRecordBatch())) return [3 /*break*/, 7];
                        header = message.header();
                        return [4 /*yield*/, this._reader.readMessageBody(message.bodyLength)];
                    case 6:
                        buffer = _b.sent();
                        recordBatch = this._loadRecordBatch(header, buffer);
                        return [2 /*return*/, recordBatch];
                    case 7: return [2 /*return*/, null];
                }
            });
        });
    };
    AsyncRecordBatchFileReaderImpl.prototype._readDictionaryBatch = function (index) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () {
            var block, _a, message, header, buffer, vector;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_b) {
                switch (_b.label) {
                    case 0:
                        block = this._footer && this._footer.getDictionaryBatch(index);
                        _a = block;
                        if (!_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._handle.seek(block.offset)];
                    case 1:
                        _a = (_b.sent());
                        _b.label = 2;
                    case 2:
                        if (!_a) return [3 /*break*/, 5];
                        return [4 /*yield*/, this._reader.readMessage(__WEBPACK_IMPORTED_MODULE_2__enum__["MessageHeader"].DictionaryBatch)];
                    case 3:
                        message = _b.sent();
                        if (!(message && message.isDictionaryBatch())) return [3 /*break*/, 5];
                        header = message.header();
                        return [4 /*yield*/, this._reader.readMessageBody(message.bodyLength)];
                    case 4:
                        buffer = _b.sent();
                        vector = this._loadDictionaryBatch(header, buffer);
                        this.dictionaries.set(header.id, vector);
                        _b.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    AsyncRecordBatchFileReaderImpl.prototype._readFooter = function () {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () {
            var _handle, _a, offset, length, buffer;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _handle = this._handle;
                        _a = _handle._pending;
                        if (!_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, _handle._pending];
                    case 1:
                        _a = (_b.sent());
                        _b.label = 2;
                    case 2:
                        _a;
                        offset = _handle.size - __WEBPACK_IMPORTED_MODULE_10__message__["f" /* magicAndPadding */];
                        return [4 /*yield*/, _handle.readInt32(offset)];
                    case 3:
                        length = _b.sent();
                        return [4 /*yield*/, _handle.readAt(offset - length, length)];
                    case 4:
                        buffer = _b.sent();
                        return [2 /*return*/, __WEBPACK_IMPORTED_MODULE_3__metadata_file__["b" /* Footer */].decode(buffer)];
                }
            });
        });
    };
    AsyncRecordBatchFileReaderImpl.prototype._readNextMessageAndValidate = function (type) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () {
            var block, _a;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this._footer) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.open()];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        if (!(this._footer && this._recordBatchIndex < this.numRecordBatches)) return [3 /*break*/, 6];
                        block = this._footer.getRecordBatch(this._recordBatchIndex);
                        _a = block;
                        if (!_a) return [3 /*break*/, 4];
                        return [4 /*yield*/, this._handle.seek(block.offset)];
                    case 3:
                        _a = (_b.sent());
                        _b.label = 4;
                    case 4:
                        if (!_a) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._reader.readMessage(type)];
                    case 5: return [2 /*return*/, _b.sent()];
                    case 6: return [2 /*return*/, null];
                }
            });
        });
    };
    return AsyncRecordBatchFileReaderImpl;
}(AsyncRecordBatchStreamReaderImpl));
/** @ignore */
var RecordBatchJSONReaderImpl = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](RecordBatchJSONReaderImpl, _super);
    function RecordBatchJSONReaderImpl(source, dictionaries) {
        return _super.call(this, source, dictionaries) || this;
    }
    RecordBatchJSONReaderImpl.prototype._loadVectors = function (header, body, types) {
        return new __WEBPACK_IMPORTED_MODULE_8__visitor_vectorloader__["a" /* JSONVectorLoader */](body, header.nodes, header.buffers).visitMany(types);
    };
    return RecordBatchJSONReaderImpl;
}(RecordBatchStreamReaderImpl));
//
// Define some helper functions and static implementations down here. There's
// a bit of branching in the static methods that can lead to the same routines
// being executed, so we've broken those out here for readability.
//
/** @ignore */
function shouldAutoDestroy(self, options) {
    return options && (typeof options['autoDestroy'] === 'boolean') ? options['autoDestroy'] : self['autoDestroy'];
}
/** @ignore */
function readAllSync(source) {
    var reader;
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
        switch (_a.label) {
            case 0:
                reader = RecordBatchReader.from(source);
                _a.label = 1;
            case 1:
                _a.trys.push([1, , 6, 7]);
                if (!!reader.open({ autoDestroy: false }).closed) return [3 /*break*/, 5];
                _a.label = 2;
            case 2: return [4 /*yield*/, reader];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4:
                if (!(reader.reset().open()).closed) return [3 /*break*/, 2];
                _a.label = 5;
            case 5: return [3 /*break*/, 7];
            case 6:
                reader.cancel();
                return [7 /*endfinally*/];
            case 7: return [2 /*return*/];
        }
    });
}
/** @ignore */
function readAllAsync(source) {
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __asyncGenerator */](this, arguments, function readAllAsync_1() {
        var reader;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __await */](RecordBatchReader.from(source))];
                case 1:
                    reader = _a.sent();
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, , 10, 12]);
                    return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __await */](reader.open({ autoDestroy: false }))];
                case 3:
                    if (!!(_a.sent()).closed) return [3 /*break*/, 9];
                    _a.label = 4;
                case 4: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __await */](reader)];
                case 5: return [4 /*yield*/, _a.sent()];
                case 6:
                    _a.sent();
                    _a.label = 7;
                case 7: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __await */](reader.reset().open())];
                case 8:
                    if (!(_a.sent()).closed) return [3 /*break*/, 4];
                    _a.label = 9;
                case 9: return [3 /*break*/, 12];
                case 10: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __await */](reader.cancel())];
                case 11:
                    _a.sent();
                    return [7 /*endfinally*/];
                case 12: return [2 /*return*/];
            }
        });
    });
}
/** @ignore */
function fromArrowJSON(source) {
    return new RecordBatchStreamReader(new RecordBatchJSONReaderImpl(source));
}
/** @ignore */
function fromByteStream(source) {
    var bytes = source.peek((__WEBPACK_IMPORTED_MODULE_10__message__["g" /* magicLength */] + 7) & ~7);
    return bytes && bytes.byteLength >= 4 ? !Object(__WEBPACK_IMPORTED_MODULE_10__message__["e" /* checkForMagicArrowString */])(bytes)
        ? new RecordBatchStreamReader(new RecordBatchStreamReaderImpl(source))
        : new RecordBatchFileReader(new RecordBatchFileReaderImpl(source.read()))
        : new RecordBatchStreamReader(new RecordBatchStreamReaderImpl(function () { return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
            return [2 /*return*/];
        }); }()));
}
/** @ignore */
function fromAsyncByteStream(source) {
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () {
        var bytes, _a, _b, _c, _d;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, source.peek((__WEBPACK_IMPORTED_MODULE_10__message__["g" /* magicLength */] + 7) & ~7)];
                case 1:
                    bytes = _e.sent();
                    if (!(bytes && bytes.byteLength >= 4)) return [3 /*break*/, 5];
                    if (!!Object(__WEBPACK_IMPORTED_MODULE_10__message__["e" /* checkForMagicArrowString */])(bytes)) return [3 /*break*/, 2];
                    _b = new AsyncRecordBatchStreamReader(new AsyncRecordBatchStreamReaderImpl(source));
                    return [3 /*break*/, 4];
                case 2:
                    _c = RecordBatchFileReader.bind;
                    _d = RecordBatchFileReaderImpl.bind;
                    return [4 /*yield*/, source.read()];
                case 3:
                    _b = new (_c.apply(RecordBatchFileReader, [void 0, new (_d.apply(RecordBatchFileReaderImpl, [void 0, _e.sent()]))()]))();
                    _e.label = 4;
                case 4:
                    _a = _b;
                    return [3 /*break*/, 6];
                case 5:
                    _a = new AsyncRecordBatchStreamReader(new AsyncRecordBatchStreamReaderImpl(function () { return __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __asyncGenerator */](this, arguments, function () { return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
                        return [2 /*return*/];
                    }); }); }()));
                    _e.label = 6;
                case 6: return [2 /*return*/, _a];
            }
        });
    });
}
/** @ignore */
function fromFileHandle(source) {
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () {
        var size, file, _a;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, source.stat()];
                case 1:
                    size = (_b.sent()).size;
                    file = new __WEBPACK_IMPORTED_MODULE_7__io_file__["a" /* AsyncRandomAccessFile */](source, size);
                    if (!(size >= __WEBPACK_IMPORTED_MODULE_10__message__["h" /* magicX2AndPadding */])) return [3 /*break*/, 3];
                    _a = __WEBPACK_IMPORTED_MODULE_10__message__["e" /* checkForMagicArrowString */];
                    return [4 /*yield*/, file.readAt(0, (__WEBPACK_IMPORTED_MODULE_10__message__["g" /* magicLength */] + 7) & ~7)];
                case 2:
                    if (_a.apply(void 0, [_b.sent()])) {
                        return [2 /*return*/, new AsyncRecordBatchFileReader(new AsyncRecordBatchFileReaderImpl(file))];
                    }
                    _b.label = 3;
                case 3: return [2 /*return*/, new AsyncRecordBatchStreamReader(new AsyncRecordBatchStreamReaderImpl(file))];
            }
        });
    });
}



/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return org; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Schema__ = __webpack_require__(46);
// automatically generated by the FlatBuffers compiler, do not modify

/**
 * ----------------------------------------------------------------------
 * Arrow File metadata
 *
 *
 * @constructor
 */
var org;
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var Footer = /** @class */ (function () {
                    function Footer() {
                        /**
                         * @type {number}
                         */
                        this.bb_pos = 0;
                    }
                    /**
                     * @param {number} i
                     * @param {flatbuffers.ByteBuffer} bb
                     * @returns {Footer}
                     */
                    Footer.prototype.__init = function (i, bb) {
                        this.bb_pos = i;
                        this.bb = bb;
                        return this;
                    };
                    /**
                     * @param {flatbuffers.ByteBuffer} bb
                     * @param {Footer=} obj
                     * @returns {Footer}
                     */
                    Footer.getRootAsFooter = function (bb, obj) {
                        return (obj || new Footer).__init(bb.readInt32(bb.position()) + bb.position(), bb);
                    };
                    /**
                     * @returns {org.apache.arrow.flatbuf.MetadataVersion}
                     */
                    Footer.prototype.version = function () {
                        var offset = this.bb.__offset(this.bb_pos, 4);
                        return offset ? /** @type {org.apache.arrow.flatbuf.MetadataVersion} */ (this.bb.readInt16(this.bb_pos + offset)) : __WEBPACK_IMPORTED_MODULE_0__Schema__["a" /* org */].apache.arrow.flatbuf.MetadataVersion.V1;
                    };
                    /**
                     * @param {org.apache.arrow.flatbuf.Schema=} obj
                     * @returns {org.apache.arrow.flatbuf.Schema|null}
                     */
                    Footer.prototype.schema = function (obj) {
                        var offset = this.bb.__offset(this.bb_pos, 6);
                        return offset ? (obj || new __WEBPACK_IMPORTED_MODULE_0__Schema__["a" /* org */].apache.arrow.flatbuf.Schema).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
                    };
                    /**
                     * @param {number} index
                     * @param {org.apache.arrow.flatbuf.Block=} obj
                     * @returns {org.apache.arrow.flatbuf.Block}
                     */
                    Footer.prototype.dictionaries = function (index, obj) {
                        var offset = this.bb.__offset(this.bb_pos, 8);
                        return offset ? (obj || new org.apache.arrow.flatbuf.Block).__init(this.bb.__vector(this.bb_pos + offset) + index * 24, this.bb) : null;
                    };
                    /**
                     * @returns {number}
                     */
                    Footer.prototype.dictionariesLength = function () {
                        var offset = this.bb.__offset(this.bb_pos, 8);
                        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
                    };
                    /**
                     * @param {number} index
                     * @param {org.apache.arrow.flatbuf.Block=} obj
                     * @returns {org.apache.arrow.flatbuf.Block}
                     */
                    Footer.prototype.recordBatches = function (index, obj) {
                        var offset = this.bb.__offset(this.bb_pos, 10);
                        return offset ? (obj || new org.apache.arrow.flatbuf.Block).__init(this.bb.__vector(this.bb_pos + offset) + index * 24, this.bb) : null;
                    };
                    /**
                     * @returns {number}
                     */
                    Footer.prototype.recordBatchesLength = function () {
                        var offset = this.bb.__offset(this.bb_pos, 10);
                        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     */
                    Footer.startFooter = function (builder) {
                        builder.startObject(4);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {org.apache.arrow.flatbuf.MetadataVersion} version
                     */
                    Footer.addVersion = function (builder, version) {
                        builder.addFieldInt16(0, version, __WEBPACK_IMPORTED_MODULE_0__Schema__["a" /* org */].apache.arrow.flatbuf.MetadataVersion.V1);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {flatbuffers.Offset} schemaOffset
                     */
                    Footer.addSchema = function (builder, schemaOffset) {
                        builder.addFieldOffset(1, schemaOffset, 0);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {flatbuffers.Offset} dictionariesOffset
                     */
                    Footer.addDictionaries = function (builder, dictionariesOffset) {
                        builder.addFieldOffset(2, dictionariesOffset, 0);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {number} numElems
                     */
                    Footer.startDictionariesVector = function (builder, numElems) {
                        builder.startVector(24, numElems, 8);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {flatbuffers.Offset} recordBatchesOffset
                     */
                    Footer.addRecordBatches = function (builder, recordBatchesOffset) {
                        builder.addFieldOffset(3, recordBatchesOffset, 0);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {number} numElems
                     */
                    Footer.startRecordBatchesVector = function (builder, numElems) {
                        builder.startVector(24, numElems, 8);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @returns {flatbuffers.Offset}
                     */
                    Footer.endFooter = function (builder) {
                        var offset = builder.endObject();
                        return offset;
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {flatbuffers.Offset} offset
                     */
                    Footer.finishFooterBuffer = function (builder, offset) {
                        builder.finish(offset);
                    };
                    return Footer;
                }());
                flatbuf.Footer = Footer;
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));
/**
 * @constructor
 */
(function (org) {
    var apache;
    (function (apache) {
        var arrow;
        (function (arrow) {
            var flatbuf;
            (function (flatbuf) {
                var Block = /** @class */ (function () {
                    function Block() {
                        /**
                         * @type {number}
                         */
                        this.bb_pos = 0;
                    }
                    /**
                     * @param {number} i
                     * @param {flatbuffers.ByteBuffer} bb
                     * @returns {Block}
                     */
                    Block.prototype.__init = function (i, bb) {
                        this.bb_pos = i;
                        this.bb = bb;
                        return this;
                    };
                    /**
                     * Index to the start of the RecordBlock (note this is past the Message header)
                     *
                     * @returns {flatbuffers.Long}
                     */
                    Block.prototype.offset = function () {
                        return this.bb.readInt64(this.bb_pos);
                    };
                    /**
                     * Length of the metadata
                     *
                     * @returns {number}
                     */
                    Block.prototype.metaDataLength = function () {
                        return this.bb.readInt32(this.bb_pos + 8);
                    };
                    /**
                     * Length of the data (this is aligned so there can be a gap between this and
                     * the metatdata).
                     *
                     * @returns {flatbuffers.Long}
                     */
                    Block.prototype.bodyLength = function () {
                        return this.bb.readInt64(this.bb_pos + 16);
                    };
                    /**
                     * @param {flatbuffers.Builder} builder
                     * @param {flatbuffers.Long} offset
                     * @param {number} metaDataLength
                     * @param {flatbuffers.Long} bodyLength
                     * @returns {flatbuffers.Offset}
                     */
                    Block.createBlock = function (builder, offset, metaDataLength, bodyLength) {
                        builder.prep(8, 24);
                        builder.writeInt64(bodyLength);
                        builder.pad(4);
                        builder.writeInt32(metaDataLength);
                        builder.writeInt64(offset);
                        return builder.offset();
                    };
                    return Block;
                }());
                flatbuf.Block = Block;
            })(flatbuf = arrow.flatbuf || (arrow.flatbuf = {}));
        })(arrow = apache.arrow || (apache.arrow = {}));
    })(apache = org.apache || (org.apache = {}));
})(org || (org = {}));



/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VectorLoader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return JSONVectorLoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__schema__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__type__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__visitor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_bit__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_utf8__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_int__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__enum__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_buffer__ = __webpack_require__(11);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.










var VectorLoader = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](VectorLoader, _super);
    function VectorLoader(bytes, nodes, buffers) {
        var _this = _super.call(this) || this;
        _this.nodesIndex = -1;
        _this.buffersIndex = -1;
        _this.bytes = bytes;
        _this.nodes = nodes;
        _this.buffers = buffers;
        return _this;
    }
    VectorLoader.prototype.visit = function (node) {
        return _super.prototype.visit.call(this, node instanceof __WEBPACK_IMPORTED_MODULE_2__schema__["a" /* Field */] ? node.type : node);
    };
    VectorLoader.prototype.visitNull = function (type, _a) {
        var _b = _a === void 0 ? this.nextFieldNode() : _a, length = _b.length, nullCount = _b.nullCount;
        return __WEBPACK_IMPORTED_MODULE_1__data__["Data"].Null(type, 0, length, nullCount, this.readNullBitmap(type, nullCount));
    };
    VectorLoader.prototype.visitBool = function (type, _a) {
        var _b = _a === void 0 ? this.nextFieldNode() : _a, length = _b.length, nullCount = _b.nullCount;
        return __WEBPACK_IMPORTED_MODULE_1__data__["Data"].Bool(type, 0, length, nullCount, this.readNullBitmap(type, nullCount), this.readData(type));
    };
    VectorLoader.prototype.visitInt = function (type, _a) {
        var _b = _a === void 0 ? this.nextFieldNode() : _a, length = _b.length, nullCount = _b.nullCount;
        return __WEBPACK_IMPORTED_MODULE_1__data__["Data"].Int(type, 0, length, nullCount, this.readNullBitmap(type, nullCount), this.readData(type));
    };
    VectorLoader.prototype.visitFloat = function (type, _a) {
        var _b = _a === void 0 ? this.nextFieldNode() : _a, length = _b.length, nullCount = _b.nullCount;
        return __WEBPACK_IMPORTED_MODULE_1__data__["Data"].Float(type, 0, length, nullCount, this.readNullBitmap(type, nullCount), this.readData(type));
    };
    VectorLoader.prototype.visitUtf8 = function (type, _a) {
        var _b = _a === void 0 ? this.nextFieldNode() : _a, length = _b.length, nullCount = _b.nullCount;
        return __WEBPACK_IMPORTED_MODULE_1__data__["Data"].Utf8(type, 0, length, nullCount, this.readNullBitmap(type, nullCount), this.readOffsets(type), this.readData(type));
    };
    VectorLoader.prototype.visitBinary = function (type, _a) {
        var _b = _a === void 0 ? this.nextFieldNode() : _a, length = _b.length, nullCount = _b.nullCount;
        return __WEBPACK_IMPORTED_MODULE_1__data__["Data"].Binary(type, 0, length, nullCount, this.readNullBitmap(type, nullCount), this.readOffsets(type), this.readData(type));
    };
    VectorLoader.prototype.visitFixedSizeBinary = function (type, _a) {
        var _b = _a === void 0 ? this.nextFieldNode() : _a, length = _b.length, nullCount = _b.nullCount;
        return __WEBPACK_IMPORTED_MODULE_1__data__["Data"].FixedSizeBinary(type, 0, length, nullCount, this.readNullBitmap(type, nullCount), this.readData(type));
    };
    VectorLoader.prototype.visitDate = function (type, _a) {
        var _b = _a === void 0 ? this.nextFieldNode() : _a, length = _b.length, nullCount = _b.nullCount;
        return __WEBPACK_IMPORTED_MODULE_1__data__["Data"].Date(type, 0, length, nullCount, this.readNullBitmap(type, nullCount), this.readData(type));
    };
    VectorLoader.prototype.visitTimestamp = function (type, _a) {
        var _b = _a === void 0 ? this.nextFieldNode() : _a, length = _b.length, nullCount = _b.nullCount;
        return __WEBPACK_IMPORTED_MODULE_1__data__["Data"].Timestamp(type, 0, length, nullCount, this.readNullBitmap(type, nullCount), this.readData(type));
    };
    VectorLoader.prototype.visitTime = function (type, _a) {
        var _b = _a === void 0 ? this.nextFieldNode() : _a, length = _b.length, nullCount = _b.nullCount;
        return __WEBPACK_IMPORTED_MODULE_1__data__["Data"].Time(type, 0, length, nullCount, this.readNullBitmap(type, nullCount), this.readData(type));
    };
    VectorLoader.prototype.visitDecimal = function (type, _a) {
        var _b = _a === void 0 ? this.nextFieldNode() : _a, length = _b.length, nullCount = _b.nullCount;
        return __WEBPACK_IMPORTED_MODULE_1__data__["Data"].Decimal(type, 0, length, nullCount, this.readNullBitmap(type, nullCount), this.readData(type));
    };
    VectorLoader.prototype.visitList = function (type, _a) {
        var _b = _a === void 0 ? this.nextFieldNode() : _a, length = _b.length, nullCount = _b.nullCount;
        return __WEBPACK_IMPORTED_MODULE_1__data__["Data"].List(type, 0, length, nullCount, this.readNullBitmap(type, nullCount), this.readOffsets(type), this.visit(type.children[0]));
    };
    VectorLoader.prototype.visitStruct = function (type, _a) {
        var _b = _a === void 0 ? this.nextFieldNode() : _a, length = _b.length, nullCount = _b.nullCount;
        return __WEBPACK_IMPORTED_MODULE_1__data__["Data"].Struct(type, 0, length, nullCount, this.readNullBitmap(type, nullCount), this.visitMany(type.children));
    };
    VectorLoader.prototype.visitUnion = function (type) { return type.mode === __WEBPACK_IMPORTED_MODULE_8__enum__["UnionMode"].Sparse ? this.visitSparseUnion(type) : this.visitDenseUnion(type); };
    VectorLoader.prototype.visitDenseUnion = function (type, _a) {
        var _b = _a === void 0 ? this.nextFieldNode() : _a, length = _b.length, nullCount = _b.nullCount;
        return __WEBPACK_IMPORTED_MODULE_1__data__["Data"].Union(type, 0, length, nullCount, this.readNullBitmap(type, nullCount), this.readTypeIds(type), this.readOffsets(type), this.visitMany(type.children));
    };
    VectorLoader.prototype.visitSparseUnion = function (type, _a) {
        var _b = _a === void 0 ? this.nextFieldNode() : _a, length = _b.length, nullCount = _b.nullCount;
        return __WEBPACK_IMPORTED_MODULE_1__data__["Data"].Union(type, 0, length, nullCount, this.readNullBitmap(type, nullCount), this.readTypeIds(type), this.visitMany(type.children));
    };
    VectorLoader.prototype.visitDictionary = function (type, _a) {
        var _b = _a === void 0 ? this.nextFieldNode() : _a, length = _b.length, nullCount = _b.nullCount;
        return __WEBPACK_IMPORTED_MODULE_1__data__["Data"].Dictionary(type, 0, length, nullCount, this.readNullBitmap(type, nullCount), this.readData(type.indices));
    };
    VectorLoader.prototype.visitInterval = function (type, _a) {
        var _b = _a === void 0 ? this.nextFieldNode() : _a, length = _b.length, nullCount = _b.nullCount;
        return __WEBPACK_IMPORTED_MODULE_1__data__["Data"].Interval(type, 0, length, nullCount, this.readNullBitmap(type, nullCount), this.readData(type));
    };
    VectorLoader.prototype.visitFixedSizeList = function (type, _a) {
        var _b = _a === void 0 ? this.nextFieldNode() : _a, length = _b.length, nullCount = _b.nullCount;
        return __WEBPACK_IMPORTED_MODULE_1__data__["Data"].FixedSizeList(type, 0, length, nullCount, this.readNullBitmap(type, nullCount), this.visit(type.children[0]));
    };
    VectorLoader.prototype.visitMap = function (type, _a) {
        var _b = _a === void 0 ? this.nextFieldNode() : _a, length = _b.length, nullCount = _b.nullCount;
        return __WEBPACK_IMPORTED_MODULE_1__data__["Data"].Map(type, 0, length, nullCount, this.readNullBitmap(type, nullCount), this.visitMany(type.children));
    };
    VectorLoader.prototype.nextFieldNode = function () { return this.nodes[++this.nodesIndex]; };
    VectorLoader.prototype.nextBufferRange = function () { return this.buffers[++this.buffersIndex]; };
    VectorLoader.prototype.readNullBitmap = function (type, nullCount, buffer) {
        if (buffer === void 0) { buffer = this.nextBufferRange(); }
        return nullCount > 0 && this.readData(type, buffer) || new Uint8Array(0);
    };
    VectorLoader.prototype.readOffsets = function (type, buffer) { return this.readData(type, buffer); };
    VectorLoader.prototype.readTypeIds = function (type, buffer) { return this.readData(type, buffer); };
    VectorLoader.prototype.readData = function (_type, _a) {
        var _b = _a === void 0 ? this.nextBufferRange() : _a, length = _b.length, offset = _b.offset;
        return this.bytes.subarray(offset, offset + length);
    };
    return VectorLoader;
}(__WEBPACK_IMPORTED_MODULE_4__visitor__["Visitor"]));

var JSONVectorLoader = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](JSONVectorLoader, _super);
    function JSONVectorLoader(sources, nodes, buffers) {
        var _this = _super.call(this, new Uint8Array(0), nodes, buffers) || this;
        _this.sources = sources;
        return _this;
    }
    JSONVectorLoader.prototype.readNullBitmap = function (_type, nullCount, _a) {
        var offset = (_a === void 0 ? this.nextBufferRange() : _a).offset;
        return nullCount <= 0 ? new Uint8Array(0) : Object(__WEBPACK_IMPORTED_MODULE_5__util_bit__["d" /* packBools */])(this.sources[offset]);
    };
    JSONVectorLoader.prototype.readOffsets = function (_type, _a) {
        var offset = (_a === void 0 ? this.nextBufferRange() : _a).offset;
        return Object(__WEBPACK_IMPORTED_MODULE_9__util_buffer__["d" /* toArrayBufferView */])(Uint8Array, Object(__WEBPACK_IMPORTED_MODULE_9__util_buffer__["d" /* toArrayBufferView */])(Int32Array, this.sources[offset]));
    };
    JSONVectorLoader.prototype.readTypeIds = function (type, _a) {
        var offset = (_a === void 0 ? this.nextBufferRange() : _a).offset;
        return Object(__WEBPACK_IMPORTED_MODULE_9__util_buffer__["d" /* toArrayBufferView */])(Uint8Array, Object(__WEBPACK_IMPORTED_MODULE_9__util_buffer__["d" /* toArrayBufferView */])(type.ArrayType, this.sources[offset]));
    };
    JSONVectorLoader.prototype.readData = function (type, _a) {
        var offset = (_a === void 0 ? this.nextBufferRange() : _a).offset;
        var sources = this.sources;
        if (__WEBPACK_IMPORTED_MODULE_3__type__["DataType"].isTimestamp(type)) {
            return Object(__WEBPACK_IMPORTED_MODULE_9__util_buffer__["d" /* toArrayBufferView */])(Uint8Array, __WEBPACK_IMPORTED_MODULE_7__util_int__["b" /* Int64 */].convertArray(sources[offset]));
        }
        else if ((__WEBPACK_IMPORTED_MODULE_3__type__["DataType"].isInt(type) || __WEBPACK_IMPORTED_MODULE_3__type__["DataType"].isTime(type)) && type.bitWidth === 64) {
            return Object(__WEBPACK_IMPORTED_MODULE_9__util_buffer__["d" /* toArrayBufferView */])(Uint8Array, __WEBPACK_IMPORTED_MODULE_7__util_int__["b" /* Int64 */].convertArray(sources[offset]));
        }
        else if (__WEBPACK_IMPORTED_MODULE_3__type__["DataType"].isDate(type) && type.unit === __WEBPACK_IMPORTED_MODULE_8__enum__["DateUnit"].MILLISECOND) {
            return Object(__WEBPACK_IMPORTED_MODULE_9__util_buffer__["d" /* toArrayBufferView */])(Uint8Array, __WEBPACK_IMPORTED_MODULE_7__util_int__["b" /* Int64 */].convertArray(sources[offset]));
        }
        else if (__WEBPACK_IMPORTED_MODULE_3__type__["DataType"].isDecimal(type)) {
            return Object(__WEBPACK_IMPORTED_MODULE_9__util_buffer__["d" /* toArrayBufferView */])(Uint8Array, __WEBPACK_IMPORTED_MODULE_7__util_int__["a" /* Int128 */].convertArray(sources[offset]));
        }
        else if (__WEBPACK_IMPORTED_MODULE_3__type__["DataType"].isBinary(type) || __WEBPACK_IMPORTED_MODULE_3__type__["DataType"].isFixedSizeBinary(type)) {
            return binaryDataFromJSON(sources[offset]);
        }
        else if (__WEBPACK_IMPORTED_MODULE_3__type__["DataType"].isBool(type)) {
            return Object(__WEBPACK_IMPORTED_MODULE_5__util_bit__["d" /* packBools */])(sources[offset]);
        }
        else if (__WEBPACK_IMPORTED_MODULE_3__type__["DataType"].isUtf8(type)) {
            return Object(__WEBPACK_IMPORTED_MODULE_6__util_utf8__["b" /* encodeUtf8 */])(sources[offset].join(''));
        }
        return Object(__WEBPACK_IMPORTED_MODULE_9__util_buffer__["d" /* toArrayBufferView */])(Uint8Array, Object(__WEBPACK_IMPORTED_MODULE_9__util_buffer__["d" /* toArrayBufferView */])(type.ArrayType, sources[offset].map(function (x) { return +x; })));
    };
    return JSONVectorLoader;
}(VectorLoader));

/** @ignore */
function binaryDataFromJSON(values) {
    // "DATA": ["49BC7D5B6C47D2","3F5FB6D9322026"]
    // There are definitely more efficient ways to do this... but it gets the
    // job done.
    var joined = values.join('');
    var data = new Uint8Array(joined.length / 2);
    for (var i = 0; i < joined.length; i += 2) {
        data[i >> 1] = parseInt(joined.substr(i, 2), 16);
    }
    return data;
}



/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TypeAssembler */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return instance; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_flatbuffers__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fb_Schema__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__visitor__ = __webpack_require__(12);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.


var Long = __WEBPACK_IMPORTED_MODULE_1_flatbuffers__["a" /* flatbuffers */].Long;


var Null = __WEBPACK_IMPORTED_MODULE_2__fb_Schema__["a" /* org */].apache.arrow.flatbuf.Null;
var Int = __WEBPACK_IMPORTED_MODULE_2__fb_Schema__["a" /* org */].apache.arrow.flatbuf.Int;
var FloatingPoint = __WEBPACK_IMPORTED_MODULE_2__fb_Schema__["a" /* org */].apache.arrow.flatbuf.FloatingPoint;
var Binary = __WEBPACK_IMPORTED_MODULE_2__fb_Schema__["a" /* org */].apache.arrow.flatbuf.Binary;
var Bool = __WEBPACK_IMPORTED_MODULE_2__fb_Schema__["a" /* org */].apache.arrow.flatbuf.Bool;
var Utf8 = __WEBPACK_IMPORTED_MODULE_2__fb_Schema__["a" /* org */].apache.arrow.flatbuf.Utf8;
var Decimal = __WEBPACK_IMPORTED_MODULE_2__fb_Schema__["a" /* org */].apache.arrow.flatbuf.Decimal;
var Date = __WEBPACK_IMPORTED_MODULE_2__fb_Schema__["a" /* org */].apache.arrow.flatbuf.Date;
var Time = __WEBPACK_IMPORTED_MODULE_2__fb_Schema__["a" /* org */].apache.arrow.flatbuf.Time;
var Timestamp = __WEBPACK_IMPORTED_MODULE_2__fb_Schema__["a" /* org */].apache.arrow.flatbuf.Timestamp;
var Interval = __WEBPACK_IMPORTED_MODULE_2__fb_Schema__["a" /* org */].apache.arrow.flatbuf.Interval;
var List = __WEBPACK_IMPORTED_MODULE_2__fb_Schema__["a" /* org */].apache.arrow.flatbuf.List;
var Struct = __WEBPACK_IMPORTED_MODULE_2__fb_Schema__["a" /* org */].apache.arrow.flatbuf.Struct_;
var Union = __WEBPACK_IMPORTED_MODULE_2__fb_Schema__["a" /* org */].apache.arrow.flatbuf.Union;
var DictionaryEncoding = __WEBPACK_IMPORTED_MODULE_2__fb_Schema__["a" /* org */].apache.arrow.flatbuf.DictionaryEncoding;
var FixedSizeBinary = __WEBPACK_IMPORTED_MODULE_2__fb_Schema__["a" /* org */].apache.arrow.flatbuf.FixedSizeBinary;
var FixedSizeList = __WEBPACK_IMPORTED_MODULE_2__fb_Schema__["a" /* org */].apache.arrow.flatbuf.FixedSizeList;
var Map_ = __WEBPACK_IMPORTED_MODULE_2__fb_Schema__["a" /* org */].apache.arrow.flatbuf.Map;
var TypeAssembler = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](TypeAssembler, _super);
    function TypeAssembler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TypeAssembler.prototype.visit = function (node, builder) {
        return (node == null || builder == null) ? undefined : _super.prototype.visit.call(this, node, builder);
    };
    TypeAssembler.prototype.visitNull = function (_node, b) {
        Null.startNull(b);
        return Null.endNull(b);
    };
    TypeAssembler.prototype.visitInt = function (node, b) {
        Int.startInt(b);
        Int.addBitWidth(b, node.bitWidth);
        Int.addIsSigned(b, node.isSigned);
        return Int.endInt(b);
    };
    TypeAssembler.prototype.visitFloat = function (node, b) {
        FloatingPoint.startFloatingPoint(b);
        FloatingPoint.addPrecision(b, node.precision);
        return FloatingPoint.endFloatingPoint(b);
    };
    TypeAssembler.prototype.visitBinary = function (_node, b) {
        Binary.startBinary(b);
        return Binary.endBinary(b);
    };
    TypeAssembler.prototype.visitBool = function (_node, b) {
        Bool.startBool(b);
        return Bool.endBool(b);
    };
    TypeAssembler.prototype.visitUtf8 = function (_node, b) {
        Utf8.startUtf8(b);
        return Utf8.endUtf8(b);
    };
    TypeAssembler.prototype.visitDecimal = function (node, b) {
        Decimal.startDecimal(b);
        Decimal.addScale(b, node.scale);
        Decimal.addPrecision(b, node.precision);
        return Decimal.endDecimal(b);
    };
    TypeAssembler.prototype.visitDate = function (node, b) {
        Date.startDate(b);
        Date.addUnit(b, node.unit);
        return Date.endDate(b);
    };
    TypeAssembler.prototype.visitTime = function (node, b) {
        Time.startTime(b);
        Time.addUnit(b, node.unit);
        Time.addBitWidth(b, node.bitWidth);
        return Time.endTime(b);
    };
    TypeAssembler.prototype.visitTimestamp = function (node, b) {
        var timezone = (node.timezone && b.createString(node.timezone)) || undefined;
        Timestamp.startTimestamp(b);
        Timestamp.addUnit(b, node.unit);
        if (timezone !== undefined) {
            Timestamp.addTimezone(b, timezone);
        }
        return Timestamp.endTimestamp(b);
    };
    TypeAssembler.prototype.visitInterval = function (node, b) {
        Interval.startInterval(b);
        Interval.addUnit(b, node.unit);
        return Interval.endInterval(b);
    };
    TypeAssembler.prototype.visitList = function (_node, b) {
        List.startList(b);
        return List.endList(b);
    };
    TypeAssembler.prototype.visitStruct = function (_node, b) {
        Struct.startStruct_(b);
        return Struct.endStruct_(b);
    };
    TypeAssembler.prototype.visitUnion = function (node, b) {
        Union.startTypeIdsVector(b, node.typeIds.length);
        var typeIds = Union.createTypeIdsVector(b, node.typeIds);
        Union.startUnion(b);
        Union.addMode(b, node.mode);
        Union.addTypeIds(b, typeIds);
        return Union.endUnion(b);
    };
    TypeAssembler.prototype.visitDictionary = function (node, b) {
        var indexType = this.visit(node.indices, b);
        DictionaryEncoding.startDictionaryEncoding(b);
        DictionaryEncoding.addId(b, new Long(node.id, 0));
        DictionaryEncoding.addIsOrdered(b, node.isOrdered);
        if (indexType !== undefined) {
            DictionaryEncoding.addIndexType(b, indexType);
        }
        return DictionaryEncoding.endDictionaryEncoding(b);
    };
    TypeAssembler.prototype.visitFixedSizeBinary = function (node, b) {
        FixedSizeBinary.startFixedSizeBinary(b);
        FixedSizeBinary.addByteWidth(b, node.byteWidth);
        return FixedSizeBinary.endFixedSizeBinary(b);
    };
    TypeAssembler.prototype.visitFixedSizeList = function (node, b) {
        FixedSizeList.startFixedSizeList(b);
        FixedSizeList.addListSize(b, node.listSize);
        return FixedSizeList.endFixedSizeList(b);
    };
    TypeAssembler.prototype.visitMap = function (node, b) {
        Map_.startMap(b);
        Map_.addKeysSorted(b, node.keysSorted);
        return Map_.endMap(b);
    };
    return TypeAssembler;
}(__WEBPACK_IMPORTED_MODULE_3__visitor__["Visitor"]));

/** @ignore */
var instance = new TypeAssembler();



/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = schemaFromJSON;
/* harmony export (immutable) */ __webpack_exports__["c"] = recordBatchFromJSON;
/* harmony export (immutable) */ __webpack_exports__["a"] = dictionaryBatchFromJSON;
/* harmony export (immutable) */ __webpack_exports__["b"] = fieldFromJSON;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__schema__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__message__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enum__ = __webpack_require__(2);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.





/** @ignore */
function schemaFromJSON(_schema, dictionaries, dictionaryFields) {
    if (dictionaries === void 0) { dictionaries = new Map(); }
    if (dictionaryFields === void 0) { dictionaryFields = new Map(); }
    return new __WEBPACK_IMPORTED_MODULE_1__schema__["b" /* Schema */](schemaFieldsFromJSON(_schema, dictionaries, dictionaryFields), customMetadataFromJSON(_schema['customMetadata']), dictionaries, dictionaryFields);
}
/** @ignore */
function recordBatchFromJSON(b) {
    return new __WEBPACK_IMPORTED_MODULE_3__message__["e" /* RecordBatch */](b['count'], fieldNodesFromJSON(b['columns']), buffersFromJSON(b['columns']));
}
/** @ignore */
function dictionaryBatchFromJSON(b) {
    return new __WEBPACK_IMPORTED_MODULE_3__message__["b" /* DictionaryBatch */](recordBatchFromJSON(b['data']), b['id'], b['isDelta']);
}
/** @ignore */
function schemaFieldsFromJSON(_schema, dictionaries, dictionaryFields) {
    return (_schema['fields'] || []).filter(Boolean).map(function (f) { return __WEBPACK_IMPORTED_MODULE_1__schema__["a" /* Field */].fromJSON(f, dictionaries, dictionaryFields); });
}
/** @ignore */
function fieldChildrenFromJSON(_field, dictionaries, dictionaryFields) {
    return (_field['children'] || []).filter(Boolean).map(function (f) { return __WEBPACK_IMPORTED_MODULE_1__schema__["a" /* Field */].fromJSON(f, dictionaries, dictionaryFields); });
}
/** @ignore */
function fieldNodesFromJSON(xs) {
    return (xs || []).reduce(function (fieldNodes, column) { return __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](fieldNodes, [
        new __WEBPACK_IMPORTED_MODULE_3__message__["c" /* FieldNode */](column['count'], nullCountFromJSON(column['VALIDITY']))
    ], fieldNodesFromJSON(column['children'])); }, []);
}
/** @ignore */
function buffersFromJSON(xs, buffers) {
    if (buffers === void 0) { buffers = []; }
    for (var i = -1, n = (xs || []).length; ++i < n;) {
        var column = xs[i];
        column['VALIDITY'] && buffers.push(new __WEBPACK_IMPORTED_MODULE_3__message__["a" /* BufferRegion */](buffers.length, column['VALIDITY'].length));
        column['TYPE'] && buffers.push(new __WEBPACK_IMPORTED_MODULE_3__message__["a" /* BufferRegion */](buffers.length, column['TYPE'].length));
        column['OFFSET'] && buffers.push(new __WEBPACK_IMPORTED_MODULE_3__message__["a" /* BufferRegion */](buffers.length, column['OFFSET'].length));
        column['DATA'] && buffers.push(new __WEBPACK_IMPORTED_MODULE_3__message__["a" /* BufferRegion */](buffers.length, column['DATA'].length));
        buffers = buffersFromJSON(column['children'], buffers);
    }
    return buffers;
}
/** @ignore */
function nullCountFromJSON(validity) {
    return (validity || []).reduce(function (sum, val) { return sum + +(val === 0); }, 0);
}
/** @ignore */
function fieldFromJSON(_field, dictionaries, dictionaryFields) {
    var id;
    var keys;
    var field;
    var dictMeta;
    var type;
    var dictType;
    var dictField;
    // If no dictionary encoding, or in the process of decoding the children of a dictionary-encoded field
    if (!dictionaries || !dictionaryFields || !(dictMeta = _field['dictionary'])) {
        type = typeFromJSON(_field, fieldChildrenFromJSON(_field, dictionaries, dictionaryFields));
        field = new __WEBPACK_IMPORTED_MODULE_1__schema__["a" /* Field */](_field['name'], type, _field['nullable'], customMetadataFromJSON(_field['customMetadata']));
    }
    // tslint:disable
    // If dictionary encoded and the first time we've seen this dictionary id, decode
    // the data type and child fields, then wrap in a Dictionary type and insert the
    // data type into the dictionary types map.
    else if (!dictionaries.has(id = dictMeta['id'])) {
        // a dictionary index defaults to signed 32 bit int if unspecified
        keys = (keys = dictMeta['indexType']) ? indexTypeFromJSON(keys) : new __WEBPACK_IMPORTED_MODULE_2__type__["Int32"]();
        dictionaries.set(id, type = typeFromJSON(_field, fieldChildrenFromJSON(_field)));
        dictType = new __WEBPACK_IMPORTED_MODULE_2__type__["Dictionary"](type, keys, id, dictMeta['isOrdered']);
        dictField = new __WEBPACK_IMPORTED_MODULE_1__schema__["a" /* Field */](_field['name'], dictType, _field['nullable'], customMetadataFromJSON(_field['customMetadata']));
        dictionaryFields.set(id, [field = dictField]);
    }
    // If dictionary encoded, and have already seen this dictionary Id in the schema, then reuse the
    // data type and wrap in a new Dictionary type and field.
    else {
        // a dictionary index defaults to signed 32 bit int if unspecified
        keys = (keys = dictMeta['indexType']) ? indexTypeFromJSON(keys) : new __WEBPACK_IMPORTED_MODULE_2__type__["Int32"]();
        dictType = new __WEBPACK_IMPORTED_MODULE_2__type__["Dictionary"](dictionaries.get(id), keys, id, dictMeta['isOrdered']);
        dictField = new __WEBPACK_IMPORTED_MODULE_1__schema__["a" /* Field */](_field['name'], dictType, _field['nullable'], customMetadataFromJSON(_field['customMetadata']));
        dictionaryFields.get(id).push(field = dictField);
    }
    return field || null;
}
/** @ignore */
function customMetadataFromJSON(_metadata) {
    return new Map(Object.entries(_metadata || {}));
}
/** @ignore */
function indexTypeFromJSON(_type) {
    return new __WEBPACK_IMPORTED_MODULE_2__type__["Int"](_type['isSigned'], _type['bitWidth']);
}
/** @ignore */
function typeFromJSON(f, children) {
    var typeId = f['type']['name'];
    switch (typeId) {
        case 'NONE': return new __WEBPACK_IMPORTED_MODULE_2__type__["DataType"]();
        case 'null': return new __WEBPACK_IMPORTED_MODULE_2__type__["Null"]();
        case 'binary': return new __WEBPACK_IMPORTED_MODULE_2__type__["Binary"]();
        case 'utf8': return new __WEBPACK_IMPORTED_MODULE_2__type__["Utf8"]();
        case 'bool': return new __WEBPACK_IMPORTED_MODULE_2__type__["Bool"]();
        case 'list': return new __WEBPACK_IMPORTED_MODULE_2__type__["List"]((children || [])[0]);
        case 'struct': return new __WEBPACK_IMPORTED_MODULE_2__type__["Struct"](children || []);
        case 'struct_': return new __WEBPACK_IMPORTED_MODULE_2__type__["Struct"](children || []);
    }
    switch (typeId) {
        case 'int': {
            var t = f['type'];
            return new __WEBPACK_IMPORTED_MODULE_2__type__["Int"](t['isSigned'], t['bitWidth']);
        }
        case 'floatingpoint': {
            var t = f['type'];
            return new __WEBPACK_IMPORTED_MODULE_2__type__["Float"](__WEBPACK_IMPORTED_MODULE_4__enum__["Precision"][t['precision']]);
        }
        case 'decimal': {
            var t = f['type'];
            return new __WEBPACK_IMPORTED_MODULE_2__type__["Decimal"](t['scale'], t['precision']);
        }
        case 'date': {
            var t = f['type'];
            return new __WEBPACK_IMPORTED_MODULE_2__type__["Date_"](__WEBPACK_IMPORTED_MODULE_4__enum__["DateUnit"][t['unit']]);
        }
        case 'time': {
            var t = f['type'];
            return new __WEBPACK_IMPORTED_MODULE_2__type__["Time"](__WEBPACK_IMPORTED_MODULE_4__enum__["TimeUnit"][t['unit']], t['bitWidth']);
        }
        case 'timestamp': {
            var t = f['type'];
            return new __WEBPACK_IMPORTED_MODULE_2__type__["Timestamp"](__WEBPACK_IMPORTED_MODULE_4__enum__["TimeUnit"][t['unit']], t['timezone']);
        }
        case 'interval': {
            var t = f['type'];
            return new __WEBPACK_IMPORTED_MODULE_2__type__["Interval"](__WEBPACK_IMPORTED_MODULE_4__enum__["IntervalUnit"][t['unit']]);
        }
        case 'union': {
            var t = f['type'];
            return new __WEBPACK_IMPORTED_MODULE_2__type__["Union"](__WEBPACK_IMPORTED_MODULE_4__enum__["UnionMode"][t['mode']], (t['typeIds'] || []), children || []);
        }
        case 'fixedsizebinary': {
            var t = f['type'];
            return new __WEBPACK_IMPORTED_MODULE_2__type__["FixedSizeBinary"](t['byteWidth']);
        }
        case 'fixedsizelist': {
            var t = f['type'];
            return new __WEBPACK_IMPORTED_MODULE_2__type__["FixedSizeList"](t['listSize'], (children || [])[0]);
        }
        case 'map': {
            var t = f['type'];
            return new __WEBPACK_IMPORTED_MODULE_2__type__["Map_"](children || [], t['keysSorted']);
        }
    }
    throw new Error("Unrecognized type: \"" + typeId + "\"");
}



/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__row__ = __webpack_require__(59);
/* unused harmony reexport Row */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vector__ = __webpack_require__(7);
/* unused harmony reexport Vector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base__ = __webpack_require__(5);
/* unused harmony reexport BaseVector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__binary__ = __webpack_require__(119);
/* unused harmony reexport BinaryVector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bool__ = __webpack_require__(120);
/* unused harmony reexport BoolVector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__chunked__ = __webpack_require__(47);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_6__chunked__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__date__ = __webpack_require__(121);
/* unused harmony reexport DateVector */
/* unused harmony reexport DateDayVector */
/* unused harmony reexport DateMillisecondVector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__decimal__ = __webpack_require__(122);
/* unused harmony reexport DecimalVector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dictionary__ = __webpack_require__(123);
/* unused harmony reexport DictionaryVector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fixedsizebinary__ = __webpack_require__(124);
/* unused harmony reexport FixedSizeBinaryVector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__fixedsizelist__ = __webpack_require__(125);
/* unused harmony reexport FixedSizeListVector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__float__ = __webpack_require__(126);
/* unused harmony reexport FloatVector */
/* unused harmony reexport Float16Vector */
/* unused harmony reexport Float32Vector */
/* unused harmony reexport Float64Vector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__interval__ = __webpack_require__(127);
/* unused harmony reexport IntervalVector */
/* unused harmony reexport IntervalDayTimeVector */
/* unused harmony reexport IntervalYearMonthVector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__int__ = __webpack_require__(128);
/* unused harmony reexport IntVector */
/* unused harmony reexport Int8Vector */
/* unused harmony reexport Int16Vector */
/* unused harmony reexport Int32Vector */
/* unused harmony reexport Int64Vector */
/* unused harmony reexport Uint8Vector */
/* unused harmony reexport Uint16Vector */
/* unused harmony reexport Uint32Vector */
/* unused harmony reexport Uint64Vector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__list__ = __webpack_require__(129);
/* unused harmony reexport ListVector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__map__ = __webpack_require__(130);
/* unused harmony reexport MapVector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__null__ = __webpack_require__(131);
/* unused harmony reexport NullVector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__struct__ = __webpack_require__(86);
/* unused harmony reexport StructVector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__timestamp__ = __webpack_require__(132);
/* unused harmony reexport TimestampVector */
/* unused harmony reexport TimestampSecondVector */
/* unused harmony reexport TimestampMillisecondVector */
/* unused harmony reexport TimestampMicrosecondVector */
/* unused harmony reexport TimestampNanosecondVector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__time__ = __webpack_require__(133);
/* unused harmony reexport TimeVector */
/* unused harmony reexport TimeSecondVector */
/* unused harmony reexport TimeMillisecondVector */
/* unused harmony reexport TimeMicrosecondVector */
/* unused harmony reexport TimeNanosecondVector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__union__ = __webpack_require__(134);
/* unused harmony reexport UnionVector */
/* unused harmony reexport DenseUnionVector */
/* unused harmony reexport SparseUnionVector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utf8__ = __webpack_require__(135);
/* unused harmony reexport Utf8Vector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__enum__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__util_bit__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__visitor_get__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__visitor_set__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__visitor_indexof__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__visitor_toarray__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__visitor_iterator__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__visitor_bytewidth__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__visitor_vectorctor__ = __webpack_require__(213);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.


































/** @nocollapse */
__WEBPACK_IMPORTED_MODULE_2__vector__["Vector"].new = newVector;
/** @ignore */
function newVector(data) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var _a;
    return new ((_a = (__WEBPACK_IMPORTED_MODULE_31__visitor_vectorctor__["a" /* instance */].getVisitFn(data.type)())).bind.apply(_a, __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */]([void 0, data], args)))();
}
//
// We provide the following method implementations for code navigability purposes only.
// They're overridden at runtime below with the specific Visitor implementation for each type,
// short-circuiting the usual Visitor traversal and reducing intermediate lookups and calls.
// This comment is here to remind you to not set breakpoints in these function bodies, or to inform
// you why the breakpoints you have already set are not being triggered. Have a great day!
//
__WEBPACK_IMPORTED_MODULE_3__base__["a" /* BaseVector */].prototype.get = function baseVectorGet(index) {
    return __WEBPACK_IMPORTED_MODULE_25__visitor_get__["a" /* instance */].visit(this, index);
};
__WEBPACK_IMPORTED_MODULE_3__base__["a" /* BaseVector */].prototype.set = function baseVectorSet(index, value) {
    return __WEBPACK_IMPORTED_MODULE_26__visitor_set__["a" /* instance */].visit(this, index, value);
};
__WEBPACK_IMPORTED_MODULE_3__base__["a" /* BaseVector */].prototype.indexOf = function baseVectorIndexOf(value, fromIndex) {
    return __WEBPACK_IMPORTED_MODULE_27__visitor_indexof__["a" /* instance */].visit(this, value, fromIndex);
};
__WEBPACK_IMPORTED_MODULE_3__base__["a" /* BaseVector */].prototype.toArray = function baseVectorToArray() {
    return __WEBPACK_IMPORTED_MODULE_28__visitor_toarray__["a" /* instance */].visit(this);
};
__WEBPACK_IMPORTED_MODULE_3__base__["a" /* BaseVector */].prototype.getByteWidth = function baseVectorGetByteWidth() {
    return __WEBPACK_IMPORTED_MODULE_30__visitor_bytewidth__["a" /* instance */].visit(this.type);
};
__WEBPACK_IMPORTED_MODULE_3__base__["a" /* BaseVector */].prototype[Symbol.iterator] = function baseVectorSymbolIterator() {
    return __WEBPACK_IMPORTED_MODULE_29__visitor_iterator__["a" /* instance */].visit(this);
};
__WEBPACK_IMPORTED_MODULE_3__base__["a" /* BaseVector */].prototype._bindDataAccessors = bindBaseVectorDataAccessors;
// Perf: bind and assign the operator Visitor methods to each of the Vector subclasses for each Type
Object.keys(__WEBPACK_IMPORTED_MODULE_23__enum__["Type"])
    .filter(function (typeId) { return typeId !== __WEBPACK_IMPORTED_MODULE_23__enum__["Type"].NONE && typeId !== __WEBPACK_IMPORTED_MODULE_23__enum__["Type"][__WEBPACK_IMPORTED_MODULE_23__enum__["Type"].NONE]; })
    .map(function (T) { return __WEBPACK_IMPORTED_MODULE_23__enum__["Type"][T]; }).filter(function (T) { return typeof T === 'number'; })
    .forEach(function (typeId) {
    var typeIds;
    switch (typeId) {
        case __WEBPACK_IMPORTED_MODULE_23__enum__["Type"].Int:
            typeIds = [__WEBPACK_IMPORTED_MODULE_23__enum__["Type"].Int8, __WEBPACK_IMPORTED_MODULE_23__enum__["Type"].Int16, __WEBPACK_IMPORTED_MODULE_23__enum__["Type"].Int32, __WEBPACK_IMPORTED_MODULE_23__enum__["Type"].Int64, __WEBPACK_IMPORTED_MODULE_23__enum__["Type"].Uint8, __WEBPACK_IMPORTED_MODULE_23__enum__["Type"].Uint16, __WEBPACK_IMPORTED_MODULE_23__enum__["Type"].Uint32, __WEBPACK_IMPORTED_MODULE_23__enum__["Type"].Uint64];
            break;
        case __WEBPACK_IMPORTED_MODULE_23__enum__["Type"].Float:
            typeIds = [__WEBPACK_IMPORTED_MODULE_23__enum__["Type"].Float16, __WEBPACK_IMPORTED_MODULE_23__enum__["Type"].Float32, __WEBPACK_IMPORTED_MODULE_23__enum__["Type"].Float64];
            break;
        case __WEBPACK_IMPORTED_MODULE_23__enum__["Type"].Date:
            typeIds = [__WEBPACK_IMPORTED_MODULE_23__enum__["Type"].DateDay, __WEBPACK_IMPORTED_MODULE_23__enum__["Type"].DateMillisecond];
            break;
        case __WEBPACK_IMPORTED_MODULE_23__enum__["Type"].Time:
            typeIds = [__WEBPACK_IMPORTED_MODULE_23__enum__["Type"].TimeSecond, __WEBPACK_IMPORTED_MODULE_23__enum__["Type"].TimeMillisecond, __WEBPACK_IMPORTED_MODULE_23__enum__["Type"].TimeMicrosecond, __WEBPACK_IMPORTED_MODULE_23__enum__["Type"].TimeNanosecond];
            break;
        case __WEBPACK_IMPORTED_MODULE_23__enum__["Type"].Timestamp:
            typeIds = [__WEBPACK_IMPORTED_MODULE_23__enum__["Type"].TimestampSecond, __WEBPACK_IMPORTED_MODULE_23__enum__["Type"].TimestampMillisecond, __WEBPACK_IMPORTED_MODULE_23__enum__["Type"].TimestampMicrosecond, __WEBPACK_IMPORTED_MODULE_23__enum__["Type"].TimestampNanosecond];
            break;
        case __WEBPACK_IMPORTED_MODULE_23__enum__["Type"].Interval:
            typeIds = [__WEBPACK_IMPORTED_MODULE_23__enum__["Type"].IntervalDayTime, __WEBPACK_IMPORTED_MODULE_23__enum__["Type"].IntervalYearMonth];
            break;
        case __WEBPACK_IMPORTED_MODULE_23__enum__["Type"].Union:
            typeIds = [__WEBPACK_IMPORTED_MODULE_23__enum__["Type"].DenseUnion, __WEBPACK_IMPORTED_MODULE_23__enum__["Type"].SparseUnion];
            break;
        default:
            typeIds = [typeId];
            break;
    }
    typeIds.forEach(function (typeId) {
        var VectorCtor = __WEBPACK_IMPORTED_MODULE_31__visitor_vectorctor__["a" /* instance */].visit(typeId);
        VectorCtor.prototype['get'] = partial1(__WEBPACK_IMPORTED_MODULE_25__visitor_get__["a" /* instance */].getVisitFn(typeId));
        VectorCtor.prototype['set'] = partial2(__WEBPACK_IMPORTED_MODULE_26__visitor_set__["a" /* instance */].getVisitFn(typeId));
        VectorCtor.prototype['indexOf'] = partial2(__WEBPACK_IMPORTED_MODULE_27__visitor_indexof__["a" /* instance */].getVisitFn(typeId));
        VectorCtor.prototype['toArray'] = partial0(__WEBPACK_IMPORTED_MODULE_28__visitor_toarray__["a" /* instance */].getVisitFn(typeId));
        VectorCtor.prototype['getByteWidth'] = partialType0(__WEBPACK_IMPORTED_MODULE_30__visitor_bytewidth__["a" /* instance */].getVisitFn(typeId));
        VectorCtor.prototype[Symbol.iterator] = partial0(__WEBPACK_IMPORTED_MODULE_29__visitor_iterator__["a" /* instance */].getVisitFn(typeId));
    });
});
/** @ignore */
function partial0(visit) {
    return function () { return visit(this); };
}
/** @ignore */
function partialType0(visit) {
    return function () { return visit(this.type); };
}
/** @ignore */
function partial1(visit) {
    return function (a) { return visit(this, a); };
}
/** @ignore */
function partial2(visit) {
    return function (a, b) { return visit(this, a, b); };
}
/** @ignore */
function wrapNullable1(fn) {
    return function (i) { return this.isValid(i) ? fn.call(this, i) : null; };
}
/** @ignore */
function wrapNullableSet(fn) {
    return function (i, a) {
        if (Object(__WEBPACK_IMPORTED_MODULE_24__util_bit__["f" /* setBool */])(this.nullBitmap, this.offset + i, a != null)) {
            fn.call(this, i, a);
        }
    };
}
/** @ignore */
function bindBaseVectorDataAccessors() {
    var nullBitmap = this.nullBitmap;
    if (nullBitmap && nullBitmap.byteLength > 0) {
        this.get = wrapNullable1(this.get);
        this.set = wrapNullableSet(this.set);
    }
}



/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SetVisitor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return instance; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__visitor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_utf8__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__enum__ = __webpack_require__(2);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.




var SetVisitor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](SetVisitor, _super);
    function SetVisitor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SetVisitor;
}(__WEBPACK_IMPORTED_MODULE_1__visitor__["Visitor"]));

/** @ignore */
var setEpochMsToDays = function (data, index, epochMs) { data[index] = (epochMs / 86400000) | 0; };
/** @ignore */
var setEpochMsToMillisecondsLong = function (data, index, epochMs) {
    data[index] = (epochMs % 4294967296) | 0;
    data[index + 1] = (epochMs / 4294967296) | 0;
};
/** @ignore */
var setEpochMsToMicrosecondsLong = function (data, index, epochMs) {
    data[index] = ((epochMs * 1000) % 4294967296) | 0;
    data[index + 1] = ((epochMs * 1000) / 4294967296) | 0;
};
/** @ignore */
var setEpochMsToNanosecondsLong = function (data, index, epochMs) {
    data[index] = ((epochMs * 1000000) % 4294967296) | 0;
    data[index + 1] = ((epochMs * 1000000) / 4294967296) | 0;
};
/** @ignore */
var setVariableWidthBytes = function (values, valueOffsets, index, value) {
    var _a = index, x = valueOffsets[_a], _b = index + 1, y = valueOffsets[_b];
    if (x != null && y != null) {
        values.set(value.subarray(0, y - x), x);
    }
};
/** @ignore */
var setBool = function (_a, index, val) {
    var offset = _a.offset, values = _a.values;
    var idx = offset + index;
    val ? (values[idx >> 3] |= (1 << (idx % 8))) // true
        : (values[idx >> 3] &= ~(1 << (idx % 8))); // false
};
/** @ignore */
var setDateDay = function (_a, index, value) {
    var values = _a.values;
    setEpochMsToDays(values, index, value.valueOf());
};
/** @ignore */
var setDateMillisecond = function (_a, index, value) {
    var values = _a.values;
    setEpochMsToMillisecondsLong(values, index * 2, value.valueOf());
};
/** @ignore */
var setNumeric = function (_a, index, value) {
    var stride = _a.stride, values = _a.values;
    values[stride * index] = value;
};
/** @ignore */
var setFloat16 = function (_a, index, value) {
    var stride = _a.stride, values = _a.values;
    values[stride * index] = (value * 32767) + 32767;
};
/** @ignore */
var setNumericX2 = function (_a, index, value) {
    var stride = _a.stride, values = _a.values;
    values.set(value.subarray(0, stride), stride * index);
};
/** @ignore */
var setFixedSizeBinary = function (_a, index, value) {
    var stride = _a.stride, values = _a.values;
    values.set(value.subarray(0, stride), stride * index);
};
/** @ignore */
var setBinary = function (_a, index, value) {
    var values = _a.values, valueOffsets = _a.valueOffsets;
    return setVariableWidthBytes(values, valueOffsets, index, value);
};
/** @ignore */
var setUtf8 = function (_a, index, value) {
    var values = _a.values, valueOffsets = _a.valueOffsets;
    setVariableWidthBytes(values, valueOffsets, index, Object(__WEBPACK_IMPORTED_MODULE_2__util_utf8__["b" /* encodeUtf8 */])(value));
};
/* istanbul ignore next */
/** @ignore */
var setInt = function (vector, index, value) {
    vector.type.bitWidth < 64
        ? setNumeric(vector, index, value)
        : setNumericX2(vector, index, value);
};
/* istanbul ignore next */
/** @ignore */
var setFloat = function (vector, index, value) {
    vector.type.precision !== __WEBPACK_IMPORTED_MODULE_3__enum__["Precision"].HALF
        ? setNumeric(vector, index, value)
        : setFloat16(vector, index, value);
};
/* istanbul ignore next */
var getDate = function (vector, index, value) {
    vector.type.unit === __WEBPACK_IMPORTED_MODULE_3__enum__["DateUnit"].DAY
        ? setDateDay(vector, index, value)
        : setDateMillisecond(vector, index, value);
};
/** @ignore */
var setTimestampSecond = function (_a, index, value) {
    var values = _a.values;
    return setEpochMsToMillisecondsLong(values, index * 2, value / 1000);
};
/** @ignore */
var setTimestampMillisecond = function (_a, index, value) {
    var values = _a.values;
    return setEpochMsToMillisecondsLong(values, index * 2, value);
};
/** @ignore */
var setTimestampMicrosecond = function (_a, index, value) {
    var values = _a.values;
    return setEpochMsToMicrosecondsLong(values, index * 2, value);
};
/** @ignore */
var setTimestampNanosecond = function (_a, index, value) {
    var values = _a.values;
    return setEpochMsToNanosecondsLong(values, index * 2, value);
};
/* istanbul ignore next */
/** @ignore */
var setTimestamp = function (vector, index, value) {
    switch (vector.type.unit) {
        case __WEBPACK_IMPORTED_MODULE_3__enum__["TimeUnit"].SECOND: return setTimestampSecond(vector, index, value);
        case __WEBPACK_IMPORTED_MODULE_3__enum__["TimeUnit"].MILLISECOND: return setTimestampMillisecond(vector, index, value);
        case __WEBPACK_IMPORTED_MODULE_3__enum__["TimeUnit"].MICROSECOND: return setTimestampMicrosecond(vector, index, value);
        case __WEBPACK_IMPORTED_MODULE_3__enum__["TimeUnit"].NANOSECOND: return setTimestampNanosecond(vector, index, value);
    }
};
/** @ignore */
var setTimeSecond = function (_a, index, value) {
    var values = _a.values, stride = _a.stride;
    values[stride * index] = value;
};
/** @ignore */
var setTimeMillisecond = function (_a, index, value) {
    var values = _a.values, stride = _a.stride;
    values[stride * index] = value;
};
/** @ignore */
var setTimeMicrosecond = function (_a, index, value) {
    var values = _a.values;
    values.set(value.subarray(0, 2), 2 * index);
};
/** @ignore */
var setTimeNanosecond = function (_a, index, value) {
    var values = _a.values;
    values.set(value.subarray(0, 2), 2 * index);
};
/* istanbul ignore next */
/** @ignore */
var setTime = function (vector, index, value) {
    switch (vector.type.unit) {
        case __WEBPACK_IMPORTED_MODULE_3__enum__["TimeUnit"].SECOND: return setTimeSecond(vector, index, value);
        case __WEBPACK_IMPORTED_MODULE_3__enum__["TimeUnit"].MILLISECOND: return setTimeMillisecond(vector, index, value);
        case __WEBPACK_IMPORTED_MODULE_3__enum__["TimeUnit"].MICROSECOND: return setTimeMicrosecond(vector, index, value);
        case __WEBPACK_IMPORTED_MODULE_3__enum__["TimeUnit"].NANOSECOND: return setTimeNanosecond(vector, index, value);
    }
};
/** @ignore */
var setDecimal = function (_a, index, value) {
    var values = _a.values;
    values.set(value.subarray(0, 4), 4 * index);
};
/** @ignore */
var setList = function (vector, index, value) {
    var values = vector.getChildAt(0);
    var valueOffsets = vector.valueOffsets, stride = vector.stride;
    var idx = -1, offset = valueOffsets[index * stride];
    var end = Math.min(value.length, valueOffsets[(index * stride) + 1] - offset);
    while (offset < end) {
        values.set(offset++, value.get(++idx));
    }
};
/** @ignore */
var setNested = function (vector, index, value) {
    vector.type.children.forEach(function (_a, idx) {
        var name = _a.name;
        var kid = vector.getChildAt(idx);
        kid && kid.set(index, value[name]);
    });
};
/* istanbul ignore next */
/** @ignore */
var setUnion = function (vector, index, value) {
    vector.type.mode === __WEBPACK_IMPORTED_MODULE_3__enum__["UnionMode"].Dense ?
        setDenseUnion(vector, index, value) :
        setSparseUnion(vector, index, value);
};
/** @ignore */
var setDenseUnion = function (vector, index, value) {
    var typeIds = vector.typeIds, typeIdToChildIndex = vector.type.typeIdToChildIndex;
    var child = vector.getChildAt(typeIdToChildIndex[typeIds[index]]);
    child && child.set(vector.valueOffsets[index], value);
};
/** @ignore */
var setSparseUnion = function (vector, index, value) {
    var typeIds = vector.typeIds, typeIdToChildIndex = vector.type.typeIdToChildIndex;
    var child = vector.getChildAt(typeIdToChildIndex[typeIds[index]]);
    child && child.set(index, value);
};
/** @ignore */
var setDictionary = function (vector, index, value) {
    var key = vector.getKey(index);
    if (key !== null) {
        vector.setValue(key, value);
    }
};
/* istanbul ignore next */
/** @ignore */
var setIntervalValue = function (vector, index, value) {
    (vector.type.unit === __WEBPACK_IMPORTED_MODULE_3__enum__["IntervalUnit"].DAY_TIME)
        ? setIntervalDayTime(vector, index, value)
        : setIntervalYearMonth(vector, index, value);
};
/** @ignore */
var setIntervalDayTime = function (_a, index, value) {
    var values = _a.values;
    values.set(value.subarray(0, 2), 2 * index);
};
/** @ignore */
var setIntervalYearMonth = function (_a, index, value) {
    var values = _a.values;
    values[index] = (value[0] * 12) + (value[1] % 12);
};
/** @ignore */
var setFixedSizeList = function (vector, index, value) {
    var child = vector.getChildAt(0), stride = vector.stride;
    for (var idx = -1, offset = index * stride; ++idx < stride;) {
        child.set(offset + idx, value.get(idx));
    }
};
SetVisitor.prototype.visitBool = setBool;
SetVisitor.prototype.visitInt = setInt;
SetVisitor.prototype.visitInt8 = setNumeric;
SetVisitor.prototype.visitInt16 = setNumeric;
SetVisitor.prototype.visitInt32 = setNumeric;
SetVisitor.prototype.visitInt64 = setNumericX2;
SetVisitor.prototype.visitUint8 = setNumeric;
SetVisitor.prototype.visitUint16 = setNumeric;
SetVisitor.prototype.visitUint32 = setNumeric;
SetVisitor.prototype.visitUint64 = setNumericX2;
SetVisitor.prototype.visitFloat = setFloat;
SetVisitor.prototype.visitFloat16 = setFloat16;
SetVisitor.prototype.visitFloat32 = setNumeric;
SetVisitor.prototype.visitFloat64 = setNumeric;
SetVisitor.prototype.visitUtf8 = setUtf8;
SetVisitor.prototype.visitBinary = setBinary;
SetVisitor.prototype.visitFixedSizeBinary = setFixedSizeBinary;
SetVisitor.prototype.visitDate = getDate;
SetVisitor.prototype.visitDateDay = setDateDay;
SetVisitor.prototype.visitDateMillisecond = setDateMillisecond;
SetVisitor.prototype.visitTimestamp = setTimestamp;
SetVisitor.prototype.visitTimestampSecond = setTimestampSecond;
SetVisitor.prototype.visitTimestampMillisecond = setTimestampMillisecond;
SetVisitor.prototype.visitTimestampMicrosecond = setTimestampMicrosecond;
SetVisitor.prototype.visitTimestampNanosecond = setTimestampNanosecond;
SetVisitor.prototype.visitTime = setTime;
SetVisitor.prototype.visitTimeSecond = setTimeSecond;
SetVisitor.prototype.visitTimeMillisecond = setTimeMillisecond;
SetVisitor.prototype.visitTimeMicrosecond = setTimeMicrosecond;
SetVisitor.prototype.visitTimeNanosecond = setTimeNanosecond;
SetVisitor.prototype.visitDecimal = setDecimal;
SetVisitor.prototype.visitList = setList;
SetVisitor.prototype.visitStruct = setNested;
SetVisitor.prototype.visitUnion = setUnion;
SetVisitor.prototype.visitDenseUnion = setDenseUnion;
SetVisitor.prototype.visitSparseUnion = setSparseUnion;
SetVisitor.prototype.visitDictionary = setDictionary;
SetVisitor.prototype.visitInterval = setIntervalValue;
SetVisitor.prototype.visitIntervalDayTime = setIntervalDayTime;
SetVisitor.prototype.visitIntervalYearMonth = setIntervalYearMonth;
SetVisitor.prototype.visitFixedSizeList = setFixedSizeList;
SetVisitor.prototype.visitMap = setNested;
/** @ignore */
var instance = new SetVisitor();



/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IndexOfVisitor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return instance; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__visitor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_bit__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_vector__ = __webpack_require__(84);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.




var IndexOfVisitor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](IndexOfVisitor, _super);
    function IndexOfVisitor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return IndexOfVisitor;
}(__WEBPACK_IMPORTED_MODULE_1__visitor__["Visitor"]));

/** @ignore */
function nullIndexOf(vector, searchElement) {
    // if you're looking for nulls and the vector isn't empty, we've got 'em!
    return searchElement === null && vector.length > 0 ? 0 : -1;
}
/** @ignore */
function indexOfNull(vector, fromIndex) {
    var e_1, _a;
    var nullBitmap = vector.nullBitmap;
    if (!nullBitmap || vector.nullCount <= 0) {
        return -1;
    }
    var i = 0;
    try {
        for (var _b = __WEBPACK_IMPORTED_MODULE_0_tslib__["k" /* __values */](Object(__WEBPACK_IMPORTED_MODULE_2__util_bit__["c" /* iterateBits */])(nullBitmap, vector.data.offset + (fromIndex || 0), vector.length, nullBitmap, __WEBPACK_IMPORTED_MODULE_2__util_bit__["b" /* getBool */])), _c = _b.next(); !_c.done; _c = _b.next()) {
            var isValid = _c.value;
            if (!isValid) {
                return i;
            }
            ++i;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return -1;
}
/** @ignore */
function indexOfValue(vector, searchElement, fromIndex) {
    if (searchElement === undefined) {
        return -1;
    }
    if (searchElement === null) {
        return indexOfNull(vector, fromIndex);
    }
    var compare = Object(__WEBPACK_IMPORTED_MODULE_3__util_vector__["b" /* createElementComparator */])(searchElement);
    for (var i = (fromIndex || 0) - 1, n = vector.length; ++i < n;) {
        if (compare(vector.get(i))) {
            return i;
        }
    }
    return -1;
}
/** @ignore */
function indexOfUnion(vector, searchElement, fromIndex) {
    // Unions are special -- they do have a nullBitmap, but so can their children.
    // If the searchElement is null, we don't know whether it came from the Union's
    // bitmap or one of its childrens'. So we don't interrogate the Union's bitmap,
    // since that will report the wrong index if a child has a null before the Union.
    var compare = Object(__WEBPACK_IMPORTED_MODULE_3__util_vector__["b" /* createElementComparator */])(searchElement);
    for (var i = (fromIndex || 0) - 1, n = vector.length; ++i < n;) {
        if (compare(vector.get(i))) {
            return i;
        }
    }
    return -1;
}
IndexOfVisitor.prototype.visitNull = nullIndexOf;
IndexOfVisitor.prototype.visitBool = indexOfValue;
IndexOfVisitor.prototype.visitInt = indexOfValue;
IndexOfVisitor.prototype.visitInt8 = indexOfValue;
IndexOfVisitor.prototype.visitInt16 = indexOfValue;
IndexOfVisitor.prototype.visitInt32 = indexOfValue;
IndexOfVisitor.prototype.visitInt64 = indexOfValue;
IndexOfVisitor.prototype.visitUint8 = indexOfValue;
IndexOfVisitor.prototype.visitUint16 = indexOfValue;
IndexOfVisitor.prototype.visitUint32 = indexOfValue;
IndexOfVisitor.prototype.visitUint64 = indexOfValue;
IndexOfVisitor.prototype.visitFloat = indexOfValue;
IndexOfVisitor.prototype.visitFloat16 = indexOfValue;
IndexOfVisitor.prototype.visitFloat32 = indexOfValue;
IndexOfVisitor.prototype.visitFloat64 = indexOfValue;
IndexOfVisitor.prototype.visitUtf8 = indexOfValue;
IndexOfVisitor.prototype.visitBinary = indexOfValue;
IndexOfVisitor.prototype.visitFixedSizeBinary = indexOfValue;
IndexOfVisitor.prototype.visitDate = indexOfValue;
IndexOfVisitor.prototype.visitDateDay = indexOfValue;
IndexOfVisitor.prototype.visitDateMillisecond = indexOfValue;
IndexOfVisitor.prototype.visitTimestamp = indexOfValue;
IndexOfVisitor.prototype.visitTimestampSecond = indexOfValue;
IndexOfVisitor.prototype.visitTimestampMillisecond = indexOfValue;
IndexOfVisitor.prototype.visitTimestampMicrosecond = indexOfValue;
IndexOfVisitor.prototype.visitTimestampNanosecond = indexOfValue;
IndexOfVisitor.prototype.visitTime = indexOfValue;
IndexOfVisitor.prototype.visitTimeSecond = indexOfValue;
IndexOfVisitor.prototype.visitTimeMillisecond = indexOfValue;
IndexOfVisitor.prototype.visitTimeMicrosecond = indexOfValue;
IndexOfVisitor.prototype.visitTimeNanosecond = indexOfValue;
IndexOfVisitor.prototype.visitDecimal = indexOfValue;
IndexOfVisitor.prototype.visitList = indexOfValue;
IndexOfVisitor.prototype.visitStruct = indexOfValue;
IndexOfVisitor.prototype.visitUnion = indexOfValue;
IndexOfVisitor.prototype.visitDenseUnion = indexOfUnion;
IndexOfVisitor.prototype.visitSparseUnion = indexOfUnion;
IndexOfVisitor.prototype.visitDictionary = indexOfValue;
IndexOfVisitor.prototype.visitInterval = indexOfValue;
IndexOfVisitor.prototype.visitIntervalDayTime = indexOfValue;
IndexOfVisitor.prototype.visitIntervalYearMonth = indexOfValue;
IndexOfVisitor.prototype.visitFixedSizeList = indexOfValue;
IndexOfVisitor.prototype.visitMap = indexOfValue;
/** @ignore */
var instance = new IndexOfVisitor();



/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ToArrayVisitor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return instance; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__visitor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enum__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__iterator__ = __webpack_require__(138);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.




var ToArrayVisitor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](ToArrayVisitor, _super);
    function ToArrayVisitor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ToArrayVisitor;
}(__WEBPACK_IMPORTED_MODULE_1__visitor__["Visitor"]));

/** @ignore */
function arrayOfVector(vector) {
    var type = vector.type, length = vector.length, stride = vector.stride;
    // Fast case, return subarray if possible
    switch (type.typeId) {
        case __WEBPACK_IMPORTED_MODULE_2__enum__["Type"].Int:
        case __WEBPACK_IMPORTED_MODULE_2__enum__["Type"].Decimal:
        case __WEBPACK_IMPORTED_MODULE_2__enum__["Type"].Time:
        case __WEBPACK_IMPORTED_MODULE_2__enum__["Type"].Timestamp:
            return vector.values.subarray(0, length * stride);
        case __WEBPACK_IMPORTED_MODULE_2__enum__["Type"].Float:
            return type.precision === __WEBPACK_IMPORTED_MODULE_2__enum__["Precision"].HALF /* Precision.HALF */
                ? new Float32Array(vector[Symbol.iterator]())
                : vector.values.subarray(0, length * stride);
    }
    // Otherwise if not primitive, slow copy
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](__WEBPACK_IMPORTED_MODULE_3__iterator__["a" /* instance */].visit(vector));
}
ToArrayVisitor.prototype.visitNull = arrayOfVector;
ToArrayVisitor.prototype.visitBool = arrayOfVector;
ToArrayVisitor.prototype.visitInt = arrayOfVector;
ToArrayVisitor.prototype.visitInt8 = arrayOfVector;
ToArrayVisitor.prototype.visitInt16 = arrayOfVector;
ToArrayVisitor.prototype.visitInt32 = arrayOfVector;
ToArrayVisitor.prototype.visitInt64 = arrayOfVector;
ToArrayVisitor.prototype.visitUint8 = arrayOfVector;
ToArrayVisitor.prototype.visitUint16 = arrayOfVector;
ToArrayVisitor.prototype.visitUint32 = arrayOfVector;
ToArrayVisitor.prototype.visitUint64 = arrayOfVector;
ToArrayVisitor.prototype.visitFloat = arrayOfVector;
ToArrayVisitor.prototype.visitFloat16 = arrayOfVector;
ToArrayVisitor.prototype.visitFloat32 = arrayOfVector;
ToArrayVisitor.prototype.visitFloat64 = arrayOfVector;
ToArrayVisitor.prototype.visitUtf8 = arrayOfVector;
ToArrayVisitor.prototype.visitBinary = arrayOfVector;
ToArrayVisitor.prototype.visitFixedSizeBinary = arrayOfVector;
ToArrayVisitor.prototype.visitDate = arrayOfVector;
ToArrayVisitor.prototype.visitDateDay = arrayOfVector;
ToArrayVisitor.prototype.visitDateMillisecond = arrayOfVector;
ToArrayVisitor.prototype.visitTimestamp = arrayOfVector;
ToArrayVisitor.prototype.visitTimestampSecond = arrayOfVector;
ToArrayVisitor.prototype.visitTimestampMillisecond = arrayOfVector;
ToArrayVisitor.prototype.visitTimestampMicrosecond = arrayOfVector;
ToArrayVisitor.prototype.visitTimestampNanosecond = arrayOfVector;
ToArrayVisitor.prototype.visitTime = arrayOfVector;
ToArrayVisitor.prototype.visitTimeSecond = arrayOfVector;
ToArrayVisitor.prototype.visitTimeMillisecond = arrayOfVector;
ToArrayVisitor.prototype.visitTimeMicrosecond = arrayOfVector;
ToArrayVisitor.prototype.visitTimeNanosecond = arrayOfVector;
ToArrayVisitor.prototype.visitDecimal = arrayOfVector;
ToArrayVisitor.prototype.visitList = arrayOfVector;
ToArrayVisitor.prototype.visitStruct = arrayOfVector;
ToArrayVisitor.prototype.visitUnion = arrayOfVector;
ToArrayVisitor.prototype.visitDenseUnion = arrayOfVector;
ToArrayVisitor.prototype.visitSparseUnion = arrayOfVector;
ToArrayVisitor.prototype.visitDictionary = arrayOfVector;
ToArrayVisitor.prototype.visitInterval = arrayOfVector;
ToArrayVisitor.prototype.visitIntervalDayTime = arrayOfVector;
ToArrayVisitor.prototype.visitIntervalYearMonth = arrayOfVector;
ToArrayVisitor.prototype.visitFixedSizeList = arrayOfVector;
ToArrayVisitor.prototype.visitMap = arrayOfVector;
/** @ignore */
var instance = new ToArrayVisitor();



/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ByteWidthVisitor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return instance; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__visitor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enum__ = __webpack_require__(2);
/* istanbul ignore file */



/** @ignore */ var sum = function (x, y) { return x + y; };
/** @ignore */ var variableWidthColumnErrorMessage = function (type) { return "Cannot compute the byte width of variable-width column " + type; };
var ByteWidthVisitor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](ByteWidthVisitor, _super);
    function ByteWidthVisitor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ByteWidthVisitor.prototype.visitNull = function (____) { return 0; };
    ByteWidthVisitor.prototype.visitInt = function (type) { return type.bitWidth / 8; };
    ByteWidthVisitor.prototype.visitFloat = function (type) { return type.ArrayType.BYTES_PER_ELEMENT; };
    ByteWidthVisitor.prototype.visitBinary = function (type) { throw new Error(variableWidthColumnErrorMessage(type)); };
    ByteWidthVisitor.prototype.visitUtf8 = function (type) { throw new Error(variableWidthColumnErrorMessage(type)); };
    ByteWidthVisitor.prototype.visitBool = function (____) { return 1 / 8; };
    ByteWidthVisitor.prototype.visitDecimal = function (____) { return 16; };
    ByteWidthVisitor.prototype.visitDate = function (type) { return (type.unit + 1) * 4; };
    ByteWidthVisitor.prototype.visitTime = function (type) { return type.bitWidth / 8; };
    ByteWidthVisitor.prototype.visitTimestamp = function (type) { return type.unit === __WEBPACK_IMPORTED_MODULE_2__enum__["TimeUnit"].SECOND ? 4 : 8; };
    ByteWidthVisitor.prototype.visitInterval = function (type) { return (type.unit + 1) * 4; };
    ByteWidthVisitor.prototype.visitList = function (type) { throw new Error(variableWidthColumnErrorMessage(type)); };
    ByteWidthVisitor.prototype.visitStruct = function (type) { return this.visitFields(type.children).reduce(sum, 0); };
    ByteWidthVisitor.prototype.visitUnion = function (type) { return this.visitFields(type.children).reduce(sum, 0); };
    ByteWidthVisitor.prototype.visitFixedSizeBinary = function (type) { return type.byteWidth; };
    ByteWidthVisitor.prototype.visitFixedSizeList = function (type) { return type.listSize * this.visitFields(type.children).reduce(sum, 0); };
    ByteWidthVisitor.prototype.visitMap = function (type) { return this.visitFields(type.children).reduce(sum, 0); };
    ByteWidthVisitor.prototype.visitDictionary = function (type) { return this.visit(type.indices); };
    ByteWidthVisitor.prototype.visitFields = function (fields) {
        var _this = this;
        return (fields || []).map(function (field) { return _this.visit(field.type); });
    };
    ByteWidthVisitor.prototype.visitSchema = function (schema) { return this.visitFields(schema.fields).reduce(sum, 0); };
    return ByteWidthVisitor;
}(__WEBPACK_IMPORTED_MODULE_1__visitor__["Visitor"]));

/** @ignore */
var instance = new ByteWidthVisitor();



/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GetVectorConstructor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return instance; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__visitor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vector_binary__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vector_bool__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vector_date__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vector_decimal__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vector_dictionary__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vector_fixedsizebinary__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vector_fixedsizelist__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__vector_float__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__vector_interval__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__vector_int__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__vector_list__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__vector_map__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__vector_null__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__vector_struct__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__vector_timestamp__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__vector_time__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__vector_union__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__vector_utf8__ = __webpack_require__(135);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.




















var GetVectorConstructor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](GetVectorConstructor, _super);
    function GetVectorConstructor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GetVectorConstructor.prototype.visitNull = function () { return __WEBPACK_IMPORTED_MODULE_14__vector_null__["a" /* NullVector */]; };
    GetVectorConstructor.prototype.visitBool = function () { return __WEBPACK_IMPORTED_MODULE_3__vector_bool__["a" /* BoolVector */]; };
    GetVectorConstructor.prototype.visitInt = function () { return __WEBPACK_IMPORTED_MODULE_11__vector_int__["e" /* IntVector */]; };
    GetVectorConstructor.prototype.visitInt8 = function () { return __WEBPACK_IMPORTED_MODULE_11__vector_int__["d" /* Int8Vector */]; };
    GetVectorConstructor.prototype.visitInt16 = function () { return __WEBPACK_IMPORTED_MODULE_11__vector_int__["a" /* Int16Vector */]; };
    GetVectorConstructor.prototype.visitInt32 = function () { return __WEBPACK_IMPORTED_MODULE_11__vector_int__["b" /* Int32Vector */]; };
    GetVectorConstructor.prototype.visitInt64 = function () { return __WEBPACK_IMPORTED_MODULE_11__vector_int__["c" /* Int64Vector */]; };
    GetVectorConstructor.prototype.visitUint8 = function () { return __WEBPACK_IMPORTED_MODULE_11__vector_int__["i" /* Uint8Vector */]; };
    GetVectorConstructor.prototype.visitUint16 = function () { return __WEBPACK_IMPORTED_MODULE_11__vector_int__["f" /* Uint16Vector */]; };
    GetVectorConstructor.prototype.visitUint32 = function () { return __WEBPACK_IMPORTED_MODULE_11__vector_int__["g" /* Uint32Vector */]; };
    GetVectorConstructor.prototype.visitUint64 = function () { return __WEBPACK_IMPORTED_MODULE_11__vector_int__["h" /* Uint64Vector */]; };
    GetVectorConstructor.prototype.visitFloat = function () { return __WEBPACK_IMPORTED_MODULE_9__vector_float__["d" /* FloatVector */]; };
    GetVectorConstructor.prototype.visitFloat16 = function () { return __WEBPACK_IMPORTED_MODULE_9__vector_float__["a" /* Float16Vector */]; };
    GetVectorConstructor.prototype.visitFloat32 = function () { return __WEBPACK_IMPORTED_MODULE_9__vector_float__["b" /* Float32Vector */]; };
    GetVectorConstructor.prototype.visitFloat64 = function () { return __WEBPACK_IMPORTED_MODULE_9__vector_float__["c" /* Float64Vector */]; };
    GetVectorConstructor.prototype.visitUtf8 = function () { return __WEBPACK_IMPORTED_MODULE_19__vector_utf8__["a" /* Utf8Vector */]; };
    GetVectorConstructor.prototype.visitBinary = function () { return __WEBPACK_IMPORTED_MODULE_2__vector_binary__["a" /* BinaryVector */]; };
    GetVectorConstructor.prototype.visitFixedSizeBinary = function () { return __WEBPACK_IMPORTED_MODULE_7__vector_fixedsizebinary__["a" /* FixedSizeBinaryVector */]; };
    GetVectorConstructor.prototype.visitDate = function () { return __WEBPACK_IMPORTED_MODULE_4__vector_date__["c" /* DateVector */]; };
    GetVectorConstructor.prototype.visitDateDay = function () { return __WEBPACK_IMPORTED_MODULE_4__vector_date__["a" /* DateDayVector */]; };
    GetVectorConstructor.prototype.visitDateMillisecond = function () { return __WEBPACK_IMPORTED_MODULE_4__vector_date__["b" /* DateMillisecondVector */]; };
    GetVectorConstructor.prototype.visitTimestamp = function () { return __WEBPACK_IMPORTED_MODULE_16__vector_timestamp__["e" /* TimestampVector */]; };
    GetVectorConstructor.prototype.visitTimestampSecond = function () { return __WEBPACK_IMPORTED_MODULE_16__vector_timestamp__["d" /* TimestampSecondVector */]; };
    GetVectorConstructor.prototype.visitTimestampMillisecond = function () { return __WEBPACK_IMPORTED_MODULE_16__vector_timestamp__["b" /* TimestampMillisecondVector */]; };
    GetVectorConstructor.prototype.visitTimestampMicrosecond = function () { return __WEBPACK_IMPORTED_MODULE_16__vector_timestamp__["a" /* TimestampMicrosecondVector */]; };
    GetVectorConstructor.prototype.visitTimestampNanosecond = function () { return __WEBPACK_IMPORTED_MODULE_16__vector_timestamp__["c" /* TimestampNanosecondVector */]; };
    GetVectorConstructor.prototype.visitTime = function () { return __WEBPACK_IMPORTED_MODULE_17__vector_time__["e" /* TimeVector */]; };
    GetVectorConstructor.prototype.visitTimeSecond = function () { return __WEBPACK_IMPORTED_MODULE_17__vector_time__["d" /* TimeSecondVector */]; };
    GetVectorConstructor.prototype.visitTimeMillisecond = function () { return __WEBPACK_IMPORTED_MODULE_17__vector_time__["b" /* TimeMillisecondVector */]; };
    GetVectorConstructor.prototype.visitTimeMicrosecond = function () { return __WEBPACK_IMPORTED_MODULE_17__vector_time__["a" /* TimeMicrosecondVector */]; };
    GetVectorConstructor.prototype.visitTimeNanosecond = function () { return __WEBPACK_IMPORTED_MODULE_17__vector_time__["c" /* TimeNanosecondVector */]; };
    GetVectorConstructor.prototype.visitDecimal = function () { return __WEBPACK_IMPORTED_MODULE_5__vector_decimal__["a" /* DecimalVector */]; };
    GetVectorConstructor.prototype.visitList = function () { return __WEBPACK_IMPORTED_MODULE_12__vector_list__["a" /* ListVector */]; };
    GetVectorConstructor.prototype.visitStruct = function () { return __WEBPACK_IMPORTED_MODULE_15__vector_struct__["a" /* StructVector */]; };
    GetVectorConstructor.prototype.visitUnion = function () { return __WEBPACK_IMPORTED_MODULE_18__vector_union__["c" /* UnionVector */]; };
    GetVectorConstructor.prototype.visitDenseUnion = function () { return __WEBPACK_IMPORTED_MODULE_18__vector_union__["a" /* DenseUnionVector */]; };
    GetVectorConstructor.prototype.visitSparseUnion = function () { return __WEBPACK_IMPORTED_MODULE_18__vector_union__["b" /* SparseUnionVector */]; };
    GetVectorConstructor.prototype.visitDictionary = function () { return __WEBPACK_IMPORTED_MODULE_6__vector_dictionary__["a" /* DictionaryVector */]; };
    GetVectorConstructor.prototype.visitInterval = function () { return __WEBPACK_IMPORTED_MODULE_10__vector_interval__["b" /* IntervalVector */]; };
    GetVectorConstructor.prototype.visitIntervalDayTime = function () { return __WEBPACK_IMPORTED_MODULE_10__vector_interval__["a" /* IntervalDayTimeVector */]; };
    GetVectorConstructor.prototype.visitIntervalYearMonth = function () { return __WEBPACK_IMPORTED_MODULE_10__vector_interval__["c" /* IntervalYearMonthVector */]; };
    GetVectorConstructor.prototype.visitFixedSizeList = function () { return __WEBPACK_IMPORTED_MODULE_8__vector_fixedsizelist__["a" /* FixedSizeListVector */]; };
    GetVectorConstructor.prototype.visitMap = function () { return __WEBPACK_IMPORTED_MODULE_13__vector_map__["a" /* MapVector */]; };
    return GetVectorConstructor;
}(__WEBPACK_IMPORTED_MODULE_1__visitor__["Visitor"]));

/** @ignore */
var instance = new GetVectorConstructor();



/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RecordBatchWriter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RecordBatchStreamWriter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RecordBatchFileWriter; });
/* unused harmony export RecordBatchJSONWriter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__table__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__message__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__column__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__schema__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vector_chunked__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata_message__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__type__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__metadata_file__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__enum__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__io_stream__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__visitor_vectorassembler__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__visitor_jsontypeassembler__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__visitor_jsonvectorassembler__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_buffer__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__io_interfaces__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_compat__ = __webpack_require__(37);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.


















var RecordBatchWriter = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](RecordBatchWriter, _super);
    function RecordBatchWriter(options) {
        var _this = _super.call(this) || this;
        _this._position = 0;
        _this._started = false;
        // @ts-ignore
        _this._sink = new __WEBPACK_IMPORTED_MODULE_10__io_stream__["a" /* AsyncByteQueue */]();
        _this._schema = null;
        _this._dictionaryBlocks = [];
        _this._recordBatchBlocks = [];
        _this._autoDestroy = options && (typeof options.autoDestroy === 'boolean') ? options.autoDestroy : true;
        return _this;
    }
    /** @nocollapse */
    // @ts-ignore
    RecordBatchWriter.throughNode = function (options) {
        throw new Error("\"throughNode\" not available in this environment");
    };
    /** @nocollapse */
    RecordBatchWriter.throughDOM = function (
    // @ts-ignore
    writableStrategy, 
    // @ts-ignore
    readableStrategy) {
        throw new Error("\"throughDOM\" not available in this environment");
    };
    RecordBatchWriter.prototype.toString = function (sync) {
        if (sync === void 0) { sync = false; }
        return this._sink.toString(sync);
    };
    RecordBatchWriter.prototype.toUint8Array = function (sync) {
        if (sync === void 0) { sync = false; }
        return this._sink.toUint8Array(sync);
    };
    RecordBatchWriter.prototype.writeAll = function (input) {
        var _this = this;
        if (Object(__WEBPACK_IMPORTED_MODULE_16__util_compat__["g" /* isPromise */])(input)) {
            return input.then(function (x) { return _this.writeAll(x); });
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_16__util_compat__["b" /* isAsyncIterable */])(input)) {
            return writeAllAsync(this, input);
        }
        return writeAll(this, input);
    };
    Object.defineProperty(RecordBatchWriter.prototype, "closed", {
        get: function () { return this._sink.closed; },
        enumerable: true,
        configurable: true
    });
    RecordBatchWriter.prototype[Symbol.asyncIterator] = function () { return this._sink[Symbol.asyncIterator](); };
    RecordBatchWriter.prototype.toDOMStream = function (options) { return this._sink.toDOMStream(options); };
    RecordBatchWriter.prototype.toNodeStream = function (options) { return this._sink.toNodeStream(options); };
    RecordBatchWriter.prototype.close = function () {
        return this.reset()._sink.close();
    };
    RecordBatchWriter.prototype.abort = function (reason) {
        return this.reset()._sink.abort(reason);
    };
    RecordBatchWriter.prototype.finish = function () {
        this._autoDestroy ? this.close() : this.reset(this._sink, this._schema);
        return this;
    };
    RecordBatchWriter.prototype.reset = function (sink, schema) {
        if (sink === void 0) { sink = this._sink; }
        if (schema === void 0) { schema = null; }
        if ((sink === this._sink) || (sink instanceof __WEBPACK_IMPORTED_MODULE_10__io_stream__["a" /* AsyncByteQueue */])) {
            this._sink = sink;
        }
        else {
            this._sink = new __WEBPACK_IMPORTED_MODULE_10__io_stream__["a" /* AsyncByteQueue */]();
            if (sink && Object(__WEBPACK_IMPORTED_MODULE_16__util_compat__["j" /* isWritableDOMStream */])(sink)) {
                this.toDOMStream({ type: 'bytes' }).pipeTo(sink);
            }
            else if (sink && Object(__WEBPACK_IMPORTED_MODULE_16__util_compat__["k" /* isWritableNodeStream */])(sink)) {
                this.toNodeStream({ objectMode: false }).pipe(sink);
            }
        }
        if (this._started && this._schema) {
            this._writeFooter();
        }
        this._started = false;
        this._dictionaryBlocks = [];
        this._recordBatchBlocks = [];
        if (!schema || (schema !== this._schema)) {
            if (schema === null) {
                this._position = 0;
                this._schema = null;
            }
            else {
                this._started = true;
                this._schema = schema;
                this._writeSchema(schema);
            }
        }
        return this;
    };
    RecordBatchWriter.prototype.write = function (chunk) {
        var schema;
        if (!this._sink) {
            throw new Error("RecordBatchWriter is closed");
        }
        else if (!chunk || !(schema = chunk.schema)) {
            return this.finish() && undefined;
        }
        else if (schema !== this._schema) {
            if (this._started && this._autoDestroy) {
                return this.close();
            }
            this.reset(this._sink, schema);
        }
        (chunk instanceof __WEBPACK_IMPORTED_MODULE_1__table__["Table"])
            ? this.writeAll(chunk.chunks)
            : this._writeRecordBatch(chunk);
    };
    RecordBatchWriter.prototype._writeMessage = function (message, alignment) {
        if (alignment === void 0) { alignment = 8; }
        var a = alignment - 1;
        var buffer = __WEBPACK_IMPORTED_MODULE_6__metadata_message__["d" /* Message */].encode(message);
        var flatbufferSize = buffer.byteLength;
        var alignedSize = (flatbufferSize + 4 + a) & ~a;
        var nPaddingBytes = alignedSize - flatbufferSize - 4;
        if (message.headerType === __WEBPACK_IMPORTED_MODULE_9__enum__["MessageHeader"].RecordBatch) {
            this._recordBatchBlocks.push(new __WEBPACK_IMPORTED_MODULE_8__metadata_file__["a" /* FileBlock */](alignedSize, message.bodyLength, this._position));
        }
        else if (message.headerType === __WEBPACK_IMPORTED_MODULE_9__enum__["MessageHeader"].DictionaryBatch) {
            this._dictionaryBlocks.push(new __WEBPACK_IMPORTED_MODULE_8__metadata_file__["a" /* FileBlock */](alignedSize, message.bodyLength, this._position));
        }
        // Write the flatbuffer size prefix including padding
        this._write(Int32Array.of(alignedSize - 4));
        // Write the flatbuffer
        if (flatbufferSize > 0) {
            this._write(buffer);
        }
        // Write any padding
        return this._writePadding(nPaddingBytes);
    };
    RecordBatchWriter.prototype._write = function (chunk) {
        if (this._started) {
            var buffer = Object(__WEBPACK_IMPORTED_MODULE_14__util_buffer__["e" /* toUint8Array */])(chunk);
            if (buffer && buffer.byteLength > 0) {
                this._sink.write(buffer);
                this._position += buffer.byteLength;
            }
        }
        return this;
    };
    RecordBatchWriter.prototype._writeSchema = function (schema) {
        return this
            ._writeMessage(__WEBPACK_IMPORTED_MODULE_6__metadata_message__["d" /* Message */].from(schema))
            ._writeDictionaries(schema.dictionaryFields);
    };
    RecordBatchWriter.prototype._writeFooter = function () {
        return this._writePadding(4); // eos bytes
    };
    RecordBatchWriter.prototype._writeMagic = function () {
        return this._write(__WEBPACK_IMPORTED_MODULE_2__message__["c" /* MAGIC */]);
    };
    RecordBatchWriter.prototype._writePadding = function (nBytes) {
        return nBytes > 0 ? this._write(new Uint8Array(nBytes)) : this;
    };
    RecordBatchWriter.prototype._writeRecordBatch = function (records) {
        var _a = __WEBPACK_IMPORTED_MODULE_11__visitor_vectorassembler__["a" /* VectorAssembler */].assemble(records), byteLength = _a.byteLength, nodes = _a.nodes, bufferRegions = _a.bufferRegions, buffers = _a.buffers;
        var recordBatch = new __WEBPACK_IMPORTED_MODULE_6__metadata_message__["e" /* RecordBatch */](records.length, nodes, bufferRegions);
        var message = __WEBPACK_IMPORTED_MODULE_6__metadata_message__["d" /* Message */].from(recordBatch, byteLength);
        return this
            ._writeMessage(message)
            ._writeBodyBuffers(buffers);
    };
    RecordBatchWriter.prototype._writeDictionaryBatch = function (dictionary, id, isDelta) {
        if (isDelta === void 0) { isDelta = false; }
        var _a = __WEBPACK_IMPORTED_MODULE_11__visitor_vectorassembler__["a" /* VectorAssembler */].assemble(dictionary), byteLength = _a.byteLength, nodes = _a.nodes, bufferRegions = _a.bufferRegions, buffers = _a.buffers;
        var recordBatch = new __WEBPACK_IMPORTED_MODULE_6__metadata_message__["e" /* RecordBatch */](dictionary.length, nodes, bufferRegions);
        var dictionaryBatch = new __WEBPACK_IMPORTED_MODULE_6__metadata_message__["b" /* DictionaryBatch */](recordBatch, id, isDelta);
        var message = __WEBPACK_IMPORTED_MODULE_6__metadata_message__["d" /* Message */].from(dictionaryBatch, byteLength);
        return this
            ._writeMessage(message)
            ._writeBodyBuffers(buffers);
    };
    RecordBatchWriter.prototype._writeBodyBuffers = function (buffers) {
        var buffer;
        var size, padding;
        for (var i = -1, n = buffers.length; ++i < n;) {
            if ((buffer = buffers[i]) && (size = buffer.byteLength) > 0) {
                this._write(buffer);
                if ((padding = ((size + 7) & ~7) - size) > 0) {
                    this._writePadding(padding);
                }
            }
        }
        return this;
    };
    RecordBatchWriter.prototype._writeDictionaries = function (dictionaryFields) {
        var e_1, _a;
        try {
            for (var dictionaryFields_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["k" /* __values */](dictionaryFields), dictionaryFields_1_1 = dictionaryFields_1.next(); !dictionaryFields_1_1.done; dictionaryFields_1_1 = dictionaryFields_1.next()) {
                var _b = __WEBPACK_IMPORTED_MODULE_0_tslib__["i" /* __read */](dictionaryFields_1_1.value, 2), id = _b[0], fields = _b[1];
                var vector = fields[0].type.dictionaryVector;
                if (!(vector instanceof __WEBPACK_IMPORTED_MODULE_5__vector_chunked__["a" /* Chunked */])) {
                    this._writeDictionaryBatch(vector, id, false);
                }
                else {
                    var chunks = vector.chunks;
                    for (var i = -1, n = chunks.length; ++i < n;) {
                        this._writeDictionaryBatch(chunks[i], id, i > 0);
                    }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (dictionaryFields_1_1 && !dictionaryFields_1_1.done && (_a = dictionaryFields_1.return)) _a.call(dictionaryFields_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return this;
    };
    return RecordBatchWriter;
}(__WEBPACK_IMPORTED_MODULE_15__io_interfaces__["d" /* ReadableInterop */]));

/** @ignore */
var RecordBatchStreamWriter = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](RecordBatchStreamWriter, _super);
    function RecordBatchStreamWriter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /** @nocollapse */
    RecordBatchStreamWriter.writeAll = function (input, options) {
        return new RecordBatchStreamWriter(options).writeAll(input);
    };
    return RecordBatchStreamWriter;
}(RecordBatchWriter));

/** @ignore */
var RecordBatchFileWriter = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](RecordBatchFileWriter, _super);
    function RecordBatchFileWriter() {
        var _this = _super.call(this) || this;
        _this._autoDestroy = true;
        return _this;
    }
    /** @nocollapse */
    RecordBatchFileWriter.writeAll = function (input) {
        return new RecordBatchFileWriter().writeAll(input);
    };
    RecordBatchFileWriter.prototype._writeSchema = function (schema) {
        return this
            ._writeMagic()._writePadding(2)
            ._writeDictionaries(schema.dictionaryFields);
    };
    RecordBatchFileWriter.prototype._writeFooter = function () {
        var buffer = __WEBPACK_IMPORTED_MODULE_8__metadata_file__["b" /* Footer */].encode(new __WEBPACK_IMPORTED_MODULE_8__metadata_file__["b" /* Footer */](this._schema, __WEBPACK_IMPORTED_MODULE_9__enum__["MetadataVersion"].V4, this._recordBatchBlocks, this._dictionaryBlocks));
        return this
            ._write(buffer) // Write the flatbuffer
            ._write(Int32Array.of(buffer.byteLength)) // then the footer size suffix
            ._writeMagic(); // then the magic suffix
    };
    return RecordBatchFileWriter;
}(RecordBatchWriter));

/** @ignore */
var RecordBatchJSONWriter = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](RecordBatchJSONWriter, _super);
    function RecordBatchJSONWriter() {
        var _this = _super.call(this) || this;
        _this._autoDestroy = true;
        return _this;
    }
    /** @nocollapse */
    RecordBatchJSONWriter.writeAll = function (input) {
        return new RecordBatchJSONWriter().writeAll(input);
    };
    RecordBatchJSONWriter.prototype._writeMessage = function () { return this; };
    RecordBatchJSONWriter.prototype._writeSchema = function (schema) {
        return this._write("{\n  \"schema\": " + JSON.stringify({ fields: schema.fields.map(fieldToJSON) }, null, 2))._writeDictionaries(schema.dictionaryFields);
    };
    RecordBatchJSONWriter.prototype._writeDictionaries = function (dictionaryFields) {
        this._write(",\n  \"dictionaries\": [\n");
        _super.prototype._writeDictionaries.call(this, dictionaryFields);
        return this._write("\n  ]");
    };
    RecordBatchJSONWriter.prototype._writeDictionaryBatch = function (dictionary, id, isDelta) {
        if (isDelta === void 0) { isDelta = false; }
        this._write(this._dictionaryBlocks.length === 0 ? "    " : ",\n    ");
        this._write("" + dictionaryBatchToJSON(this._schema, dictionary, id, isDelta));
        this._dictionaryBlocks.push(new __WEBPACK_IMPORTED_MODULE_8__metadata_file__["a" /* FileBlock */](0, 0, 0));
        return this;
    };
    RecordBatchJSONWriter.prototype._writeRecordBatch = function (records) {
        this._write(this._recordBatchBlocks.length === 0
            ? ",\n  \"batches\": [\n    "
            : ",\n    ");
        this._write("" + recordBatchToJSON(records));
        this._recordBatchBlocks.push(new __WEBPACK_IMPORTED_MODULE_8__metadata_file__["a" /* FileBlock */](0, 0, 0));
        return this;
    };
    RecordBatchJSONWriter.prototype.close = function () {
        if (this._recordBatchBlocks.length > 0) {
            this._write("\n  ]");
        }
        if (this._schema) {
            this._write("\n}");
        }
        return _super.prototype.close.call(this);
    };
    return RecordBatchJSONWriter;
}(RecordBatchWriter));

/** @ignore */
function writeAll(writer, input) {
    var e_2, _a;
    var chunks = (input instanceof __WEBPACK_IMPORTED_MODULE_1__table__["Table"]) ? input.chunks : input;
    try {
        for (var chunks_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["k" /* __values */](chunks), chunks_1_1 = chunks_1.next(); !chunks_1_1.done; chunks_1_1 = chunks_1.next()) {
            var batch = chunks_1_1.value;
            writer.write(batch);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (chunks_1_1 && !chunks_1_1.done && (_a = chunks_1.return)) _a.call(chunks_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return writer.finish();
}
/** @ignore */
function writeAllAsync(writer, batches) {
    var batches_1, batches_1_1;
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __awaiter */](this, void 0, void 0, function () {
        var e_3, _a, batch, e_3_1;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 5, 6, 11]);
                    batches_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __asyncValues */](batches);
                    _b.label = 1;
                case 1: return [4 /*yield*/, batches_1.next()];
                case 2:
                    if (!(batches_1_1 = _b.sent(), !batches_1_1.done)) return [3 /*break*/, 4];
                    batch = batches_1_1.value;
                    writer.write(batch);
                    _b.label = 3;
                case 3: return [3 /*break*/, 1];
                case 4: return [3 /*break*/, 11];
                case 5:
                    e_3_1 = _b.sent();
                    e_3 = { error: e_3_1 };
                    return [3 /*break*/, 11];
                case 6:
                    _b.trys.push([6, , 9, 10]);
                    if (!(batches_1_1 && !batches_1_1.done && (_a = batches_1.return))) return [3 /*break*/, 8];
                    return [4 /*yield*/, _a.call(batches_1)];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8: return [3 /*break*/, 10];
                case 9:
                    if (e_3) throw e_3.error;
                    return [7 /*endfinally*/];
                case 10: return [7 /*endfinally*/];
                case 11: return [2 /*return*/, writer.finish()];
            }
        });
    });
}
/** @ignore */
function fieldToJSON(_a) {
    var name = _a.name, type = _a.type, nullable = _a.nullable;
    var assembler = new __WEBPACK_IMPORTED_MODULE_12__visitor_jsontypeassembler__["a" /* JSONTypeAssembler */]();
    return {
        'name': name, 'nullable': nullable,
        'type': assembler.visit(type),
        'children': (type.children || []).map(fieldToJSON),
        'dictionary': !__WEBPACK_IMPORTED_MODULE_7__type__["DataType"].isDictionary(type) ? undefined : {
            'id': type.id,
            'isOrdered': type.isOrdered,
            'indexType': assembler.visit(type.indices)
        }
    };
}
/** @ignore */
function dictionaryBatchToJSON(schema, dictionary, id, isDelta) {
    if (isDelta === void 0) { isDelta = false; }
    var f = schema.dictionaryFields.get(id)[0];
    var field = new __WEBPACK_IMPORTED_MODULE_4__schema__["a" /* Field */](f.name, f.type.dictionary, f.nullable, f.metadata);
    var columns = __WEBPACK_IMPORTED_MODULE_13__visitor_jsonvectorassembler__["a" /* JSONVectorAssembler */].assemble(new __WEBPACK_IMPORTED_MODULE_3__column__["a" /* Column */](field, [dictionary]));
    return JSON.stringify({
        'id': id,
        'isDelta': isDelta,
        'data': {
            'count': dictionary.length,
            'columns': columns
        }
    }, null, 2);
}
/** @ignore */
function recordBatchToJSON(records) {
    return JSON.stringify({
        'count': records.length,
        'columns': __WEBPACK_IMPORTED_MODULE_13__visitor_jsonvectorassembler__["a" /* JSONVectorAssembler */].assemble(records)
    }, null, 2);
}



/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VectorAssembler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vector__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__visitor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__enum__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__recordbatch__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_buffer__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_bit__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ipc_metadata_message__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__type__ = __webpack_require__(3);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.









var VectorAssembler = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](VectorAssembler, _super);
    function VectorAssembler() {
        var _this = _super.call(this) || this;
        _this._byteLength = 0;
        _this._nodes = [];
        _this._buffers = [];
        _this._bufferRegions = [];
        return _this;
    }
    /** @nocollapse */
    VectorAssembler.assemble = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var vectors = args.reduce(function flatten(xs, x) {
            if (Array.isArray(x)) {
                return x.reduce(flatten, xs);
            }
            if (!(x instanceof __WEBPACK_IMPORTED_MODULE_4__recordbatch__["a" /* RecordBatch */])) {
                return __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](xs, [x]);
            }
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](xs, x.schema.fields.map(function (_, i) { return x.getChildAt(i); }));
        }, []).filter(function (x) { return x instanceof __WEBPACK_IMPORTED_MODULE_1__vector__["Vector"]; });
        return new VectorAssembler().visitMany(vectors)[0];
    };
    VectorAssembler.prototype.visit = function (vector) {
        if (!__WEBPACK_IMPORTED_MODULE_8__type__["DataType"].isDictionary(vector.type)) {
            var data = vector.data, length_1 = vector.length, nullCount = vector.nullCount;
            if (length_1 > 2147483647) {
                /* istanbul ignore next */
                throw new RangeError('Cannot write arrays larger than 2^31 - 1 in length');
            }
            addBuffer.call(this, nullCount <= 0
                ? new Uint8Array(0) // placeholder validity buffer
                : Object(__WEBPACK_IMPORTED_MODULE_6__util_bit__["g" /* truncateBitmap */])(data.offset, length_1, data.nullBitmap)).nodes.push(new __WEBPACK_IMPORTED_MODULE_7__ipc_metadata_message__["c" /* FieldNode */](length_1, nullCount));
        }
        return _super.prototype.visit.call(this, vector);
    };
    VectorAssembler.prototype.visitNull = function (_nullV) { return this; };
    VectorAssembler.prototype.visitDictionary = function (vector) {
        // Assemble the indices here, Dictionary assembled separately.
        return this.visit(vector.indices);
    };
    Object.defineProperty(VectorAssembler.prototype, "nodes", {
        get: function () { return this._nodes; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VectorAssembler.prototype, "buffers", {
        get: function () { return this._buffers; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VectorAssembler.prototype, "byteLength", {
        get: function () { return this._byteLength; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VectorAssembler.prototype, "bufferRegions", {
        get: function () { return this._bufferRegions; },
        enumerable: true,
        configurable: true
    });
    return VectorAssembler;
}(__WEBPACK_IMPORTED_MODULE_2__visitor__["Visitor"]));

/** @ignore */
function addBuffer(values) {
    var byteLength = (values.byteLength + 7) & ~7; // Round up to a multiple of 8
    this.buffers.push(values);
    this.bufferRegions.push(new __WEBPACK_IMPORTED_MODULE_7__ipc_metadata_message__["a" /* BufferRegion */](this._byteLength, byteLength));
    this._byteLength += byteLength;
    return this;
}
/** @ignore */
function assembleUnion(vector) {
    var type = vector.type, length = vector.length, typeIds = vector.typeIds, valueOffsets = vector.valueOffsets;
    // All Union Vectors have a typeIds buffer
    addBuffer.call(this, typeIds);
    // If this is a Sparse Union, treat it like all other Nested types
    if (type.mode === __WEBPACK_IMPORTED_MODULE_3__enum__["UnionMode"].Sparse) {
        return assembleNestedVector.call(this, vector);
    }
    else if (type.mode === __WEBPACK_IMPORTED_MODULE_3__enum__["UnionMode"].Dense) {
        // If this is a Dense Union, add the valueOffsets buffer and potentially slice the children
        if (vector.offset <= 0) {
            // If the Vector hasn't been sliced, write the existing valueOffsets
            addBuffer.call(this, valueOffsets);
            // We can treat this like all other Nested types
            return assembleNestedVector.call(this, vector);
        }
        else {
            // A sliced Dense Union is an unpleasant case. Because the offsets are different for
            // each child vector, we need to "rebase" the valueOffsets for each child
            // Union typeIds are not necessary 0-indexed
            var maxChildTypeId = typeIds.reduce(function (x, y) { return Math.max(x, y); }, typeIds[0]);
            var childLengths = new Int32Array(maxChildTypeId + 1);
            // Set all to -1 to indicate that we haven't observed a first occurrence of a particular child yet
            var childOffsets = new Int32Array(maxChildTypeId + 1).fill(-1);
            var shiftedOffsets = new Int32Array(length);
            // If we have a non-zero offset, then the value offsets do not start at
            // zero. We must a) create a new offsets array with shifted offsets and
            // b) slice the values array accordingly
            var unshiftedOffsets = Object(__WEBPACK_IMPORTED_MODULE_5__util_buffer__["c" /* rebaseValueOffsets */])(-valueOffsets[0], length, valueOffsets);
            for (var typeId = void 0, shift = void 0, index = -1; ++index < length;) {
                if ((shift = childOffsets[typeId = typeIds[index]]) === -1) {
                    shift = childOffsets[typeId] = unshiftedOffsets[typeId];
                }
                shiftedOffsets[index] = unshiftedOffsets[index] - shift;
                ++childLengths[typeId];
            }
            addBuffer.call(this, shiftedOffsets);
            // Slice and visit children accordingly
            for (var child = void 0, childIndex = -1, numChildren = type.children.length; ++childIndex < numChildren;) {
                if (child = vector.getChildAt(childIndex)) {
                    var typeId = type.typeIds[childIndex];
                    var childLength = Math.min(length, childLengths[typeId]);
                    this.visit(child.slice(childOffsets[typeId], childLength));
                }
            }
        }
    }
    return this;
}
/** @ignore */
function assembleBoolVector(vector) {
    // Bool vector is a special case of FlatVector, as its data buffer needs to stay packed
    var values;
    if (vector.nullCount >= vector.length) {
        // If all values are null, just insert a placeholder empty data buffer (fastest path)
        return addBuffer.call(this, new Uint8Array(0));
    }
    else if ((values = vector.values) instanceof Uint8Array) {
        // If values is already a Uint8Array, slice the bitmap (fast path)
        return addBuffer.call(this, Object(__WEBPACK_IMPORTED_MODULE_6__util_bit__["g" /* truncateBitmap */])(vector.offset, vector.length, values));
    }
    // Otherwise if the underlying data *isn't* a Uint8Array, enumerate the
    // values as bools and re-pack them into a Uint8Array. This code isn't
    // reachable unless you're trying to manipulate the Data internals,
    // we we're only doing this for safety.
    /* istanbul ignore next */
    return addBuffer.call(this, Object(__WEBPACK_IMPORTED_MODULE_6__util_bit__["d" /* packBools */])(vector));
}
/** @ignore */
function assembleFlatVector(vector) {
    return addBuffer.call(this, vector.values.subarray(0, vector.length * vector.stride));
}
/** @ignore */
function assembleFlatListVector(vector) {
    var length = vector.length, values = vector.values, valueOffsets = vector.valueOffsets;
    var firstOffset = valueOffsets[0];
    var lastOffset = valueOffsets[length];
    var byteLength = Math.min(lastOffset - firstOffset, values.byteLength - firstOffset);
    // Push in the order FlatList types read their buffers
    addBuffer.call(this, Object(__WEBPACK_IMPORTED_MODULE_5__util_buffer__["c" /* rebaseValueOffsets */])(-valueOffsets[0], length, valueOffsets)); // valueOffsets buffer first
    addBuffer.call(this, values.subarray(firstOffset, firstOffset + byteLength)); // sliced values buffer second
    return this;
}
/** @ignore */
function assembleListVector(vector) {
    var length = vector.length, valueOffsets = vector.valueOffsets;
    // If we have valueOffsets (ListVector), push that buffer first
    if (valueOffsets) {
        addBuffer.call(this, Object(__WEBPACK_IMPORTED_MODULE_5__util_buffer__["c" /* rebaseValueOffsets */])(valueOffsets[0], length, valueOffsets));
    }
    // Then insert the List's values child
    return this.visit(vector.getChildAt(0));
}
/** @ignore */
function assembleNestedVector(vector) {
    return this.visitMany(vector.type.children.map(function (_, i) { return vector.getChildAt(i); }).filter(Boolean))[0];
}
VectorAssembler.prototype.visitBool = assembleBoolVector;
VectorAssembler.prototype.visitInt = assembleFlatVector;
VectorAssembler.prototype.visitFloat = assembleFlatVector;
VectorAssembler.prototype.visitUtf8 = assembleFlatListVector;
VectorAssembler.prototype.visitBinary = assembleFlatListVector;
VectorAssembler.prototype.visitFixedSizeBinary = assembleFlatVector;
VectorAssembler.prototype.visitDate = assembleFlatVector;
VectorAssembler.prototype.visitTimestamp = assembleFlatVector;
VectorAssembler.prototype.visitTime = assembleFlatVector;
VectorAssembler.prototype.visitDecimal = assembleFlatVector;
VectorAssembler.prototype.visitList = assembleListVector;
VectorAssembler.prototype.visitStruct = assembleNestedVector;
VectorAssembler.prototype.visitUnion = assembleUnion;
VectorAssembler.prototype.visitInterval = assembleFlatVector;
VectorAssembler.prototype.visitFixedSizeList = assembleListVector;
VectorAssembler.prototype.visitMap = assembleNestedVector;



/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return JSONTypeAssembler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__visitor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enum__ = __webpack_require__(2);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.



var JSONTypeAssembler = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](JSONTypeAssembler, _super);
    function JSONTypeAssembler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    JSONTypeAssembler.prototype.visit = function (node) {
        return node == null ? undefined : _super.prototype.visit.call(this, node);
    };
    JSONTypeAssembler.prototype.visitNull = function (_a) {
        var typeId = _a.typeId;
        return { 'name': __WEBPACK_IMPORTED_MODULE_2__enum__["ArrowType"][typeId].toLowerCase() };
    };
    JSONTypeAssembler.prototype.visitInt = function (_a) {
        var typeId = _a.typeId, bitWidth = _a.bitWidth, isSigned = _a.isSigned;
        return { 'name': __WEBPACK_IMPORTED_MODULE_2__enum__["ArrowType"][typeId].toLowerCase(), 'bitWidth': bitWidth, 'isSigned': isSigned };
    };
    JSONTypeAssembler.prototype.visitFloat = function (_a) {
        var typeId = _a.typeId, precision = _a.precision;
        return { 'name': __WEBPACK_IMPORTED_MODULE_2__enum__["ArrowType"][typeId].toLowerCase(), 'precision': __WEBPACK_IMPORTED_MODULE_2__enum__["Precision"][precision] };
    };
    JSONTypeAssembler.prototype.visitBinary = function (_a) {
        var typeId = _a.typeId;
        return { 'name': __WEBPACK_IMPORTED_MODULE_2__enum__["ArrowType"][typeId].toLowerCase() };
    };
    JSONTypeAssembler.prototype.visitBool = function (_a) {
        var typeId = _a.typeId;
        return { 'name': __WEBPACK_IMPORTED_MODULE_2__enum__["ArrowType"][typeId].toLowerCase() };
    };
    JSONTypeAssembler.prototype.visitUtf8 = function (_a) {
        var typeId = _a.typeId;
        return { 'name': __WEBPACK_IMPORTED_MODULE_2__enum__["ArrowType"][typeId].toLowerCase() };
    };
    JSONTypeAssembler.prototype.visitDecimal = function (_a) {
        var typeId = _a.typeId, scale = _a.scale, precision = _a.precision;
        return { 'name': __WEBPACK_IMPORTED_MODULE_2__enum__["ArrowType"][typeId].toLowerCase(), 'scale': scale, 'precision': precision };
    };
    JSONTypeAssembler.prototype.visitDate = function (_a) {
        var typeId = _a.typeId, unit = _a.unit;
        return { 'name': __WEBPACK_IMPORTED_MODULE_2__enum__["ArrowType"][typeId].toLowerCase(), 'unit': __WEBPACK_IMPORTED_MODULE_2__enum__["DateUnit"][unit] };
    };
    JSONTypeAssembler.prototype.visitTime = function (_a) {
        var typeId = _a.typeId, unit = _a.unit, bitWidth = _a.bitWidth;
        return { 'name': __WEBPACK_IMPORTED_MODULE_2__enum__["ArrowType"][typeId].toLowerCase(), 'unit': __WEBPACK_IMPORTED_MODULE_2__enum__["TimeUnit"][unit], bitWidth: bitWidth };
    };
    JSONTypeAssembler.prototype.visitTimestamp = function (_a) {
        var typeId = _a.typeId, timezone = _a.timezone, unit = _a.unit;
        return { 'name': __WEBPACK_IMPORTED_MODULE_2__enum__["ArrowType"][typeId].toLowerCase(), 'unit': __WEBPACK_IMPORTED_MODULE_2__enum__["TimeUnit"][unit], timezone: timezone };
    };
    JSONTypeAssembler.prototype.visitInterval = function (_a) {
        var typeId = _a.typeId, unit = _a.unit;
        return { 'name': __WEBPACK_IMPORTED_MODULE_2__enum__["ArrowType"][typeId].toLowerCase(), 'unit': __WEBPACK_IMPORTED_MODULE_2__enum__["IntervalUnit"][unit] };
    };
    JSONTypeAssembler.prototype.visitList = function (_a) {
        var typeId = _a.typeId;
        return { 'name': __WEBPACK_IMPORTED_MODULE_2__enum__["ArrowType"][typeId].toLowerCase() };
    };
    JSONTypeAssembler.prototype.visitStruct = function (_a) {
        var typeId = _a.typeId;
        return { 'name': __WEBPACK_IMPORTED_MODULE_2__enum__["ArrowType"][typeId].toLowerCase() };
    };
    JSONTypeAssembler.prototype.visitUnion = function (_a) {
        var typeId = _a.typeId, mode = _a.mode, typeIds = _a.typeIds;
        return {
            'name': __WEBPACK_IMPORTED_MODULE_2__enum__["ArrowType"][typeId].toLowerCase(),
            'mode': __WEBPACK_IMPORTED_MODULE_2__enum__["UnionMode"][mode],
            'typeIds': __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](typeIds)
        };
    };
    JSONTypeAssembler.prototype.visitDictionary = function (node) {
        return this.visit(node.dictionary);
    };
    JSONTypeAssembler.prototype.visitFixedSizeBinary = function (_a) {
        var typeId = _a.typeId, byteWidth = _a.byteWidth;
        return { 'name': __WEBPACK_IMPORTED_MODULE_2__enum__["ArrowType"][typeId].toLowerCase(), 'byteWidth': byteWidth };
    };
    JSONTypeAssembler.prototype.visitFixedSizeList = function (_a) {
        var typeId = _a.typeId, listSize = _a.listSize;
        return { 'name': __WEBPACK_IMPORTED_MODULE_2__enum__["ArrowType"][typeId].toLowerCase(), 'listSize': listSize };
    };
    JSONTypeAssembler.prototype.visitMap = function (_a) {
        var typeId = _a.typeId, keysSorted = _a.keysSorted;
        return { 'name': __WEBPACK_IMPORTED_MODULE_2__enum__["ArrowType"][typeId].toLowerCase(), 'keysSorted': keysSorted };
    };
    return JSONTypeAssembler;
}(__WEBPACK_IMPORTED_MODULE_1__visitor__["Visitor"]));




/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return JSONVectorAssembler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_bn__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__column__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vector__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__visitor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__recordbatch__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__enum__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_bit__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__type__ = __webpack_require__(3);
// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.










var JSONVectorAssembler = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __extends */](JSONVectorAssembler, _super);
    function JSONVectorAssembler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /** @nocollapse */
    JSONVectorAssembler.assemble = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var vectors = args.reduce(function flatten(xs, x) {
            if (Array.isArray(x)) {
                return x.reduce(flatten, xs);
            }
            if (!(x instanceof __WEBPACK_IMPORTED_MODULE_5__recordbatch__["a" /* RecordBatch */])) {
                return __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](xs, [x]);
            }
            return xs.concat(x.schema.fields.map(function (f, i) { return new __WEBPACK_IMPORTED_MODULE_2__column__["a" /* Column */](f, [x.getChildAt(i)]); }));
        }, []).filter(function (x) { return x instanceof __WEBPACK_IMPORTED_MODULE_2__column__["a" /* Column */]; });
        return new JSONVectorAssembler().visitMany(vectors);
    };
    JSONVectorAssembler.prototype.visit = function (column) {
        var _a;
        var data = column.data, name = column.name, length = column.length;
        var offset = data.offset, nullCount = data.nullCount, nullBitmap = data.nullBitmap;
        var type = __WEBPACK_IMPORTED_MODULE_8__type__["DataType"].isDictionary(column.type) ? column.type.indices : column.type;
        var buffers = Object.assign([], data.buffers, (_a = {}, _a[__WEBPACK_IMPORTED_MODULE_6__enum__["VectorType"].VALIDITY] = undefined, _a));
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ 'name': name, 'count': length, 'VALIDITY': nullCount <= 0
                ? Array.from({ length: length }, function () { return 1; })
                : __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](Object(__WEBPACK_IMPORTED_MODULE_7__util_bit__["c" /* iterateBits */])(nullBitmap, offset, length, null, __WEBPACK_IMPORTED_MODULE_7__util_bit__["a" /* getBit */])) }, _super.prototype.visit.call(this, __WEBPACK_IMPORTED_MODULE_3__vector__["Vector"].new(data.clone(type, offset, length, 0, buffers))));
    };
    JSONVectorAssembler.prototype.visitNull = function () { return {}; };
    JSONVectorAssembler.prototype.visitBool = function (_a) {
        var values = _a.values, offset = _a.offset, length = _a.length;
        return { 'DATA': __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](Object(__WEBPACK_IMPORTED_MODULE_7__util_bit__["c" /* iterateBits */])(values, offset, length, null, __WEBPACK_IMPORTED_MODULE_7__util_bit__["b" /* getBool */])) };
    };
    JSONVectorAssembler.prototype.visitInt = function (vector) {
        return {
            'DATA': vector.type.bitWidth < 64
                ? __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](vector.values) : __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](bigNumsToStrings(vector.values, 2))
        };
    };
    JSONVectorAssembler.prototype.visitFloat = function (vector) {
        return { 'DATA': __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](vector.values) };
    };
    JSONVectorAssembler.prototype.visitUtf8 = function (vector) {
        return { 'DATA': __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](vector), 'OFFSET': __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](vector.valueOffsets) };
    };
    JSONVectorAssembler.prototype.visitBinary = function (vector) {
        return { 'DATA': __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](binaryToString(vector)), OFFSET: __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](vector.valueOffsets) };
    };
    JSONVectorAssembler.prototype.visitFixedSizeBinary = function (vector) {
        return { 'DATA': __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](binaryToString(vector)) };
    };
    JSONVectorAssembler.prototype.visitDate = function (vector) {
        return {
            'DATA': vector.type.unit === __WEBPACK_IMPORTED_MODULE_6__enum__["DateUnit"].DAY
                ? __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](vector.values) : __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](bigNumsToStrings(vector.values, 2))
        };
    };
    JSONVectorAssembler.prototype.visitTimestamp = function (vector) {
        return { 'DATA': __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](bigNumsToStrings(vector.values, 2)) };
    };
    JSONVectorAssembler.prototype.visitTime = function (vector) {
        return {
            'DATA': vector.type.unit < __WEBPACK_IMPORTED_MODULE_6__enum__["TimeUnit"].MICROSECOND
                ? __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](vector.values) : __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](bigNumsToStrings(vector.values, 2))
        };
    };
    JSONVectorAssembler.prototype.visitDecimal = function (vector) {
        return { 'DATA': __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](bigNumsToStrings(vector.values, 4)) };
    };
    JSONVectorAssembler.prototype.visitList = function (vector) {
        var _this = this;
        return {
            'OFFSET': __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](vector.valueOffsets),
            'children': vector.type.children.map(function (f, i) {
                return _this.visit(new __WEBPACK_IMPORTED_MODULE_2__column__["a" /* Column */](f, [vector.getChildAt(i)]));
            })
        };
    };
    JSONVectorAssembler.prototype.visitStruct = function (vector) {
        var _this = this;
        return {
            'children': vector.type.children.map(function (f, i) {
                return _this.visit(new __WEBPACK_IMPORTED_MODULE_2__column__["a" /* Column */](f, [vector.getChildAt(i)]));
            })
        };
    };
    JSONVectorAssembler.prototype.visitUnion = function (vector) {
        var _this = this;
        return {
            'TYPE': __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](vector.typeIds),
            'OFFSET': vector.type.mode === __WEBPACK_IMPORTED_MODULE_6__enum__["UnionMode"].Dense ? __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](vector.valueOffsets) : undefined,
            'children': vector.type.children.map(function (f, i) { return _this.visit(new __WEBPACK_IMPORTED_MODULE_2__column__["a" /* Column */](f, [vector.getChildAt(i)])); })
        };
    };
    JSONVectorAssembler.prototype.visitInterval = function (vector) {
        return { 'DATA': __WEBPACK_IMPORTED_MODULE_0_tslib__["j" /* __spread */](vector.values) };
    };
    JSONVectorAssembler.prototype.visitFixedSizeList = function (vector) {
        var _this = this;
        return {
            'children': vector.type.children.map(function (f, i) {
                return _this.visit(new __WEBPACK_IMPORTED_MODULE_2__column__["a" /* Column */](f, [vector.getChildAt(i)]));
            })
        };
    };
    JSONVectorAssembler.prototype.visitMap = function (vector) {
        var _this = this;
        return {
            'children': vector.type.children.map(function (f, i) {
                return _this.visit(new __WEBPACK_IMPORTED_MODULE_2__column__["a" /* Column */](f, [vector.getChildAt(i)]));
            })
        };
    };
    return JSONVectorAssembler;
}(__WEBPACK_IMPORTED_MODULE_4__visitor__["Visitor"]));

/** @ignore */
function binaryToString(vector) {
    var e_1, _a, _b, _c, octets, e_1_1;
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_d) {
        switch (_d.label) {
            case 0:
                _d.trys.push([0, 5, 6, 7]);
                _b = __WEBPACK_IMPORTED_MODULE_0_tslib__["k" /* __values */](vector), _c = _b.next();
                _d.label = 1;
            case 1:
                if (!!_c.done) return [3 /*break*/, 4];
                octets = _c.value;
                return [4 /*yield*/, octets.reduce(function (str, byte) {
                        return "" + str + ('0' + (byte & 0xFF).toString(16)).slice(-2);
                    }, '').toUpperCase()];
            case 2:
                _d.sent();
                _d.label = 3;
            case 3:
                _c = _b.next();
                return [3 /*break*/, 1];
            case 4: return [3 /*break*/, 7];
            case 5:
                e_1_1 = _d.sent();
                e_1 = { error: e_1_1 };
                return [3 /*break*/, 7];
            case 6:
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
                return [7 /*endfinally*/];
            case 7: return [2 /*return*/];
        }
    });
}
/** @ignore */
function bigNumsToStrings(values, stride) {
    var i, n;
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __generator */](this, function (_a) {
        switch (_a.label) {
            case 0:
                i = -1, n = values.length / stride;
                _a.label = 1;
            case 1:
                if (!(++i < n)) return [3 /*break*/, 4];
                return [4 /*yield*/, "" + __WEBPACK_IMPORTED_MODULE_1__util_bn__["a" /* BN */].new(values.subarray((i + 0) * stride, (i + 1) * stride))];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3: return [3 /*break*/, 1];
            case 4: return [2 /*return*/];
        }
    });
}



/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(23);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

__webpack_require__(105);

__webpack_require__(219);

var _papaparse = _interopRequireDefault(__webpack_require__(139));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/******************************************************************************
 *
 * Copyright (c) 2017, the Perspective Authors.
 *
 * This file is part of the Perspective library, distributed under the terms of
 * the Apache License 2.0.  The full license can be found in the LICENSE file.
 *
 */
var jsonFormatter = {
  initDataValue: function initDataValue() {
    return [];
  },
  initRowValue: function initRowValue() {
    return {};
  },
  initColumnValue: function initColumnValue(data, row, colName) {
    return row[colName] = [];
  },
  setColumnValue: function setColumnValue(data, row, colName, value) {
    return row[colName] = value;
  },
  addColumnValue: function addColumnValue(data, row, colName, value) {
    return row[colName].unshift(value);
  },
  addRow: function addRow(data, row) {
    return data.push(row);
  },
  formatData: function formatData(data) {
    return data;
  },
  slice: function slice(data, start) {
    return data.slice(start);
  }
};
var csvFormatter = Object.assign({}, jsonFormatter, {
  addColumnValue: function addColumnValue(data, row, colName, value) {
    return row[colName.split("|").join(",")].unshift(value);
  },
  setColumnValue: function setColumnValue(data, row, colName, value) {
    return row[colName.split("|").join(",")] = value;
  },
  formatData: function formatData(data, config) {
    return _papaparse["default"].unparse(data, config);
  }
});
var jsonTableFormatter = {
  initDataValue: function initDataValue() {
    return new Object();
  },
  initRowValue: function initRowValue() {},
  setColumnValue: function setColumnValue(data, row, colName, value) {
    data[colName] = data[colName] || [];
    data[colName].push(value);
  },
  addColumnValue: function addColumnValue(data, row, colName, value) {
    data[colName] = data[colName] || [];
    data[colName][data[colName].length - 1].unshift(value);
  },
  initColumnValue: function initColumnValue(data, row, colName) {
    data[colName] = data[colName] || [];
    data[colName].push([]);
  },
  addRow: function addRow() {},
  formatData: function formatData(data) {
    return data;
  },
  slice: function slice(data, start) {
    var new_data = {};

    for (var x in data) {
      new_data[x] = data[x].slice(start);
    }

    return new_data;
  }
};
var _default = {
  jsonFormatter: jsonFormatter,
  jsonTableFormatter: jsonTableFormatter,
  csvFormatter: csvFormatter
};
exports["default"] = _default;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(1);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(220) });


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(31);
var gOPS = __webpack_require__(80);
var pIE = __webpack_require__(56);
var toObject = __webpack_require__(17);
var IObject = __webpack_require__(52);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(8)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// perspective.wasm.worker.js